/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as LayoutRouteImport } from "./routes/_layout"
import { Route as ChangePasswordRouteImport } from "./routes/change-password"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as RecoverPasswordRouteImport } from "./routes/recover-password"
import { Route as ResetPasswordRouteImport } from "./routes/reset-password"
import { Route as LayoutIndexRouteImport } from "./routes/_layout/index"
import { Route as LayoutAgentRouteRouteImport } from "./routes/_layout/agent/route"
import { Route as LayoutAircraftRouteRouteImport } from "./routes/_layout/aircraft/route"
import { Route as LayoutAirworthinessDirectivesRouteRouteImport } from "./routes/_layout/airworthiness-directives/route"
import { Route as LayoutApprovedVendorsRouteRouteImport } from "./routes/_layout/approved-vendors/route"
import { Route as LayoutCustomerRouteRouteImport } from "./routes/_layout/customer/route"
import { Route as LayoutDocumentsRouteRouteImport } from "./routes/_layout/documents/route"
import { Route as LayoutForecastsRouteRouteImport } from "./routes/_layout/forecasts/route"
import { Route as LayoutInventoryRouteRouteImport } from "./routes/_layout/inventory/route"
import { Route as LayoutMaintenanceProgrammesRouteRouteImport } from "./routes/_layout/maintenance-programmes/route"
import { Route as LayoutPlanningRouteRouteImport } from "./routes/_layout/planning/route"
import { Route as LayoutQuotesRouteRouteImport } from "./routes/_layout/quotes/route"
import { Route as LayoutSettingsRouteRouteImport } from "./routes/_layout/settings/route"
import { Route as LayoutTechLogsRouteRouteImport } from "./routes/_layout/tech-logs/route"
import { Route as LayoutTemplatesRouteRouteImport } from "./routes/_layout/templates/route"
import { Route as LayoutTieInRouteRouteImport } from "./routes/_layout/tie-in/route"
import { Route as LayoutTimesheetRouteRouteImport } from "./routes/_layout/timesheet/route"
import { Route as LayoutToolsRouteRouteImport } from "./routes/_layout/tools/route"
import { Route as ReviewTokenRouteRouteImport } from "./routes/review/$token/route"
import { Route as LayoutAgentIndexRouteImport } from "./routes/_layout/agent/index"
import { Route as LayoutAgentIdRouteImport } from "./routes/_layout/agent/$id"
import { Route as LayoutAgentChatsRouteImport } from "./routes/_layout/agent/chats"
import { Route as LayoutAircraftIndexRouteImport } from "./routes/_layout/aircraft/index"
import { Route as LayoutAircraftAircraftIdRouteRouteImport } from "./routes/_layout/aircraft_/$aircraftId/route"
import { Route as LayoutAircraftNewRouteImport } from "./routes/_layout/aircraft_/new"
import { Route as LayoutAirworthinessDirectivesIndexRouteImport } from "./routes/_layout/airworthiness-directives/index"
import { Route as LayoutAirworthinessDirectivesUploadRouteImport } from "./routes/_layout/airworthiness-directives/upload"
import { Route as LayoutAirworthinessDirectivesDocumentIdRouteImport } from "./routes/_layout/airworthiness-directives_/$documentId"
import { Route as LayoutApprovedVendorsIndexRouteImport } from "./routes/_layout/approved-vendors/index"
import { Route as LayoutApprovedVendorsVendorIdRouteImport } from "./routes/_layout/approved-vendors_/$vendorId"
import { Route as LayoutApprovedVendorsNewRouteImport } from "./routes/_layout/approved-vendors_/new"
import { Route as LayoutCustomerIndexRouteImport } from "./routes/_layout/customer/index"
import { Route as LayoutCustomerCustomerIdRouteRouteImport } from "./routes/_layout/customer_/$customerId/route"
import { Route as LayoutCustomerNewRouteImport } from "./routes/_layout/customer_/new"
import { Route as LayoutDocumentsDocumentIdRouteImport } from "./routes/_layout/documents/$documentId"
import { Route as LayoutDocumentsListRouteRouteImport } from "./routes/_layout/documents/_list/route"
import { Route as LayoutForecastsIndexRouteImport } from "./routes/_layout/forecasts/index"
import { Route as LayoutForecastsNewRouteImport } from "./routes/_layout/forecasts/new"
import { Route as LayoutForecastsForecastIdRouteImport } from "./routes/_layout/forecasts_/$forecastId"
import { Route as LayoutForecastsPreviewRouteImport } from "./routes/_layout/forecasts_/preview"
import { Route as LayoutInventoryIndexRouteImport } from "./routes/_layout/inventory/index"
import { Route as LayoutInventoryPartIdRouteRouteImport } from "./routes/_layout/inventory/$partId/route"
import { Route as LayoutInventoryNewRouteImport } from "./routes/_layout/inventory/new"
import { Route as LayoutInventoryPurchaseOrdersRouteRouteImport } from "./routes/_layout/inventory_/purchase-orders/route"
import { Route as LayoutMaintenanceProgrammesIndexRouteImport } from "./routes/_layout/maintenance-programmes/index"
import { Route as LayoutMaintenanceProgrammesNewRouteImport } from "./routes/_layout/maintenance-programmes/new"
import { Route as LayoutMaintenanceProgrammesProgrammeIdRouteRouteImport } from "./routes/_layout/maintenance-programmes_/$programmeId/route"
import { Route as LayoutManpowerIndexRouteImport } from "./routes/_layout/manpower/index"
import { Route as LayoutPlanningIndexRouteImport } from "./routes/_layout/planning/index"
import { Route as LayoutPlanningPlanIdRouteRouteImport } from "./routes/_layout/planning_/$planId/route"
import { Route as LayoutQuotesIndexRouteImport } from "./routes/_layout/quotes/index"
import { Route as LayoutQuotesCreateRouteImport } from "./routes/_layout/quotes/create"
import { Route as LayoutQuotesFromFileRouteImport } from "./routes/_layout/quotes/from-file"
import { Route as LayoutQuotesQuoteIdRouteRouteImport } from "./routes/_layout/quotes_/$quoteId/route"
import { Route as LayoutQuotingIndexRouteImport } from "./routes/_layout/quoting/index"
import { Route as LayoutQuotingEmailsRouteRouteImport } from "./routes/_layout/quoting_/emails/route"
import { Route as LayoutQuotingSquawksRouteRouteImport } from "./routes/_layout/quoting_/squawks/route"
import { Route as LayoutSettingsIndexRouteImport } from "./routes/_layout/settings/index"
import { Route as LayoutSettingsPanelRouteRouteImport } from "./routes/_layout/settings/_panel/route"
import { Route as LayoutSettingsCompanyRouteImport } from "./routes/_layout/settings/company"
import { Route as LayoutSettingsSystemRouteImport } from "./routes/_layout/settings/system"
import { Route as LayoutSettingsUserRouteImport } from "./routes/_layout/settings/user"
import { Route as LayoutTechLogsIndexRouteImport } from "./routes/_layout/tech-logs/index"
import { Route as LayoutTechLogsPageIdRouteImport } from "./routes/_layout/tech-logs/$pageId"
import { Route as LayoutTechLogsNewRouteImport } from "./routes/_layout/tech-logs/new"
import { Route as LayoutTemplatesIndexRouteImport } from "./routes/_layout/templates/index"
import { Route as LayoutTemplatesQuotesRouteRouteImport } from "./routes/_layout/templates/quotes/route"
import { Route as LayoutTemplatesTasksRouteRouteImport } from "./routes/_layout/templates/tasks/route"
import { Route as LayoutTimesheetIndexRouteImport } from "./routes/_layout/timesheet/index"
import { Route as LayoutTimesheetLogRouteImport } from "./routes/_layout/timesheet/log"
import { Route as LayoutToolsIndexRouteImport } from "./routes/_layout/tools/index"
import { Route as LayoutToolsToolIdRouteRouteImport } from "./routes/_layout/tools/$toolId/route"
import { Route as LayoutToolsNewRouteImport } from "./routes/_layout/tools/new"
import { Route as LayoutWorkOrdersWorkOrderIdRouteRouteImport } from "./routes/_layout/work-orders/$workOrderId/route"
import { Route as LayoutWorkOrdersListRouteRouteImport } from "./routes/_layout/work-orders/_list/route"
import { Route as LayoutWorkTaskIdRouteImport } from "./routes/_layout/work-task/$id"
import { Route as ReviewTokenIndexRouteImport } from "./routes/review/$token/index"
import { Route as ReviewTokenSignRouteImport } from "./routes/review/$token/sign"
import { Route as LayoutAgentDeleteIdRouteImport } from "./routes/_layout/agent/delete.$id"
import { Route as LayoutAircraftAircraftIdIndexRouteImport } from "./routes/_layout/aircraft_/$aircraftId/index"
import { Route as LayoutAircraftAircraftIdEditRouteImport } from "./routes/_layout/aircraft_/$aircraftId_/edit"
import { Route as LayoutAirworthinessDirectivesDeleteDocumentIdRouteImport } from "./routes/_layout/airworthiness-directives/delete/$documentId"
import { Route as LayoutApprovedVendorsDeleteVendorIdRouteImport } from "./routes/_layout/approved-vendors/delete/$vendorId"
import { Route as LayoutApprovedVendorsDeleteBulkRouteImport } from "./routes/_layout/approved-vendors/delete/bulk"
import { Route as LayoutAssessmentsAdReportIdRouteImport } from "./routes/_layout/assessments/ad/$reportId"
import { Route as LayoutAssessmentsSbReportIdRouteImport } from "./routes/_layout/assessments/sb/$reportId"
import { Route as LayoutCustomerDeleteCustomerIdRouteImport } from "./routes/_layout/customer/delete/$customerId"
import { Route as LayoutCustomerCustomerIdIndexRouteImport } from "./routes/_layout/customer_/$customerId/index"
import { Route as LayoutCustomerCustomerIdAircraftRouteImport } from "./routes/_layout/customer_/$customerId/aircraft"
import { Route as LayoutCustomerCustomerIdContactsRouteRouteImport } from "./routes/_layout/customer_/$customerId/contacts/route"
import { Route as LayoutCustomerCustomerIdDeleteRouteImport } from "./routes/_layout/customer_/$customerId/delete"
import { Route as LayoutCustomerCustomerIdWoHistoryRouteImport } from "./routes/_layout/customer_/$customerId/wo-history"
import { Route as LayoutDocumentsListIndexRouteImport } from "./routes/_layout/documents/_list/index"
import { Route as LayoutDocumentsListUploadRouteRouteImport } from "./routes/_layout/documents/_list/upload/route"
import { Route as LayoutForecastsDeleteForecastIdRouteImport } from "./routes/_layout/forecasts/delete/$forecastId"
import { Route as LayoutInventoryPartIdIndexRouteImport } from "./routes/_layout/inventory/$partId/index"
import { Route as LayoutInventoryPartIdArchiveRouteImport } from "./routes/_layout/inventory/$partId/archive"
import { Route as LayoutInventoryDeletePartIdRouteImport } from "./routes/_layout/inventory/delete/$partId"
import { Route as LayoutInventoryDeleteBulkRouteImport } from "./routes/_layout/inventory/delete/bulk"
import { Route as LayoutInventoryPurchaseOrdersIndexRouteImport } from "./routes/_layout/inventory_/purchase-orders/index"
import { Route as LayoutInventoryPurchaseOrdersPurchaseOrderIdRouteImport } from "./routes/_layout/inventory_/purchase-orders/$purchaseOrderId"
import { Route as LayoutInventoryPurchaseOrdersNewRouteImport } from "./routes/_layout/inventory_/purchase-orders/new"
import { Route as LayoutMaintenanceProgrammesDeleteProgrammeIdRouteImport } from "./routes/_layout/maintenance-programmes/delete/$programmeId"
import { Route as LayoutMaintenanceProgrammesProgrammeIdIndexRouteImport } from "./routes/_layout/maintenance-programmes_/$programmeId/index"
import { Route as LayoutPlanningNewForecastRouteImport } from "./routes/_layout/planning/new/forecast"
import { Route as LayoutPlanningNewQuoteRouteImport } from "./routes/_layout/planning/new/quote"
import { Route as LayoutPlanningPlanIdIndexRouteImport } from "./routes/_layout/planning_/$planId/index"
import { Route as LayoutQuotesDeleteQuoteIdRouteImport } from "./routes/_layout/quotes/delete/$quoteId"
import { Route as LayoutQuotesQuoteIdIndexRouteImport } from "./routes/_layout/quotes_/$quoteId/index"
import { Route as LayoutQuotesQuoteIdCorridorRouteImport } from "./routes/_layout/quotes_/$quoteId/corridor"
import { Route as LayoutQuotesQuoteIdSendRouteImport } from "./routes/_layout/quotes_/$quoteId/send"
import { Route as LayoutQuotesQuoteIdSentRouteImport } from "./routes/_layout/quotes_/$quoteId/sent"
import { Route as LayoutQuotingCannedIndexRouteImport } from "./routes/_layout/quoting/canned/index"
import { Route as LayoutQuotingCannedPackageIdRouteImport } from "./routes/_layout/quoting/canned/$packageId"
import { Route as LayoutQuotingEmailsListRouteRouteImport } from "./routes/_layout/quoting_/emails/_list/route"
import { Route as LayoutQuotingQuotesIndexRouteImport } from "./routes/_layout/quoting_/quotes/index"
import { Route as LayoutQuotingQuotesQuoteIdRouteImport } from "./routes/_layout/quoting_/quotes/$quoteId"
import { Route as LayoutQuotingSquawksIndexRouteImport } from "./routes/_layout/quoting_/squawks/index"
import { Route as LayoutQuotingSquawksSquawkIdRouteImport } from "./routes/_layout/quoting_/squawks/$squawkId"
import { Route as LayoutTechLogsDeletePageIdRouteImport } from "./routes/_layout/tech-logs/delete/$pageId"
import { Route as LayoutTemplatesQuotesIndexRouteImport } from "./routes/_layout/templates/quotes/index"
import { Route as LayoutTemplatesQuotesDeleteRouteImport } from "./routes/_layout/templates/quotes/delete"
import { Route as LayoutTemplatesQuotesPackageIdRouteRouteImport } from "./routes/_layout/templates/quotes_/$packageId/route"
import { Route as LayoutTemplatesTasksIndexRouteImport } from "./routes/_layout/templates/tasks/index"
import { Route as LayoutTemplatesTasksTaskIdRouteRouteImport } from "./routes/_layout/templates/tasks/$taskId/route"
import { Route as LayoutTemplatesTasksCreateRouteImport } from "./routes/_layout/templates/tasks/create"
import { Route as LayoutTemplatesTasksDeleteRouteImport } from "./routes/_layout/templates/tasks/delete"
import { Route as LayoutTimesheetDeleteTimeEntryIdRouteImport } from "./routes/_layout/timesheet/delete/$timeEntryId"
import { Route as LayoutToolsToolIdIndexRouteImport } from "./routes/_layout/tools/$toolId/index"
import { Route as LayoutToolsToolIdIssueRouteImport } from "./routes/_layout/tools/$toolId/issue"
import { Route as LayoutToolsToolIdLabelRouteImport } from "./routes/_layout/tools/$toolId/label"
import { Route as LayoutToolsToolIdRetireRouteImport } from "./routes/_layout/tools/$toolId/retire"
import { Route as LayoutWorkOrdersWorkOrderIdIndexRouteImport } from "./routes/_layout/work-orders/$workOrderId/index"
import { Route as LayoutWorkOrdersWorkOrderIdCancelRouteImport } from "./routes/_layout/work-orders/$workOrderId/cancel"
import { Route as LayoutWorkOrdersWorkOrderIdCloseRouteImport } from "./routes/_layout/work-orders/$workOrderId/close"
import { Route as LayoutWorkOrdersListIndexRouteImport } from "./routes/_layout/work-orders/_list/index"
import { Route as LayoutAgentChatsDeleteIdRouteImport } from "./routes/_layout/agent/chats.delete.$id"
import { Route as LayoutAircraftAircraftIdFittedComponentsNewRouteImport } from "./routes/_layout/aircraft_/$aircraftId/fitted-components/new"
import { Route as LayoutAircraftAircraftIdModStatusNewRouteImport } from "./routes/_layout/aircraft_/$aircraftId/mod-status/new"
import { Route as LayoutAircraftAircraftIdReadingsNewRouteImport } from "./routes/_layout/aircraft_/$aircraftId/readings/new"
import { Route as LayoutAircraftAircraftIdTechLogPageIdRouteImport } from "./routes/_layout/aircraft_/$aircraftId/tech-log/$pageId"
import { Route as LayoutAircraftAircraftIdTechLogNewRouteImport } from "./routes/_layout/aircraft_/$aircraftId/tech-log/new"
import { Route as LayoutCustomerCustomerIdContactsListRouteRouteImport } from "./routes/_layout/customer_/$customerId/contacts/_list/route"
import { Route as LayoutCustomerCustomerIdContactsCreateRouteImport } from "./routes/_layout/customer_/$customerId/contacts/create"
import { Route as LayoutDocumentsListDeleteDocumentIdRouteImport } from "./routes/_layout/documents/_list/delete/$documentId"
import { Route as LayoutDocumentsListDeleteBulkRouteImport } from "./routes/_layout/documents/_list/delete/bulk"
import { Route as LayoutDocumentsListMakePrivateDocumentIdRouteImport } from "./routes/_layout/documents/_list/make-private/$documentId"
import { Route as LayoutDocumentsListShareDocumentIdRouteImport } from "./routes/_layout/documents/_list/share/$documentId"
import { Route as LayoutDocumentsListShareBulkRouteImport } from "./routes/_layout/documents/_list/share/bulk"
import { Route as LayoutMaintenanceProgrammesProgrammeIdAircraftEnrolRouteImport } from "./routes/_layout/maintenance-programmes_/$programmeId/aircraft/enrol"
import { Route as LayoutMaintenanceProgrammesProgrammeIdPhasesPhaseIdRouteImport } from "./routes/_layout/maintenance-programmes_/$programmeId/phases/$phaseId"
import { Route as LayoutMaintenanceProgrammesProgrammeIdPhasesNewRouteImport } from "./routes/_layout/maintenance-programmes_/$programmeId/phases/new"
import { Route as LayoutMaintenanceProgrammesProgrammeIdRevisionsNewRouteImport } from "./routes/_layout/maintenance-programmes_/$programmeId/revisions/new"
import { Route as LayoutMaintenanceProgrammesProgrammeIdTasksTaskIdRouteImport } from "./routes/_layout/maintenance-programmes_/$programmeId/tasks/$taskId"
import { Route as LayoutMaintenanceProgrammesProgrammeIdTasksNewRouteImport } from "./routes/_layout/maintenance-programmes_/$programmeId/tasks/new"
import { Route as LayoutQuotesQuoteIdPhasesNewRouteImport } from "./routes/_layout/quotes_/$quoteId/phases/new"
import { Route as LayoutQuotesQuoteIdTasksTaskIdRouteRouteImport } from "./routes/_layout/quotes_/$quoteId/tasks/$taskId/route"
import { Route as LayoutQuotesQuoteIdTasksFromTemplateRouteImport } from "./routes/_layout/quotes_/$quoteId/tasks/from-template"
import { Route as LayoutQuotingEmailsListIndexRouteImport } from "./routes/_layout/quoting_/emails/_list/index"
import { Route as LayoutQuotingEmailsListEmailIdRouteRouteImport } from "./routes/_layout/quoting_/emails/_list/$emailId/route"
import { Route as LayoutQuotingSquawksDeleteSquawkIdRouteImport } from "./routes/_layout/quoting_/squawks/delete/$squawkId"
import { Route as LayoutQuotingSquawksEditSquawkIdRouteImport } from "./routes/_layout/quoting_/squawks/edit/$squawkId"
import { Route as LayoutSettingsPanelAccountProfileRouteRouteImport } from "./routes/_layout/settings/_panel/account/profile/route"
import { Route as LayoutSettingsPanelIntegrationsCrmRouteImport } from "./routes/_layout/settings/_panel/integrations/crm"
import { Route as LayoutSettingsPanelIntegrationsErpRouteRouteImport } from "./routes/_layout/settings/_panel/integrations/erp/route"
import { Route as LayoutSettingsPanelQuotingCustomerApprovalRouteImport } from "./routes/_layout/settings/_panel/quoting/customer-approval"
import { Route as LayoutSettingsPanelQuotingGeneralRouteImport } from "./routes/_layout/settings/_panel/quoting/general"
import { Route as LayoutSettingsPanelQuotingPlaybooksRouteRouteImport } from "./routes/_layout/settings/_panel/quoting/playbooks/route"
import { Route as LayoutSettingsPanelQuotingRateCardsRouteRouteImport } from "./routes/_layout/settings/_panel/quoting/rate-cards/route"
import { Route as LayoutSettingsPanelQuotingStatusRouteRouteImport } from "./routes/_layout/settings/_panel/quoting/status/route"
import { Route as LayoutSettingsPanelQuotingTaskGroupsRouteRouteImport } from "./routes/_layout/settings/_panel/quoting/task-groups/route"
import { Route as LayoutSettingsPanelQuotingTaxRatesRouteRouteImport } from "./routes/_layout/settings/_panel/quoting/tax-rates/route"
import { Route as LayoutSettingsPanelWorkOrdersGeneralRouteImport } from "./routes/_layout/settings/_panel/work-orders/general"
import { Route as LayoutSettingsPanelWorkspaceApprovalFlowsRouteRouteImport } from "./routes/_layout/settings/_panel/workspace/approval-flows/route"
import { Route as LayoutSettingsPanelWorkspaceDepartmentsRouteRouteImport } from "./routes/_layout/settings/_panel/workspace/departments/route"
import { Route as LayoutSettingsPanelWorkspaceFacilitiesRouteRouteImport } from "./routes/_layout/settings/_panel/workspace/facilities/route"
import { Route as LayoutSettingsPanelWorkspaceMembersRouteRouteImport } from "./routes/_layout/settings/_panel/workspace/members/route"
import { Route as LayoutSettingsPanelWorkspaceNotificationRulesRouteRouteImport } from "./routes/_layout/settings/_panel/workspace/notification-rules/route"
import { Route as LayoutSettingsPanelWorkspaceRolesRouteRouteImport } from "./routes/_layout/settings/_panel/workspace/roles/route"
import { Route as LayoutSettingsPanelWorkspaceTeamsRouteRouteImport } from "./routes/_layout/settings/_panel/workspace/teams/route"
import { Route as LayoutSettingsPanelWorkspaceTemplatesRouteRouteImport } from "./routes/_layout/settings/_panel/workspace/templates/route"
import { Route as LayoutSettingsPanelWorkspaceToolCategoriesRouteRouteImport } from "./routes/_layout/settings/_panel/workspace/tool-categories/route"
import { Route as LayoutSettingsSystemAuditLogIndexRouteImport } from "./routes/_layout/settings/system_/audit-log/index"
import { Route as LayoutSettingsSystemTenantsTenantIdRouteRouteImport } from "./routes/_layout/settings/system_/tenants/$tenantId/route"
import { Route as LayoutTemplatesQuotesPackageIdListRouteRouteImport } from "./routes/_layout/templates/quotes_/$packageId/_list/route"
import { Route as LayoutTemplatesQuotesPackageIdOverviewRouteRouteImport } from "./routes/_layout/templates/quotes_/$packageId/overview/route"
import { Route as LayoutTemplatesTasksTaskIdIndexRouteImport } from "./routes/_layout/templates/tasks/$taskId/index"
import { Route as LayoutTemplatesTasksTaskIdArchiveRouteImport } from "./routes/_layout/templates/tasks/$taskId/archive"
import { Route as LayoutToolsToolIdCalibrationsRecordRouteImport } from "./routes/_layout/tools/$toolId/calibrations/record"
import { Route as LayoutToolsToolIdCalibrationsSendRouteImport } from "./routes/_layout/tools/$toolId/calibrations/send"
import { Route as LayoutTraceSandboxConversationSessionIdSplatRouteImport } from "./routes/_layout/trace/sandbox/$conversationSessionId/$"
import { Route as LayoutWorkOrdersWorkOrderIdPhasesNewRouteImport } from "./routes/_layout/work-orders/$workOrderId/phases/new"
import { Route as LayoutWorkOrdersWorkOrderIdSquawksSquawkIdRouteImport } from "./routes/_layout/work-orders/$workOrderId/squawks/$squawkId"
import { Route as LayoutWorkOrdersWorkOrderIdTasksTaskIdRouteImport } from "./routes/_layout/work-orders/$workOrderId/tasks/$taskId"
import { Route as LayoutWorkOrdersWorkOrderIdTasksDeleteRouteImport } from "./routes/_layout/work-orders/$workOrderId/tasks/delete"
import { Route as LayoutWorkOrdersWorkOrderIdTasksNewRouteImport } from "./routes/_layout/work-orders/$workOrderId/tasks/new"
import { Route as LayoutWorkOrdersListDeleteWorkOrderIdRouteImport } from "./routes/_layout/work-orders/_list/delete/$workOrderId"
import { Route as LayoutAircraftAircraftIdFittedComponentsRemoveComponentIdRouteImport } from "./routes/_layout/aircraft_/$aircraftId/fitted-components/remove/$componentId"
import { Route as LayoutAircraftAircraftIdTechLogVoidPageIdRouteImport } from "./routes/_layout/aircraft_/$aircraftId/tech-log/void/$pageId"
import { Route as LayoutCustomerCustomerIdContactsListIndexRouteImport } from "./routes/_layout/customer_/$customerId/contacts/_list/index"
import { Route as LayoutCustomerCustomerIdContactsListContactIdRouteRouteImport } from "./routes/_layout/customer_/$customerId/contacts/_list/$contactId/route"
import { Route as LayoutInventoryPartIdPricesPriceIdDeleteRouteImport } from "./routes/_layout/inventory/$partId/prices/$priceId/delete"
import { Route as LayoutMaintenanceProgrammesProgrammeIdAircraftRemoveEnrolmentIdRouteImport } from "./routes/_layout/maintenance-programmes_/$programmeId/aircraft/remove/$enrolmentId"
import { Route as LayoutMaintenanceProgrammesProgrammeIdPhasesRemovePhaseIdRouteImport } from "./routes/_layout/maintenance-programmes_/$programmeId/phases/remove/$phaseId"
import { Route as LayoutMaintenanceProgrammesProgrammeIdRevisionsReleaseRevisionIdRouteImport } from "./routes/_layout/maintenance-programmes_/$programmeId/revisions/release/$revisionId"
import { Route as LayoutMaintenanceProgrammesProgrammeIdTasksRemoveTaskIdRouteImport } from "./routes/_layout/maintenance-programmes_/$programmeId/tasks/remove/$taskId"
import { Route as LayoutPlanningPlanIdStepsStepIdIndexRouteImport } from "./routes/_layout/planning_/$planId/steps/$stepId/index"
import { Route as LayoutQuotesQuoteIdPhasesPhaseIdDeleteRouteImport } from "./routes/_layout/quotes_/$quoteId/phases/$phaseId/delete"
import { Route as LayoutQuotesQuoteIdPhasesPhaseIdRenameRouteImport } from "./routes/_layout/quotes_/$quoteId/phases/$phaseId/rename"
import { Route as LayoutQuotesQuoteIdTasksTaskIdIndexRouteImport } from "./routes/_layout/quotes_/$quoteId/tasks/$taskId/index"
import { Route as LayoutQuotesQuoteIdTasksTaskIdApplyTemplateRouteImport } from "./routes/_layout/quotes_/$quoteId/tasks/$taskId/apply-template"
import { Route as LayoutQuotingEmailsListEmailIdIndexRouteImport } from "./routes/_layout/quoting_/emails/_list/$emailId/index"
import { Route as LayoutQuotingEmailsListEmailIdShareRouteImport } from "./routes/_layout/quoting_/emails/_list/$emailId/share"
import { Route as LayoutQuotingEmailsListDeleteEmailIdRouteImport } from "./routes/_layout/quoting_/emails/_list/delete/$emailId"
import { Route as LayoutQuotingEmailsListDeleteBulkRouteImport } from "./routes/_layout/quoting_/emails/_list/delete/bulk"
import { Route as LayoutQuotingEmailsListShareBulkRouteImport } from "./routes/_layout/quoting_/emails/_list/share/bulk"
import { Route as LayoutQuotingQuotesBuilderQuoteIdIndexRouteImport } from "./routes/_layout/quoting_/quotes/builder/$quoteId/index"
import { Route as LayoutSettingsPanelAccountNotificationsIndexRouteImport } from "./routes/_layout/settings/_panel/account/notifications/index"
import { Route as LayoutSettingsPanelAccountProfileIndexRouteImport } from "./routes/_layout/settings/_panel/account/profile/index"
import { Route as LayoutSettingsPanelAccountProfileChangePasswordRouteImport } from "./routes/_layout/settings/_panel/account/profile/change-password"
import { Route as LayoutSettingsPanelAccountSigningPinIndexRouteImport } from "./routes/_layout/settings/_panel/account/signing-pin/index"
import { Route as LayoutSettingsPanelIntegrationsErpListRouteRouteImport } from "./routes/_layout/settings/_panel/integrations/erp/_list/route"
import { Route as LayoutSettingsPanelQuotingFlatRatesIndexRouteImport } from "./routes/_layout/settings/_panel/quoting/flat-rates/index"
import { Route as LayoutSettingsPanelQuotingFlatRatesPackageIdRouteImport } from "./routes/_layout/settings/_panel/quoting/flat-rates/$packageId"
import { Route as LayoutSettingsPanelQuotingPlaybooksIndexRouteImport } from "./routes/_layout/settings/_panel/quoting/playbooks/index"
import { Route as LayoutSettingsPanelQuotingPlaybooksPlaybookIdRouteRouteImport } from "./routes/_layout/settings/_panel/quoting/playbooks/$playbookId/route"
import { Route as LayoutSettingsPanelQuotingPlaybooksCreateRouteImport } from "./routes/_layout/settings/_panel/quoting/playbooks/create"
import { Route as LayoutSettingsPanelQuotingRateCardsIndexRouteImport } from "./routes/_layout/settings/_panel/quoting/rate-cards/index"
import { Route as LayoutSettingsPanelQuotingRateCardsRateCardIdRouteRouteImport } from "./routes/_layout/settings/_panel/quoting/rate-cards/$rateCardId/route"
import { Route as LayoutSettingsPanelQuotingStatusIndexRouteImport } from "./routes/_layout/settings/_panel/quoting/status/index"
import { Route as LayoutSettingsPanelQuotingTaskGroupsIndexRouteImport } from "./routes/_layout/settings/_panel/quoting/task-groups/index"
import { Route as LayoutSettingsPanelQuotingTaskGroupsImportRouteImport } from "./routes/_layout/settings/_panel/quoting/task-groups/import"
import { Route as LayoutSettingsPanelQuotingTaxRatesIndexRouteImport } from "./routes/_layout/settings/_panel/quoting/tax-rates/index"
import { Route as LayoutSettingsPanelQuotingTaxRatesTaxRateIdRouteRouteImport } from "./routes/_layout/settings/_panel/quoting/tax-rates/$taxRateId/route"
import { Route as LayoutSettingsPanelWorkspaceApprovalFlowsIndexRouteImport } from "./routes/_layout/settings/_panel/workspace/approval-flows/index"
import { Route as LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdRouteRouteImport } from "./routes/_layout/settings/_panel/workspace/approval-flows/$policyId/route"
import { Route as LayoutSettingsPanelWorkspaceApprovalFlowsCreateRouteImport } from "./routes/_layout/settings/_panel/workspace/approval-flows/create"
import { Route as LayoutSettingsPanelWorkspaceDepartmentsListRouteRouteImport } from "./routes/_layout/settings/_panel/workspace/departments/_list/route"
import { Route as LayoutSettingsPanelWorkspaceDepartmentsCreateRouteImport } from "./routes/_layout/settings/_panel/workspace/departments/create"
import { Route as LayoutSettingsPanelWorkspaceFacilitiesListRouteRouteImport } from "./routes/_layout/settings/_panel/workspace/facilities/_list/route"
import { Route as LayoutSettingsPanelWorkspaceFacilitiesCreateRouteImport } from "./routes/_layout/settings/_panel/workspace/facilities/create"
import { Route as LayoutSettingsPanelWorkspaceGeneralIndexRouteImport } from "./routes/_layout/settings/_panel/workspace/general/index"
import { Route as LayoutSettingsPanelWorkspaceMembersListRouteRouteImport } from "./routes/_layout/settings/_panel/workspace/members/_list/route"
import { Route as LayoutSettingsPanelWorkspaceMembersCreateRouteImport } from "./routes/_layout/settings/_panel/workspace/members/create"
import { Route as LayoutSettingsPanelWorkspaceNotificationRulesIndexRouteImport } from "./routes/_layout/settings/_panel/workspace/notification-rules/index"
import { Route as LayoutSettingsPanelWorkspaceNotificationRulesRuleIdRouteRouteImport } from "./routes/_layout/settings/_panel/workspace/notification-rules/$ruleId/route"
import { Route as LayoutSettingsPanelWorkspaceNotificationRulesCreateRouteImport } from "./routes/_layout/settings/_panel/workspace/notification-rules/create"
import { Route as LayoutSettingsPanelWorkspaceRolesListRouteRouteImport } from "./routes/_layout/settings/_panel/workspace/roles/_list/route"
import { Route as LayoutSettingsPanelWorkspaceRolesCreateRouteImport } from "./routes/_layout/settings/_panel/workspace/roles/create"
import { Route as LayoutSettingsPanelWorkspaceTeamsListRouteRouteImport } from "./routes/_layout/settings/_panel/workspace/teams/_list/route"
import { Route as LayoutSettingsPanelWorkspaceTeamsCreateRouteImport } from "./routes/_layout/settings/_panel/workspace/teams/create"
import { Route as LayoutSettingsPanelWorkspaceTemplatesIndexRouteImport } from "./routes/_layout/settings/_panel/workspace/templates/index"
import { Route as LayoutSettingsPanelWorkspaceTemplatesKindRouteRouteImport } from "./routes/_layout/settings/_panel/workspace/templates/$kind/route"
import { Route as LayoutSettingsPanelWorkspaceToolCategoriesListRouteRouteImport } from "./routes/_layout/settings/_panel/workspace/tool-categories/_list/route"
import { Route as LayoutSettingsPanelWorkspaceToolCategoriesCreateRouteImport } from "./routes/_layout/settings/_panel/workspace/tool-categories/create"
import { Route as LayoutSettingsSystemTenantsTenantIdIndexRouteImport } from "./routes/_layout/settings/system_/tenants/$tenantId/index"
import { Route as LayoutSettingsSystemTenantsTenantIdApprovalPoliciesRouteImport } from "./routes/_layout/settings/system_/tenants/$tenantId/approval-policies"
import { Route as LayoutSettingsSystemTenantsTenantIdIntegrationsRouteImport } from "./routes/_layout/settings/system_/tenants/$tenantId/integrations"
import { Route as LayoutSettingsSystemTenantsTenantIdNotificationRulesRouteImport } from "./routes/_layout/settings/system_/tenants/$tenantId/notification-rules"
import { Route as LayoutSettingsSystemTenantsTenantIdSettingsRouteRouteImport } from "./routes/_layout/settings/system_/tenants/$tenantId/settings/route"
import { Route as LayoutSettingsSystemTenantsTenantIdUsersRouteImport } from "./routes/_layout/settings/system_/tenants/$tenantId/users"
import { Route as LayoutTemplatesQuotesPackageIdListIndexRouteImport } from "./routes/_layout/templates/quotes_/$packageId/_list/index"
import { Route as LayoutTemplatesQuotesPackageIdOverviewIndexRouteImport } from "./routes/_layout/templates/quotes_/$packageId/overview/index"
import { Route as LayoutTemplatesQuotesPackageIdOverviewArchiveRouteImport } from "./routes/_layout/templates/quotes_/$packageId/overview/archive"
import { Route as LayoutToolsToolIdCalibrationsCalibrationIdCompleteRouteImport } from "./routes/_layout/tools/$toolId/calibrations/$calibrationId/complete"
import { Route as LayoutToolsToolIdLoansLoanIdReceiveRouteImport } from "./routes/_layout/tools/$toolId/loans/$loanId/receive"
import { Route as LayoutWorkOrdersWorkOrderIdPhasesPhaseIdDeleteRouteImport } from "./routes/_layout/work-orders/$workOrderId/phases/$phaseId/delete"
import { Route as LayoutWorkOrdersWorkOrderIdPhasesPhaseIdRenameRouteImport } from "./routes/_layout/work-orders/$workOrderId/phases/$phaseId/rename"
import { Route as LayoutWorkOrdersWorkOrderIdTasksTaskIdDeleteRouteImport } from "./routes/_layout/work-orders/$workOrderId/tasks/$taskId/delete"
import { Route as LayoutAircraftAircraftIdPartInstancesPartInstanceIdReadingsNewRouteImport } from "./routes/_layout/aircraft_/$aircraftId/part-instances/$partInstanceId/readings/new"
import { Route as LayoutCustomerCustomerIdContactsListContactIdIndexRouteImport } from "./routes/_layout/customer_/$customerId/contacts/_list/$contactId/index"
import { Route as LayoutCustomerCustomerIdContactsListContactIdDeleteRouteImport } from "./routes/_layout/customer_/$customerId/contacts/_list/$contactId/delete"
import { Route as LayoutPlanningPlanIdStepsStepIdTasksTaskIndexRouteImport } from "./routes/_layout/planning_/$planId/steps/$stepId/tasks/$taskIndex"
import { Route as LayoutQuotingQuotesBuilderQuoteIdTaskTaskIdRouteImport } from "./routes/_layout/quoting_/quotes/builder/$quoteId/task/$taskId"
import { Route as LayoutSettingsPanelIntegrationsErpListIndexRouteImport } from "./routes/_layout/settings/_panel/integrations/erp/_list/index"
import { Route as LayoutSettingsPanelIntegrationsErpApiKeySetRouteImport } from "./routes/_layout/settings/_panel/integrations/erp/api-key/set"
import { Route as LayoutSettingsPanelIntegrationsErpRelaySetRouteImport } from "./routes/_layout/settings/_panel/integrations/erp/relay/set"
import { Route as LayoutSettingsPanelQuotingPlaybooksPlaybookIdIndexRouteImport } from "./routes/_layout/settings/_panel/quoting/playbooks/$playbookId/index"
import { Route as LayoutSettingsPanelQuotingPlaybooksPlaybookIdActivityRouteImport } from "./routes/_layout/settings/_panel/quoting/playbooks/$playbookId/activity"
import { Route as LayoutSettingsPanelQuotingPlaybooksPlaybookIdConfigurationRouteImport } from "./routes/_layout/settings/_panel/quoting/playbooks/$playbookId/configuration"
import { Route as LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesRouteRouteImport } from "./routes/_layout/settings/_panel/quoting/playbooks/$playbookId/rules/route"
import { Route as LayoutSettingsPanelQuotingRateCardsRateCardIdIndexRouteImport } from "./routes/_layout/settings/_panel/quoting/rate-cards/$rateCardId/index"
import { Route as LayoutSettingsPanelQuotingRateCardsRateCardIdArchiveRouteImport } from "./routes/_layout/settings/_panel/quoting/rate-cards/$rateCardId/archive"
import { Route as LayoutSettingsPanelQuotingTaskGroupsGroupIdArchiveRouteImport } from "./routes/_layout/settings/_panel/quoting/task-groups/$groupId/archive"
import { Route as LayoutSettingsPanelQuotingTaxRatesTaxRateIdIndexRouteImport } from "./routes/_layout/settings/_panel/quoting/tax-rates/$taxRateId/index"
import { Route as LayoutSettingsPanelQuotingTaxRatesTaxRateIdArchiveRouteImport } from "./routes/_layout/settings/_panel/quoting/tax-rates/$taxRateId/archive"
import { Route as LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdIndexRouteImport } from "./routes/_layout/settings/_panel/workspace/approval-flows/$policyId/index"
import { Route as LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdDeleteRouteImport } from "./routes/_layout/settings/_panel/workspace/approval-flows/$policyId/delete"
import { Route as LayoutSettingsPanelWorkspaceApprovalFlowsDuplicatePolicyIdRouteImport } from "./routes/_layout/settings/_panel/workspace/approval-flows/duplicate/$policyId"
import { Route as LayoutSettingsPanelWorkspaceDepartmentsListIndexRouteImport } from "./routes/_layout/settings/_panel/workspace/departments/_list/index"
import { Route as LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdRouteRouteImport } from "./routes/_layout/settings/_panel/workspace/departments/_list/$departmentId/route"
import { Route as LayoutSettingsPanelWorkspaceFacilitiesListIndexRouteImport } from "./routes/_layout/settings/_panel/workspace/facilities/_list/index"
import { Route as LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdRouteRouteImport } from "./routes/_layout/settings/_panel/workspace/facilities/_list/$facilityId/route"
import { Route as LayoutSettingsPanelWorkspaceMembersListIndexRouteImport } from "./routes/_layout/settings/_panel/workspace/members/_list/index"
import { Route as LayoutSettingsPanelWorkspaceMembersListUserIdRouteRouteImport } from "./routes/_layout/settings/_panel/workspace/members/_list/$userId/route"
import { Route as LayoutSettingsPanelWorkspaceNotificationRulesRuleIdIndexRouteImport } from "./routes/_layout/settings/_panel/workspace/notification-rules/$ruleId/index"
import { Route as LayoutSettingsPanelWorkspaceNotificationRulesRuleIdDeleteRouteImport } from "./routes/_layout/settings/_panel/workspace/notification-rules/$ruleId/delete"
import { Route as LayoutSettingsPanelWorkspaceNotificationRulesDuplicateRuleIdRouteImport } from "./routes/_layout/settings/_panel/workspace/notification-rules/duplicate/$ruleId"
import { Route as LayoutSettingsPanelWorkspaceRolesListIndexRouteImport } from "./routes/_layout/settings/_panel/workspace/roles/_list/index"
import { Route as LayoutSettingsPanelWorkspaceRolesListRoleIdRouteRouteImport } from "./routes/_layout/settings/_panel/workspace/roles/_list/$roleId/route"
import { Route as LayoutSettingsPanelWorkspaceRolesDuplicateRoleIdRouteImport } from "./routes/_layout/settings/_panel/workspace/roles/duplicate/$roleId"
import { Route as LayoutSettingsPanelWorkspaceTeamsListIndexRouteImport } from "./routes/_layout/settings/_panel/workspace/teams/_list/index"
import { Route as LayoutSettingsPanelWorkspaceTeamsListTeamIdRouteRouteImport } from "./routes/_layout/settings/_panel/workspace/teams/_list/$teamId/route"
import { Route as LayoutSettingsPanelWorkspaceTemplatesKindIndexRouteImport } from "./routes/_layout/settings/_panel/workspace/templates/$kind/index"
import { Route as LayoutSettingsPanelWorkspaceTemplatesKindRevertRouteImport } from "./routes/_layout/settings/_panel/workspace/templates/$kind/revert"
import { Route as LayoutSettingsPanelWorkspaceToolCategoriesListIndexRouteImport } from "./routes/_layout/settings/_panel/workspace/tool-categories/_list/index"
import { Route as LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdRouteRouteImport } from "./routes/_layout/settings/_panel/workspace/tool-categories/_list/$categoryId/route"
import { Route as LayoutSettingsSystemTenantsTenantIdSettingsIndexRouteImport } from "./routes/_layout/settings/system_/tenants/$tenantId/settings/index"
import { Route as LayoutSettingsSystemTenantsTenantIdSettingsReindexRouteImport } from "./routes/_layout/settings/system_/tenants/$tenantId/settings/reindex"
import { Route as LayoutTemplatesQuotesPackageIdListTasksTaskIdRouteRouteImport } from "./routes/_layout/templates/quotes_/$packageId/_list/tasks/$taskId/route"
import { Route as LayoutTemplatesQuotesPackageIdListTasksCreateRouteImport } from "./routes/_layout/templates/quotes_/$packageId/_list/tasks/create"
import { Route as LayoutAircraftAircraftIdPartInstancesPartInstanceIdReadingsReadingIdDeleteRouteImport } from "./routes/_layout/aircraft_/$aircraftId/part-instances/$partInstanceId/readings/$readingId/delete"
import { Route as LayoutQuotesQuoteIdTasksTaskIdStepsStepIdRemoveRouteImport } from "./routes/_layout/quotes_/$quoteId/tasks/$taskId/steps/$stepId/remove"
import { Route as LayoutSettingsPanelIntegrationsErpListApiKeyRevokeRouteImport } from "./routes/_layout/settings/_panel/integrations/erp/_list/api-key/revoke"
import { Route as LayoutSettingsPanelIntegrationsErpListRelayRemoveRouteImport } from "./routes/_layout/settings/_panel/integrations/erp/_list/relay/remove"
import { Route as LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesIndexRouteImport } from "./routes/_layout/settings/_panel/quoting/playbooks/$playbookId/rules/index"
import { Route as LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdIndexRouteImport } from "./routes/_layout/settings/_panel/workspace/departments/_list/$departmentId/index"
import { Route as LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdDeleteRouteImport } from "./routes/_layout/settings/_panel/workspace/departments/_list/$departmentId/delete"
import { Route as LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdIndexRouteImport } from "./routes/_layout/settings/_panel/workspace/facilities/_list/$facilityId/index"
import { Route as LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdDeleteRouteImport } from "./routes/_layout/settings/_panel/workspace/facilities/_list/$facilityId/delete"
import { Route as LayoutSettingsPanelWorkspaceMembersListUserIdIndexRouteImport } from "./routes/_layout/settings/_panel/workspace/members/_list/$userId/index"
import { Route as LayoutSettingsPanelWorkspaceMembersListUserIdChangePasswordRouteImport } from "./routes/_layout/settings/_panel/workspace/members/_list/$userId/change-password"
import { Route as LayoutSettingsPanelWorkspaceMembersListUserIdDeleteRouteImport } from "./routes/_layout/settings/_panel/workspace/members/_list/$userId/delete"
import { Route as LayoutSettingsPanelWorkspaceMembersListUserIdResendLoginEmailRouteImport } from "./routes/_layout/settings/_panel/workspace/members/_list/$userId/resend-login-email"
import { Route as LayoutSettingsPanelWorkspaceRolesListRoleIdIndexRouteImport } from "./routes/_layout/settings/_panel/workspace/roles/_list/$roleId/index"
import { Route as LayoutSettingsPanelWorkspaceRolesListRoleIdDeleteRouteImport } from "./routes/_layout/settings/_panel/workspace/roles/_list/$roleId/delete"
import { Route as LayoutSettingsPanelWorkspaceRolesListRoleIdResetRouteImport } from "./routes/_layout/settings/_panel/workspace/roles/_list/$roleId/reset"
import { Route as LayoutSettingsPanelWorkspaceTeamsListTeamIdIndexRouteImport } from "./routes/_layout/settings/_panel/workspace/teams/_list/$teamId/index"
import { Route as LayoutSettingsPanelWorkspaceTeamsListTeamIdDeleteRouteImport } from "./routes/_layout/settings/_panel/workspace/teams/_list/$teamId/delete"
import { Route as LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdIndexRouteImport } from "./routes/_layout/settings/_panel/workspace/tool-categories/_list/$categoryId/index"
import { Route as LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdDeleteRouteImport } from "./routes/_layout/settings/_panel/workspace/tool-categories/_list/$categoryId/delete"
import { Route as LayoutTemplatesQuotesPackageIdListTasksTaskIdIndexRouteImport } from "./routes/_layout/templates/quotes_/$packageId/_list/tasks/$taskId/index"
import { Route as LayoutTemplatesQuotesPackageIdListTasksTaskIdArchiveRouteImport } from "./routes/_layout/templates/quotes_/$packageId/_list/tasks/$taskId/archive"
import { Route as LayoutWorkOrdersWorkOrderIdTasksTaskIdStepsStepIdDeleteRouteImport } from "./routes/_layout/work-orders/$workOrderId/tasks/$taskId/steps/$stepId/delete"
import { Route as LayoutWorkOrdersWorkOrderIdTasksTaskIdTimeEntriesTimeEntryIdDeleteRouteImport } from "./routes/_layout/work-orders/$workOrderId/tasks/$taskId/time-entries/$timeEntryId/delete"
import { Route as LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesLineageIdDeleteRouteImport } from "./routes/_layout/settings/_panel/quoting/playbooks/$playbookId/rules/$lineageId/delete"
import { Route as LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdPositionsPositionIdRemoveRouteImport } from "./routes/_layout/settings/_panel/workspace/departments/_list/$departmentId/positions/$positionId/remove"
import { Route as LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdLocationsLocationIdDeleteRouteImport } from "./routes/_layout/settings/_panel/workspace/facilities/_list/$facilityId/locations/$locationId/delete"
import { Route as LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdPositionsPositionIdRemoveRouteImport } from "./routes/_layout/settings/_panel/workspace/facilities/_list/$facilityId/positions/$positionId/remove"
import { Route as LayoutSettingsPanelWorkspaceTeamsListTeamIdPositionsPositionIdRemoveRouteImport } from "./routes/_layout/settings/_panel/workspace/teams/_list/$teamId/positions/$positionId/remove"

const LayoutRoute = LayoutRouteImport.update({
  id: "/_layout",
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: "/change-password",
  path: "/change-password",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const RecoverPasswordRoute = RecoverPasswordRouteImport.update({
  id: "/recover-password",
  path: "/recover-password",
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: "/reset-password",
  path: "/reset-password",
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutIndexRoute = LayoutIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutAgentRouteRoute = LayoutAgentRouteRouteImport.update({
  id: "/agent",
  path: "/agent",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutAircraftRouteRoute = LayoutAircraftRouteRouteImport.update({
  id: "/aircraft",
  path: "/aircraft",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutAirworthinessDirectivesRouteRoute =
  LayoutAirworthinessDirectivesRouteRouteImport.update({
    id: "/airworthiness-directives",
    path: "/airworthiness-directives",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutApprovedVendorsRouteRoute =
  LayoutApprovedVendorsRouteRouteImport.update({
    id: "/approved-vendors",
    path: "/approved-vendors",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutCustomerRouteRoute = LayoutCustomerRouteRouteImport.update({
  id: "/customer",
  path: "/customer",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutDocumentsRouteRoute = LayoutDocumentsRouteRouteImport.update({
  id: "/documents",
  path: "/documents",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutForecastsRouteRoute = LayoutForecastsRouteRouteImport.update({
  id: "/forecasts",
  path: "/forecasts",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutInventoryRouteRoute = LayoutInventoryRouteRouteImport.update({
  id: "/inventory",
  path: "/inventory",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutMaintenanceProgrammesRouteRoute =
  LayoutMaintenanceProgrammesRouteRouteImport.update({
    id: "/maintenance-programmes",
    path: "/maintenance-programmes",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutPlanningRouteRoute = LayoutPlanningRouteRouteImport.update({
  id: "/planning",
  path: "/planning",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutQuotesRouteRoute = LayoutQuotesRouteRouteImport.update({
  id: "/quotes",
  path: "/quotes",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSettingsRouteRoute = LayoutSettingsRouteRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutTechLogsRouteRoute = LayoutTechLogsRouteRouteImport.update({
  id: "/tech-logs",
  path: "/tech-logs",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutTemplatesRouteRoute = LayoutTemplatesRouteRouteImport.update({
  id: "/templates",
  path: "/templates",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutTieInRouteRoute = LayoutTieInRouteRouteImport.update({
  id: "/tie-in",
  path: "/tie-in",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutTimesheetRouteRoute = LayoutTimesheetRouteRouteImport.update({
  id: "/timesheet",
  path: "/timesheet",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutToolsRouteRoute = LayoutToolsRouteRouteImport.update({
  id: "/tools",
  path: "/tools",
  getParentRoute: () => LayoutRoute,
} as any)
const ReviewTokenRouteRoute = ReviewTokenRouteRouteImport.update({
  id: "/review/$token",
  path: "/review/$token",
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutAgentIndexRoute = LayoutAgentIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutAgentRouteRoute,
} as any)
const LayoutAgentIdRoute = LayoutAgentIdRouteImport.update({
  id: "/$id",
  path: "/$id",
  getParentRoute: () => LayoutAgentRouteRoute,
} as any)
const LayoutAgentChatsRoute = LayoutAgentChatsRouteImport.update({
  id: "/chats",
  path: "/chats",
  getParentRoute: () => LayoutAgentRouteRoute,
} as any)
const LayoutAircraftIndexRoute = LayoutAircraftIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutAircraftRouteRoute,
} as any)
const LayoutAircraftAircraftIdRouteRoute =
  LayoutAircraftAircraftIdRouteRouteImport.update({
    id: "/aircraft_/$aircraftId",
    path: "/aircraft/$aircraftId",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutAircraftNewRoute = LayoutAircraftNewRouteImport.update({
  id: "/aircraft_/new",
  path: "/aircraft/new",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutAirworthinessDirectivesIndexRoute =
  LayoutAirworthinessDirectivesIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutAirworthinessDirectivesRouteRoute,
  } as any)
const LayoutAirworthinessDirectivesUploadRoute =
  LayoutAirworthinessDirectivesUploadRouteImport.update({
    id: "/upload",
    path: "/upload",
    getParentRoute: () => LayoutAirworthinessDirectivesRouteRoute,
  } as any)
const LayoutAirworthinessDirectivesDocumentIdRoute =
  LayoutAirworthinessDirectivesDocumentIdRouteImport.update({
    id: "/airworthiness-directives_/$documentId",
    path: "/airworthiness-directives/$documentId",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutApprovedVendorsIndexRoute =
  LayoutApprovedVendorsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutApprovedVendorsRouteRoute,
  } as any)
const LayoutApprovedVendorsVendorIdRoute =
  LayoutApprovedVendorsVendorIdRouteImport.update({
    id: "/approved-vendors_/$vendorId",
    path: "/approved-vendors/$vendorId",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutApprovedVendorsNewRoute =
  LayoutApprovedVendorsNewRouteImport.update({
    id: "/approved-vendors_/new",
    path: "/approved-vendors/new",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutCustomerIndexRoute = LayoutCustomerIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutCustomerRouteRoute,
} as any)
const LayoutCustomerCustomerIdRouteRoute =
  LayoutCustomerCustomerIdRouteRouteImport.update({
    id: "/customer_/$customerId",
    path: "/customer/$customerId",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutCustomerNewRoute = LayoutCustomerNewRouteImport.update({
  id: "/customer_/new",
  path: "/customer/new",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutDocumentsDocumentIdRoute =
  LayoutDocumentsDocumentIdRouteImport.update({
    id: "/$documentId",
    path: "/$documentId",
    getParentRoute: () => LayoutDocumentsRouteRoute,
  } as any)
const LayoutDocumentsListRouteRoute =
  LayoutDocumentsListRouteRouteImport.update({
    id: "/_list",
    getParentRoute: () => LayoutDocumentsRouteRoute,
  } as any)
const LayoutForecastsIndexRoute = LayoutForecastsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutForecastsRouteRoute,
} as any)
const LayoutForecastsNewRoute = LayoutForecastsNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => LayoutForecastsRouteRoute,
} as any)
const LayoutForecastsForecastIdRoute =
  LayoutForecastsForecastIdRouteImport.update({
    id: "/forecasts_/$forecastId",
    path: "/forecasts/$forecastId",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutForecastsPreviewRoute = LayoutForecastsPreviewRouteImport.update({
  id: "/forecasts_/preview",
  path: "/forecasts/preview",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutInventoryIndexRoute = LayoutInventoryIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutInventoryRouteRoute,
} as any)
const LayoutInventoryPartIdRouteRoute =
  LayoutInventoryPartIdRouteRouteImport.update({
    id: "/$partId",
    path: "/$partId",
    getParentRoute: () => LayoutInventoryRouteRoute,
  } as any)
const LayoutInventoryNewRoute = LayoutInventoryNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => LayoutInventoryRouteRoute,
} as any)
const LayoutInventoryPurchaseOrdersRouteRoute =
  LayoutInventoryPurchaseOrdersRouteRouteImport.update({
    id: "/inventory_/purchase-orders",
    path: "/inventory/purchase-orders",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutMaintenanceProgrammesIndexRoute =
  LayoutMaintenanceProgrammesIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutMaintenanceProgrammesRouteRoute,
  } as any)
const LayoutMaintenanceProgrammesNewRoute =
  LayoutMaintenanceProgrammesNewRouteImport.update({
    id: "/new",
    path: "/new",
    getParentRoute: () => LayoutMaintenanceProgrammesRouteRoute,
  } as any)
const LayoutMaintenanceProgrammesProgrammeIdRouteRoute =
  LayoutMaintenanceProgrammesProgrammeIdRouteRouteImport.update({
    id: "/maintenance-programmes_/$programmeId",
    path: "/maintenance-programmes/$programmeId",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutManpowerIndexRoute = LayoutManpowerIndexRouteImport.update({
  id: "/manpower/",
  path: "/manpower/",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutPlanningIndexRoute = LayoutPlanningIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutPlanningRouteRoute,
} as any)
const LayoutPlanningPlanIdRouteRoute =
  LayoutPlanningPlanIdRouteRouteImport.update({
    id: "/planning_/$planId",
    path: "/planning/$planId",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutQuotesIndexRoute = LayoutQuotesIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutQuotesRouteRoute,
} as any)
const LayoutQuotesCreateRoute = LayoutQuotesCreateRouteImport.update({
  id: "/create",
  path: "/create",
  getParentRoute: () => LayoutQuotesRouteRoute,
} as any)
const LayoutQuotesFromFileRoute = LayoutQuotesFromFileRouteImport.update({
  id: "/from-file",
  path: "/from-file",
  getParentRoute: () => LayoutQuotesRouteRoute,
} as any)
const LayoutQuotesQuoteIdRouteRoute =
  LayoutQuotesQuoteIdRouteRouteImport.update({
    id: "/quotes_/$quoteId",
    path: "/quotes/$quoteId",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutQuotingIndexRoute = LayoutQuotingIndexRouteImport.update({
  id: "/quoting/",
  path: "/quoting/",
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutQuotingEmailsRouteRoute =
  LayoutQuotingEmailsRouteRouteImport.update({
    id: "/quoting_/emails",
    path: "/quoting/emails",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutQuotingSquawksRouteRoute =
  LayoutQuotingSquawksRouteRouteImport.update({
    id: "/quoting_/squawks",
    path: "/quoting/squawks",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutSettingsIndexRoute = LayoutSettingsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutSettingsRouteRoute,
} as any)
const LayoutSettingsPanelRouteRoute =
  LayoutSettingsPanelRouteRouteImport.update({
    id: "/_panel",
    getParentRoute: () => LayoutSettingsRouteRoute,
  } as any)
const LayoutSettingsCompanyRoute = LayoutSettingsCompanyRouteImport.update({
  id: "/company",
  path: "/company",
  getParentRoute: () => LayoutSettingsRouteRoute,
} as any)
const LayoutSettingsSystemRoute = LayoutSettingsSystemRouteImport.update({
  id: "/system",
  path: "/system",
  getParentRoute: () => LayoutSettingsRouteRoute,
} as any)
const LayoutSettingsUserRoute = LayoutSettingsUserRouteImport.update({
  id: "/user",
  path: "/user",
  getParentRoute: () => LayoutSettingsRouteRoute,
} as any)
const LayoutTechLogsIndexRoute = LayoutTechLogsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutTechLogsRouteRoute,
} as any)
const LayoutTechLogsPageIdRoute = LayoutTechLogsPageIdRouteImport.update({
  id: "/$pageId",
  path: "/$pageId",
  getParentRoute: () => LayoutTechLogsRouteRoute,
} as any)
const LayoutTechLogsNewRoute = LayoutTechLogsNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => LayoutTechLogsRouteRoute,
} as any)
const LayoutTemplatesIndexRoute = LayoutTemplatesIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutTemplatesRouteRoute,
} as any)
const LayoutTemplatesQuotesRouteRoute =
  LayoutTemplatesQuotesRouteRouteImport.update({
    id: "/quotes",
    path: "/quotes",
    getParentRoute: () => LayoutTemplatesRouteRoute,
  } as any)
const LayoutTemplatesTasksRouteRoute =
  LayoutTemplatesTasksRouteRouteImport.update({
    id: "/tasks",
    path: "/tasks",
    getParentRoute: () => LayoutTemplatesRouteRoute,
  } as any)
const LayoutTimesheetIndexRoute = LayoutTimesheetIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutTimesheetRouteRoute,
} as any)
const LayoutTimesheetLogRoute = LayoutTimesheetLogRouteImport.update({
  id: "/log",
  path: "/log",
  getParentRoute: () => LayoutTimesheetRouteRoute,
} as any)
const LayoutToolsIndexRoute = LayoutToolsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutToolsRouteRoute,
} as any)
const LayoutToolsToolIdRouteRoute = LayoutToolsToolIdRouteRouteImport.update({
  id: "/$toolId",
  path: "/$toolId",
  getParentRoute: () => LayoutToolsRouteRoute,
} as any)
const LayoutToolsNewRoute = LayoutToolsNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => LayoutToolsRouteRoute,
} as any)
const LayoutWorkOrdersWorkOrderIdRouteRoute =
  LayoutWorkOrdersWorkOrderIdRouteRouteImport.update({
    id: "/work-orders/$workOrderId",
    path: "/work-orders/$workOrderId",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWorkOrdersListRouteRoute =
  LayoutWorkOrdersListRouteRouteImport.update({
    id: "/work-orders/_list",
    path: "/work-orders",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWorkTaskIdRoute = LayoutWorkTaskIdRouteImport.update({
  id: "/work-task/$id",
  path: "/work-task/$id",
  getParentRoute: () => LayoutRoute,
} as any)
const ReviewTokenIndexRoute = ReviewTokenIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => ReviewTokenRouteRoute,
} as any)
const ReviewTokenSignRoute = ReviewTokenSignRouteImport.update({
  id: "/sign",
  path: "/sign",
  getParentRoute: () => ReviewTokenRouteRoute,
} as any)
const LayoutAgentDeleteIdRoute = LayoutAgentDeleteIdRouteImport.update({
  id: "/delete/$id",
  path: "/delete/$id",
  getParentRoute: () => LayoutAgentRouteRoute,
} as any)
const LayoutAircraftAircraftIdIndexRoute =
  LayoutAircraftAircraftIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutAircraftAircraftIdRouteRoute,
  } as any)
const LayoutAircraftAircraftIdEditRoute =
  LayoutAircraftAircraftIdEditRouteImport.update({
    id: "/aircraft_/$aircraftId_/edit",
    path: "/aircraft/$aircraftId/edit",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutAirworthinessDirectivesDeleteDocumentIdRoute =
  LayoutAirworthinessDirectivesDeleteDocumentIdRouteImport.update({
    id: "/delete/$documentId",
    path: "/delete/$documentId",
    getParentRoute: () => LayoutAirworthinessDirectivesRouteRoute,
  } as any)
const LayoutApprovedVendorsDeleteVendorIdRoute =
  LayoutApprovedVendorsDeleteVendorIdRouteImport.update({
    id: "/delete/$vendorId",
    path: "/delete/$vendorId",
    getParentRoute: () => LayoutApprovedVendorsRouteRoute,
  } as any)
const LayoutApprovedVendorsDeleteBulkRoute =
  LayoutApprovedVendorsDeleteBulkRouteImport.update({
    id: "/delete/bulk",
    path: "/delete/bulk",
    getParentRoute: () => LayoutApprovedVendorsRouteRoute,
  } as any)
const LayoutAssessmentsAdReportIdRoute =
  LayoutAssessmentsAdReportIdRouteImport.update({
    id: "/assessments/ad/$reportId",
    path: "/assessments/ad/$reportId",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutAssessmentsSbReportIdRoute =
  LayoutAssessmentsSbReportIdRouteImport.update({
    id: "/assessments/sb/$reportId",
    path: "/assessments/sb/$reportId",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutCustomerDeleteCustomerIdRoute =
  LayoutCustomerDeleteCustomerIdRouteImport.update({
    id: "/delete/$customerId",
    path: "/delete/$customerId",
    getParentRoute: () => LayoutCustomerRouteRoute,
  } as any)
const LayoutCustomerCustomerIdIndexRoute =
  LayoutCustomerCustomerIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutCustomerCustomerIdRouteRoute,
  } as any)
const LayoutCustomerCustomerIdAircraftRoute =
  LayoutCustomerCustomerIdAircraftRouteImport.update({
    id: "/aircraft",
    path: "/aircraft",
    getParentRoute: () => LayoutCustomerCustomerIdRouteRoute,
  } as any)
const LayoutCustomerCustomerIdContactsRouteRoute =
  LayoutCustomerCustomerIdContactsRouteRouteImport.update({
    id: "/contacts",
    path: "/contacts",
    getParentRoute: () => LayoutCustomerCustomerIdRouteRoute,
  } as any)
const LayoutCustomerCustomerIdDeleteRoute =
  LayoutCustomerCustomerIdDeleteRouteImport.update({
    id: "/delete",
    path: "/delete",
    getParentRoute: () => LayoutCustomerCustomerIdRouteRoute,
  } as any)
const LayoutCustomerCustomerIdWoHistoryRoute =
  LayoutCustomerCustomerIdWoHistoryRouteImport.update({
    id: "/wo-history",
    path: "/wo-history",
    getParentRoute: () => LayoutCustomerCustomerIdRouteRoute,
  } as any)
const LayoutDocumentsListIndexRoute =
  LayoutDocumentsListIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutDocumentsListRouteRoute,
  } as any)
const LayoutDocumentsListUploadRouteRoute =
  LayoutDocumentsListUploadRouteRouteImport.update({
    id: "/upload",
    path: "/upload",
    getParentRoute: () => LayoutDocumentsListRouteRoute,
  } as any)
const LayoutForecastsDeleteForecastIdRoute =
  LayoutForecastsDeleteForecastIdRouteImport.update({
    id: "/delete/$forecastId",
    path: "/delete/$forecastId",
    getParentRoute: () => LayoutForecastsRouteRoute,
  } as any)
const LayoutInventoryPartIdIndexRoute =
  LayoutInventoryPartIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutInventoryPartIdRouteRoute,
  } as any)
const LayoutInventoryPartIdArchiveRoute =
  LayoutInventoryPartIdArchiveRouteImport.update({
    id: "/archive",
    path: "/archive",
    getParentRoute: () => LayoutInventoryPartIdRouteRoute,
  } as any)
const LayoutInventoryDeletePartIdRoute =
  LayoutInventoryDeletePartIdRouteImport.update({
    id: "/delete/$partId",
    path: "/delete/$partId",
    getParentRoute: () => LayoutInventoryRouteRoute,
  } as any)
const LayoutInventoryDeleteBulkRoute =
  LayoutInventoryDeleteBulkRouteImport.update({
    id: "/delete/bulk",
    path: "/delete/bulk",
    getParentRoute: () => LayoutInventoryRouteRoute,
  } as any)
const LayoutInventoryPurchaseOrdersIndexRoute =
  LayoutInventoryPurchaseOrdersIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutInventoryPurchaseOrdersRouteRoute,
  } as any)
const LayoutInventoryPurchaseOrdersPurchaseOrderIdRoute =
  LayoutInventoryPurchaseOrdersPurchaseOrderIdRouteImport.update({
    id: "/$purchaseOrderId",
    path: "/$purchaseOrderId",
    getParentRoute: () => LayoutInventoryPurchaseOrdersRouteRoute,
  } as any)
const LayoutInventoryPurchaseOrdersNewRoute =
  LayoutInventoryPurchaseOrdersNewRouteImport.update({
    id: "/new",
    path: "/new",
    getParentRoute: () => LayoutInventoryPurchaseOrdersRouteRoute,
  } as any)
const LayoutMaintenanceProgrammesDeleteProgrammeIdRoute =
  LayoutMaintenanceProgrammesDeleteProgrammeIdRouteImport.update({
    id: "/delete/$programmeId",
    path: "/delete/$programmeId",
    getParentRoute: () => LayoutMaintenanceProgrammesRouteRoute,
  } as any)
const LayoutMaintenanceProgrammesProgrammeIdIndexRoute =
  LayoutMaintenanceProgrammesProgrammeIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutMaintenanceProgrammesProgrammeIdRouteRoute,
  } as any)
const LayoutPlanningNewForecastRoute =
  LayoutPlanningNewForecastRouteImport.update({
    id: "/new/forecast",
    path: "/new/forecast",
    getParentRoute: () => LayoutPlanningRouteRoute,
  } as any)
const LayoutPlanningNewQuoteRoute = LayoutPlanningNewQuoteRouteImport.update({
  id: "/new/quote",
  path: "/new/quote",
  getParentRoute: () => LayoutPlanningRouteRoute,
} as any)
const LayoutPlanningPlanIdIndexRoute =
  LayoutPlanningPlanIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutPlanningPlanIdRouteRoute,
  } as any)
const LayoutQuotesDeleteQuoteIdRoute =
  LayoutQuotesDeleteQuoteIdRouteImport.update({
    id: "/delete/$quoteId",
    path: "/delete/$quoteId",
    getParentRoute: () => LayoutQuotesRouteRoute,
  } as any)
const LayoutQuotesQuoteIdIndexRoute =
  LayoutQuotesQuoteIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutQuotesQuoteIdRouteRoute,
  } as any)
const LayoutQuotesQuoteIdCorridorRoute =
  LayoutQuotesQuoteIdCorridorRouteImport.update({
    id: "/corridor",
    path: "/corridor",
    getParentRoute: () => LayoutQuotesQuoteIdRouteRoute,
  } as any)
const LayoutQuotesQuoteIdSendRoute = LayoutQuotesQuoteIdSendRouteImport.update({
  id: "/send",
  path: "/send",
  getParentRoute: () => LayoutQuotesQuoteIdRouteRoute,
} as any)
const LayoutQuotesQuoteIdSentRoute = LayoutQuotesQuoteIdSentRouteImport.update({
  id: "/sent",
  path: "/sent",
  getParentRoute: () => LayoutQuotesQuoteIdRouteRoute,
} as any)
const LayoutQuotingCannedIndexRoute =
  LayoutQuotingCannedIndexRouteImport.update({
    id: "/quoting/canned/",
    path: "/quoting/canned/",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutQuotingCannedPackageIdRoute =
  LayoutQuotingCannedPackageIdRouteImport.update({
    id: "/quoting/canned/$packageId",
    path: "/quoting/canned/$packageId",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutQuotingEmailsListRouteRoute =
  LayoutQuotingEmailsListRouteRouteImport.update({
    id: "/_list",
    getParentRoute: () => LayoutQuotingEmailsRouteRoute,
  } as any)
const LayoutQuotingQuotesIndexRoute =
  LayoutQuotingQuotesIndexRouteImport.update({
    id: "/quoting_/quotes/",
    path: "/quoting/quotes/",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutQuotingQuotesQuoteIdRoute =
  LayoutQuotingQuotesQuoteIdRouteImport.update({
    id: "/quoting_/quotes/$quoteId",
    path: "/quoting/quotes/$quoteId",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutQuotingSquawksIndexRoute =
  LayoutQuotingSquawksIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutQuotingSquawksRouteRoute,
  } as any)
const LayoutQuotingSquawksSquawkIdRoute =
  LayoutQuotingSquawksSquawkIdRouteImport.update({
    id: "/$squawkId",
    path: "/$squawkId",
    getParentRoute: () => LayoutQuotingSquawksRouteRoute,
  } as any)
const LayoutTechLogsDeletePageIdRoute =
  LayoutTechLogsDeletePageIdRouteImport.update({
    id: "/delete/$pageId",
    path: "/delete/$pageId",
    getParentRoute: () => LayoutTechLogsRouteRoute,
  } as any)
const LayoutTemplatesQuotesIndexRoute =
  LayoutTemplatesQuotesIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutTemplatesQuotesRouteRoute,
  } as any)
const LayoutTemplatesQuotesDeleteRoute =
  LayoutTemplatesQuotesDeleteRouteImport.update({
    id: "/delete",
    path: "/delete",
    getParentRoute: () => LayoutTemplatesQuotesRouteRoute,
  } as any)
const LayoutTemplatesQuotesPackageIdRouteRoute =
  LayoutTemplatesQuotesPackageIdRouteRouteImport.update({
    id: "/quotes_/$packageId",
    path: "/quotes/$packageId",
    getParentRoute: () => LayoutTemplatesRouteRoute,
  } as any)
const LayoutTemplatesTasksIndexRoute =
  LayoutTemplatesTasksIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutTemplatesTasksRouteRoute,
  } as any)
const LayoutTemplatesTasksTaskIdRouteRoute =
  LayoutTemplatesTasksTaskIdRouteRouteImport.update({
    id: "/$taskId",
    path: "/$taskId",
    getParentRoute: () => LayoutTemplatesTasksRouteRoute,
  } as any)
const LayoutTemplatesTasksCreateRoute =
  LayoutTemplatesTasksCreateRouteImport.update({
    id: "/create",
    path: "/create",
    getParentRoute: () => LayoutTemplatesTasksRouteRoute,
  } as any)
const LayoutTemplatesTasksDeleteRoute =
  LayoutTemplatesTasksDeleteRouteImport.update({
    id: "/delete",
    path: "/delete",
    getParentRoute: () => LayoutTemplatesTasksRouteRoute,
  } as any)
const LayoutTimesheetDeleteTimeEntryIdRoute =
  LayoutTimesheetDeleteTimeEntryIdRouteImport.update({
    id: "/delete/$timeEntryId",
    path: "/delete/$timeEntryId",
    getParentRoute: () => LayoutTimesheetRouteRoute,
  } as any)
const LayoutToolsToolIdIndexRoute = LayoutToolsToolIdIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LayoutToolsToolIdRouteRoute,
} as any)
const LayoutToolsToolIdIssueRoute = LayoutToolsToolIdIssueRouteImport.update({
  id: "/issue",
  path: "/issue",
  getParentRoute: () => LayoutToolsToolIdRouteRoute,
} as any)
const LayoutToolsToolIdLabelRoute = LayoutToolsToolIdLabelRouteImport.update({
  id: "/label",
  path: "/label",
  getParentRoute: () => LayoutToolsToolIdRouteRoute,
} as any)
const LayoutToolsToolIdRetireRoute = LayoutToolsToolIdRetireRouteImport.update({
  id: "/retire",
  path: "/retire",
  getParentRoute: () => LayoutToolsToolIdRouteRoute,
} as any)
const LayoutWorkOrdersWorkOrderIdIndexRoute =
  LayoutWorkOrdersWorkOrderIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutWorkOrdersWorkOrderIdRouteRoute,
  } as any)
const LayoutWorkOrdersWorkOrderIdCancelRoute =
  LayoutWorkOrdersWorkOrderIdCancelRouteImport.update({
    id: "/cancel",
    path: "/cancel",
    getParentRoute: () => LayoutWorkOrdersWorkOrderIdRouteRoute,
  } as any)
const LayoutWorkOrdersWorkOrderIdCloseRoute =
  LayoutWorkOrdersWorkOrderIdCloseRouteImport.update({
    id: "/close",
    path: "/close",
    getParentRoute: () => LayoutWorkOrdersWorkOrderIdRouteRoute,
  } as any)
const LayoutWorkOrdersListIndexRoute =
  LayoutWorkOrdersListIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutWorkOrdersListRouteRoute,
  } as any)
const LayoutAgentChatsDeleteIdRoute =
  LayoutAgentChatsDeleteIdRouteImport.update({
    id: "/delete/$id",
    path: "/delete/$id",
    getParentRoute: () => LayoutAgentChatsRoute,
  } as any)
const LayoutAircraftAircraftIdFittedComponentsNewRoute =
  LayoutAircraftAircraftIdFittedComponentsNewRouteImport.update({
    id: "/fitted-components/new",
    path: "/fitted-components/new",
    getParentRoute: () => LayoutAircraftAircraftIdRouteRoute,
  } as any)
const LayoutAircraftAircraftIdModStatusNewRoute =
  LayoutAircraftAircraftIdModStatusNewRouteImport.update({
    id: "/mod-status/new",
    path: "/mod-status/new",
    getParentRoute: () => LayoutAircraftAircraftIdRouteRoute,
  } as any)
const LayoutAircraftAircraftIdReadingsNewRoute =
  LayoutAircraftAircraftIdReadingsNewRouteImport.update({
    id: "/readings/new",
    path: "/readings/new",
    getParentRoute: () => LayoutAircraftAircraftIdRouteRoute,
  } as any)
const LayoutAircraftAircraftIdTechLogPageIdRoute =
  LayoutAircraftAircraftIdTechLogPageIdRouteImport.update({
    id: "/tech-log/$pageId",
    path: "/tech-log/$pageId",
    getParentRoute: () => LayoutAircraftAircraftIdRouteRoute,
  } as any)
const LayoutAircraftAircraftIdTechLogNewRoute =
  LayoutAircraftAircraftIdTechLogNewRouteImport.update({
    id: "/tech-log/new",
    path: "/tech-log/new",
    getParentRoute: () => LayoutAircraftAircraftIdRouteRoute,
  } as any)
const LayoutCustomerCustomerIdContactsListRouteRoute =
  LayoutCustomerCustomerIdContactsListRouteRouteImport.update({
    id: "/_list",
    getParentRoute: () => LayoutCustomerCustomerIdContactsRouteRoute,
  } as any)
const LayoutCustomerCustomerIdContactsCreateRoute =
  LayoutCustomerCustomerIdContactsCreateRouteImport.update({
    id: "/create",
    path: "/create",
    getParentRoute: () => LayoutCustomerCustomerIdContactsRouteRoute,
  } as any)
const LayoutDocumentsListDeleteDocumentIdRoute =
  LayoutDocumentsListDeleteDocumentIdRouteImport.update({
    id: "/delete/$documentId",
    path: "/delete/$documentId",
    getParentRoute: () => LayoutDocumentsListRouteRoute,
  } as any)
const LayoutDocumentsListDeleteBulkRoute =
  LayoutDocumentsListDeleteBulkRouteImport.update({
    id: "/delete/bulk",
    path: "/delete/bulk",
    getParentRoute: () => LayoutDocumentsListRouteRoute,
  } as any)
const LayoutDocumentsListMakePrivateDocumentIdRoute =
  LayoutDocumentsListMakePrivateDocumentIdRouteImport.update({
    id: "/make-private/$documentId",
    path: "/make-private/$documentId",
    getParentRoute: () => LayoutDocumentsListRouteRoute,
  } as any)
const LayoutDocumentsListShareDocumentIdRoute =
  LayoutDocumentsListShareDocumentIdRouteImport.update({
    id: "/share/$documentId",
    path: "/share/$documentId",
    getParentRoute: () => LayoutDocumentsListRouteRoute,
  } as any)
const LayoutDocumentsListShareBulkRoute =
  LayoutDocumentsListShareBulkRouteImport.update({
    id: "/share/bulk",
    path: "/share/bulk",
    getParentRoute: () => LayoutDocumentsListRouteRoute,
  } as any)
const LayoutMaintenanceProgrammesProgrammeIdAircraftEnrolRoute =
  LayoutMaintenanceProgrammesProgrammeIdAircraftEnrolRouteImport.update({
    id: "/aircraft/enrol",
    path: "/aircraft/enrol",
    getParentRoute: () => LayoutMaintenanceProgrammesProgrammeIdRouteRoute,
  } as any)
const LayoutMaintenanceProgrammesProgrammeIdPhasesPhaseIdRoute =
  LayoutMaintenanceProgrammesProgrammeIdPhasesPhaseIdRouteImport.update({
    id: "/phases/$phaseId",
    path: "/phases/$phaseId",
    getParentRoute: () => LayoutMaintenanceProgrammesProgrammeIdRouteRoute,
  } as any)
const LayoutMaintenanceProgrammesProgrammeIdPhasesNewRoute =
  LayoutMaintenanceProgrammesProgrammeIdPhasesNewRouteImport.update({
    id: "/phases/new",
    path: "/phases/new",
    getParentRoute: () => LayoutMaintenanceProgrammesProgrammeIdRouteRoute,
  } as any)
const LayoutMaintenanceProgrammesProgrammeIdRevisionsNewRoute =
  LayoutMaintenanceProgrammesProgrammeIdRevisionsNewRouteImport.update({
    id: "/revisions/new",
    path: "/revisions/new",
    getParentRoute: () => LayoutMaintenanceProgrammesProgrammeIdRouteRoute,
  } as any)
const LayoutMaintenanceProgrammesProgrammeIdTasksTaskIdRoute =
  LayoutMaintenanceProgrammesProgrammeIdTasksTaskIdRouteImport.update({
    id: "/tasks/$taskId",
    path: "/tasks/$taskId",
    getParentRoute: () => LayoutMaintenanceProgrammesProgrammeIdRouteRoute,
  } as any)
const LayoutMaintenanceProgrammesProgrammeIdTasksNewRoute =
  LayoutMaintenanceProgrammesProgrammeIdTasksNewRouteImport.update({
    id: "/tasks/new",
    path: "/tasks/new",
    getParentRoute: () => LayoutMaintenanceProgrammesProgrammeIdRouteRoute,
  } as any)
const LayoutQuotesQuoteIdPhasesNewRoute =
  LayoutQuotesQuoteIdPhasesNewRouteImport.update({
    id: "/phases/new",
    path: "/phases/new",
    getParentRoute: () => LayoutQuotesQuoteIdRouteRoute,
  } as any)
const LayoutQuotesQuoteIdTasksTaskIdRouteRoute =
  LayoutQuotesQuoteIdTasksTaskIdRouteRouteImport.update({
    id: "/tasks/$taskId",
    path: "/tasks/$taskId",
    getParentRoute: () => LayoutQuotesQuoteIdRouteRoute,
  } as any)
const LayoutQuotesQuoteIdTasksFromTemplateRoute =
  LayoutQuotesQuoteIdTasksFromTemplateRouteImport.update({
    id: "/tasks/from-template",
    path: "/tasks/from-template",
    getParentRoute: () => LayoutQuotesQuoteIdRouteRoute,
  } as any)
const LayoutQuotingEmailsListIndexRoute =
  LayoutQuotingEmailsListIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutQuotingEmailsListRouteRoute,
  } as any)
const LayoutQuotingEmailsListEmailIdRouteRoute =
  LayoutQuotingEmailsListEmailIdRouteRouteImport.update({
    id: "/$emailId",
    path: "/$emailId",
    getParentRoute: () => LayoutQuotingEmailsListRouteRoute,
  } as any)
const LayoutQuotingSquawksDeleteSquawkIdRoute =
  LayoutQuotingSquawksDeleteSquawkIdRouteImport.update({
    id: "/delete/$squawkId",
    path: "/delete/$squawkId",
    getParentRoute: () => LayoutQuotingSquawksRouteRoute,
  } as any)
const LayoutQuotingSquawksEditSquawkIdRoute =
  LayoutQuotingSquawksEditSquawkIdRouteImport.update({
    id: "/edit/$squawkId",
    path: "/edit/$squawkId",
    getParentRoute: () => LayoutQuotingSquawksRouteRoute,
  } as any)
const LayoutSettingsPanelAccountProfileRouteRoute =
  LayoutSettingsPanelAccountProfileRouteRouteImport.update({
    id: "/account/profile",
    path: "/account/profile",
    getParentRoute: () => LayoutSettingsPanelRouteRoute,
  } as any)
const LayoutSettingsPanelIntegrationsCrmRoute =
  LayoutSettingsPanelIntegrationsCrmRouteImport.update({
    id: "/integrations/crm",
    path: "/integrations/crm",
    getParentRoute: () => LayoutSettingsPanelRouteRoute,
  } as any)
const LayoutSettingsPanelIntegrationsErpRouteRoute =
  LayoutSettingsPanelIntegrationsErpRouteRouteImport.update({
    id: "/integrations/erp",
    path: "/integrations/erp",
    getParentRoute: () => LayoutSettingsPanelRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingCustomerApprovalRoute =
  LayoutSettingsPanelQuotingCustomerApprovalRouteImport.update({
    id: "/quoting/customer-approval",
    path: "/quoting/customer-approval",
    getParentRoute: () => LayoutSettingsPanelRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingGeneralRoute =
  LayoutSettingsPanelQuotingGeneralRouteImport.update({
    id: "/quoting/general",
    path: "/quoting/general",
    getParentRoute: () => LayoutSettingsPanelRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingPlaybooksRouteRoute =
  LayoutSettingsPanelQuotingPlaybooksRouteRouteImport.update({
    id: "/quoting/playbooks",
    path: "/quoting/playbooks",
    getParentRoute: () => LayoutSettingsPanelRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingRateCardsRouteRoute =
  LayoutSettingsPanelQuotingRateCardsRouteRouteImport.update({
    id: "/quoting/rate-cards",
    path: "/quoting/rate-cards",
    getParentRoute: () => LayoutSettingsPanelRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingStatusRouteRoute =
  LayoutSettingsPanelQuotingStatusRouteRouteImport.update({
    id: "/quoting/status",
    path: "/quoting/status",
    getParentRoute: () => LayoutSettingsPanelRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingTaskGroupsRouteRoute =
  LayoutSettingsPanelQuotingTaskGroupsRouteRouteImport.update({
    id: "/quoting/task-groups",
    path: "/quoting/task-groups",
    getParentRoute: () => LayoutSettingsPanelRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingTaxRatesRouteRoute =
  LayoutSettingsPanelQuotingTaxRatesRouteRouteImport.update({
    id: "/quoting/tax-rates",
    path: "/quoting/tax-rates",
    getParentRoute: () => LayoutSettingsPanelRouteRoute,
  } as any)
const LayoutSettingsPanelWorkOrdersGeneralRoute =
  LayoutSettingsPanelWorkOrdersGeneralRouteImport.update({
    id: "/work-orders/general",
    path: "/work-orders/general",
    getParentRoute: () => LayoutSettingsPanelRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceApprovalFlowsRouteRoute =
  LayoutSettingsPanelWorkspaceApprovalFlowsRouteRouteImport.update({
    id: "/workspace/approval-flows",
    path: "/workspace/approval-flows",
    getParentRoute: () => LayoutSettingsPanelRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceDepartmentsRouteRoute =
  LayoutSettingsPanelWorkspaceDepartmentsRouteRouteImport.update({
    id: "/workspace/departments",
    path: "/workspace/departments",
    getParentRoute: () => LayoutSettingsPanelRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceFacilitiesRouteRoute =
  LayoutSettingsPanelWorkspaceFacilitiesRouteRouteImport.update({
    id: "/workspace/facilities",
    path: "/workspace/facilities",
    getParentRoute: () => LayoutSettingsPanelRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceMembersRouteRoute =
  LayoutSettingsPanelWorkspaceMembersRouteRouteImport.update({
    id: "/workspace/members",
    path: "/workspace/members",
    getParentRoute: () => LayoutSettingsPanelRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceNotificationRulesRouteRoute =
  LayoutSettingsPanelWorkspaceNotificationRulesRouteRouteImport.update({
    id: "/workspace/notification-rules",
    path: "/workspace/notification-rules",
    getParentRoute: () => LayoutSettingsPanelRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceRolesRouteRoute =
  LayoutSettingsPanelWorkspaceRolesRouteRouteImport.update({
    id: "/workspace/roles",
    path: "/workspace/roles",
    getParentRoute: () => LayoutSettingsPanelRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceTeamsRouteRoute =
  LayoutSettingsPanelWorkspaceTeamsRouteRouteImport.update({
    id: "/workspace/teams",
    path: "/workspace/teams",
    getParentRoute: () => LayoutSettingsPanelRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceTemplatesRouteRoute =
  LayoutSettingsPanelWorkspaceTemplatesRouteRouteImport.update({
    id: "/workspace/templates",
    path: "/workspace/templates",
    getParentRoute: () => LayoutSettingsPanelRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceToolCategoriesRouteRoute =
  LayoutSettingsPanelWorkspaceToolCategoriesRouteRouteImport.update({
    id: "/workspace/tool-categories",
    path: "/workspace/tool-categories",
    getParentRoute: () => LayoutSettingsPanelRouteRoute,
  } as any)
const LayoutSettingsSystemAuditLogIndexRoute =
  LayoutSettingsSystemAuditLogIndexRouteImport.update({
    id: "/system_/audit-log/",
    path: "/system/audit-log/",
    getParentRoute: () => LayoutSettingsRouteRoute,
  } as any)
const LayoutSettingsSystemTenantsTenantIdRouteRoute =
  LayoutSettingsSystemTenantsTenantIdRouteRouteImport.update({
    id: "/system_/tenants/$tenantId",
    path: "/system/tenants/$tenantId",
    getParentRoute: () => LayoutSettingsRouteRoute,
  } as any)
const LayoutTemplatesQuotesPackageIdListRouteRoute =
  LayoutTemplatesQuotesPackageIdListRouteRouteImport.update({
    id: "/_list",
    getParentRoute: () => LayoutTemplatesQuotesPackageIdRouteRoute,
  } as any)
const LayoutTemplatesQuotesPackageIdOverviewRouteRoute =
  LayoutTemplatesQuotesPackageIdOverviewRouteRouteImport.update({
    id: "/overview",
    path: "/overview",
    getParentRoute: () => LayoutTemplatesQuotesPackageIdRouteRoute,
  } as any)
const LayoutTemplatesTasksTaskIdIndexRoute =
  LayoutTemplatesTasksTaskIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutTemplatesTasksTaskIdRouteRoute,
  } as any)
const LayoutTemplatesTasksTaskIdArchiveRoute =
  LayoutTemplatesTasksTaskIdArchiveRouteImport.update({
    id: "/archive",
    path: "/archive",
    getParentRoute: () => LayoutTemplatesTasksTaskIdRouteRoute,
  } as any)
const LayoutToolsToolIdCalibrationsRecordRoute =
  LayoutToolsToolIdCalibrationsRecordRouteImport.update({
    id: "/calibrations/record",
    path: "/calibrations/record",
    getParentRoute: () => LayoutToolsToolIdRouteRoute,
  } as any)
const LayoutToolsToolIdCalibrationsSendRoute =
  LayoutToolsToolIdCalibrationsSendRouteImport.update({
    id: "/calibrations/send",
    path: "/calibrations/send",
    getParentRoute: () => LayoutToolsToolIdRouteRoute,
  } as any)
const LayoutTraceSandboxConversationSessionIdSplatRoute =
  LayoutTraceSandboxConversationSessionIdSplatRouteImport.update({
    id: "/trace/sandbox/$conversationSessionId/$",
    path: "/trace/sandbox/$conversationSessionId/$",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutWorkOrdersWorkOrderIdPhasesNewRoute =
  LayoutWorkOrdersWorkOrderIdPhasesNewRouteImport.update({
    id: "/phases/new",
    path: "/phases/new",
    getParentRoute: () => LayoutWorkOrdersWorkOrderIdRouteRoute,
  } as any)
const LayoutWorkOrdersWorkOrderIdSquawksSquawkIdRoute =
  LayoutWorkOrdersWorkOrderIdSquawksSquawkIdRouteImport.update({
    id: "/squawks/$squawkId",
    path: "/squawks/$squawkId",
    getParentRoute: () => LayoutWorkOrdersWorkOrderIdRouteRoute,
  } as any)
const LayoutWorkOrdersWorkOrderIdTasksTaskIdRoute =
  LayoutWorkOrdersWorkOrderIdTasksTaskIdRouteImport.update({
    id: "/tasks/$taskId",
    path: "/tasks/$taskId",
    getParentRoute: () => LayoutWorkOrdersWorkOrderIdRouteRoute,
  } as any)
const LayoutWorkOrdersWorkOrderIdTasksDeleteRoute =
  LayoutWorkOrdersWorkOrderIdTasksDeleteRouteImport.update({
    id: "/tasks/delete",
    path: "/tasks/delete",
    getParentRoute: () => LayoutWorkOrdersWorkOrderIdRouteRoute,
  } as any)
const LayoutWorkOrdersWorkOrderIdTasksNewRoute =
  LayoutWorkOrdersWorkOrderIdTasksNewRouteImport.update({
    id: "/tasks/new",
    path: "/tasks/new",
    getParentRoute: () => LayoutWorkOrdersWorkOrderIdRouteRoute,
  } as any)
const LayoutWorkOrdersListDeleteWorkOrderIdRoute =
  LayoutWorkOrdersListDeleteWorkOrderIdRouteImport.update({
    id: "/delete/$workOrderId",
    path: "/delete/$workOrderId",
    getParentRoute: () => LayoutWorkOrdersListRouteRoute,
  } as any)
const LayoutAircraftAircraftIdFittedComponentsRemoveComponentIdRoute =
  LayoutAircraftAircraftIdFittedComponentsRemoveComponentIdRouteImport.update({
    id: "/fitted-components/remove/$componentId",
    path: "/fitted-components/remove/$componentId",
    getParentRoute: () => LayoutAircraftAircraftIdRouteRoute,
  } as any)
const LayoutAircraftAircraftIdTechLogVoidPageIdRoute =
  LayoutAircraftAircraftIdTechLogVoidPageIdRouteImport.update({
    id: "/tech-log/void/$pageId",
    path: "/tech-log/void/$pageId",
    getParentRoute: () => LayoutAircraftAircraftIdRouteRoute,
  } as any)
const LayoutCustomerCustomerIdContactsListIndexRoute =
  LayoutCustomerCustomerIdContactsListIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutCustomerCustomerIdContactsListRouteRoute,
  } as any)
const LayoutCustomerCustomerIdContactsListContactIdRouteRoute =
  LayoutCustomerCustomerIdContactsListContactIdRouteRouteImport.update({
    id: "/$contactId",
    path: "/$contactId",
    getParentRoute: () => LayoutCustomerCustomerIdContactsListRouteRoute,
  } as any)
const LayoutInventoryPartIdPricesPriceIdDeleteRoute =
  LayoutInventoryPartIdPricesPriceIdDeleteRouteImport.update({
    id: "/prices/$priceId/delete",
    path: "/prices/$priceId/delete",
    getParentRoute: () => LayoutInventoryPartIdRouteRoute,
  } as any)
const LayoutMaintenanceProgrammesProgrammeIdAircraftRemoveEnrolmentIdRoute =
  LayoutMaintenanceProgrammesProgrammeIdAircraftRemoveEnrolmentIdRouteImport.update(
    {
      id: "/aircraft/remove/$enrolmentId",
      path: "/aircraft/remove/$enrolmentId",
      getParentRoute: () => LayoutMaintenanceProgrammesProgrammeIdRouteRoute,
    } as any,
  )
const LayoutMaintenanceProgrammesProgrammeIdPhasesRemovePhaseIdRoute =
  LayoutMaintenanceProgrammesProgrammeIdPhasesRemovePhaseIdRouteImport.update({
    id: "/phases/remove/$phaseId",
    path: "/phases/remove/$phaseId",
    getParentRoute: () => LayoutMaintenanceProgrammesProgrammeIdRouteRoute,
  } as any)
const LayoutMaintenanceProgrammesProgrammeIdRevisionsReleaseRevisionIdRoute =
  LayoutMaintenanceProgrammesProgrammeIdRevisionsReleaseRevisionIdRouteImport.update(
    {
      id: "/revisions/release/$revisionId",
      path: "/revisions/release/$revisionId",
      getParentRoute: () => LayoutMaintenanceProgrammesProgrammeIdRouteRoute,
    } as any,
  )
const LayoutMaintenanceProgrammesProgrammeIdTasksRemoveTaskIdRoute =
  LayoutMaintenanceProgrammesProgrammeIdTasksRemoveTaskIdRouteImport.update({
    id: "/tasks/remove/$taskId",
    path: "/tasks/remove/$taskId",
    getParentRoute: () => LayoutMaintenanceProgrammesProgrammeIdRouteRoute,
  } as any)
const LayoutPlanningPlanIdStepsStepIdIndexRoute =
  LayoutPlanningPlanIdStepsStepIdIndexRouteImport.update({
    id: "/steps/$stepId/",
    path: "/steps/$stepId/",
    getParentRoute: () => LayoutPlanningPlanIdRouteRoute,
  } as any)
const LayoutQuotesQuoteIdPhasesPhaseIdDeleteRoute =
  LayoutQuotesQuoteIdPhasesPhaseIdDeleteRouteImport.update({
    id: "/phases/$phaseId/delete",
    path: "/phases/$phaseId/delete",
    getParentRoute: () => LayoutQuotesQuoteIdRouteRoute,
  } as any)
const LayoutQuotesQuoteIdPhasesPhaseIdRenameRoute =
  LayoutQuotesQuoteIdPhasesPhaseIdRenameRouteImport.update({
    id: "/phases/$phaseId/rename",
    path: "/phases/$phaseId/rename",
    getParentRoute: () => LayoutQuotesQuoteIdRouteRoute,
  } as any)
const LayoutQuotesQuoteIdTasksTaskIdIndexRoute =
  LayoutQuotesQuoteIdTasksTaskIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutQuotesQuoteIdTasksTaskIdRouteRoute,
  } as any)
const LayoutQuotesQuoteIdTasksTaskIdApplyTemplateRoute =
  LayoutQuotesQuoteIdTasksTaskIdApplyTemplateRouteImport.update({
    id: "/apply-template",
    path: "/apply-template",
    getParentRoute: () => LayoutQuotesQuoteIdTasksTaskIdRouteRoute,
  } as any)
const LayoutQuotingEmailsListEmailIdIndexRoute =
  LayoutQuotingEmailsListEmailIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutQuotingEmailsListEmailIdRouteRoute,
  } as any)
const LayoutQuotingEmailsListEmailIdShareRoute =
  LayoutQuotingEmailsListEmailIdShareRouteImport.update({
    id: "/share",
    path: "/share",
    getParentRoute: () => LayoutQuotingEmailsListEmailIdRouteRoute,
  } as any)
const LayoutQuotingEmailsListDeleteEmailIdRoute =
  LayoutQuotingEmailsListDeleteEmailIdRouteImport.update({
    id: "/delete/$emailId",
    path: "/delete/$emailId",
    getParentRoute: () => LayoutQuotingEmailsListRouteRoute,
  } as any)
const LayoutQuotingEmailsListDeleteBulkRoute =
  LayoutQuotingEmailsListDeleteBulkRouteImport.update({
    id: "/delete/bulk",
    path: "/delete/bulk",
    getParentRoute: () => LayoutQuotingEmailsListRouteRoute,
  } as any)
const LayoutQuotingEmailsListShareBulkRoute =
  LayoutQuotingEmailsListShareBulkRouteImport.update({
    id: "/share/bulk",
    path: "/share/bulk",
    getParentRoute: () => LayoutQuotingEmailsListRouteRoute,
  } as any)
const LayoutQuotingQuotesBuilderQuoteIdIndexRoute =
  LayoutQuotingQuotesBuilderQuoteIdIndexRouteImport.update({
    id: "/quoting_/quotes/builder/$quoteId/",
    path: "/quoting/quotes/builder/$quoteId/",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutSettingsPanelAccountNotificationsIndexRoute =
  LayoutSettingsPanelAccountNotificationsIndexRouteImport.update({
    id: "/account/notifications/",
    path: "/account/notifications/",
    getParentRoute: () => LayoutSettingsPanelRouteRoute,
  } as any)
const LayoutSettingsPanelAccountProfileIndexRoute =
  LayoutSettingsPanelAccountProfileIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutSettingsPanelAccountProfileRouteRoute,
  } as any)
const LayoutSettingsPanelAccountProfileChangePasswordRoute =
  LayoutSettingsPanelAccountProfileChangePasswordRouteImport.update({
    id: "/change-password",
    path: "/change-password",
    getParentRoute: () => LayoutSettingsPanelAccountProfileRouteRoute,
  } as any)
const LayoutSettingsPanelAccountSigningPinIndexRoute =
  LayoutSettingsPanelAccountSigningPinIndexRouteImport.update({
    id: "/account/signing-pin/",
    path: "/account/signing-pin/",
    getParentRoute: () => LayoutSettingsPanelRouteRoute,
  } as any)
const LayoutSettingsPanelIntegrationsErpListRouteRoute =
  LayoutSettingsPanelIntegrationsErpListRouteRouteImport.update({
    id: "/_list",
    getParentRoute: () => LayoutSettingsPanelIntegrationsErpRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingFlatRatesIndexRoute =
  LayoutSettingsPanelQuotingFlatRatesIndexRouteImport.update({
    id: "/quoting/flat-rates/",
    path: "/quoting/flat-rates/",
    getParentRoute: () => LayoutSettingsPanelRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingFlatRatesPackageIdRoute =
  LayoutSettingsPanelQuotingFlatRatesPackageIdRouteImport.update({
    id: "/quoting/flat-rates/$packageId",
    path: "/quoting/flat-rates/$packageId",
    getParentRoute: () => LayoutSettingsPanelRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingPlaybooksIndexRoute =
  LayoutSettingsPanelQuotingPlaybooksIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutSettingsPanelQuotingPlaybooksRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingPlaybooksPlaybookIdRouteRoute =
  LayoutSettingsPanelQuotingPlaybooksPlaybookIdRouteRouteImport.update({
    id: "/$playbookId",
    path: "/$playbookId",
    getParentRoute: () => LayoutSettingsPanelQuotingPlaybooksRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingPlaybooksCreateRoute =
  LayoutSettingsPanelQuotingPlaybooksCreateRouteImport.update({
    id: "/create",
    path: "/create",
    getParentRoute: () => LayoutSettingsPanelQuotingPlaybooksRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingRateCardsIndexRoute =
  LayoutSettingsPanelQuotingRateCardsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutSettingsPanelQuotingRateCardsRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingRateCardsRateCardIdRouteRoute =
  LayoutSettingsPanelQuotingRateCardsRateCardIdRouteRouteImport.update({
    id: "/$rateCardId",
    path: "/$rateCardId",
    getParentRoute: () => LayoutSettingsPanelQuotingRateCardsRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingStatusIndexRoute =
  LayoutSettingsPanelQuotingStatusIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutSettingsPanelQuotingStatusRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingTaskGroupsIndexRoute =
  LayoutSettingsPanelQuotingTaskGroupsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutSettingsPanelQuotingTaskGroupsRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingTaskGroupsImportRoute =
  LayoutSettingsPanelQuotingTaskGroupsImportRouteImport.update({
    id: "/import",
    path: "/import",
    getParentRoute: () => LayoutSettingsPanelQuotingTaskGroupsRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingTaxRatesIndexRoute =
  LayoutSettingsPanelQuotingTaxRatesIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutSettingsPanelQuotingTaxRatesRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingTaxRatesTaxRateIdRouteRoute =
  LayoutSettingsPanelQuotingTaxRatesTaxRateIdRouteRouteImport.update({
    id: "/$taxRateId",
    path: "/$taxRateId",
    getParentRoute: () => LayoutSettingsPanelQuotingTaxRatesRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceApprovalFlowsIndexRoute =
  LayoutSettingsPanelWorkspaceApprovalFlowsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutSettingsPanelWorkspaceApprovalFlowsRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdRouteRoute =
  LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdRouteRouteImport.update({
    id: "/$policyId",
    path: "/$policyId",
    getParentRoute: () => LayoutSettingsPanelWorkspaceApprovalFlowsRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceApprovalFlowsCreateRoute =
  LayoutSettingsPanelWorkspaceApprovalFlowsCreateRouteImport.update({
    id: "/create",
    path: "/create",
    getParentRoute: () => LayoutSettingsPanelWorkspaceApprovalFlowsRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceDepartmentsListRouteRoute =
  LayoutSettingsPanelWorkspaceDepartmentsListRouteRouteImport.update({
    id: "/_list",
    getParentRoute: () => LayoutSettingsPanelWorkspaceDepartmentsRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceDepartmentsCreateRoute =
  LayoutSettingsPanelWorkspaceDepartmentsCreateRouteImport.update({
    id: "/create",
    path: "/create",
    getParentRoute: () => LayoutSettingsPanelWorkspaceDepartmentsRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceFacilitiesListRouteRoute =
  LayoutSettingsPanelWorkspaceFacilitiesListRouteRouteImport.update({
    id: "/_list",
    getParentRoute: () => LayoutSettingsPanelWorkspaceFacilitiesRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceFacilitiesCreateRoute =
  LayoutSettingsPanelWorkspaceFacilitiesCreateRouteImport.update({
    id: "/create",
    path: "/create",
    getParentRoute: () => LayoutSettingsPanelWorkspaceFacilitiesRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceGeneralIndexRoute =
  LayoutSettingsPanelWorkspaceGeneralIndexRouteImport.update({
    id: "/workspace/general/",
    path: "/workspace/general/",
    getParentRoute: () => LayoutSettingsPanelRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceMembersListRouteRoute =
  LayoutSettingsPanelWorkspaceMembersListRouteRouteImport.update({
    id: "/_list",
    getParentRoute: () => LayoutSettingsPanelWorkspaceMembersRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceMembersCreateRoute =
  LayoutSettingsPanelWorkspaceMembersCreateRouteImport.update({
    id: "/create",
    path: "/create",
    getParentRoute: () => LayoutSettingsPanelWorkspaceMembersRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceNotificationRulesIndexRoute =
  LayoutSettingsPanelWorkspaceNotificationRulesIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      LayoutSettingsPanelWorkspaceNotificationRulesRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceNotificationRulesRuleIdRouteRoute =
  LayoutSettingsPanelWorkspaceNotificationRulesRuleIdRouteRouteImport.update({
    id: "/$ruleId",
    path: "/$ruleId",
    getParentRoute: () =>
      LayoutSettingsPanelWorkspaceNotificationRulesRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceNotificationRulesCreateRoute =
  LayoutSettingsPanelWorkspaceNotificationRulesCreateRouteImport.update({
    id: "/create",
    path: "/create",
    getParentRoute: () =>
      LayoutSettingsPanelWorkspaceNotificationRulesRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceRolesListRouteRoute =
  LayoutSettingsPanelWorkspaceRolesListRouteRouteImport.update({
    id: "/_list",
    getParentRoute: () => LayoutSettingsPanelWorkspaceRolesRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceRolesCreateRoute =
  LayoutSettingsPanelWorkspaceRolesCreateRouteImport.update({
    id: "/create",
    path: "/create",
    getParentRoute: () => LayoutSettingsPanelWorkspaceRolesRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceTeamsListRouteRoute =
  LayoutSettingsPanelWorkspaceTeamsListRouteRouteImport.update({
    id: "/_list",
    getParentRoute: () => LayoutSettingsPanelWorkspaceTeamsRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceTeamsCreateRoute =
  LayoutSettingsPanelWorkspaceTeamsCreateRouteImport.update({
    id: "/create",
    path: "/create",
    getParentRoute: () => LayoutSettingsPanelWorkspaceTeamsRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceTemplatesIndexRoute =
  LayoutSettingsPanelWorkspaceTemplatesIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutSettingsPanelWorkspaceTemplatesRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceTemplatesKindRouteRoute =
  LayoutSettingsPanelWorkspaceTemplatesKindRouteRouteImport.update({
    id: "/$kind",
    path: "/$kind",
    getParentRoute: () => LayoutSettingsPanelWorkspaceTemplatesRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceToolCategoriesListRouteRoute =
  LayoutSettingsPanelWorkspaceToolCategoriesListRouteRouteImport.update({
    id: "/_list",
    getParentRoute: () => LayoutSettingsPanelWorkspaceToolCategoriesRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceToolCategoriesCreateRoute =
  LayoutSettingsPanelWorkspaceToolCategoriesCreateRouteImport.update({
    id: "/create",
    path: "/create",
    getParentRoute: () => LayoutSettingsPanelWorkspaceToolCategoriesRouteRoute,
  } as any)
const LayoutSettingsSystemTenantsTenantIdIndexRoute =
  LayoutSettingsSystemTenantsTenantIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutSettingsSystemTenantsTenantIdRouteRoute,
  } as any)
const LayoutSettingsSystemTenantsTenantIdApprovalPoliciesRoute =
  LayoutSettingsSystemTenantsTenantIdApprovalPoliciesRouteImport.update({
    id: "/approval-policies",
    path: "/approval-policies",
    getParentRoute: () => LayoutSettingsSystemTenantsTenantIdRouteRoute,
  } as any)
const LayoutSettingsSystemTenantsTenantIdIntegrationsRoute =
  LayoutSettingsSystemTenantsTenantIdIntegrationsRouteImport.update({
    id: "/integrations",
    path: "/integrations",
    getParentRoute: () => LayoutSettingsSystemTenantsTenantIdRouteRoute,
  } as any)
const LayoutSettingsSystemTenantsTenantIdNotificationRulesRoute =
  LayoutSettingsSystemTenantsTenantIdNotificationRulesRouteImport.update({
    id: "/notification-rules",
    path: "/notification-rules",
    getParentRoute: () => LayoutSettingsSystemTenantsTenantIdRouteRoute,
  } as any)
const LayoutSettingsSystemTenantsTenantIdSettingsRouteRoute =
  LayoutSettingsSystemTenantsTenantIdSettingsRouteRouteImport.update({
    id: "/settings",
    path: "/settings",
    getParentRoute: () => LayoutSettingsSystemTenantsTenantIdRouteRoute,
  } as any)
const LayoutSettingsSystemTenantsTenantIdUsersRoute =
  LayoutSettingsSystemTenantsTenantIdUsersRouteImport.update({
    id: "/users",
    path: "/users",
    getParentRoute: () => LayoutSettingsSystemTenantsTenantIdRouteRoute,
  } as any)
const LayoutTemplatesQuotesPackageIdListIndexRoute =
  LayoutTemplatesQuotesPackageIdListIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutTemplatesQuotesPackageIdListRouteRoute,
  } as any)
const LayoutTemplatesQuotesPackageIdOverviewIndexRoute =
  LayoutTemplatesQuotesPackageIdOverviewIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutTemplatesQuotesPackageIdOverviewRouteRoute,
  } as any)
const LayoutTemplatesQuotesPackageIdOverviewArchiveRoute =
  LayoutTemplatesQuotesPackageIdOverviewArchiveRouteImport.update({
    id: "/archive",
    path: "/archive",
    getParentRoute: () => LayoutTemplatesQuotesPackageIdOverviewRouteRoute,
  } as any)
const LayoutToolsToolIdCalibrationsCalibrationIdCompleteRoute =
  LayoutToolsToolIdCalibrationsCalibrationIdCompleteRouteImport.update({
    id: "/calibrations/$calibrationId/complete",
    path: "/calibrations/$calibrationId/complete",
    getParentRoute: () => LayoutToolsToolIdRouteRoute,
  } as any)
const LayoutToolsToolIdLoansLoanIdReceiveRoute =
  LayoutToolsToolIdLoansLoanIdReceiveRouteImport.update({
    id: "/loans/$loanId/receive",
    path: "/loans/$loanId/receive",
    getParentRoute: () => LayoutToolsToolIdRouteRoute,
  } as any)
const LayoutWorkOrdersWorkOrderIdPhasesPhaseIdDeleteRoute =
  LayoutWorkOrdersWorkOrderIdPhasesPhaseIdDeleteRouteImport.update({
    id: "/phases/$phaseId/delete",
    path: "/phases/$phaseId/delete",
    getParentRoute: () => LayoutWorkOrdersWorkOrderIdRouteRoute,
  } as any)
const LayoutWorkOrdersWorkOrderIdPhasesPhaseIdRenameRoute =
  LayoutWorkOrdersWorkOrderIdPhasesPhaseIdRenameRouteImport.update({
    id: "/phases/$phaseId/rename",
    path: "/phases/$phaseId/rename",
    getParentRoute: () => LayoutWorkOrdersWorkOrderIdRouteRoute,
  } as any)
const LayoutWorkOrdersWorkOrderIdTasksTaskIdDeleteRoute =
  LayoutWorkOrdersWorkOrderIdTasksTaskIdDeleteRouteImport.update({
    id: "/delete",
    path: "/delete",
    getParentRoute: () => LayoutWorkOrdersWorkOrderIdTasksTaskIdRoute,
  } as any)
const LayoutAircraftAircraftIdPartInstancesPartInstanceIdReadingsNewRoute =
  LayoutAircraftAircraftIdPartInstancesPartInstanceIdReadingsNewRouteImport.update(
    {
      id: "/part-instances/$partInstanceId/readings/new",
      path: "/part-instances/$partInstanceId/readings/new",
      getParentRoute: () => LayoutAircraftAircraftIdRouteRoute,
    } as any,
  )
const LayoutCustomerCustomerIdContactsListContactIdIndexRoute =
  LayoutCustomerCustomerIdContactsListContactIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      LayoutCustomerCustomerIdContactsListContactIdRouteRoute,
  } as any)
const LayoutCustomerCustomerIdContactsListContactIdDeleteRoute =
  LayoutCustomerCustomerIdContactsListContactIdDeleteRouteImport.update({
    id: "/delete",
    path: "/delete",
    getParentRoute: () =>
      LayoutCustomerCustomerIdContactsListContactIdRouteRoute,
  } as any)
const LayoutPlanningPlanIdStepsStepIdTasksTaskIndexRoute =
  LayoutPlanningPlanIdStepsStepIdTasksTaskIndexRouteImport.update({
    id: "/steps/$stepId/tasks/$taskIndex",
    path: "/steps/$stepId/tasks/$taskIndex",
    getParentRoute: () => LayoutPlanningPlanIdRouteRoute,
  } as any)
const LayoutQuotingQuotesBuilderQuoteIdTaskTaskIdRoute =
  LayoutQuotingQuotesBuilderQuoteIdTaskTaskIdRouteImport.update({
    id: "/quoting_/quotes/builder/$quoteId/task/$taskId",
    path: "/quoting/quotes/builder/$quoteId/task/$taskId",
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutSettingsPanelIntegrationsErpListIndexRoute =
  LayoutSettingsPanelIntegrationsErpListIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutSettingsPanelIntegrationsErpListRouteRoute,
  } as any)
const LayoutSettingsPanelIntegrationsErpApiKeySetRoute =
  LayoutSettingsPanelIntegrationsErpApiKeySetRouteImport.update({
    id: "/api-key/set",
    path: "/api-key/set",
    getParentRoute: () => LayoutSettingsPanelIntegrationsErpRouteRoute,
  } as any)
const LayoutSettingsPanelIntegrationsErpRelaySetRoute =
  LayoutSettingsPanelIntegrationsErpRelaySetRouteImport.update({
    id: "/relay/set",
    path: "/relay/set",
    getParentRoute: () => LayoutSettingsPanelIntegrationsErpRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingPlaybooksPlaybookIdIndexRoute =
  LayoutSettingsPanelQuotingPlaybooksPlaybookIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      LayoutSettingsPanelQuotingPlaybooksPlaybookIdRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingPlaybooksPlaybookIdActivityRoute =
  LayoutSettingsPanelQuotingPlaybooksPlaybookIdActivityRouteImport.update({
    id: "/activity",
    path: "/activity",
    getParentRoute: () =>
      LayoutSettingsPanelQuotingPlaybooksPlaybookIdRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingPlaybooksPlaybookIdConfigurationRoute =
  LayoutSettingsPanelQuotingPlaybooksPlaybookIdConfigurationRouteImport.update({
    id: "/configuration",
    path: "/configuration",
    getParentRoute: () =>
      LayoutSettingsPanelQuotingPlaybooksPlaybookIdRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesRouteRoute =
  LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesRouteRouteImport.update({
    id: "/rules",
    path: "/rules",
    getParentRoute: () =>
      LayoutSettingsPanelQuotingPlaybooksPlaybookIdRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingRateCardsRateCardIdIndexRoute =
  LayoutSettingsPanelQuotingRateCardsRateCardIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      LayoutSettingsPanelQuotingRateCardsRateCardIdRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingRateCardsRateCardIdArchiveRoute =
  LayoutSettingsPanelQuotingRateCardsRateCardIdArchiveRouteImport.update({
    id: "/archive",
    path: "/archive",
    getParentRoute: () =>
      LayoutSettingsPanelQuotingRateCardsRateCardIdRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingTaskGroupsGroupIdArchiveRoute =
  LayoutSettingsPanelQuotingTaskGroupsGroupIdArchiveRouteImport.update({
    id: "/$groupId/archive",
    path: "/$groupId/archive",
    getParentRoute: () => LayoutSettingsPanelQuotingTaskGroupsRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingTaxRatesTaxRateIdIndexRoute =
  LayoutSettingsPanelQuotingTaxRatesTaxRateIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutSettingsPanelQuotingTaxRatesTaxRateIdRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingTaxRatesTaxRateIdArchiveRoute =
  LayoutSettingsPanelQuotingTaxRatesTaxRateIdArchiveRouteImport.update({
    id: "/archive",
    path: "/archive",
    getParentRoute: () => LayoutSettingsPanelQuotingTaxRatesTaxRateIdRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdIndexRoute =
  LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdDeleteRoute =
  LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdDeleteRouteImport.update({
    id: "/delete",
    path: "/delete",
    getParentRoute: () =>
      LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceApprovalFlowsDuplicatePolicyIdRoute =
  LayoutSettingsPanelWorkspaceApprovalFlowsDuplicatePolicyIdRouteImport.update({
    id: "/duplicate/$policyId",
    path: "/duplicate/$policyId",
    getParentRoute: () => LayoutSettingsPanelWorkspaceApprovalFlowsRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceDepartmentsListIndexRoute =
  LayoutSettingsPanelWorkspaceDepartmentsListIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutSettingsPanelWorkspaceDepartmentsListRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdRouteRoute =
  LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdRouteRouteImport.update(
    {
      id: "/$departmentId",
      path: "/$departmentId",
      getParentRoute: () =>
        LayoutSettingsPanelWorkspaceDepartmentsListRouteRoute,
    } as any,
  )
const LayoutSettingsPanelWorkspaceFacilitiesListIndexRoute =
  LayoutSettingsPanelWorkspaceFacilitiesListIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutSettingsPanelWorkspaceFacilitiesListRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdRouteRoute =
  LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdRouteRouteImport.update({
    id: "/$facilityId",
    path: "/$facilityId",
    getParentRoute: () => LayoutSettingsPanelWorkspaceFacilitiesListRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceMembersListIndexRoute =
  LayoutSettingsPanelWorkspaceMembersListIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutSettingsPanelWorkspaceMembersListRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceMembersListUserIdRouteRoute =
  LayoutSettingsPanelWorkspaceMembersListUserIdRouteRouteImport.update({
    id: "/$userId",
    path: "/$userId",
    getParentRoute: () => LayoutSettingsPanelWorkspaceMembersListRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceNotificationRulesRuleIdIndexRoute =
  LayoutSettingsPanelWorkspaceNotificationRulesRuleIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      LayoutSettingsPanelWorkspaceNotificationRulesRuleIdRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceNotificationRulesRuleIdDeleteRoute =
  LayoutSettingsPanelWorkspaceNotificationRulesRuleIdDeleteRouteImport.update({
    id: "/delete",
    path: "/delete",
    getParentRoute: () =>
      LayoutSettingsPanelWorkspaceNotificationRulesRuleIdRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceNotificationRulesDuplicateRuleIdRoute =
  LayoutSettingsPanelWorkspaceNotificationRulesDuplicateRuleIdRouteImport.update(
    {
      id: "/duplicate/$ruleId",
      path: "/duplicate/$ruleId",
      getParentRoute: () =>
        LayoutSettingsPanelWorkspaceNotificationRulesRouteRoute,
    } as any,
  )
const LayoutSettingsPanelWorkspaceRolesListIndexRoute =
  LayoutSettingsPanelWorkspaceRolesListIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutSettingsPanelWorkspaceRolesListRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceRolesListRoleIdRouteRoute =
  LayoutSettingsPanelWorkspaceRolesListRoleIdRouteRouteImport.update({
    id: "/$roleId",
    path: "/$roleId",
    getParentRoute: () => LayoutSettingsPanelWorkspaceRolesListRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceRolesDuplicateRoleIdRoute =
  LayoutSettingsPanelWorkspaceRolesDuplicateRoleIdRouteImport.update({
    id: "/duplicate/$roleId",
    path: "/duplicate/$roleId",
    getParentRoute: () => LayoutSettingsPanelWorkspaceRolesRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceTeamsListIndexRoute =
  LayoutSettingsPanelWorkspaceTeamsListIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutSettingsPanelWorkspaceTeamsListRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceTeamsListTeamIdRouteRoute =
  LayoutSettingsPanelWorkspaceTeamsListTeamIdRouteRouteImport.update({
    id: "/$teamId",
    path: "/$teamId",
    getParentRoute: () => LayoutSettingsPanelWorkspaceTeamsListRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceTemplatesKindIndexRoute =
  LayoutSettingsPanelWorkspaceTemplatesKindIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutSettingsPanelWorkspaceTemplatesKindRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceTemplatesKindRevertRoute =
  LayoutSettingsPanelWorkspaceTemplatesKindRevertRouteImport.update({
    id: "/revert",
    path: "/revert",
    getParentRoute: () => LayoutSettingsPanelWorkspaceTemplatesKindRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceToolCategoriesListIndexRoute =
  LayoutSettingsPanelWorkspaceToolCategoriesListIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      LayoutSettingsPanelWorkspaceToolCategoriesListRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdRouteRoute =
  LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdRouteRouteImport.update(
    {
      id: "/$categoryId",
      path: "/$categoryId",
      getParentRoute: () =>
        LayoutSettingsPanelWorkspaceToolCategoriesListRouteRoute,
    } as any,
  )
const LayoutSettingsSystemTenantsTenantIdSettingsIndexRoute =
  LayoutSettingsSystemTenantsTenantIdSettingsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutSettingsSystemTenantsTenantIdSettingsRouteRoute,
  } as any)
const LayoutSettingsSystemTenantsTenantIdSettingsReindexRoute =
  LayoutSettingsSystemTenantsTenantIdSettingsReindexRouteImport.update({
    id: "/reindex",
    path: "/reindex",
    getParentRoute: () => LayoutSettingsSystemTenantsTenantIdSettingsRouteRoute,
  } as any)
const LayoutTemplatesQuotesPackageIdListTasksTaskIdRouteRoute =
  LayoutTemplatesQuotesPackageIdListTasksTaskIdRouteRouteImport.update({
    id: "/tasks/$taskId",
    path: "/tasks/$taskId",
    getParentRoute: () => LayoutTemplatesQuotesPackageIdListRouteRoute,
  } as any)
const LayoutTemplatesQuotesPackageIdListTasksCreateRoute =
  LayoutTemplatesQuotesPackageIdListTasksCreateRouteImport.update({
    id: "/tasks/create",
    path: "/tasks/create",
    getParentRoute: () => LayoutTemplatesQuotesPackageIdListRouteRoute,
  } as any)
const LayoutAircraftAircraftIdPartInstancesPartInstanceIdReadingsReadingIdDeleteRoute =
  LayoutAircraftAircraftIdPartInstancesPartInstanceIdReadingsReadingIdDeleteRouteImport.update(
    {
      id: "/part-instances/$partInstanceId/readings/$readingId/delete",
      path: "/part-instances/$partInstanceId/readings/$readingId/delete",
      getParentRoute: () => LayoutAircraftAircraftIdRouteRoute,
    } as any,
  )
const LayoutQuotesQuoteIdTasksTaskIdStepsStepIdRemoveRoute =
  LayoutQuotesQuoteIdTasksTaskIdStepsStepIdRemoveRouteImport.update({
    id: "/steps/$stepId/remove",
    path: "/steps/$stepId/remove",
    getParentRoute: () => LayoutQuotesQuoteIdTasksTaskIdRouteRoute,
  } as any)
const LayoutSettingsPanelIntegrationsErpListApiKeyRevokeRoute =
  LayoutSettingsPanelIntegrationsErpListApiKeyRevokeRouteImport.update({
    id: "/api-key/revoke",
    path: "/api-key/revoke",
    getParentRoute: () => LayoutSettingsPanelIntegrationsErpListRouteRoute,
  } as any)
const LayoutSettingsPanelIntegrationsErpListRelayRemoveRoute =
  LayoutSettingsPanelIntegrationsErpListRelayRemoveRouteImport.update({
    id: "/relay/remove",
    path: "/relay/remove",
    getParentRoute: () => LayoutSettingsPanelIntegrationsErpListRouteRoute,
  } as any)
const LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesIndexRoute =
  LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdIndexRoute =
  LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdIndexRouteImport.update(
    {
      id: "/",
      path: "/",
      getParentRoute: () =>
        LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdRouteRoute,
    } as any,
  )
const LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdDeleteRoute =
  LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdDeleteRouteImport.update(
    {
      id: "/delete",
      path: "/delete",
      getParentRoute: () =>
        LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdRouteRoute,
    } as any,
  )
const LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdIndexRoute =
  LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdDeleteRoute =
  LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdDeleteRouteImport.update({
    id: "/delete",
    path: "/delete",
    getParentRoute: () =>
      LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceMembersListUserIdIndexRoute =
  LayoutSettingsPanelWorkspaceMembersListUserIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      LayoutSettingsPanelWorkspaceMembersListUserIdRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceMembersListUserIdChangePasswordRoute =
  LayoutSettingsPanelWorkspaceMembersListUserIdChangePasswordRouteImport.update(
    {
      id: "/change-password",
      path: "/change-password",
      getParentRoute: () =>
        LayoutSettingsPanelWorkspaceMembersListUserIdRouteRoute,
    } as any,
  )
const LayoutSettingsPanelWorkspaceMembersListUserIdDeleteRoute =
  LayoutSettingsPanelWorkspaceMembersListUserIdDeleteRouteImport.update({
    id: "/delete",
    path: "/delete",
    getParentRoute: () =>
      LayoutSettingsPanelWorkspaceMembersListUserIdRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceMembersListUserIdResendLoginEmailRoute =
  LayoutSettingsPanelWorkspaceMembersListUserIdResendLoginEmailRouteImport.update(
    {
      id: "/resend-login-email",
      path: "/resend-login-email",
      getParentRoute: () =>
        LayoutSettingsPanelWorkspaceMembersListUserIdRouteRoute,
    } as any,
  )
const LayoutSettingsPanelWorkspaceRolesListRoleIdIndexRoute =
  LayoutSettingsPanelWorkspaceRolesListRoleIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutSettingsPanelWorkspaceRolesListRoleIdRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceRolesListRoleIdDeleteRoute =
  LayoutSettingsPanelWorkspaceRolesListRoleIdDeleteRouteImport.update({
    id: "/delete",
    path: "/delete",
    getParentRoute: () => LayoutSettingsPanelWorkspaceRolesListRoleIdRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceRolesListRoleIdResetRoute =
  LayoutSettingsPanelWorkspaceRolesListRoleIdResetRouteImport.update({
    id: "/reset",
    path: "/reset",
    getParentRoute: () => LayoutSettingsPanelWorkspaceRolesListRoleIdRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceTeamsListTeamIdIndexRoute =
  LayoutSettingsPanelWorkspaceTeamsListTeamIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => LayoutSettingsPanelWorkspaceTeamsListTeamIdRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceTeamsListTeamIdDeleteRoute =
  LayoutSettingsPanelWorkspaceTeamsListTeamIdDeleteRouteImport.update({
    id: "/delete",
    path: "/delete",
    getParentRoute: () => LayoutSettingsPanelWorkspaceTeamsListTeamIdRouteRoute,
  } as any)
const LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdIndexRoute =
  LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdIndexRouteImport.update(
    {
      id: "/",
      path: "/",
      getParentRoute: () =>
        LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdRouteRoute,
    } as any,
  )
const LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdDeleteRoute =
  LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdDeleteRouteImport.update(
    {
      id: "/delete",
      path: "/delete",
      getParentRoute: () =>
        LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdRouteRoute,
    } as any,
  )
const LayoutTemplatesQuotesPackageIdListTasksTaskIdIndexRoute =
  LayoutTemplatesQuotesPackageIdListTasksTaskIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      LayoutTemplatesQuotesPackageIdListTasksTaskIdRouteRoute,
  } as any)
const LayoutTemplatesQuotesPackageIdListTasksTaskIdArchiveRoute =
  LayoutTemplatesQuotesPackageIdListTasksTaskIdArchiveRouteImport.update({
    id: "/archive",
    path: "/archive",
    getParentRoute: () =>
      LayoutTemplatesQuotesPackageIdListTasksTaskIdRouteRoute,
  } as any)
const LayoutWorkOrdersWorkOrderIdTasksTaskIdStepsStepIdDeleteRoute =
  LayoutWorkOrdersWorkOrderIdTasksTaskIdStepsStepIdDeleteRouteImport.update({
    id: "/steps/$stepId/delete",
    path: "/steps/$stepId/delete",
    getParentRoute: () => LayoutWorkOrdersWorkOrderIdTasksTaskIdRoute,
  } as any)
const LayoutWorkOrdersWorkOrderIdTasksTaskIdTimeEntriesTimeEntryIdDeleteRoute =
  LayoutWorkOrdersWorkOrderIdTasksTaskIdTimeEntriesTimeEntryIdDeleteRouteImport.update(
    {
      id: "/time-entries/$timeEntryId/delete",
      path: "/time-entries/$timeEntryId/delete",
      getParentRoute: () => LayoutWorkOrdersWorkOrderIdTasksTaskIdRoute,
    } as any,
  )
const LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesLineageIdDeleteRoute =
  LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesLineageIdDeleteRouteImport.update(
    {
      id: "/$lineageId/delete",
      path: "/$lineageId/delete",
      getParentRoute: () =>
        LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesRouteRoute,
    } as any,
  )
const LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdPositionsPositionIdRemoveRoute =
  LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdPositionsPositionIdRemoveRouteImport.update(
    {
      id: "/positions/$positionId/remove",
      path: "/positions/$positionId/remove",
      getParentRoute: () =>
        LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdRouteRoute,
    } as any,
  )
const LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdLocationsLocationIdDeleteRoute =
  LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdLocationsLocationIdDeleteRouteImport.update(
    {
      id: "/locations/$locationId/delete",
      path: "/locations/$locationId/delete",
      getParentRoute: () =>
        LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdRouteRoute,
    } as any,
  )
const LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdPositionsPositionIdRemoveRoute =
  LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdPositionsPositionIdRemoveRouteImport.update(
    {
      id: "/positions/$positionId/remove",
      path: "/positions/$positionId/remove",
      getParentRoute: () =>
        LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdRouteRoute,
    } as any,
  )
const LayoutSettingsPanelWorkspaceTeamsListTeamIdPositionsPositionIdRemoveRoute =
  LayoutSettingsPanelWorkspaceTeamsListTeamIdPositionsPositionIdRemoveRouteImport.update(
    {
      id: "/positions/$positionId/remove",
      path: "/positions/$positionId/remove",
      getParentRoute: () =>
        LayoutSettingsPanelWorkspaceTeamsListTeamIdRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  "/": typeof LayoutIndexRoute
  "/change-password": typeof ChangePasswordRoute
  "/login": typeof LoginRoute
  "/recover-password": typeof RecoverPasswordRoute
  "/reset-password": typeof ResetPasswordRoute
  "/agent": typeof LayoutAgentRouteRouteWithChildren
  "/aircraft": typeof LayoutAircraftRouteRouteWithChildren
  "/airworthiness-directives": typeof LayoutAirworthinessDirectivesRouteRouteWithChildren
  "/approved-vendors": typeof LayoutApprovedVendorsRouteRouteWithChildren
  "/customer": typeof LayoutCustomerRouteRouteWithChildren
  "/documents": typeof LayoutDocumentsRouteRouteWithChildren
  "/forecasts": typeof LayoutForecastsRouteRouteWithChildren
  "/inventory": typeof LayoutInventoryRouteRouteWithChildren
  "/maintenance-programmes": typeof LayoutMaintenanceProgrammesRouteRouteWithChildren
  "/planning": typeof LayoutPlanningRouteRouteWithChildren
  "/quotes": typeof LayoutQuotesRouteRouteWithChildren
  "/settings": typeof LayoutSettingsRouteRouteWithChildren
  "/tech-logs": typeof LayoutTechLogsRouteRouteWithChildren
  "/templates": typeof LayoutTemplatesRouteRouteWithChildren
  "/tie-in": typeof LayoutTieInRouteRoute
  "/timesheet": typeof LayoutTimesheetRouteRouteWithChildren
  "/tools": typeof LayoutToolsRouteRouteWithChildren
  "/review/$token": typeof ReviewTokenRouteRouteWithChildren
  "/aircraft/$aircraftId": typeof LayoutAircraftAircraftIdRouteRouteWithChildren
  "/customer/$customerId": typeof LayoutCustomerCustomerIdRouteRouteWithChildren
  "/inventory/$partId": typeof LayoutInventoryPartIdRouteRouteWithChildren
  "/inventory/purchase-orders": typeof LayoutInventoryPurchaseOrdersRouteRouteWithChildren
  "/maintenance-programmes/$programmeId": typeof LayoutMaintenanceProgrammesProgrammeIdRouteRouteWithChildren
  "/planning/$planId": typeof LayoutPlanningPlanIdRouteRouteWithChildren
  "/quotes/$quoteId": typeof LayoutQuotesQuoteIdRouteRouteWithChildren
  "/quoting/emails": typeof LayoutQuotingEmailsRouteRouteWithChildren
  "/quoting/squawks": typeof LayoutQuotingSquawksRouteRouteWithChildren
  "/templates/quotes": typeof LayoutTemplatesQuotesRouteRouteWithChildren
  "/templates/tasks": typeof LayoutTemplatesTasksRouteRouteWithChildren
  "/tools/$toolId": typeof LayoutToolsToolIdRouteRouteWithChildren
  "/work-orders/$workOrderId": typeof LayoutWorkOrdersWorkOrderIdRouteRouteWithChildren
  "/work-orders": typeof LayoutWorkOrdersListRouteRouteWithChildren
  "/agent/$id": typeof LayoutAgentIdRoute
  "/agent/chats": typeof LayoutAgentChatsRouteWithChildren
  "/aircraft/new": typeof LayoutAircraftNewRoute
  "/airworthiness-directives/upload": typeof LayoutAirworthinessDirectivesUploadRoute
  "/airworthiness-directives/$documentId": typeof LayoutAirworthinessDirectivesDocumentIdRoute
  "/approved-vendors/$vendorId": typeof LayoutApprovedVendorsVendorIdRoute
  "/approved-vendors/new": typeof LayoutApprovedVendorsNewRoute
  "/customer/new": typeof LayoutCustomerNewRoute
  "/documents/$documentId": typeof LayoutDocumentsDocumentIdRoute
  "/forecasts/new": typeof LayoutForecastsNewRoute
  "/forecasts/$forecastId": typeof LayoutForecastsForecastIdRoute
  "/forecasts/preview": typeof LayoutForecastsPreviewRoute
  "/inventory/new": typeof LayoutInventoryNewRoute
  "/maintenance-programmes/new": typeof LayoutMaintenanceProgrammesNewRoute
  "/quotes/create": typeof LayoutQuotesCreateRoute
  "/quotes/from-file": typeof LayoutQuotesFromFileRoute
  "/settings/company": typeof LayoutSettingsCompanyRoute
  "/settings/system": typeof LayoutSettingsSystemRoute
  "/settings/user": typeof LayoutSettingsUserRoute
  "/tech-logs/$pageId": typeof LayoutTechLogsPageIdRoute
  "/tech-logs/new": typeof LayoutTechLogsNewRoute
  "/timesheet/log": typeof LayoutTimesheetLogRoute
  "/tools/new": typeof LayoutToolsNewRoute
  "/work-task/$id": typeof LayoutWorkTaskIdRoute
  "/review/$token/sign": typeof ReviewTokenSignRoute
  "/agent/": typeof LayoutAgentIndexRoute
  "/aircraft/": typeof LayoutAircraftIndexRoute
  "/airworthiness-directives/": typeof LayoutAirworthinessDirectivesIndexRoute
  "/approved-vendors/": typeof LayoutApprovedVendorsIndexRoute
  "/customer/": typeof LayoutCustomerIndexRoute
  "/forecasts/": typeof LayoutForecastsIndexRoute
  "/inventory/": typeof LayoutInventoryIndexRoute
  "/maintenance-programmes/": typeof LayoutMaintenanceProgrammesIndexRoute
  "/manpower/": typeof LayoutManpowerIndexRoute
  "/planning/": typeof LayoutPlanningIndexRoute
  "/quotes/": typeof LayoutQuotesIndexRoute
  "/quoting/": typeof LayoutQuotingIndexRoute
  "/settings/": typeof LayoutSettingsIndexRoute
  "/tech-logs/": typeof LayoutTechLogsIndexRoute
  "/templates/": typeof LayoutTemplatesIndexRoute
  "/timesheet/": typeof LayoutTimesheetIndexRoute
  "/tools/": typeof LayoutToolsIndexRoute
  "/review/$token/": typeof ReviewTokenIndexRoute
  "/customer/$customerId/contacts": typeof LayoutCustomerCustomerIdContactsRouteRouteWithChildren
  "/documents/upload": typeof LayoutDocumentsListUploadRouteRoute
  "/templates/quotes/$packageId": typeof LayoutTemplatesQuotesPackageIdRouteRouteWithChildren
  "/templates/tasks/$taskId": typeof LayoutTemplatesTasksTaskIdRouteRouteWithChildren
  "/agent/delete/$id": typeof LayoutAgentDeleteIdRoute
  "/aircraft/$aircraftId/edit": typeof LayoutAircraftAircraftIdEditRoute
  "/airworthiness-directives/delete/$documentId": typeof LayoutAirworthinessDirectivesDeleteDocumentIdRoute
  "/approved-vendors/delete/$vendorId": typeof LayoutApprovedVendorsDeleteVendorIdRoute
  "/approved-vendors/delete/bulk": typeof LayoutApprovedVendorsDeleteBulkRoute
  "/assessments/ad/$reportId": typeof LayoutAssessmentsAdReportIdRoute
  "/assessments/sb/$reportId": typeof LayoutAssessmentsSbReportIdRoute
  "/customer/delete/$customerId": typeof LayoutCustomerDeleteCustomerIdRoute
  "/customer/$customerId/aircraft": typeof LayoutCustomerCustomerIdAircraftRoute
  "/customer/$customerId/delete": typeof LayoutCustomerCustomerIdDeleteRoute
  "/customer/$customerId/wo-history": typeof LayoutCustomerCustomerIdWoHistoryRoute
  "/forecasts/delete/$forecastId": typeof LayoutForecastsDeleteForecastIdRoute
  "/inventory/$partId/archive": typeof LayoutInventoryPartIdArchiveRoute
  "/inventory/delete/$partId": typeof LayoutInventoryDeletePartIdRoute
  "/inventory/delete/bulk": typeof LayoutInventoryDeleteBulkRoute
  "/inventory/purchase-orders/$purchaseOrderId": typeof LayoutInventoryPurchaseOrdersPurchaseOrderIdRoute
  "/inventory/purchase-orders/new": typeof LayoutInventoryPurchaseOrdersNewRoute
  "/maintenance-programmes/delete/$programmeId": typeof LayoutMaintenanceProgrammesDeleteProgrammeIdRoute
  "/planning/new/forecast": typeof LayoutPlanningNewForecastRoute
  "/planning/new/quote": typeof LayoutPlanningNewQuoteRoute
  "/quotes/delete/$quoteId": typeof LayoutQuotesDeleteQuoteIdRoute
  "/quotes/$quoteId/corridor": typeof LayoutQuotesQuoteIdCorridorRoute
  "/quotes/$quoteId/send": typeof LayoutQuotesQuoteIdSendRoute
  "/quotes/$quoteId/sent": typeof LayoutQuotesQuoteIdSentRoute
  "/quoting/canned/$packageId": typeof LayoutQuotingCannedPackageIdRoute
  "/quoting/quotes/$quoteId": typeof LayoutQuotingQuotesQuoteIdRoute
  "/quoting/squawks/$squawkId": typeof LayoutQuotingSquawksSquawkIdRoute
  "/tech-logs/delete/$pageId": typeof LayoutTechLogsDeletePageIdRoute
  "/templates/quotes/delete": typeof LayoutTemplatesQuotesDeleteRoute
  "/templates/tasks/create": typeof LayoutTemplatesTasksCreateRoute
  "/templates/tasks/delete": typeof LayoutTemplatesTasksDeleteRoute
  "/timesheet/delete/$timeEntryId": typeof LayoutTimesheetDeleteTimeEntryIdRoute
  "/tools/$toolId/issue": typeof LayoutToolsToolIdIssueRoute
  "/tools/$toolId/label": typeof LayoutToolsToolIdLabelRoute
  "/tools/$toolId/retire": typeof LayoutToolsToolIdRetireRoute
  "/work-orders/$workOrderId/cancel": typeof LayoutWorkOrdersWorkOrderIdCancelRoute
  "/work-orders/$workOrderId/close": typeof LayoutWorkOrdersWorkOrderIdCloseRoute
  "/aircraft/$aircraftId/": typeof LayoutAircraftAircraftIdIndexRoute
  "/customer/$customerId/": typeof LayoutCustomerCustomerIdIndexRoute
  "/documents/": typeof LayoutDocumentsListIndexRoute
  "/inventory/$partId/": typeof LayoutInventoryPartIdIndexRoute
  "/inventory/purchase-orders/": typeof LayoutInventoryPurchaseOrdersIndexRoute
  "/maintenance-programmes/$programmeId/": typeof LayoutMaintenanceProgrammesProgrammeIdIndexRoute
  "/planning/$planId/": typeof LayoutPlanningPlanIdIndexRoute
  "/quotes/$quoteId/": typeof LayoutQuotesQuoteIdIndexRoute
  "/quoting/canned/": typeof LayoutQuotingCannedIndexRoute
  "/quoting/quotes/": typeof LayoutQuotingQuotesIndexRoute
  "/quoting/squawks/": typeof LayoutQuotingSquawksIndexRoute
  "/templates/quotes/": typeof LayoutTemplatesQuotesIndexRoute
  "/templates/tasks/": typeof LayoutTemplatesTasksIndexRoute
  "/tools/$toolId/": typeof LayoutToolsToolIdIndexRoute
  "/work-orders/$workOrderId/": typeof LayoutWorkOrdersWorkOrderIdIndexRoute
  "/work-orders/": typeof LayoutWorkOrdersListIndexRoute
  "/quotes/$quoteId/tasks/$taskId": typeof LayoutQuotesQuoteIdTasksTaskIdRouteRouteWithChildren
  "/quoting/emails/$emailId": typeof LayoutQuotingEmailsListEmailIdRouteRouteWithChildren
  "/settings/account/profile": typeof LayoutSettingsPanelAccountProfileRouteRouteWithChildren
  "/settings/integrations/erp": typeof LayoutSettingsPanelIntegrationsErpRouteRouteWithChildren
  "/settings/quoting/playbooks": typeof LayoutSettingsPanelQuotingPlaybooksRouteRouteWithChildren
  "/settings/quoting/rate-cards": typeof LayoutSettingsPanelQuotingRateCardsRouteRouteWithChildren
  "/settings/quoting/status": typeof LayoutSettingsPanelQuotingStatusRouteRouteWithChildren
  "/settings/quoting/task-groups": typeof LayoutSettingsPanelQuotingTaskGroupsRouteRouteWithChildren
  "/settings/quoting/tax-rates": typeof LayoutSettingsPanelQuotingTaxRatesRouteRouteWithChildren
  "/settings/workspace/approval-flows": typeof LayoutSettingsPanelWorkspaceApprovalFlowsRouteRouteWithChildren
  "/settings/workspace/departments": typeof LayoutSettingsPanelWorkspaceDepartmentsRouteRouteWithChildren
  "/settings/workspace/facilities": typeof LayoutSettingsPanelWorkspaceFacilitiesRouteRouteWithChildren
  "/settings/workspace/members": typeof LayoutSettingsPanelWorkspaceMembersRouteRouteWithChildren
  "/settings/workspace/notification-rules": typeof LayoutSettingsPanelWorkspaceNotificationRulesRouteRouteWithChildren
  "/settings/workspace/roles": typeof LayoutSettingsPanelWorkspaceRolesRouteRouteWithChildren
  "/settings/workspace/teams": typeof LayoutSettingsPanelWorkspaceTeamsRouteRouteWithChildren
  "/settings/workspace/templates": typeof LayoutSettingsPanelWorkspaceTemplatesRouteRouteWithChildren
  "/settings/workspace/tool-categories": typeof LayoutSettingsPanelWorkspaceToolCategoriesRouteRouteWithChildren
  "/settings/system/tenants/$tenantId": typeof LayoutSettingsSystemTenantsTenantIdRouteRouteWithChildren
  "/templates/quotes/$packageId/overview": typeof LayoutTemplatesQuotesPackageIdOverviewRouteRouteWithChildren
  "/agent/chats/delete/$id": typeof LayoutAgentChatsDeleteIdRoute
  "/aircraft/$aircraftId/fitted-components/new": typeof LayoutAircraftAircraftIdFittedComponentsNewRoute
  "/aircraft/$aircraftId/mod-status/new": typeof LayoutAircraftAircraftIdModStatusNewRoute
  "/aircraft/$aircraftId/readings/new": typeof LayoutAircraftAircraftIdReadingsNewRoute
  "/aircraft/$aircraftId/tech-log/$pageId": typeof LayoutAircraftAircraftIdTechLogPageIdRoute
  "/aircraft/$aircraftId/tech-log/new": typeof LayoutAircraftAircraftIdTechLogNewRoute
  "/customer/$customerId/contacts/create": typeof LayoutCustomerCustomerIdContactsCreateRoute
  "/documents/delete/$documentId": typeof LayoutDocumentsListDeleteDocumentIdRoute
  "/documents/delete/bulk": typeof LayoutDocumentsListDeleteBulkRoute
  "/documents/make-private/$documentId": typeof LayoutDocumentsListMakePrivateDocumentIdRoute
  "/documents/share/$documentId": typeof LayoutDocumentsListShareDocumentIdRoute
  "/documents/share/bulk": typeof LayoutDocumentsListShareBulkRoute
  "/maintenance-programmes/$programmeId/aircraft/enrol": typeof LayoutMaintenanceProgrammesProgrammeIdAircraftEnrolRoute
  "/maintenance-programmes/$programmeId/phases/$phaseId": typeof LayoutMaintenanceProgrammesProgrammeIdPhasesPhaseIdRoute
  "/maintenance-programmes/$programmeId/phases/new": typeof LayoutMaintenanceProgrammesProgrammeIdPhasesNewRoute
  "/maintenance-programmes/$programmeId/revisions/new": typeof LayoutMaintenanceProgrammesProgrammeIdRevisionsNewRoute
  "/maintenance-programmes/$programmeId/tasks/$taskId": typeof LayoutMaintenanceProgrammesProgrammeIdTasksTaskIdRoute
  "/maintenance-programmes/$programmeId/tasks/new": typeof LayoutMaintenanceProgrammesProgrammeIdTasksNewRoute
  "/quotes/$quoteId/phases/new": typeof LayoutQuotesQuoteIdPhasesNewRoute
  "/quotes/$quoteId/tasks/from-template": typeof LayoutQuotesQuoteIdTasksFromTemplateRoute
  "/quoting/squawks/delete/$squawkId": typeof LayoutQuotingSquawksDeleteSquawkIdRoute
  "/quoting/squawks/edit/$squawkId": typeof LayoutQuotingSquawksEditSquawkIdRoute
  "/settings/integrations/crm": typeof LayoutSettingsPanelIntegrationsCrmRoute
  "/settings/quoting/customer-approval": typeof LayoutSettingsPanelQuotingCustomerApprovalRoute
  "/settings/quoting/general": typeof LayoutSettingsPanelQuotingGeneralRoute
  "/settings/work-orders/general": typeof LayoutSettingsPanelWorkOrdersGeneralRoute
  "/templates/tasks/$taskId/archive": typeof LayoutTemplatesTasksTaskIdArchiveRoute
  "/tools/$toolId/calibrations/record": typeof LayoutToolsToolIdCalibrationsRecordRoute
  "/tools/$toolId/calibrations/send": typeof LayoutToolsToolIdCalibrationsSendRoute
  "/trace/sandbox/$conversationSessionId/$": typeof LayoutTraceSandboxConversationSessionIdSplatRoute
  "/work-orders/$workOrderId/phases/new": typeof LayoutWorkOrdersWorkOrderIdPhasesNewRoute
  "/work-orders/$workOrderId/squawks/$squawkId": typeof LayoutWorkOrdersWorkOrderIdSquawksSquawkIdRoute
  "/work-orders/$workOrderId/tasks/$taskId": typeof LayoutWorkOrdersWorkOrderIdTasksTaskIdRouteWithChildren
  "/work-orders/$workOrderId/tasks/delete": typeof LayoutWorkOrdersWorkOrderIdTasksDeleteRoute
  "/work-orders/$workOrderId/tasks/new": typeof LayoutWorkOrdersWorkOrderIdTasksNewRoute
  "/work-orders/delete/$workOrderId": typeof LayoutWorkOrdersListDeleteWorkOrderIdRoute
  "/quoting/emails/": typeof LayoutQuotingEmailsListIndexRoute
  "/settings/system/audit-log/": typeof LayoutSettingsSystemAuditLogIndexRoute
  "/templates/tasks/$taskId/": typeof LayoutTemplatesTasksTaskIdIndexRoute
  "/customer/$customerId/contacts/$contactId": typeof LayoutCustomerCustomerIdContactsListContactIdRouteRouteWithChildren
  "/settings/quoting/playbooks/$playbookId": typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdRouteRouteWithChildren
  "/settings/quoting/rate-cards/$rateCardId": typeof LayoutSettingsPanelQuotingRateCardsRateCardIdRouteRouteWithChildren
  "/settings/quoting/tax-rates/$taxRateId": typeof LayoutSettingsPanelQuotingTaxRatesTaxRateIdRouteRouteWithChildren
  "/settings/workspace/approval-flows/$policyId": typeof LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdRouteRouteWithChildren
  "/settings/workspace/notification-rules/$ruleId": typeof LayoutSettingsPanelWorkspaceNotificationRulesRuleIdRouteRouteWithChildren
  "/settings/workspace/templates/$kind": typeof LayoutSettingsPanelWorkspaceTemplatesKindRouteRouteWithChildren
  "/settings/system/tenants/$tenantId/settings": typeof LayoutSettingsSystemTenantsTenantIdSettingsRouteRouteWithChildren
  "/aircraft/$aircraftId/fitted-components/remove/$componentId": typeof LayoutAircraftAircraftIdFittedComponentsRemoveComponentIdRoute
  "/aircraft/$aircraftId/tech-log/void/$pageId": typeof LayoutAircraftAircraftIdTechLogVoidPageIdRoute
  "/inventory/$partId/prices/$priceId/delete": typeof LayoutInventoryPartIdPricesPriceIdDeleteRoute
  "/maintenance-programmes/$programmeId/aircraft/remove/$enrolmentId": typeof LayoutMaintenanceProgrammesProgrammeIdAircraftRemoveEnrolmentIdRoute
  "/maintenance-programmes/$programmeId/phases/remove/$phaseId": typeof LayoutMaintenanceProgrammesProgrammeIdPhasesRemovePhaseIdRoute
  "/maintenance-programmes/$programmeId/revisions/release/$revisionId": typeof LayoutMaintenanceProgrammesProgrammeIdRevisionsReleaseRevisionIdRoute
  "/maintenance-programmes/$programmeId/tasks/remove/$taskId": typeof LayoutMaintenanceProgrammesProgrammeIdTasksRemoveTaskIdRoute
  "/quotes/$quoteId/phases/$phaseId/delete": typeof LayoutQuotesQuoteIdPhasesPhaseIdDeleteRoute
  "/quotes/$quoteId/phases/$phaseId/rename": typeof LayoutQuotesQuoteIdPhasesPhaseIdRenameRoute
  "/quotes/$quoteId/tasks/$taskId/apply-template": typeof LayoutQuotesQuoteIdTasksTaskIdApplyTemplateRoute
  "/quoting/emails/$emailId/share": typeof LayoutQuotingEmailsListEmailIdShareRoute
  "/quoting/emails/delete/$emailId": typeof LayoutQuotingEmailsListDeleteEmailIdRoute
  "/quoting/emails/delete/bulk": typeof LayoutQuotingEmailsListDeleteBulkRoute
  "/quoting/emails/share/bulk": typeof LayoutQuotingEmailsListShareBulkRoute
  "/settings/account/profile/change-password": typeof LayoutSettingsPanelAccountProfileChangePasswordRoute
  "/settings/quoting/flat-rates/$packageId": typeof LayoutSettingsPanelQuotingFlatRatesPackageIdRoute
  "/settings/quoting/playbooks/create": typeof LayoutSettingsPanelQuotingPlaybooksCreateRoute
  "/settings/quoting/task-groups/import": typeof LayoutSettingsPanelQuotingTaskGroupsImportRoute
  "/settings/workspace/approval-flows/create": typeof LayoutSettingsPanelWorkspaceApprovalFlowsCreateRoute
  "/settings/workspace/departments/create": typeof LayoutSettingsPanelWorkspaceDepartmentsCreateRoute
  "/settings/workspace/facilities/create": typeof LayoutSettingsPanelWorkspaceFacilitiesCreateRoute
  "/settings/workspace/members/create": typeof LayoutSettingsPanelWorkspaceMembersCreateRoute
  "/settings/workspace/notification-rules/create": typeof LayoutSettingsPanelWorkspaceNotificationRulesCreateRoute
  "/settings/workspace/roles/create": typeof LayoutSettingsPanelWorkspaceRolesCreateRoute
  "/settings/workspace/teams/create": typeof LayoutSettingsPanelWorkspaceTeamsCreateRoute
  "/settings/workspace/tool-categories/create": typeof LayoutSettingsPanelWorkspaceToolCategoriesCreateRoute
  "/settings/system/tenants/$tenantId/approval-policies": typeof LayoutSettingsSystemTenantsTenantIdApprovalPoliciesRoute
  "/settings/system/tenants/$tenantId/integrations": typeof LayoutSettingsSystemTenantsTenantIdIntegrationsRoute
  "/settings/system/tenants/$tenantId/notification-rules": typeof LayoutSettingsSystemTenantsTenantIdNotificationRulesRoute
  "/settings/system/tenants/$tenantId/users": typeof LayoutSettingsSystemTenantsTenantIdUsersRoute
  "/templates/quotes/$packageId/overview/archive": typeof LayoutTemplatesQuotesPackageIdOverviewArchiveRoute
  "/tools/$toolId/calibrations/$calibrationId/complete": typeof LayoutToolsToolIdCalibrationsCalibrationIdCompleteRoute
  "/tools/$toolId/loans/$loanId/receive": typeof LayoutToolsToolIdLoansLoanIdReceiveRoute
  "/work-orders/$workOrderId/phases/$phaseId/delete": typeof LayoutWorkOrdersWorkOrderIdPhasesPhaseIdDeleteRoute
  "/work-orders/$workOrderId/phases/$phaseId/rename": typeof LayoutWorkOrdersWorkOrderIdPhasesPhaseIdRenameRoute
  "/work-orders/$workOrderId/tasks/$taskId/delete": typeof LayoutWorkOrdersWorkOrderIdTasksTaskIdDeleteRoute
  "/customer/$customerId/contacts/": typeof LayoutCustomerCustomerIdContactsListIndexRoute
  "/planning/$planId/steps/$stepId/": typeof LayoutPlanningPlanIdStepsStepIdIndexRoute
  "/quotes/$quoteId/tasks/$taskId/": typeof LayoutQuotesQuoteIdTasksTaskIdIndexRoute
  "/quoting/emails/$emailId/": typeof LayoutQuotingEmailsListEmailIdIndexRoute
  "/quoting/quotes/builder/$quoteId/": typeof LayoutQuotingQuotesBuilderQuoteIdIndexRoute
  "/settings/account/notifications/": typeof LayoutSettingsPanelAccountNotificationsIndexRoute
  "/settings/account/profile/": typeof LayoutSettingsPanelAccountProfileIndexRoute
  "/settings/account/signing-pin/": typeof LayoutSettingsPanelAccountSigningPinIndexRoute
  "/settings/quoting/flat-rates/": typeof LayoutSettingsPanelQuotingFlatRatesIndexRoute
  "/settings/quoting/playbooks/": typeof LayoutSettingsPanelQuotingPlaybooksIndexRoute
  "/settings/quoting/rate-cards/": typeof LayoutSettingsPanelQuotingRateCardsIndexRoute
  "/settings/quoting/status/": typeof LayoutSettingsPanelQuotingStatusIndexRoute
  "/settings/quoting/task-groups/": typeof LayoutSettingsPanelQuotingTaskGroupsIndexRoute
  "/settings/quoting/tax-rates/": typeof LayoutSettingsPanelQuotingTaxRatesIndexRoute
  "/settings/workspace/approval-flows/": typeof LayoutSettingsPanelWorkspaceApprovalFlowsIndexRoute
  "/settings/workspace/general/": typeof LayoutSettingsPanelWorkspaceGeneralIndexRoute
  "/settings/workspace/notification-rules/": typeof LayoutSettingsPanelWorkspaceNotificationRulesIndexRoute
  "/settings/workspace/templates/": typeof LayoutSettingsPanelWorkspaceTemplatesIndexRoute
  "/settings/system/tenants/$tenantId/": typeof LayoutSettingsSystemTenantsTenantIdIndexRoute
  "/templates/quotes/$packageId/": typeof LayoutTemplatesQuotesPackageIdListIndexRoute
  "/templates/quotes/$packageId/overview/": typeof LayoutTemplatesQuotesPackageIdOverviewIndexRoute
  "/settings/quoting/playbooks/$playbookId/rules": typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesRouteRouteWithChildren
  "/settings/workspace/departments/$departmentId": typeof LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdRouteRouteWithChildren
  "/settings/workspace/facilities/$facilityId": typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdRouteRouteWithChildren
  "/settings/workspace/members/$userId": typeof LayoutSettingsPanelWorkspaceMembersListUserIdRouteRouteWithChildren
  "/settings/workspace/roles/$roleId": typeof LayoutSettingsPanelWorkspaceRolesListRoleIdRouteRouteWithChildren
  "/settings/workspace/teams/$teamId": typeof LayoutSettingsPanelWorkspaceTeamsListTeamIdRouteRouteWithChildren
  "/settings/workspace/tool-categories/$categoryId": typeof LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdRouteRouteWithChildren
  "/templates/quotes/$packageId/tasks/$taskId": typeof LayoutTemplatesQuotesPackageIdListTasksTaskIdRouteRouteWithChildren
  "/aircraft/$aircraftId/part-instances/$partInstanceId/readings/new": typeof LayoutAircraftAircraftIdPartInstancesPartInstanceIdReadingsNewRoute
  "/customer/$customerId/contacts/$contactId/delete": typeof LayoutCustomerCustomerIdContactsListContactIdDeleteRoute
  "/planning/$planId/steps/$stepId/tasks/$taskIndex": typeof LayoutPlanningPlanIdStepsStepIdTasksTaskIndexRoute
  "/quoting/quotes/builder/$quoteId/task/$taskId": typeof LayoutQuotingQuotesBuilderQuoteIdTaskTaskIdRoute
  "/settings/integrations/erp/api-key/set": typeof LayoutSettingsPanelIntegrationsErpApiKeySetRoute
  "/settings/integrations/erp/relay/set": typeof LayoutSettingsPanelIntegrationsErpRelaySetRoute
  "/settings/quoting/playbooks/$playbookId/activity": typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdActivityRoute
  "/settings/quoting/playbooks/$playbookId/configuration": typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdConfigurationRoute
  "/settings/quoting/rate-cards/$rateCardId/archive": typeof LayoutSettingsPanelQuotingRateCardsRateCardIdArchiveRoute
  "/settings/quoting/task-groups/$groupId/archive": typeof LayoutSettingsPanelQuotingTaskGroupsGroupIdArchiveRoute
  "/settings/quoting/tax-rates/$taxRateId/archive": typeof LayoutSettingsPanelQuotingTaxRatesTaxRateIdArchiveRoute
  "/settings/workspace/approval-flows/$policyId/delete": typeof LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdDeleteRoute
  "/settings/workspace/approval-flows/duplicate/$policyId": typeof LayoutSettingsPanelWorkspaceApprovalFlowsDuplicatePolicyIdRoute
  "/settings/workspace/notification-rules/$ruleId/delete": typeof LayoutSettingsPanelWorkspaceNotificationRulesRuleIdDeleteRoute
  "/settings/workspace/notification-rules/duplicate/$ruleId": typeof LayoutSettingsPanelWorkspaceNotificationRulesDuplicateRuleIdRoute
  "/settings/workspace/roles/duplicate/$roleId": typeof LayoutSettingsPanelWorkspaceRolesDuplicateRoleIdRoute
  "/settings/workspace/templates/$kind/revert": typeof LayoutSettingsPanelWorkspaceTemplatesKindRevertRoute
  "/settings/system/tenants/$tenantId/settings/reindex": typeof LayoutSettingsSystemTenantsTenantIdSettingsReindexRoute
  "/templates/quotes/$packageId/tasks/create": typeof LayoutTemplatesQuotesPackageIdListTasksCreateRoute
  "/customer/$customerId/contacts/$contactId/": typeof LayoutCustomerCustomerIdContactsListContactIdIndexRoute
  "/settings/integrations/erp/": typeof LayoutSettingsPanelIntegrationsErpListIndexRoute
  "/settings/quoting/playbooks/$playbookId/": typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdIndexRoute
  "/settings/quoting/rate-cards/$rateCardId/": typeof LayoutSettingsPanelQuotingRateCardsRateCardIdIndexRoute
  "/settings/quoting/tax-rates/$taxRateId/": typeof LayoutSettingsPanelQuotingTaxRatesTaxRateIdIndexRoute
  "/settings/workspace/approval-flows/$policyId/": typeof LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdIndexRoute
  "/settings/workspace/departments/": typeof LayoutSettingsPanelWorkspaceDepartmentsListIndexRoute
  "/settings/workspace/facilities/": typeof LayoutSettingsPanelWorkspaceFacilitiesListIndexRoute
  "/settings/workspace/members/": typeof LayoutSettingsPanelWorkspaceMembersListIndexRoute
  "/settings/workspace/notification-rules/$ruleId/": typeof LayoutSettingsPanelWorkspaceNotificationRulesRuleIdIndexRoute
  "/settings/workspace/roles/": typeof LayoutSettingsPanelWorkspaceRolesListIndexRoute
  "/settings/workspace/teams/": typeof LayoutSettingsPanelWorkspaceTeamsListIndexRoute
  "/settings/workspace/templates/$kind/": typeof LayoutSettingsPanelWorkspaceTemplatesKindIndexRoute
  "/settings/workspace/tool-categories/": typeof LayoutSettingsPanelWorkspaceToolCategoriesListIndexRoute
  "/settings/system/tenants/$tenantId/settings/": typeof LayoutSettingsSystemTenantsTenantIdSettingsIndexRoute
  "/aircraft/$aircraftId/part-instances/$partInstanceId/readings/$readingId/delete": typeof LayoutAircraftAircraftIdPartInstancesPartInstanceIdReadingsReadingIdDeleteRoute
  "/quotes/$quoteId/tasks/$taskId/steps/$stepId/remove": typeof LayoutQuotesQuoteIdTasksTaskIdStepsStepIdRemoveRoute
  "/settings/integrations/erp/api-key/revoke": typeof LayoutSettingsPanelIntegrationsErpListApiKeyRevokeRoute
  "/settings/integrations/erp/relay/remove": typeof LayoutSettingsPanelIntegrationsErpListRelayRemoveRoute
  "/settings/workspace/departments/$departmentId/delete": typeof LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdDeleteRoute
  "/settings/workspace/facilities/$facilityId/delete": typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdDeleteRoute
  "/settings/workspace/members/$userId/change-password": typeof LayoutSettingsPanelWorkspaceMembersListUserIdChangePasswordRoute
  "/settings/workspace/members/$userId/delete": typeof LayoutSettingsPanelWorkspaceMembersListUserIdDeleteRoute
  "/settings/workspace/members/$userId/resend-login-email": typeof LayoutSettingsPanelWorkspaceMembersListUserIdResendLoginEmailRoute
  "/settings/workspace/roles/$roleId/delete": typeof LayoutSettingsPanelWorkspaceRolesListRoleIdDeleteRoute
  "/settings/workspace/roles/$roleId/reset": typeof LayoutSettingsPanelWorkspaceRolesListRoleIdResetRoute
  "/settings/workspace/teams/$teamId/delete": typeof LayoutSettingsPanelWorkspaceTeamsListTeamIdDeleteRoute
  "/settings/workspace/tool-categories/$categoryId/delete": typeof LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdDeleteRoute
  "/templates/quotes/$packageId/tasks/$taskId/archive": typeof LayoutTemplatesQuotesPackageIdListTasksTaskIdArchiveRoute
  "/work-orders/$workOrderId/tasks/$taskId/steps/$stepId/delete": typeof LayoutWorkOrdersWorkOrderIdTasksTaskIdStepsStepIdDeleteRoute
  "/work-orders/$workOrderId/tasks/$taskId/time-entries/$timeEntryId/delete": typeof LayoutWorkOrdersWorkOrderIdTasksTaskIdTimeEntriesTimeEntryIdDeleteRoute
  "/settings/quoting/playbooks/$playbookId/rules/": typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesIndexRoute
  "/settings/workspace/departments/$departmentId/": typeof LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdIndexRoute
  "/settings/workspace/facilities/$facilityId/": typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdIndexRoute
  "/settings/workspace/members/$userId/": typeof LayoutSettingsPanelWorkspaceMembersListUserIdIndexRoute
  "/settings/workspace/roles/$roleId/": typeof LayoutSettingsPanelWorkspaceRolesListRoleIdIndexRoute
  "/settings/workspace/teams/$teamId/": typeof LayoutSettingsPanelWorkspaceTeamsListTeamIdIndexRoute
  "/settings/workspace/tool-categories/$categoryId/": typeof LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdIndexRoute
  "/templates/quotes/$packageId/tasks/$taskId/": typeof LayoutTemplatesQuotesPackageIdListTasksTaskIdIndexRoute
  "/settings/quoting/playbooks/$playbookId/rules/$lineageId/delete": typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesLineageIdDeleteRoute
  "/settings/workspace/departments/$departmentId/positions/$positionId/remove": typeof LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdPositionsPositionIdRemoveRoute
  "/settings/workspace/facilities/$facilityId/locations/$locationId/delete": typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdLocationsLocationIdDeleteRoute
  "/settings/workspace/facilities/$facilityId/positions/$positionId/remove": typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdPositionsPositionIdRemoveRoute
  "/settings/workspace/teams/$teamId/positions/$positionId/remove": typeof LayoutSettingsPanelWorkspaceTeamsListTeamIdPositionsPositionIdRemoveRoute
}
export interface FileRoutesByTo {
  "/change-password": typeof ChangePasswordRoute
  "/login": typeof LoginRoute
  "/recover-password": typeof RecoverPasswordRoute
  "/reset-password": typeof ResetPasswordRoute
  "/documents": typeof LayoutDocumentsListIndexRoute
  "/tie-in": typeof LayoutTieInRouteRoute
  "/": typeof LayoutIndexRoute
  "/quoting/emails": typeof LayoutQuotingEmailsListIndexRoute
  "/settings": typeof LayoutSettingsIndexRoute
  "/agent/$id": typeof LayoutAgentIdRoute
  "/agent/chats": typeof LayoutAgentChatsRouteWithChildren
  "/aircraft/new": typeof LayoutAircraftNewRoute
  "/airworthiness-directives/upload": typeof LayoutAirworthinessDirectivesUploadRoute
  "/airworthiness-directives/$documentId": typeof LayoutAirworthinessDirectivesDocumentIdRoute
  "/approved-vendors/$vendorId": typeof LayoutApprovedVendorsVendorIdRoute
  "/approved-vendors/new": typeof LayoutApprovedVendorsNewRoute
  "/customer/new": typeof LayoutCustomerNewRoute
  "/documents/$documentId": typeof LayoutDocumentsDocumentIdRoute
  "/forecasts/new": typeof LayoutForecastsNewRoute
  "/forecasts/$forecastId": typeof LayoutForecastsForecastIdRoute
  "/forecasts/preview": typeof LayoutForecastsPreviewRoute
  "/inventory/new": typeof LayoutInventoryNewRoute
  "/maintenance-programmes/new": typeof LayoutMaintenanceProgrammesNewRoute
  "/quotes/create": typeof LayoutQuotesCreateRoute
  "/quotes/from-file": typeof LayoutQuotesFromFileRoute
  "/settings/company": typeof LayoutSettingsCompanyRoute
  "/settings/system": typeof LayoutSettingsSystemRoute
  "/settings/user": typeof LayoutSettingsUserRoute
  "/tech-logs/$pageId": typeof LayoutTechLogsPageIdRoute
  "/tech-logs/new": typeof LayoutTechLogsNewRoute
  "/timesheet/log": typeof LayoutTimesheetLogRoute
  "/tools/new": typeof LayoutToolsNewRoute
  "/work-task/$id": typeof LayoutWorkTaskIdRoute
  "/review/$token/sign": typeof ReviewTokenSignRoute
  "/agent": typeof LayoutAgentIndexRoute
  "/aircraft": typeof LayoutAircraftIndexRoute
  "/airworthiness-directives": typeof LayoutAirworthinessDirectivesIndexRoute
  "/approved-vendors": typeof LayoutApprovedVendorsIndexRoute
  "/customer": typeof LayoutCustomerIndexRoute
  "/forecasts": typeof LayoutForecastsIndexRoute
  "/inventory": typeof LayoutInventoryIndexRoute
  "/maintenance-programmes": typeof LayoutMaintenanceProgrammesIndexRoute
  "/manpower": typeof LayoutManpowerIndexRoute
  "/planning": typeof LayoutPlanningIndexRoute
  "/quotes": typeof LayoutQuotesIndexRoute
  "/quoting": typeof LayoutQuotingIndexRoute
  "/tech-logs": typeof LayoutTechLogsIndexRoute
  "/templates": typeof LayoutTemplatesIndexRoute
  "/timesheet": typeof LayoutTimesheetIndexRoute
  "/tools": typeof LayoutToolsIndexRoute
  "/review/$token": typeof ReviewTokenIndexRoute
  "/customer/$customerId/contacts": typeof LayoutCustomerCustomerIdContactsListIndexRoute
  "/documents/upload": typeof LayoutDocumentsListUploadRouteRoute
  "/templates/quotes/$packageId": typeof LayoutTemplatesQuotesPackageIdListIndexRoute
  "/agent/delete/$id": typeof LayoutAgentDeleteIdRoute
  "/aircraft/$aircraftId/edit": typeof LayoutAircraftAircraftIdEditRoute
  "/airworthiness-directives/delete/$documentId": typeof LayoutAirworthinessDirectivesDeleteDocumentIdRoute
  "/approved-vendors/delete/$vendorId": typeof LayoutApprovedVendorsDeleteVendorIdRoute
  "/approved-vendors/delete/bulk": typeof LayoutApprovedVendorsDeleteBulkRoute
  "/assessments/ad/$reportId": typeof LayoutAssessmentsAdReportIdRoute
  "/assessments/sb/$reportId": typeof LayoutAssessmentsSbReportIdRoute
  "/customer/delete/$customerId": typeof LayoutCustomerDeleteCustomerIdRoute
  "/customer/$customerId/aircraft": typeof LayoutCustomerCustomerIdAircraftRoute
  "/customer/$customerId/delete": typeof LayoutCustomerCustomerIdDeleteRoute
  "/customer/$customerId/wo-history": typeof LayoutCustomerCustomerIdWoHistoryRoute
  "/forecasts/delete/$forecastId": typeof LayoutForecastsDeleteForecastIdRoute
  "/inventory/$partId/archive": typeof LayoutInventoryPartIdArchiveRoute
  "/inventory/delete/$partId": typeof LayoutInventoryDeletePartIdRoute
  "/inventory/delete/bulk": typeof LayoutInventoryDeleteBulkRoute
  "/inventory/purchase-orders/$purchaseOrderId": typeof LayoutInventoryPurchaseOrdersPurchaseOrderIdRoute
  "/inventory/purchase-orders/new": typeof LayoutInventoryPurchaseOrdersNewRoute
  "/maintenance-programmes/delete/$programmeId": typeof LayoutMaintenanceProgrammesDeleteProgrammeIdRoute
  "/planning/new/forecast": typeof LayoutPlanningNewForecastRoute
  "/planning/new/quote": typeof LayoutPlanningNewQuoteRoute
  "/quotes/delete/$quoteId": typeof LayoutQuotesDeleteQuoteIdRoute
  "/quotes/$quoteId/corridor": typeof LayoutQuotesQuoteIdCorridorRoute
  "/quotes/$quoteId/send": typeof LayoutQuotesQuoteIdSendRoute
  "/quotes/$quoteId/sent": typeof LayoutQuotesQuoteIdSentRoute
  "/quoting/canned/$packageId": typeof LayoutQuotingCannedPackageIdRoute
  "/quoting/quotes/$quoteId": typeof LayoutQuotingQuotesQuoteIdRoute
  "/quoting/squawks/$squawkId": typeof LayoutQuotingSquawksSquawkIdRoute
  "/tech-logs/delete/$pageId": typeof LayoutTechLogsDeletePageIdRoute
  "/templates/quotes/delete": typeof LayoutTemplatesQuotesDeleteRoute
  "/templates/tasks/create": typeof LayoutTemplatesTasksCreateRoute
  "/templates/tasks/delete": typeof LayoutTemplatesTasksDeleteRoute
  "/timesheet/delete/$timeEntryId": typeof LayoutTimesheetDeleteTimeEntryIdRoute
  "/tools/$toolId/issue": typeof LayoutToolsToolIdIssueRoute
  "/tools/$toolId/label": typeof LayoutToolsToolIdLabelRoute
  "/tools/$toolId/retire": typeof LayoutToolsToolIdRetireRoute
  "/work-orders/$workOrderId/cancel": typeof LayoutWorkOrdersWorkOrderIdCancelRoute
  "/work-orders/$workOrderId/close": typeof LayoutWorkOrdersWorkOrderIdCloseRoute
  "/aircraft/$aircraftId": typeof LayoutAircraftAircraftIdIndexRoute
  "/customer/$customerId": typeof LayoutCustomerCustomerIdIndexRoute
  "/inventory/$partId": typeof LayoutInventoryPartIdIndexRoute
  "/inventory/purchase-orders": typeof LayoutInventoryPurchaseOrdersIndexRoute
  "/maintenance-programmes/$programmeId": typeof LayoutMaintenanceProgrammesProgrammeIdIndexRoute
  "/planning/$planId": typeof LayoutPlanningPlanIdIndexRoute
  "/quotes/$quoteId": typeof LayoutQuotesQuoteIdIndexRoute
  "/quoting/canned": typeof LayoutQuotingCannedIndexRoute
  "/quoting/quotes": typeof LayoutQuotingQuotesIndexRoute
  "/quoting/squawks": typeof LayoutQuotingSquawksIndexRoute
  "/templates/quotes": typeof LayoutTemplatesQuotesIndexRoute
  "/templates/tasks": typeof LayoutTemplatesTasksIndexRoute
  "/tools/$toolId": typeof LayoutToolsToolIdIndexRoute
  "/work-orders/$workOrderId": typeof LayoutWorkOrdersWorkOrderIdIndexRoute
  "/work-orders": typeof LayoutWorkOrdersListIndexRoute
  "/settings/integrations/erp": typeof LayoutSettingsPanelIntegrationsErpListIndexRoute
  "/settings/workspace/departments": typeof LayoutSettingsPanelWorkspaceDepartmentsListIndexRoute
  "/settings/workspace/facilities": typeof LayoutSettingsPanelWorkspaceFacilitiesListIndexRoute
  "/settings/workspace/members": typeof LayoutSettingsPanelWorkspaceMembersListIndexRoute
  "/settings/workspace/roles": typeof LayoutSettingsPanelWorkspaceRolesListIndexRoute
  "/settings/workspace/teams": typeof LayoutSettingsPanelWorkspaceTeamsListIndexRoute
  "/settings/workspace/tool-categories": typeof LayoutSettingsPanelWorkspaceToolCategoriesListIndexRoute
  "/agent/chats/delete/$id": typeof LayoutAgentChatsDeleteIdRoute
  "/aircraft/$aircraftId/fitted-components/new": typeof LayoutAircraftAircraftIdFittedComponentsNewRoute
  "/aircraft/$aircraftId/mod-status/new": typeof LayoutAircraftAircraftIdModStatusNewRoute
  "/aircraft/$aircraftId/readings/new": typeof LayoutAircraftAircraftIdReadingsNewRoute
  "/aircraft/$aircraftId/tech-log/$pageId": typeof LayoutAircraftAircraftIdTechLogPageIdRoute
  "/aircraft/$aircraftId/tech-log/new": typeof LayoutAircraftAircraftIdTechLogNewRoute
  "/customer/$customerId/contacts/create": typeof LayoutCustomerCustomerIdContactsCreateRoute
  "/documents/delete/$documentId": typeof LayoutDocumentsListDeleteDocumentIdRoute
  "/documents/delete/bulk": typeof LayoutDocumentsListDeleteBulkRoute
  "/documents/make-private/$documentId": typeof LayoutDocumentsListMakePrivateDocumentIdRoute
  "/documents/share/$documentId": typeof LayoutDocumentsListShareDocumentIdRoute
  "/documents/share/bulk": typeof LayoutDocumentsListShareBulkRoute
  "/maintenance-programmes/$programmeId/aircraft/enrol": typeof LayoutMaintenanceProgrammesProgrammeIdAircraftEnrolRoute
  "/maintenance-programmes/$programmeId/phases/$phaseId": typeof LayoutMaintenanceProgrammesProgrammeIdPhasesPhaseIdRoute
  "/maintenance-programmes/$programmeId/phases/new": typeof LayoutMaintenanceProgrammesProgrammeIdPhasesNewRoute
  "/maintenance-programmes/$programmeId/revisions/new": typeof LayoutMaintenanceProgrammesProgrammeIdRevisionsNewRoute
  "/maintenance-programmes/$programmeId/tasks/$taskId": typeof LayoutMaintenanceProgrammesProgrammeIdTasksTaskIdRoute
  "/maintenance-programmes/$programmeId/tasks/new": typeof LayoutMaintenanceProgrammesProgrammeIdTasksNewRoute
  "/quotes/$quoteId/phases/new": typeof LayoutQuotesQuoteIdPhasesNewRoute
  "/quotes/$quoteId/tasks/from-template": typeof LayoutQuotesQuoteIdTasksFromTemplateRoute
  "/quoting/squawks/delete/$squawkId": typeof LayoutQuotingSquawksDeleteSquawkIdRoute
  "/quoting/squawks/edit/$squawkId": typeof LayoutQuotingSquawksEditSquawkIdRoute
  "/settings/integrations/crm": typeof LayoutSettingsPanelIntegrationsCrmRoute
  "/settings/quoting/customer-approval": typeof LayoutSettingsPanelQuotingCustomerApprovalRoute
  "/settings/quoting/general": typeof LayoutSettingsPanelQuotingGeneralRoute
  "/settings/work-orders/general": typeof LayoutSettingsPanelWorkOrdersGeneralRoute
  "/templates/tasks/$taskId/archive": typeof LayoutTemplatesTasksTaskIdArchiveRoute
  "/tools/$toolId/calibrations/record": typeof LayoutToolsToolIdCalibrationsRecordRoute
  "/tools/$toolId/calibrations/send": typeof LayoutToolsToolIdCalibrationsSendRoute
  "/trace/sandbox/$conversationSessionId/$": typeof LayoutTraceSandboxConversationSessionIdSplatRoute
  "/work-orders/$workOrderId/phases/new": typeof LayoutWorkOrdersWorkOrderIdPhasesNewRoute
  "/work-orders/$workOrderId/squawks/$squawkId": typeof LayoutWorkOrdersWorkOrderIdSquawksSquawkIdRoute
  "/work-orders/$workOrderId/tasks/$taskId": typeof LayoutWorkOrdersWorkOrderIdTasksTaskIdRouteWithChildren
  "/work-orders/$workOrderId/tasks/delete": typeof LayoutWorkOrdersWorkOrderIdTasksDeleteRoute
  "/work-orders/$workOrderId/tasks/new": typeof LayoutWorkOrdersWorkOrderIdTasksNewRoute
  "/work-orders/delete/$workOrderId": typeof LayoutWorkOrdersListDeleteWorkOrderIdRoute
  "/settings/system/audit-log": typeof LayoutSettingsSystemAuditLogIndexRoute
  "/templates/tasks/$taskId": typeof LayoutTemplatesTasksTaskIdIndexRoute
  "/aircraft/$aircraftId/fitted-components/remove/$componentId": typeof LayoutAircraftAircraftIdFittedComponentsRemoveComponentIdRoute
  "/aircraft/$aircraftId/tech-log/void/$pageId": typeof LayoutAircraftAircraftIdTechLogVoidPageIdRoute
  "/inventory/$partId/prices/$priceId/delete": typeof LayoutInventoryPartIdPricesPriceIdDeleteRoute
  "/maintenance-programmes/$programmeId/aircraft/remove/$enrolmentId": typeof LayoutMaintenanceProgrammesProgrammeIdAircraftRemoveEnrolmentIdRoute
  "/maintenance-programmes/$programmeId/phases/remove/$phaseId": typeof LayoutMaintenanceProgrammesProgrammeIdPhasesRemovePhaseIdRoute
  "/maintenance-programmes/$programmeId/revisions/release/$revisionId": typeof LayoutMaintenanceProgrammesProgrammeIdRevisionsReleaseRevisionIdRoute
  "/maintenance-programmes/$programmeId/tasks/remove/$taskId": typeof LayoutMaintenanceProgrammesProgrammeIdTasksRemoveTaskIdRoute
  "/quotes/$quoteId/phases/$phaseId/delete": typeof LayoutQuotesQuoteIdPhasesPhaseIdDeleteRoute
  "/quotes/$quoteId/phases/$phaseId/rename": typeof LayoutQuotesQuoteIdPhasesPhaseIdRenameRoute
  "/quotes/$quoteId/tasks/$taskId/apply-template": typeof LayoutQuotesQuoteIdTasksTaskIdApplyTemplateRoute
  "/quoting/emails/$emailId/share": typeof LayoutQuotingEmailsListEmailIdShareRoute
  "/quoting/emails/delete/$emailId": typeof LayoutQuotingEmailsListDeleteEmailIdRoute
  "/quoting/emails/delete/bulk": typeof LayoutQuotingEmailsListDeleteBulkRoute
  "/quoting/emails/share/bulk": typeof LayoutQuotingEmailsListShareBulkRoute
  "/settings/account/profile/change-password": typeof LayoutSettingsPanelAccountProfileChangePasswordRoute
  "/settings/quoting/flat-rates/$packageId": typeof LayoutSettingsPanelQuotingFlatRatesPackageIdRoute
  "/settings/quoting/playbooks/create": typeof LayoutSettingsPanelQuotingPlaybooksCreateRoute
  "/settings/quoting/task-groups/import": typeof LayoutSettingsPanelQuotingTaskGroupsImportRoute
  "/settings/workspace/approval-flows/create": typeof LayoutSettingsPanelWorkspaceApprovalFlowsCreateRoute
  "/settings/workspace/departments/create": typeof LayoutSettingsPanelWorkspaceDepartmentsCreateRoute
  "/settings/workspace/facilities/create": typeof LayoutSettingsPanelWorkspaceFacilitiesCreateRoute
  "/settings/workspace/members/create": typeof LayoutSettingsPanelWorkspaceMembersCreateRoute
  "/settings/workspace/notification-rules/create": typeof LayoutSettingsPanelWorkspaceNotificationRulesCreateRoute
  "/settings/workspace/roles/create": typeof LayoutSettingsPanelWorkspaceRolesCreateRoute
  "/settings/workspace/teams/create": typeof LayoutSettingsPanelWorkspaceTeamsCreateRoute
  "/settings/workspace/tool-categories/create": typeof LayoutSettingsPanelWorkspaceToolCategoriesCreateRoute
  "/settings/system/tenants/$tenantId/approval-policies": typeof LayoutSettingsSystemTenantsTenantIdApprovalPoliciesRoute
  "/settings/system/tenants/$tenantId/integrations": typeof LayoutSettingsSystemTenantsTenantIdIntegrationsRoute
  "/settings/system/tenants/$tenantId/notification-rules": typeof LayoutSettingsSystemTenantsTenantIdNotificationRulesRoute
  "/settings/system/tenants/$tenantId/users": typeof LayoutSettingsSystemTenantsTenantIdUsersRoute
  "/templates/quotes/$packageId/overview/archive": typeof LayoutTemplatesQuotesPackageIdOverviewArchiveRoute
  "/tools/$toolId/calibrations/$calibrationId/complete": typeof LayoutToolsToolIdCalibrationsCalibrationIdCompleteRoute
  "/tools/$toolId/loans/$loanId/receive": typeof LayoutToolsToolIdLoansLoanIdReceiveRoute
  "/work-orders/$workOrderId/phases/$phaseId/delete": typeof LayoutWorkOrdersWorkOrderIdPhasesPhaseIdDeleteRoute
  "/work-orders/$workOrderId/phases/$phaseId/rename": typeof LayoutWorkOrdersWorkOrderIdPhasesPhaseIdRenameRoute
  "/work-orders/$workOrderId/tasks/$taskId/delete": typeof LayoutWorkOrdersWorkOrderIdTasksTaskIdDeleteRoute
  "/planning/$planId/steps/$stepId": typeof LayoutPlanningPlanIdStepsStepIdIndexRoute
  "/quotes/$quoteId/tasks/$taskId": typeof LayoutQuotesQuoteIdTasksTaskIdIndexRoute
  "/quoting/emails/$emailId": typeof LayoutQuotingEmailsListEmailIdIndexRoute
  "/quoting/quotes/builder/$quoteId": typeof LayoutQuotingQuotesBuilderQuoteIdIndexRoute
  "/settings/account/notifications": typeof LayoutSettingsPanelAccountNotificationsIndexRoute
  "/settings/account/profile": typeof LayoutSettingsPanelAccountProfileIndexRoute
  "/settings/account/signing-pin": typeof LayoutSettingsPanelAccountSigningPinIndexRoute
  "/settings/quoting/flat-rates": typeof LayoutSettingsPanelQuotingFlatRatesIndexRoute
  "/settings/quoting/playbooks": typeof LayoutSettingsPanelQuotingPlaybooksIndexRoute
  "/settings/quoting/rate-cards": typeof LayoutSettingsPanelQuotingRateCardsIndexRoute
  "/settings/quoting/status": typeof LayoutSettingsPanelQuotingStatusIndexRoute
  "/settings/quoting/task-groups": typeof LayoutSettingsPanelQuotingTaskGroupsIndexRoute
  "/settings/quoting/tax-rates": typeof LayoutSettingsPanelQuotingTaxRatesIndexRoute
  "/settings/workspace/approval-flows": typeof LayoutSettingsPanelWorkspaceApprovalFlowsIndexRoute
  "/settings/workspace/general": typeof LayoutSettingsPanelWorkspaceGeneralIndexRoute
  "/settings/workspace/notification-rules": typeof LayoutSettingsPanelWorkspaceNotificationRulesIndexRoute
  "/settings/workspace/templates": typeof LayoutSettingsPanelWorkspaceTemplatesIndexRoute
  "/settings/system/tenants/$tenantId": typeof LayoutSettingsSystemTenantsTenantIdIndexRoute
  "/templates/quotes/$packageId/overview": typeof LayoutTemplatesQuotesPackageIdOverviewIndexRoute
  "/aircraft/$aircraftId/part-instances/$partInstanceId/readings/new": typeof LayoutAircraftAircraftIdPartInstancesPartInstanceIdReadingsNewRoute
  "/customer/$customerId/contacts/$contactId/delete": typeof LayoutCustomerCustomerIdContactsListContactIdDeleteRoute
  "/planning/$planId/steps/$stepId/tasks/$taskIndex": typeof LayoutPlanningPlanIdStepsStepIdTasksTaskIndexRoute
  "/quoting/quotes/builder/$quoteId/task/$taskId": typeof LayoutQuotingQuotesBuilderQuoteIdTaskTaskIdRoute
  "/settings/integrations/erp/api-key/set": typeof LayoutSettingsPanelIntegrationsErpApiKeySetRoute
  "/settings/integrations/erp/relay/set": typeof LayoutSettingsPanelIntegrationsErpRelaySetRoute
  "/settings/quoting/playbooks/$playbookId/activity": typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdActivityRoute
  "/settings/quoting/playbooks/$playbookId/configuration": typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdConfigurationRoute
  "/settings/quoting/rate-cards/$rateCardId/archive": typeof LayoutSettingsPanelQuotingRateCardsRateCardIdArchiveRoute
  "/settings/quoting/task-groups/$groupId/archive": typeof LayoutSettingsPanelQuotingTaskGroupsGroupIdArchiveRoute
  "/settings/quoting/tax-rates/$taxRateId/archive": typeof LayoutSettingsPanelQuotingTaxRatesTaxRateIdArchiveRoute
  "/settings/workspace/approval-flows/$policyId/delete": typeof LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdDeleteRoute
  "/settings/workspace/approval-flows/duplicate/$policyId": typeof LayoutSettingsPanelWorkspaceApprovalFlowsDuplicatePolicyIdRoute
  "/settings/workspace/notification-rules/$ruleId/delete": typeof LayoutSettingsPanelWorkspaceNotificationRulesRuleIdDeleteRoute
  "/settings/workspace/notification-rules/duplicate/$ruleId": typeof LayoutSettingsPanelWorkspaceNotificationRulesDuplicateRuleIdRoute
  "/settings/workspace/roles/duplicate/$roleId": typeof LayoutSettingsPanelWorkspaceRolesDuplicateRoleIdRoute
  "/settings/workspace/templates/$kind/revert": typeof LayoutSettingsPanelWorkspaceTemplatesKindRevertRoute
  "/settings/system/tenants/$tenantId/settings/reindex": typeof LayoutSettingsSystemTenantsTenantIdSettingsReindexRoute
  "/templates/quotes/$packageId/tasks/create": typeof LayoutTemplatesQuotesPackageIdListTasksCreateRoute
  "/customer/$customerId/contacts/$contactId": typeof LayoutCustomerCustomerIdContactsListContactIdIndexRoute
  "/settings/quoting/playbooks/$playbookId": typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdIndexRoute
  "/settings/quoting/rate-cards/$rateCardId": typeof LayoutSettingsPanelQuotingRateCardsRateCardIdIndexRoute
  "/settings/quoting/tax-rates/$taxRateId": typeof LayoutSettingsPanelQuotingTaxRatesTaxRateIdIndexRoute
  "/settings/workspace/approval-flows/$policyId": typeof LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdIndexRoute
  "/settings/workspace/notification-rules/$ruleId": typeof LayoutSettingsPanelWorkspaceNotificationRulesRuleIdIndexRoute
  "/settings/workspace/templates/$kind": typeof LayoutSettingsPanelWorkspaceTemplatesKindIndexRoute
  "/settings/system/tenants/$tenantId/settings": typeof LayoutSettingsSystemTenantsTenantIdSettingsIndexRoute
  "/aircraft/$aircraftId/part-instances/$partInstanceId/readings/$readingId/delete": typeof LayoutAircraftAircraftIdPartInstancesPartInstanceIdReadingsReadingIdDeleteRoute
  "/quotes/$quoteId/tasks/$taskId/steps/$stepId/remove": typeof LayoutQuotesQuoteIdTasksTaskIdStepsStepIdRemoveRoute
  "/settings/integrations/erp/api-key/revoke": typeof LayoutSettingsPanelIntegrationsErpListApiKeyRevokeRoute
  "/settings/integrations/erp/relay/remove": typeof LayoutSettingsPanelIntegrationsErpListRelayRemoveRoute
  "/settings/workspace/departments/$departmentId/delete": typeof LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdDeleteRoute
  "/settings/workspace/facilities/$facilityId/delete": typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdDeleteRoute
  "/settings/workspace/members/$userId/change-password": typeof LayoutSettingsPanelWorkspaceMembersListUserIdChangePasswordRoute
  "/settings/workspace/members/$userId/delete": typeof LayoutSettingsPanelWorkspaceMembersListUserIdDeleteRoute
  "/settings/workspace/members/$userId/resend-login-email": typeof LayoutSettingsPanelWorkspaceMembersListUserIdResendLoginEmailRoute
  "/settings/workspace/roles/$roleId/delete": typeof LayoutSettingsPanelWorkspaceRolesListRoleIdDeleteRoute
  "/settings/workspace/roles/$roleId/reset": typeof LayoutSettingsPanelWorkspaceRolesListRoleIdResetRoute
  "/settings/workspace/teams/$teamId/delete": typeof LayoutSettingsPanelWorkspaceTeamsListTeamIdDeleteRoute
  "/settings/workspace/tool-categories/$categoryId/delete": typeof LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdDeleteRoute
  "/templates/quotes/$packageId/tasks/$taskId/archive": typeof LayoutTemplatesQuotesPackageIdListTasksTaskIdArchiveRoute
  "/work-orders/$workOrderId/tasks/$taskId/steps/$stepId/delete": typeof LayoutWorkOrdersWorkOrderIdTasksTaskIdStepsStepIdDeleteRoute
  "/work-orders/$workOrderId/tasks/$taskId/time-entries/$timeEntryId/delete": typeof LayoutWorkOrdersWorkOrderIdTasksTaskIdTimeEntriesTimeEntryIdDeleteRoute
  "/settings/quoting/playbooks/$playbookId/rules": typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesIndexRoute
  "/settings/workspace/departments/$departmentId": typeof LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdIndexRoute
  "/settings/workspace/facilities/$facilityId": typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdIndexRoute
  "/settings/workspace/members/$userId": typeof LayoutSettingsPanelWorkspaceMembersListUserIdIndexRoute
  "/settings/workspace/roles/$roleId": typeof LayoutSettingsPanelWorkspaceRolesListRoleIdIndexRoute
  "/settings/workspace/teams/$teamId": typeof LayoutSettingsPanelWorkspaceTeamsListTeamIdIndexRoute
  "/settings/workspace/tool-categories/$categoryId": typeof LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdIndexRoute
  "/templates/quotes/$packageId/tasks/$taskId": typeof LayoutTemplatesQuotesPackageIdListTasksTaskIdIndexRoute
  "/settings/quoting/playbooks/$playbookId/rules/$lineageId/delete": typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesLineageIdDeleteRoute
  "/settings/workspace/departments/$departmentId/positions/$positionId/remove": typeof LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdPositionsPositionIdRemoveRoute
  "/settings/workspace/facilities/$facilityId/locations/$locationId/delete": typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdLocationsLocationIdDeleteRoute
  "/settings/workspace/facilities/$facilityId/positions/$positionId/remove": typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdPositionsPositionIdRemoveRoute
  "/settings/workspace/teams/$teamId/positions/$positionId/remove": typeof LayoutSettingsPanelWorkspaceTeamsListTeamIdPositionsPositionIdRemoveRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_layout": typeof LayoutRouteWithChildren
  "/change-password": typeof ChangePasswordRoute
  "/login": typeof LoginRoute
  "/recover-password": typeof RecoverPasswordRoute
  "/reset-password": typeof ResetPasswordRoute
  "/_layout/agent": typeof LayoutAgentRouteRouteWithChildren
  "/_layout/aircraft": typeof LayoutAircraftRouteRouteWithChildren
  "/_layout/airworthiness-directives": typeof LayoutAirworthinessDirectivesRouteRouteWithChildren
  "/_layout/approved-vendors": typeof LayoutApprovedVendorsRouteRouteWithChildren
  "/_layout/customer": typeof LayoutCustomerRouteRouteWithChildren
  "/_layout/documents": typeof LayoutDocumentsRouteRouteWithChildren
  "/_layout/forecasts": typeof LayoutForecastsRouteRouteWithChildren
  "/_layout/inventory": typeof LayoutInventoryRouteRouteWithChildren
  "/_layout/maintenance-programmes": typeof LayoutMaintenanceProgrammesRouteRouteWithChildren
  "/_layout/planning": typeof LayoutPlanningRouteRouteWithChildren
  "/_layout/quotes": typeof LayoutQuotesRouteRouteWithChildren
  "/_layout/settings": typeof LayoutSettingsRouteRouteWithChildren
  "/_layout/tech-logs": typeof LayoutTechLogsRouteRouteWithChildren
  "/_layout/templates": typeof LayoutTemplatesRouteRouteWithChildren
  "/_layout/tie-in": typeof LayoutTieInRouteRoute
  "/_layout/timesheet": typeof LayoutTimesheetRouteRouteWithChildren
  "/_layout/tools": typeof LayoutToolsRouteRouteWithChildren
  "/review/$token": typeof ReviewTokenRouteRouteWithChildren
  "/_layout/": typeof LayoutIndexRoute
  "/_layout/aircraft_/$aircraftId": typeof LayoutAircraftAircraftIdRouteRouteWithChildren
  "/_layout/customer_/$customerId": typeof LayoutCustomerCustomerIdRouteRouteWithChildren
  "/_layout/documents/_list": typeof LayoutDocumentsListRouteRouteWithChildren
  "/_layout/inventory/$partId": typeof LayoutInventoryPartIdRouteRouteWithChildren
  "/_layout/inventory_/purchase-orders": typeof LayoutInventoryPurchaseOrdersRouteRouteWithChildren
  "/_layout/maintenance-programmes_/$programmeId": typeof LayoutMaintenanceProgrammesProgrammeIdRouteRouteWithChildren
  "/_layout/planning_/$planId": typeof LayoutPlanningPlanIdRouteRouteWithChildren
  "/_layout/quotes_/$quoteId": typeof LayoutQuotesQuoteIdRouteRouteWithChildren
  "/_layout/quoting_/emails": typeof LayoutQuotingEmailsRouteRouteWithChildren
  "/_layout/quoting_/squawks": typeof LayoutQuotingSquawksRouteRouteWithChildren
  "/_layout/settings/_panel": typeof LayoutSettingsPanelRouteRouteWithChildren
  "/_layout/templates/quotes": typeof LayoutTemplatesQuotesRouteRouteWithChildren
  "/_layout/templates/tasks": typeof LayoutTemplatesTasksRouteRouteWithChildren
  "/_layout/tools/$toolId": typeof LayoutToolsToolIdRouteRouteWithChildren
  "/_layout/work-orders/$workOrderId": typeof LayoutWorkOrdersWorkOrderIdRouteRouteWithChildren
  "/_layout/work-orders/_list": typeof LayoutWorkOrdersListRouteRouteWithChildren
  "/_layout/agent/$id": typeof LayoutAgentIdRoute
  "/_layout/agent/chats": typeof LayoutAgentChatsRouteWithChildren
  "/_layout/aircraft_/new": typeof LayoutAircraftNewRoute
  "/_layout/airworthiness-directives/upload": typeof LayoutAirworthinessDirectivesUploadRoute
  "/_layout/airworthiness-directives_/$documentId": typeof LayoutAirworthinessDirectivesDocumentIdRoute
  "/_layout/approved-vendors_/$vendorId": typeof LayoutApprovedVendorsVendorIdRoute
  "/_layout/approved-vendors_/new": typeof LayoutApprovedVendorsNewRoute
  "/_layout/customer_/new": typeof LayoutCustomerNewRoute
  "/_layout/documents/$documentId": typeof LayoutDocumentsDocumentIdRoute
  "/_layout/forecasts/new": typeof LayoutForecastsNewRoute
  "/_layout/forecasts_/$forecastId": typeof LayoutForecastsForecastIdRoute
  "/_layout/forecasts_/preview": typeof LayoutForecastsPreviewRoute
  "/_layout/inventory/new": typeof LayoutInventoryNewRoute
  "/_layout/maintenance-programmes/new": typeof LayoutMaintenanceProgrammesNewRoute
  "/_layout/quotes/create": typeof LayoutQuotesCreateRoute
  "/_layout/quotes/from-file": typeof LayoutQuotesFromFileRoute
  "/_layout/settings/company": typeof LayoutSettingsCompanyRoute
  "/_layout/settings/system": typeof LayoutSettingsSystemRoute
  "/_layout/settings/user": typeof LayoutSettingsUserRoute
  "/_layout/tech-logs/$pageId": typeof LayoutTechLogsPageIdRoute
  "/_layout/tech-logs/new": typeof LayoutTechLogsNewRoute
  "/_layout/timesheet/log": typeof LayoutTimesheetLogRoute
  "/_layout/tools/new": typeof LayoutToolsNewRoute
  "/_layout/work-task/$id": typeof LayoutWorkTaskIdRoute
  "/review/$token/sign": typeof ReviewTokenSignRoute
  "/_layout/agent/": typeof LayoutAgentIndexRoute
  "/_layout/aircraft/": typeof LayoutAircraftIndexRoute
  "/_layout/airworthiness-directives/": typeof LayoutAirworthinessDirectivesIndexRoute
  "/_layout/approved-vendors/": typeof LayoutApprovedVendorsIndexRoute
  "/_layout/customer/": typeof LayoutCustomerIndexRoute
  "/_layout/forecasts/": typeof LayoutForecastsIndexRoute
  "/_layout/inventory/": typeof LayoutInventoryIndexRoute
  "/_layout/maintenance-programmes/": typeof LayoutMaintenanceProgrammesIndexRoute
  "/_layout/manpower/": typeof LayoutManpowerIndexRoute
  "/_layout/planning/": typeof LayoutPlanningIndexRoute
  "/_layout/quotes/": typeof LayoutQuotesIndexRoute
  "/_layout/quoting/": typeof LayoutQuotingIndexRoute
  "/_layout/settings/": typeof LayoutSettingsIndexRoute
  "/_layout/tech-logs/": typeof LayoutTechLogsIndexRoute
  "/_layout/templates/": typeof LayoutTemplatesIndexRoute
  "/_layout/timesheet/": typeof LayoutTimesheetIndexRoute
  "/_layout/tools/": typeof LayoutToolsIndexRoute
  "/review/$token/": typeof ReviewTokenIndexRoute
  "/_layout/customer_/$customerId/contacts": typeof LayoutCustomerCustomerIdContactsRouteRouteWithChildren
  "/_layout/documents/_list/upload": typeof LayoutDocumentsListUploadRouteRoute
  "/_layout/quoting_/emails/_list": typeof LayoutQuotingEmailsListRouteRouteWithChildren
  "/_layout/templates/quotes_/$packageId": typeof LayoutTemplatesQuotesPackageIdRouteRouteWithChildren
  "/_layout/templates/tasks/$taskId": typeof LayoutTemplatesTasksTaskIdRouteRouteWithChildren
  "/_layout/agent/delete/$id": typeof LayoutAgentDeleteIdRoute
  "/_layout/aircraft_/$aircraftId_/edit": typeof LayoutAircraftAircraftIdEditRoute
  "/_layout/airworthiness-directives/delete/$documentId": typeof LayoutAirworthinessDirectivesDeleteDocumentIdRoute
  "/_layout/approved-vendors/delete/$vendorId": typeof LayoutApprovedVendorsDeleteVendorIdRoute
  "/_layout/approved-vendors/delete/bulk": typeof LayoutApprovedVendorsDeleteBulkRoute
  "/_layout/assessments/ad/$reportId": typeof LayoutAssessmentsAdReportIdRoute
  "/_layout/assessments/sb/$reportId": typeof LayoutAssessmentsSbReportIdRoute
  "/_layout/customer/delete/$customerId": typeof LayoutCustomerDeleteCustomerIdRoute
  "/_layout/customer_/$customerId/aircraft": typeof LayoutCustomerCustomerIdAircraftRoute
  "/_layout/customer_/$customerId/delete": typeof LayoutCustomerCustomerIdDeleteRoute
  "/_layout/customer_/$customerId/wo-history": typeof LayoutCustomerCustomerIdWoHistoryRoute
  "/_layout/forecasts/delete/$forecastId": typeof LayoutForecastsDeleteForecastIdRoute
  "/_layout/inventory/$partId/archive": typeof LayoutInventoryPartIdArchiveRoute
  "/_layout/inventory/delete/$partId": typeof LayoutInventoryDeletePartIdRoute
  "/_layout/inventory/delete/bulk": typeof LayoutInventoryDeleteBulkRoute
  "/_layout/inventory_/purchase-orders/$purchaseOrderId": typeof LayoutInventoryPurchaseOrdersPurchaseOrderIdRoute
  "/_layout/inventory_/purchase-orders/new": typeof LayoutInventoryPurchaseOrdersNewRoute
  "/_layout/maintenance-programmes/delete/$programmeId": typeof LayoutMaintenanceProgrammesDeleteProgrammeIdRoute
  "/_layout/planning/new/forecast": typeof LayoutPlanningNewForecastRoute
  "/_layout/planning/new/quote": typeof LayoutPlanningNewQuoteRoute
  "/_layout/quotes/delete/$quoteId": typeof LayoutQuotesDeleteQuoteIdRoute
  "/_layout/quotes_/$quoteId/corridor": typeof LayoutQuotesQuoteIdCorridorRoute
  "/_layout/quotes_/$quoteId/send": typeof LayoutQuotesQuoteIdSendRoute
  "/_layout/quotes_/$quoteId/sent": typeof LayoutQuotesQuoteIdSentRoute
  "/_layout/quoting/canned/$packageId": typeof LayoutQuotingCannedPackageIdRoute
  "/_layout/quoting_/quotes/$quoteId": typeof LayoutQuotingQuotesQuoteIdRoute
  "/_layout/quoting_/squawks/$squawkId": typeof LayoutQuotingSquawksSquawkIdRoute
  "/_layout/tech-logs/delete/$pageId": typeof LayoutTechLogsDeletePageIdRoute
  "/_layout/templates/quotes/delete": typeof LayoutTemplatesQuotesDeleteRoute
  "/_layout/templates/tasks/create": typeof LayoutTemplatesTasksCreateRoute
  "/_layout/templates/tasks/delete": typeof LayoutTemplatesTasksDeleteRoute
  "/_layout/timesheet/delete/$timeEntryId": typeof LayoutTimesheetDeleteTimeEntryIdRoute
  "/_layout/tools/$toolId/issue": typeof LayoutToolsToolIdIssueRoute
  "/_layout/tools/$toolId/label": typeof LayoutToolsToolIdLabelRoute
  "/_layout/tools/$toolId/retire": typeof LayoutToolsToolIdRetireRoute
  "/_layout/work-orders/$workOrderId/cancel": typeof LayoutWorkOrdersWorkOrderIdCancelRoute
  "/_layout/work-orders/$workOrderId/close": typeof LayoutWorkOrdersWorkOrderIdCloseRoute
  "/_layout/aircraft_/$aircraftId/": typeof LayoutAircraftAircraftIdIndexRoute
  "/_layout/customer_/$customerId/": typeof LayoutCustomerCustomerIdIndexRoute
  "/_layout/documents/_list/": typeof LayoutDocumentsListIndexRoute
  "/_layout/inventory/$partId/": typeof LayoutInventoryPartIdIndexRoute
  "/_layout/inventory_/purchase-orders/": typeof LayoutInventoryPurchaseOrdersIndexRoute
  "/_layout/maintenance-programmes_/$programmeId/": typeof LayoutMaintenanceProgrammesProgrammeIdIndexRoute
  "/_layout/planning_/$planId/": typeof LayoutPlanningPlanIdIndexRoute
  "/_layout/quotes_/$quoteId/": typeof LayoutQuotesQuoteIdIndexRoute
  "/_layout/quoting/canned/": typeof LayoutQuotingCannedIndexRoute
  "/_layout/quoting_/quotes/": typeof LayoutQuotingQuotesIndexRoute
  "/_layout/quoting_/squawks/": typeof LayoutQuotingSquawksIndexRoute
  "/_layout/templates/quotes/": typeof LayoutTemplatesQuotesIndexRoute
  "/_layout/templates/tasks/": typeof LayoutTemplatesTasksIndexRoute
  "/_layout/tools/$toolId/": typeof LayoutToolsToolIdIndexRoute
  "/_layout/work-orders/$workOrderId/": typeof LayoutWorkOrdersWorkOrderIdIndexRoute
  "/_layout/work-orders/_list/": typeof LayoutWorkOrdersListIndexRoute
  "/_layout/customer_/$customerId/contacts/_list": typeof LayoutCustomerCustomerIdContactsListRouteRouteWithChildren
  "/_layout/quotes_/$quoteId/tasks/$taskId": typeof LayoutQuotesQuoteIdTasksTaskIdRouteRouteWithChildren
  "/_layout/quoting_/emails/_list/$emailId": typeof LayoutQuotingEmailsListEmailIdRouteRouteWithChildren
  "/_layout/settings/_panel/account/profile": typeof LayoutSettingsPanelAccountProfileRouteRouteWithChildren
  "/_layout/settings/_panel/integrations/erp": typeof LayoutSettingsPanelIntegrationsErpRouteRouteWithChildren
  "/_layout/settings/_panel/quoting/playbooks": typeof LayoutSettingsPanelQuotingPlaybooksRouteRouteWithChildren
  "/_layout/settings/_panel/quoting/rate-cards": typeof LayoutSettingsPanelQuotingRateCardsRouteRouteWithChildren
  "/_layout/settings/_panel/quoting/status": typeof LayoutSettingsPanelQuotingStatusRouteRouteWithChildren
  "/_layout/settings/_panel/quoting/task-groups": typeof LayoutSettingsPanelQuotingTaskGroupsRouteRouteWithChildren
  "/_layout/settings/_panel/quoting/tax-rates": typeof LayoutSettingsPanelQuotingTaxRatesRouteRouteWithChildren
  "/_layout/settings/_panel/workspace/approval-flows": typeof LayoutSettingsPanelWorkspaceApprovalFlowsRouteRouteWithChildren
  "/_layout/settings/_panel/workspace/departments": typeof LayoutSettingsPanelWorkspaceDepartmentsRouteRouteWithChildren
  "/_layout/settings/_panel/workspace/facilities": typeof LayoutSettingsPanelWorkspaceFacilitiesRouteRouteWithChildren
  "/_layout/settings/_panel/workspace/members": typeof LayoutSettingsPanelWorkspaceMembersRouteRouteWithChildren
  "/_layout/settings/_panel/workspace/notification-rules": typeof LayoutSettingsPanelWorkspaceNotificationRulesRouteRouteWithChildren
  "/_layout/settings/_panel/workspace/roles": typeof LayoutSettingsPanelWorkspaceRolesRouteRouteWithChildren
  "/_layout/settings/_panel/workspace/teams": typeof LayoutSettingsPanelWorkspaceTeamsRouteRouteWithChildren
  "/_layout/settings/_panel/workspace/templates": typeof LayoutSettingsPanelWorkspaceTemplatesRouteRouteWithChildren
  "/_layout/settings/_panel/workspace/tool-categories": typeof LayoutSettingsPanelWorkspaceToolCategoriesRouteRouteWithChildren
  "/_layout/settings/system_/tenants/$tenantId": typeof LayoutSettingsSystemTenantsTenantIdRouteRouteWithChildren
  "/_layout/templates/quotes_/$packageId/_list": typeof LayoutTemplatesQuotesPackageIdListRouteRouteWithChildren
  "/_layout/templates/quotes_/$packageId/overview": typeof LayoutTemplatesQuotesPackageIdOverviewRouteRouteWithChildren
  "/_layout/agent/chats/delete/$id": typeof LayoutAgentChatsDeleteIdRoute
  "/_layout/aircraft_/$aircraftId/fitted-components/new": typeof LayoutAircraftAircraftIdFittedComponentsNewRoute
  "/_layout/aircraft_/$aircraftId/mod-status/new": typeof LayoutAircraftAircraftIdModStatusNewRoute
  "/_layout/aircraft_/$aircraftId/readings/new": typeof LayoutAircraftAircraftIdReadingsNewRoute
  "/_layout/aircraft_/$aircraftId/tech-log/$pageId": typeof LayoutAircraftAircraftIdTechLogPageIdRoute
  "/_layout/aircraft_/$aircraftId/tech-log/new": typeof LayoutAircraftAircraftIdTechLogNewRoute
  "/_layout/customer_/$customerId/contacts/create": typeof LayoutCustomerCustomerIdContactsCreateRoute
  "/_layout/documents/_list/delete/$documentId": typeof LayoutDocumentsListDeleteDocumentIdRoute
  "/_layout/documents/_list/delete/bulk": typeof LayoutDocumentsListDeleteBulkRoute
  "/_layout/documents/_list/make-private/$documentId": typeof LayoutDocumentsListMakePrivateDocumentIdRoute
  "/_layout/documents/_list/share/$documentId": typeof LayoutDocumentsListShareDocumentIdRoute
  "/_layout/documents/_list/share/bulk": typeof LayoutDocumentsListShareBulkRoute
  "/_layout/maintenance-programmes_/$programmeId/aircraft/enrol": typeof LayoutMaintenanceProgrammesProgrammeIdAircraftEnrolRoute
  "/_layout/maintenance-programmes_/$programmeId/phases/$phaseId": typeof LayoutMaintenanceProgrammesProgrammeIdPhasesPhaseIdRoute
  "/_layout/maintenance-programmes_/$programmeId/phases/new": typeof LayoutMaintenanceProgrammesProgrammeIdPhasesNewRoute
  "/_layout/maintenance-programmes_/$programmeId/revisions/new": typeof LayoutMaintenanceProgrammesProgrammeIdRevisionsNewRoute
  "/_layout/maintenance-programmes_/$programmeId/tasks/$taskId": typeof LayoutMaintenanceProgrammesProgrammeIdTasksTaskIdRoute
  "/_layout/maintenance-programmes_/$programmeId/tasks/new": typeof LayoutMaintenanceProgrammesProgrammeIdTasksNewRoute
  "/_layout/quotes_/$quoteId/phases/new": typeof LayoutQuotesQuoteIdPhasesNewRoute
  "/_layout/quotes_/$quoteId/tasks/from-template": typeof LayoutQuotesQuoteIdTasksFromTemplateRoute
  "/_layout/quoting_/squawks/delete/$squawkId": typeof LayoutQuotingSquawksDeleteSquawkIdRoute
  "/_layout/quoting_/squawks/edit/$squawkId": typeof LayoutQuotingSquawksEditSquawkIdRoute
  "/_layout/settings/_panel/integrations/crm": typeof LayoutSettingsPanelIntegrationsCrmRoute
  "/_layout/settings/_panel/quoting/customer-approval": typeof LayoutSettingsPanelQuotingCustomerApprovalRoute
  "/_layout/settings/_panel/quoting/general": typeof LayoutSettingsPanelQuotingGeneralRoute
  "/_layout/settings/_panel/work-orders/general": typeof LayoutSettingsPanelWorkOrdersGeneralRoute
  "/_layout/templates/tasks/$taskId/archive": typeof LayoutTemplatesTasksTaskIdArchiveRoute
  "/_layout/tools/$toolId/calibrations/record": typeof LayoutToolsToolIdCalibrationsRecordRoute
  "/_layout/tools/$toolId/calibrations/send": typeof LayoutToolsToolIdCalibrationsSendRoute
  "/_layout/trace/sandbox/$conversationSessionId/$": typeof LayoutTraceSandboxConversationSessionIdSplatRoute
  "/_layout/work-orders/$workOrderId/phases/new": typeof LayoutWorkOrdersWorkOrderIdPhasesNewRoute
  "/_layout/work-orders/$workOrderId/squawks/$squawkId": typeof LayoutWorkOrdersWorkOrderIdSquawksSquawkIdRoute
  "/_layout/work-orders/$workOrderId/tasks/$taskId": typeof LayoutWorkOrdersWorkOrderIdTasksTaskIdRouteWithChildren
  "/_layout/work-orders/$workOrderId/tasks/delete": typeof LayoutWorkOrdersWorkOrderIdTasksDeleteRoute
  "/_layout/work-orders/$workOrderId/tasks/new": typeof LayoutWorkOrdersWorkOrderIdTasksNewRoute
  "/_layout/work-orders/_list/delete/$workOrderId": typeof LayoutWorkOrdersListDeleteWorkOrderIdRoute
  "/_layout/quoting_/emails/_list/": typeof LayoutQuotingEmailsListIndexRoute
  "/_layout/settings/system_/audit-log/": typeof LayoutSettingsSystemAuditLogIndexRoute
  "/_layout/templates/tasks/$taskId/": typeof LayoutTemplatesTasksTaskIdIndexRoute
  "/_layout/customer_/$customerId/contacts/_list/$contactId": typeof LayoutCustomerCustomerIdContactsListContactIdRouteRouteWithChildren
  "/_layout/settings/_panel/integrations/erp/_list": typeof LayoutSettingsPanelIntegrationsErpListRouteRouteWithChildren
  "/_layout/settings/_panel/quoting/playbooks/$playbookId": typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdRouteRouteWithChildren
  "/_layout/settings/_panel/quoting/rate-cards/$rateCardId": typeof LayoutSettingsPanelQuotingRateCardsRateCardIdRouteRouteWithChildren
  "/_layout/settings/_panel/quoting/tax-rates/$taxRateId": typeof LayoutSettingsPanelQuotingTaxRatesTaxRateIdRouteRouteWithChildren
  "/_layout/settings/_panel/workspace/approval-flows/$policyId": typeof LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdRouteRouteWithChildren
  "/_layout/settings/_panel/workspace/departments/_list": typeof LayoutSettingsPanelWorkspaceDepartmentsListRouteRouteWithChildren
  "/_layout/settings/_panel/workspace/facilities/_list": typeof LayoutSettingsPanelWorkspaceFacilitiesListRouteRouteWithChildren
  "/_layout/settings/_panel/workspace/members/_list": typeof LayoutSettingsPanelWorkspaceMembersListRouteRouteWithChildren
  "/_layout/settings/_panel/workspace/notification-rules/$ruleId": typeof LayoutSettingsPanelWorkspaceNotificationRulesRuleIdRouteRouteWithChildren
  "/_layout/settings/_panel/workspace/roles/_list": typeof LayoutSettingsPanelWorkspaceRolesListRouteRouteWithChildren
  "/_layout/settings/_panel/workspace/teams/_list": typeof LayoutSettingsPanelWorkspaceTeamsListRouteRouteWithChildren
  "/_layout/settings/_panel/workspace/templates/$kind": typeof LayoutSettingsPanelWorkspaceTemplatesKindRouteRouteWithChildren
  "/_layout/settings/_panel/workspace/tool-categories/_list": typeof LayoutSettingsPanelWorkspaceToolCategoriesListRouteRouteWithChildren
  "/_layout/settings/system_/tenants/$tenantId/settings": typeof LayoutSettingsSystemTenantsTenantIdSettingsRouteRouteWithChildren
  "/_layout/aircraft_/$aircraftId/fitted-components/remove/$componentId": typeof LayoutAircraftAircraftIdFittedComponentsRemoveComponentIdRoute
  "/_layout/aircraft_/$aircraftId/tech-log/void/$pageId": typeof LayoutAircraftAircraftIdTechLogVoidPageIdRoute
  "/_layout/inventory/$partId/prices/$priceId/delete": typeof LayoutInventoryPartIdPricesPriceIdDeleteRoute
  "/_layout/maintenance-programmes_/$programmeId/aircraft/remove/$enrolmentId": typeof LayoutMaintenanceProgrammesProgrammeIdAircraftRemoveEnrolmentIdRoute
  "/_layout/maintenance-programmes_/$programmeId/phases/remove/$phaseId": typeof LayoutMaintenanceProgrammesProgrammeIdPhasesRemovePhaseIdRoute
  "/_layout/maintenance-programmes_/$programmeId/revisions/release/$revisionId": typeof LayoutMaintenanceProgrammesProgrammeIdRevisionsReleaseRevisionIdRoute
  "/_layout/maintenance-programmes_/$programmeId/tasks/remove/$taskId": typeof LayoutMaintenanceProgrammesProgrammeIdTasksRemoveTaskIdRoute
  "/_layout/quotes_/$quoteId/phases/$phaseId/delete": typeof LayoutQuotesQuoteIdPhasesPhaseIdDeleteRoute
  "/_layout/quotes_/$quoteId/phases/$phaseId/rename": typeof LayoutQuotesQuoteIdPhasesPhaseIdRenameRoute
  "/_layout/quotes_/$quoteId/tasks/$taskId/apply-template": typeof LayoutQuotesQuoteIdTasksTaskIdApplyTemplateRoute
  "/_layout/quoting_/emails/_list/$emailId/share": typeof LayoutQuotingEmailsListEmailIdShareRoute
  "/_layout/quoting_/emails/_list/delete/$emailId": typeof LayoutQuotingEmailsListDeleteEmailIdRoute
  "/_layout/quoting_/emails/_list/delete/bulk": typeof LayoutQuotingEmailsListDeleteBulkRoute
  "/_layout/quoting_/emails/_list/share/bulk": typeof LayoutQuotingEmailsListShareBulkRoute
  "/_layout/settings/_panel/account/profile/change-password": typeof LayoutSettingsPanelAccountProfileChangePasswordRoute
  "/_layout/settings/_panel/quoting/flat-rates/$packageId": typeof LayoutSettingsPanelQuotingFlatRatesPackageIdRoute
  "/_layout/settings/_panel/quoting/playbooks/create": typeof LayoutSettingsPanelQuotingPlaybooksCreateRoute
  "/_layout/settings/_panel/quoting/task-groups/import": typeof LayoutSettingsPanelQuotingTaskGroupsImportRoute
  "/_layout/settings/_panel/workspace/approval-flows/create": typeof LayoutSettingsPanelWorkspaceApprovalFlowsCreateRoute
  "/_layout/settings/_panel/workspace/departments/create": typeof LayoutSettingsPanelWorkspaceDepartmentsCreateRoute
  "/_layout/settings/_panel/workspace/facilities/create": typeof LayoutSettingsPanelWorkspaceFacilitiesCreateRoute
  "/_layout/settings/_panel/workspace/members/create": typeof LayoutSettingsPanelWorkspaceMembersCreateRoute
  "/_layout/settings/_panel/workspace/notification-rules/create": typeof LayoutSettingsPanelWorkspaceNotificationRulesCreateRoute
  "/_layout/settings/_panel/workspace/roles/create": typeof LayoutSettingsPanelWorkspaceRolesCreateRoute
  "/_layout/settings/_panel/workspace/teams/create": typeof LayoutSettingsPanelWorkspaceTeamsCreateRoute
  "/_layout/settings/_panel/workspace/tool-categories/create": typeof LayoutSettingsPanelWorkspaceToolCategoriesCreateRoute
  "/_layout/settings/system_/tenants/$tenantId/approval-policies": typeof LayoutSettingsSystemTenantsTenantIdApprovalPoliciesRoute
  "/_layout/settings/system_/tenants/$tenantId/integrations": typeof LayoutSettingsSystemTenantsTenantIdIntegrationsRoute
  "/_layout/settings/system_/tenants/$tenantId/notification-rules": typeof LayoutSettingsSystemTenantsTenantIdNotificationRulesRoute
  "/_layout/settings/system_/tenants/$tenantId/users": typeof LayoutSettingsSystemTenantsTenantIdUsersRoute
  "/_layout/templates/quotes_/$packageId/overview/archive": typeof LayoutTemplatesQuotesPackageIdOverviewArchiveRoute
  "/_layout/tools/$toolId/calibrations/$calibrationId/complete": typeof LayoutToolsToolIdCalibrationsCalibrationIdCompleteRoute
  "/_layout/tools/$toolId/loans/$loanId/receive": typeof LayoutToolsToolIdLoansLoanIdReceiveRoute
  "/_layout/work-orders/$workOrderId/phases/$phaseId/delete": typeof LayoutWorkOrdersWorkOrderIdPhasesPhaseIdDeleteRoute
  "/_layout/work-orders/$workOrderId/phases/$phaseId/rename": typeof LayoutWorkOrdersWorkOrderIdPhasesPhaseIdRenameRoute
  "/_layout/work-orders/$workOrderId/tasks/$taskId/delete": typeof LayoutWorkOrdersWorkOrderIdTasksTaskIdDeleteRoute
  "/_layout/customer_/$customerId/contacts/_list/": typeof LayoutCustomerCustomerIdContactsListIndexRoute
  "/_layout/planning_/$planId/steps/$stepId/": typeof LayoutPlanningPlanIdStepsStepIdIndexRoute
  "/_layout/quotes_/$quoteId/tasks/$taskId/": typeof LayoutQuotesQuoteIdTasksTaskIdIndexRoute
  "/_layout/quoting_/emails/_list/$emailId/": typeof LayoutQuotingEmailsListEmailIdIndexRoute
  "/_layout/quoting_/quotes/builder/$quoteId/": typeof LayoutQuotingQuotesBuilderQuoteIdIndexRoute
  "/_layout/settings/_panel/account/notifications/": typeof LayoutSettingsPanelAccountNotificationsIndexRoute
  "/_layout/settings/_panel/account/profile/": typeof LayoutSettingsPanelAccountProfileIndexRoute
  "/_layout/settings/_panel/account/signing-pin/": typeof LayoutSettingsPanelAccountSigningPinIndexRoute
  "/_layout/settings/_panel/quoting/flat-rates/": typeof LayoutSettingsPanelQuotingFlatRatesIndexRoute
  "/_layout/settings/_panel/quoting/playbooks/": typeof LayoutSettingsPanelQuotingPlaybooksIndexRoute
  "/_layout/settings/_panel/quoting/rate-cards/": typeof LayoutSettingsPanelQuotingRateCardsIndexRoute
  "/_layout/settings/_panel/quoting/status/": typeof LayoutSettingsPanelQuotingStatusIndexRoute
  "/_layout/settings/_panel/quoting/task-groups/": typeof LayoutSettingsPanelQuotingTaskGroupsIndexRoute
  "/_layout/settings/_panel/quoting/tax-rates/": typeof LayoutSettingsPanelQuotingTaxRatesIndexRoute
  "/_layout/settings/_panel/workspace/approval-flows/": typeof LayoutSettingsPanelWorkspaceApprovalFlowsIndexRoute
  "/_layout/settings/_panel/workspace/general/": typeof LayoutSettingsPanelWorkspaceGeneralIndexRoute
  "/_layout/settings/_panel/workspace/notification-rules/": typeof LayoutSettingsPanelWorkspaceNotificationRulesIndexRoute
  "/_layout/settings/_panel/workspace/templates/": typeof LayoutSettingsPanelWorkspaceTemplatesIndexRoute
  "/_layout/settings/system_/tenants/$tenantId/": typeof LayoutSettingsSystemTenantsTenantIdIndexRoute
  "/_layout/templates/quotes_/$packageId/_list/": typeof LayoutTemplatesQuotesPackageIdListIndexRoute
  "/_layout/templates/quotes_/$packageId/overview/": typeof LayoutTemplatesQuotesPackageIdOverviewIndexRoute
  "/_layout/settings/_panel/quoting/playbooks/$playbookId/rules": typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesRouteRouteWithChildren
  "/_layout/settings/_panel/workspace/departments/_list/$departmentId": typeof LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdRouteRouteWithChildren
  "/_layout/settings/_panel/workspace/facilities/_list/$facilityId": typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdRouteRouteWithChildren
  "/_layout/settings/_panel/workspace/members/_list/$userId": typeof LayoutSettingsPanelWorkspaceMembersListUserIdRouteRouteWithChildren
  "/_layout/settings/_panel/workspace/roles/_list/$roleId": typeof LayoutSettingsPanelWorkspaceRolesListRoleIdRouteRouteWithChildren
  "/_layout/settings/_panel/workspace/teams/_list/$teamId": typeof LayoutSettingsPanelWorkspaceTeamsListTeamIdRouteRouteWithChildren
  "/_layout/settings/_panel/workspace/tool-categories/_list/$categoryId": typeof LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdRouteRouteWithChildren
  "/_layout/templates/quotes_/$packageId/_list/tasks/$taskId": typeof LayoutTemplatesQuotesPackageIdListTasksTaskIdRouteRouteWithChildren
  "/_layout/aircraft_/$aircraftId/part-instances/$partInstanceId/readings/new": typeof LayoutAircraftAircraftIdPartInstancesPartInstanceIdReadingsNewRoute
  "/_layout/customer_/$customerId/contacts/_list/$contactId/delete": typeof LayoutCustomerCustomerIdContactsListContactIdDeleteRoute
  "/_layout/planning_/$planId/steps/$stepId/tasks/$taskIndex": typeof LayoutPlanningPlanIdStepsStepIdTasksTaskIndexRoute
  "/_layout/quoting_/quotes/builder/$quoteId/task/$taskId": typeof LayoutQuotingQuotesBuilderQuoteIdTaskTaskIdRoute
  "/_layout/settings/_panel/integrations/erp/api-key/set": typeof LayoutSettingsPanelIntegrationsErpApiKeySetRoute
  "/_layout/settings/_panel/integrations/erp/relay/set": typeof LayoutSettingsPanelIntegrationsErpRelaySetRoute
  "/_layout/settings/_panel/quoting/playbooks/$playbookId/activity": typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdActivityRoute
  "/_layout/settings/_panel/quoting/playbooks/$playbookId/configuration": typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdConfigurationRoute
  "/_layout/settings/_panel/quoting/rate-cards/$rateCardId/archive": typeof LayoutSettingsPanelQuotingRateCardsRateCardIdArchiveRoute
  "/_layout/settings/_panel/quoting/task-groups/$groupId/archive": typeof LayoutSettingsPanelQuotingTaskGroupsGroupIdArchiveRoute
  "/_layout/settings/_panel/quoting/tax-rates/$taxRateId/archive": typeof LayoutSettingsPanelQuotingTaxRatesTaxRateIdArchiveRoute
  "/_layout/settings/_panel/workspace/approval-flows/$policyId/delete": typeof LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdDeleteRoute
  "/_layout/settings/_panel/workspace/approval-flows/duplicate/$policyId": typeof LayoutSettingsPanelWorkspaceApprovalFlowsDuplicatePolicyIdRoute
  "/_layout/settings/_panel/workspace/notification-rules/$ruleId/delete": typeof LayoutSettingsPanelWorkspaceNotificationRulesRuleIdDeleteRoute
  "/_layout/settings/_panel/workspace/notification-rules/duplicate/$ruleId": typeof LayoutSettingsPanelWorkspaceNotificationRulesDuplicateRuleIdRoute
  "/_layout/settings/_panel/workspace/roles/duplicate/$roleId": typeof LayoutSettingsPanelWorkspaceRolesDuplicateRoleIdRoute
  "/_layout/settings/_panel/workspace/templates/$kind/revert": typeof LayoutSettingsPanelWorkspaceTemplatesKindRevertRoute
  "/_layout/settings/system_/tenants/$tenantId/settings/reindex": typeof LayoutSettingsSystemTenantsTenantIdSettingsReindexRoute
  "/_layout/templates/quotes_/$packageId/_list/tasks/create": typeof LayoutTemplatesQuotesPackageIdListTasksCreateRoute
  "/_layout/customer_/$customerId/contacts/_list/$contactId/": typeof LayoutCustomerCustomerIdContactsListContactIdIndexRoute
  "/_layout/settings/_panel/integrations/erp/_list/": typeof LayoutSettingsPanelIntegrationsErpListIndexRoute
  "/_layout/settings/_panel/quoting/playbooks/$playbookId/": typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdIndexRoute
  "/_layout/settings/_panel/quoting/rate-cards/$rateCardId/": typeof LayoutSettingsPanelQuotingRateCardsRateCardIdIndexRoute
  "/_layout/settings/_panel/quoting/tax-rates/$taxRateId/": typeof LayoutSettingsPanelQuotingTaxRatesTaxRateIdIndexRoute
  "/_layout/settings/_panel/workspace/approval-flows/$policyId/": typeof LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdIndexRoute
  "/_layout/settings/_panel/workspace/departments/_list/": typeof LayoutSettingsPanelWorkspaceDepartmentsListIndexRoute
  "/_layout/settings/_panel/workspace/facilities/_list/": typeof LayoutSettingsPanelWorkspaceFacilitiesListIndexRoute
  "/_layout/settings/_panel/workspace/members/_list/": typeof LayoutSettingsPanelWorkspaceMembersListIndexRoute
  "/_layout/settings/_panel/workspace/notification-rules/$ruleId/": typeof LayoutSettingsPanelWorkspaceNotificationRulesRuleIdIndexRoute
  "/_layout/settings/_panel/workspace/roles/_list/": typeof LayoutSettingsPanelWorkspaceRolesListIndexRoute
  "/_layout/settings/_panel/workspace/teams/_list/": typeof LayoutSettingsPanelWorkspaceTeamsListIndexRoute
  "/_layout/settings/_panel/workspace/templates/$kind/": typeof LayoutSettingsPanelWorkspaceTemplatesKindIndexRoute
  "/_layout/settings/_panel/workspace/tool-categories/_list/": typeof LayoutSettingsPanelWorkspaceToolCategoriesListIndexRoute
  "/_layout/settings/system_/tenants/$tenantId/settings/": typeof LayoutSettingsSystemTenantsTenantIdSettingsIndexRoute
  "/_layout/aircraft_/$aircraftId/part-instances/$partInstanceId/readings/$readingId/delete": typeof LayoutAircraftAircraftIdPartInstancesPartInstanceIdReadingsReadingIdDeleteRoute
  "/_layout/quotes_/$quoteId/tasks/$taskId/steps/$stepId/remove": typeof LayoutQuotesQuoteIdTasksTaskIdStepsStepIdRemoveRoute
  "/_layout/settings/_panel/integrations/erp/_list/api-key/revoke": typeof LayoutSettingsPanelIntegrationsErpListApiKeyRevokeRoute
  "/_layout/settings/_panel/integrations/erp/_list/relay/remove": typeof LayoutSettingsPanelIntegrationsErpListRelayRemoveRoute
  "/_layout/settings/_panel/workspace/departments/_list/$departmentId/delete": typeof LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdDeleteRoute
  "/_layout/settings/_panel/workspace/facilities/_list/$facilityId/delete": typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdDeleteRoute
  "/_layout/settings/_panel/workspace/members/_list/$userId/change-password": typeof LayoutSettingsPanelWorkspaceMembersListUserIdChangePasswordRoute
  "/_layout/settings/_panel/workspace/members/_list/$userId/delete": typeof LayoutSettingsPanelWorkspaceMembersListUserIdDeleteRoute
  "/_layout/settings/_panel/workspace/members/_list/$userId/resend-login-email": typeof LayoutSettingsPanelWorkspaceMembersListUserIdResendLoginEmailRoute
  "/_layout/settings/_panel/workspace/roles/_list/$roleId/delete": typeof LayoutSettingsPanelWorkspaceRolesListRoleIdDeleteRoute
  "/_layout/settings/_panel/workspace/roles/_list/$roleId/reset": typeof LayoutSettingsPanelWorkspaceRolesListRoleIdResetRoute
  "/_layout/settings/_panel/workspace/teams/_list/$teamId/delete": typeof LayoutSettingsPanelWorkspaceTeamsListTeamIdDeleteRoute
  "/_layout/settings/_panel/workspace/tool-categories/_list/$categoryId/delete": typeof LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdDeleteRoute
  "/_layout/templates/quotes_/$packageId/_list/tasks/$taskId/archive": typeof LayoutTemplatesQuotesPackageIdListTasksTaskIdArchiveRoute
  "/_layout/work-orders/$workOrderId/tasks/$taskId/steps/$stepId/delete": typeof LayoutWorkOrdersWorkOrderIdTasksTaskIdStepsStepIdDeleteRoute
  "/_layout/work-orders/$workOrderId/tasks/$taskId/time-entries/$timeEntryId/delete": typeof LayoutWorkOrdersWorkOrderIdTasksTaskIdTimeEntriesTimeEntryIdDeleteRoute
  "/_layout/settings/_panel/quoting/playbooks/$playbookId/rules/": typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesIndexRoute
  "/_layout/settings/_panel/workspace/departments/_list/$departmentId/": typeof LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdIndexRoute
  "/_layout/settings/_panel/workspace/facilities/_list/$facilityId/": typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdIndexRoute
  "/_layout/settings/_panel/workspace/members/_list/$userId/": typeof LayoutSettingsPanelWorkspaceMembersListUserIdIndexRoute
  "/_layout/settings/_panel/workspace/roles/_list/$roleId/": typeof LayoutSettingsPanelWorkspaceRolesListRoleIdIndexRoute
  "/_layout/settings/_panel/workspace/teams/_list/$teamId/": typeof LayoutSettingsPanelWorkspaceTeamsListTeamIdIndexRoute
  "/_layout/settings/_panel/workspace/tool-categories/_list/$categoryId/": typeof LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdIndexRoute
  "/_layout/templates/quotes_/$packageId/_list/tasks/$taskId/": typeof LayoutTemplatesQuotesPackageIdListTasksTaskIdIndexRoute
  "/_layout/settings/_panel/quoting/playbooks/$playbookId/rules/$lineageId/delete": typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesLineageIdDeleteRoute
  "/_layout/settings/_panel/workspace/departments/_list/$departmentId/positions/$positionId/remove": typeof LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdPositionsPositionIdRemoveRoute
  "/_layout/settings/_panel/workspace/facilities/_list/$facilityId/locations/$locationId/delete": typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdLocationsLocationIdDeleteRoute
  "/_layout/settings/_panel/workspace/facilities/_list/$facilityId/positions/$positionId/remove": typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdPositionsPositionIdRemoveRoute
  "/_layout/settings/_panel/workspace/teams/_list/$teamId/positions/$positionId/remove": typeof LayoutSettingsPanelWorkspaceTeamsListTeamIdPositionsPositionIdRemoveRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/change-password"
    | "/login"
    | "/recover-password"
    | "/reset-password"
    | "/agent"
    | "/aircraft"
    | "/airworthiness-directives"
    | "/approved-vendors"
    | "/customer"
    | "/documents"
    | "/forecasts"
    | "/inventory"
    | "/maintenance-programmes"
    | "/planning"
    | "/quotes"
    | "/settings"
    | "/tech-logs"
    | "/templates"
    | "/tie-in"
    | "/timesheet"
    | "/tools"
    | "/review/$token"
    | "/aircraft/$aircraftId"
    | "/customer/$customerId"
    | "/inventory/$partId"
    | "/inventory/purchase-orders"
    | "/maintenance-programmes/$programmeId"
    | "/planning/$planId"
    | "/quotes/$quoteId"
    | "/quoting/emails"
    | "/quoting/squawks"
    | "/templates/quotes"
    | "/templates/tasks"
    | "/tools/$toolId"
    | "/work-orders/$workOrderId"
    | "/work-orders"
    | "/agent/$id"
    | "/agent/chats"
    | "/aircraft/new"
    | "/airworthiness-directives/upload"
    | "/airworthiness-directives/$documentId"
    | "/approved-vendors/$vendorId"
    | "/approved-vendors/new"
    | "/customer/new"
    | "/documents/$documentId"
    | "/forecasts/new"
    | "/forecasts/$forecastId"
    | "/forecasts/preview"
    | "/inventory/new"
    | "/maintenance-programmes/new"
    | "/quotes/create"
    | "/quotes/from-file"
    | "/settings/company"
    | "/settings/system"
    | "/settings/user"
    | "/tech-logs/$pageId"
    | "/tech-logs/new"
    | "/timesheet/log"
    | "/tools/new"
    | "/work-task/$id"
    | "/review/$token/sign"
    | "/agent/"
    | "/aircraft/"
    | "/airworthiness-directives/"
    | "/approved-vendors/"
    | "/customer/"
    | "/forecasts/"
    | "/inventory/"
    | "/maintenance-programmes/"
    | "/manpower/"
    | "/planning/"
    | "/quotes/"
    | "/quoting/"
    | "/settings/"
    | "/tech-logs/"
    | "/templates/"
    | "/timesheet/"
    | "/tools/"
    | "/review/$token/"
    | "/customer/$customerId/contacts"
    | "/documents/upload"
    | "/templates/quotes/$packageId"
    | "/templates/tasks/$taskId"
    | "/agent/delete/$id"
    | "/aircraft/$aircraftId/edit"
    | "/airworthiness-directives/delete/$documentId"
    | "/approved-vendors/delete/$vendorId"
    | "/approved-vendors/delete/bulk"
    | "/assessments/ad/$reportId"
    | "/assessments/sb/$reportId"
    | "/customer/delete/$customerId"
    | "/customer/$customerId/aircraft"
    | "/customer/$customerId/delete"
    | "/customer/$customerId/wo-history"
    | "/forecasts/delete/$forecastId"
    | "/inventory/$partId/archive"
    | "/inventory/delete/$partId"
    | "/inventory/delete/bulk"
    | "/inventory/purchase-orders/$purchaseOrderId"
    | "/inventory/purchase-orders/new"
    | "/maintenance-programmes/delete/$programmeId"
    | "/planning/new/forecast"
    | "/planning/new/quote"
    | "/quotes/delete/$quoteId"
    | "/quotes/$quoteId/corridor"
    | "/quotes/$quoteId/send"
    | "/quotes/$quoteId/sent"
    | "/quoting/canned/$packageId"
    | "/quoting/quotes/$quoteId"
    | "/quoting/squawks/$squawkId"
    | "/tech-logs/delete/$pageId"
    | "/templates/quotes/delete"
    | "/templates/tasks/create"
    | "/templates/tasks/delete"
    | "/timesheet/delete/$timeEntryId"
    | "/tools/$toolId/issue"
    | "/tools/$toolId/label"
    | "/tools/$toolId/retire"
    | "/work-orders/$workOrderId/cancel"
    | "/work-orders/$workOrderId/close"
    | "/aircraft/$aircraftId/"
    | "/customer/$customerId/"
    | "/documents/"
    | "/inventory/$partId/"
    | "/inventory/purchase-orders/"
    | "/maintenance-programmes/$programmeId/"
    | "/planning/$planId/"
    | "/quotes/$quoteId/"
    | "/quoting/canned/"
    | "/quoting/quotes/"
    | "/quoting/squawks/"
    | "/templates/quotes/"
    | "/templates/tasks/"
    | "/tools/$toolId/"
    | "/work-orders/$workOrderId/"
    | "/work-orders/"
    | "/quotes/$quoteId/tasks/$taskId"
    | "/quoting/emails/$emailId"
    | "/settings/account/profile"
    | "/settings/integrations/erp"
    | "/settings/quoting/playbooks"
    | "/settings/quoting/rate-cards"
    | "/settings/quoting/status"
    | "/settings/quoting/task-groups"
    | "/settings/quoting/tax-rates"
    | "/settings/workspace/approval-flows"
    | "/settings/workspace/departments"
    | "/settings/workspace/facilities"
    | "/settings/workspace/members"
    | "/settings/workspace/notification-rules"
    | "/settings/workspace/roles"
    | "/settings/workspace/teams"
    | "/settings/workspace/templates"
    | "/settings/workspace/tool-categories"
    | "/settings/system/tenants/$tenantId"
    | "/templates/quotes/$packageId/overview"
    | "/agent/chats/delete/$id"
    | "/aircraft/$aircraftId/fitted-components/new"
    | "/aircraft/$aircraftId/mod-status/new"
    | "/aircraft/$aircraftId/readings/new"
    | "/aircraft/$aircraftId/tech-log/$pageId"
    | "/aircraft/$aircraftId/tech-log/new"
    | "/customer/$customerId/contacts/create"
    | "/documents/delete/$documentId"
    | "/documents/delete/bulk"
    | "/documents/make-private/$documentId"
    | "/documents/share/$documentId"
    | "/documents/share/bulk"
    | "/maintenance-programmes/$programmeId/aircraft/enrol"
    | "/maintenance-programmes/$programmeId/phases/$phaseId"
    | "/maintenance-programmes/$programmeId/phases/new"
    | "/maintenance-programmes/$programmeId/revisions/new"
    | "/maintenance-programmes/$programmeId/tasks/$taskId"
    | "/maintenance-programmes/$programmeId/tasks/new"
    | "/quotes/$quoteId/phases/new"
    | "/quotes/$quoteId/tasks/from-template"
    | "/quoting/squawks/delete/$squawkId"
    | "/quoting/squawks/edit/$squawkId"
    | "/settings/integrations/crm"
    | "/settings/quoting/customer-approval"
    | "/settings/quoting/general"
    | "/settings/work-orders/general"
    | "/templates/tasks/$taskId/archive"
    | "/tools/$toolId/calibrations/record"
    | "/tools/$toolId/calibrations/send"
    | "/trace/sandbox/$conversationSessionId/$"
    | "/work-orders/$workOrderId/phases/new"
    | "/work-orders/$workOrderId/squawks/$squawkId"
    | "/work-orders/$workOrderId/tasks/$taskId"
    | "/work-orders/$workOrderId/tasks/delete"
    | "/work-orders/$workOrderId/tasks/new"
    | "/work-orders/delete/$workOrderId"
    | "/quoting/emails/"
    | "/settings/system/audit-log/"
    | "/templates/tasks/$taskId/"
    | "/customer/$customerId/contacts/$contactId"
    | "/settings/quoting/playbooks/$playbookId"
    | "/settings/quoting/rate-cards/$rateCardId"
    | "/settings/quoting/tax-rates/$taxRateId"
    | "/settings/workspace/approval-flows/$policyId"
    | "/settings/workspace/notification-rules/$ruleId"
    | "/settings/workspace/templates/$kind"
    | "/settings/system/tenants/$tenantId/settings"
    | "/aircraft/$aircraftId/fitted-components/remove/$componentId"
    | "/aircraft/$aircraftId/tech-log/void/$pageId"
    | "/inventory/$partId/prices/$priceId/delete"
    | "/maintenance-programmes/$programmeId/aircraft/remove/$enrolmentId"
    | "/maintenance-programmes/$programmeId/phases/remove/$phaseId"
    | "/maintenance-programmes/$programmeId/revisions/release/$revisionId"
    | "/maintenance-programmes/$programmeId/tasks/remove/$taskId"
    | "/quotes/$quoteId/phases/$phaseId/delete"
    | "/quotes/$quoteId/phases/$phaseId/rename"
    | "/quotes/$quoteId/tasks/$taskId/apply-template"
    | "/quoting/emails/$emailId/share"
    | "/quoting/emails/delete/$emailId"
    | "/quoting/emails/delete/bulk"
    | "/quoting/emails/share/bulk"
    | "/settings/account/profile/change-password"
    | "/settings/quoting/flat-rates/$packageId"
    | "/settings/quoting/playbooks/create"
    | "/settings/quoting/task-groups/import"
    | "/settings/workspace/approval-flows/create"
    | "/settings/workspace/departments/create"
    | "/settings/workspace/facilities/create"
    | "/settings/workspace/members/create"
    | "/settings/workspace/notification-rules/create"
    | "/settings/workspace/roles/create"
    | "/settings/workspace/teams/create"
    | "/settings/workspace/tool-categories/create"
    | "/settings/system/tenants/$tenantId/approval-policies"
    | "/settings/system/tenants/$tenantId/integrations"
    | "/settings/system/tenants/$tenantId/notification-rules"
    | "/settings/system/tenants/$tenantId/users"
    | "/templates/quotes/$packageId/overview/archive"
    | "/tools/$toolId/calibrations/$calibrationId/complete"
    | "/tools/$toolId/loans/$loanId/receive"
    | "/work-orders/$workOrderId/phases/$phaseId/delete"
    | "/work-orders/$workOrderId/phases/$phaseId/rename"
    | "/work-orders/$workOrderId/tasks/$taskId/delete"
    | "/customer/$customerId/contacts/"
    | "/planning/$planId/steps/$stepId/"
    | "/quotes/$quoteId/tasks/$taskId/"
    | "/quoting/emails/$emailId/"
    | "/quoting/quotes/builder/$quoteId/"
    | "/settings/account/notifications/"
    | "/settings/account/profile/"
    | "/settings/account/signing-pin/"
    | "/settings/quoting/flat-rates/"
    | "/settings/quoting/playbooks/"
    | "/settings/quoting/rate-cards/"
    | "/settings/quoting/status/"
    | "/settings/quoting/task-groups/"
    | "/settings/quoting/tax-rates/"
    | "/settings/workspace/approval-flows/"
    | "/settings/workspace/general/"
    | "/settings/workspace/notification-rules/"
    | "/settings/workspace/templates/"
    | "/settings/system/tenants/$tenantId/"
    | "/templates/quotes/$packageId/"
    | "/templates/quotes/$packageId/overview/"
    | "/settings/quoting/playbooks/$playbookId/rules"
    | "/settings/workspace/departments/$departmentId"
    | "/settings/workspace/facilities/$facilityId"
    | "/settings/workspace/members/$userId"
    | "/settings/workspace/roles/$roleId"
    | "/settings/workspace/teams/$teamId"
    | "/settings/workspace/tool-categories/$categoryId"
    | "/templates/quotes/$packageId/tasks/$taskId"
    | "/aircraft/$aircraftId/part-instances/$partInstanceId/readings/new"
    | "/customer/$customerId/contacts/$contactId/delete"
    | "/planning/$planId/steps/$stepId/tasks/$taskIndex"
    | "/quoting/quotes/builder/$quoteId/task/$taskId"
    | "/settings/integrations/erp/api-key/set"
    | "/settings/integrations/erp/relay/set"
    | "/settings/quoting/playbooks/$playbookId/activity"
    | "/settings/quoting/playbooks/$playbookId/configuration"
    | "/settings/quoting/rate-cards/$rateCardId/archive"
    | "/settings/quoting/task-groups/$groupId/archive"
    | "/settings/quoting/tax-rates/$taxRateId/archive"
    | "/settings/workspace/approval-flows/$policyId/delete"
    | "/settings/workspace/approval-flows/duplicate/$policyId"
    | "/settings/workspace/notification-rules/$ruleId/delete"
    | "/settings/workspace/notification-rules/duplicate/$ruleId"
    | "/settings/workspace/roles/duplicate/$roleId"
    | "/settings/workspace/templates/$kind/revert"
    | "/settings/system/tenants/$tenantId/settings/reindex"
    | "/templates/quotes/$packageId/tasks/create"
    | "/customer/$customerId/contacts/$contactId/"
    | "/settings/integrations/erp/"
    | "/settings/quoting/playbooks/$playbookId/"
    | "/settings/quoting/rate-cards/$rateCardId/"
    | "/settings/quoting/tax-rates/$taxRateId/"
    | "/settings/workspace/approval-flows/$policyId/"
    | "/settings/workspace/departments/"
    | "/settings/workspace/facilities/"
    | "/settings/workspace/members/"
    | "/settings/workspace/notification-rules/$ruleId/"
    | "/settings/workspace/roles/"
    | "/settings/workspace/teams/"
    | "/settings/workspace/templates/$kind/"
    | "/settings/workspace/tool-categories/"
    | "/settings/system/tenants/$tenantId/settings/"
    | "/aircraft/$aircraftId/part-instances/$partInstanceId/readings/$readingId/delete"
    | "/quotes/$quoteId/tasks/$taskId/steps/$stepId/remove"
    | "/settings/integrations/erp/api-key/revoke"
    | "/settings/integrations/erp/relay/remove"
    | "/settings/workspace/departments/$departmentId/delete"
    | "/settings/workspace/facilities/$facilityId/delete"
    | "/settings/workspace/members/$userId/change-password"
    | "/settings/workspace/members/$userId/delete"
    | "/settings/workspace/members/$userId/resend-login-email"
    | "/settings/workspace/roles/$roleId/delete"
    | "/settings/workspace/roles/$roleId/reset"
    | "/settings/workspace/teams/$teamId/delete"
    | "/settings/workspace/tool-categories/$categoryId/delete"
    | "/templates/quotes/$packageId/tasks/$taskId/archive"
    | "/work-orders/$workOrderId/tasks/$taskId/steps/$stepId/delete"
    | "/work-orders/$workOrderId/tasks/$taskId/time-entries/$timeEntryId/delete"
    | "/settings/quoting/playbooks/$playbookId/rules/"
    | "/settings/workspace/departments/$departmentId/"
    | "/settings/workspace/facilities/$facilityId/"
    | "/settings/workspace/members/$userId/"
    | "/settings/workspace/roles/$roleId/"
    | "/settings/workspace/teams/$teamId/"
    | "/settings/workspace/tool-categories/$categoryId/"
    | "/templates/quotes/$packageId/tasks/$taskId/"
    | "/settings/quoting/playbooks/$playbookId/rules/$lineageId/delete"
    | "/settings/workspace/departments/$departmentId/positions/$positionId/remove"
    | "/settings/workspace/facilities/$facilityId/locations/$locationId/delete"
    | "/settings/workspace/facilities/$facilityId/positions/$positionId/remove"
    | "/settings/workspace/teams/$teamId/positions/$positionId/remove"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/change-password"
    | "/login"
    | "/recover-password"
    | "/reset-password"
    | "/documents"
    | "/tie-in"
    | "/"
    | "/quoting/emails"
    | "/settings"
    | "/agent/$id"
    | "/agent/chats"
    | "/aircraft/new"
    | "/airworthiness-directives/upload"
    | "/airworthiness-directives/$documentId"
    | "/approved-vendors/$vendorId"
    | "/approved-vendors/new"
    | "/customer/new"
    | "/documents/$documentId"
    | "/forecasts/new"
    | "/forecasts/$forecastId"
    | "/forecasts/preview"
    | "/inventory/new"
    | "/maintenance-programmes/new"
    | "/quotes/create"
    | "/quotes/from-file"
    | "/settings/company"
    | "/settings/system"
    | "/settings/user"
    | "/tech-logs/$pageId"
    | "/tech-logs/new"
    | "/timesheet/log"
    | "/tools/new"
    | "/work-task/$id"
    | "/review/$token/sign"
    | "/agent"
    | "/aircraft"
    | "/airworthiness-directives"
    | "/approved-vendors"
    | "/customer"
    | "/forecasts"
    | "/inventory"
    | "/maintenance-programmes"
    | "/manpower"
    | "/planning"
    | "/quotes"
    | "/quoting"
    | "/tech-logs"
    | "/templates"
    | "/timesheet"
    | "/tools"
    | "/review/$token"
    | "/customer/$customerId/contacts"
    | "/documents/upload"
    | "/templates/quotes/$packageId"
    | "/agent/delete/$id"
    | "/aircraft/$aircraftId/edit"
    | "/airworthiness-directives/delete/$documentId"
    | "/approved-vendors/delete/$vendorId"
    | "/approved-vendors/delete/bulk"
    | "/assessments/ad/$reportId"
    | "/assessments/sb/$reportId"
    | "/customer/delete/$customerId"
    | "/customer/$customerId/aircraft"
    | "/customer/$customerId/delete"
    | "/customer/$customerId/wo-history"
    | "/forecasts/delete/$forecastId"
    | "/inventory/$partId/archive"
    | "/inventory/delete/$partId"
    | "/inventory/delete/bulk"
    | "/inventory/purchase-orders/$purchaseOrderId"
    | "/inventory/purchase-orders/new"
    | "/maintenance-programmes/delete/$programmeId"
    | "/planning/new/forecast"
    | "/planning/new/quote"
    | "/quotes/delete/$quoteId"
    | "/quotes/$quoteId/corridor"
    | "/quotes/$quoteId/send"
    | "/quotes/$quoteId/sent"
    | "/quoting/canned/$packageId"
    | "/quoting/quotes/$quoteId"
    | "/quoting/squawks/$squawkId"
    | "/tech-logs/delete/$pageId"
    | "/templates/quotes/delete"
    | "/templates/tasks/create"
    | "/templates/tasks/delete"
    | "/timesheet/delete/$timeEntryId"
    | "/tools/$toolId/issue"
    | "/tools/$toolId/label"
    | "/tools/$toolId/retire"
    | "/work-orders/$workOrderId/cancel"
    | "/work-orders/$workOrderId/close"
    | "/aircraft/$aircraftId"
    | "/customer/$customerId"
    | "/inventory/$partId"
    | "/inventory/purchase-orders"
    | "/maintenance-programmes/$programmeId"
    | "/planning/$planId"
    | "/quotes/$quoteId"
    | "/quoting/canned"
    | "/quoting/quotes"
    | "/quoting/squawks"
    | "/templates/quotes"
    | "/templates/tasks"
    | "/tools/$toolId"
    | "/work-orders/$workOrderId"
    | "/work-orders"
    | "/settings/integrations/erp"
    | "/settings/workspace/departments"
    | "/settings/workspace/facilities"
    | "/settings/workspace/members"
    | "/settings/workspace/roles"
    | "/settings/workspace/teams"
    | "/settings/workspace/tool-categories"
    | "/agent/chats/delete/$id"
    | "/aircraft/$aircraftId/fitted-components/new"
    | "/aircraft/$aircraftId/mod-status/new"
    | "/aircraft/$aircraftId/readings/new"
    | "/aircraft/$aircraftId/tech-log/$pageId"
    | "/aircraft/$aircraftId/tech-log/new"
    | "/customer/$customerId/contacts/create"
    | "/documents/delete/$documentId"
    | "/documents/delete/bulk"
    | "/documents/make-private/$documentId"
    | "/documents/share/$documentId"
    | "/documents/share/bulk"
    | "/maintenance-programmes/$programmeId/aircraft/enrol"
    | "/maintenance-programmes/$programmeId/phases/$phaseId"
    | "/maintenance-programmes/$programmeId/phases/new"
    | "/maintenance-programmes/$programmeId/revisions/new"
    | "/maintenance-programmes/$programmeId/tasks/$taskId"
    | "/maintenance-programmes/$programmeId/tasks/new"
    | "/quotes/$quoteId/phases/new"
    | "/quotes/$quoteId/tasks/from-template"
    | "/quoting/squawks/delete/$squawkId"
    | "/quoting/squawks/edit/$squawkId"
    | "/settings/integrations/crm"
    | "/settings/quoting/customer-approval"
    | "/settings/quoting/general"
    | "/settings/work-orders/general"
    | "/templates/tasks/$taskId/archive"
    | "/tools/$toolId/calibrations/record"
    | "/tools/$toolId/calibrations/send"
    | "/trace/sandbox/$conversationSessionId/$"
    | "/work-orders/$workOrderId/phases/new"
    | "/work-orders/$workOrderId/squawks/$squawkId"
    | "/work-orders/$workOrderId/tasks/$taskId"
    | "/work-orders/$workOrderId/tasks/delete"
    | "/work-orders/$workOrderId/tasks/new"
    | "/work-orders/delete/$workOrderId"
    | "/settings/system/audit-log"
    | "/templates/tasks/$taskId"
    | "/aircraft/$aircraftId/fitted-components/remove/$componentId"
    | "/aircraft/$aircraftId/tech-log/void/$pageId"
    | "/inventory/$partId/prices/$priceId/delete"
    | "/maintenance-programmes/$programmeId/aircraft/remove/$enrolmentId"
    | "/maintenance-programmes/$programmeId/phases/remove/$phaseId"
    | "/maintenance-programmes/$programmeId/revisions/release/$revisionId"
    | "/maintenance-programmes/$programmeId/tasks/remove/$taskId"
    | "/quotes/$quoteId/phases/$phaseId/delete"
    | "/quotes/$quoteId/phases/$phaseId/rename"
    | "/quotes/$quoteId/tasks/$taskId/apply-template"
    | "/quoting/emails/$emailId/share"
    | "/quoting/emails/delete/$emailId"
    | "/quoting/emails/delete/bulk"
    | "/quoting/emails/share/bulk"
    | "/settings/account/profile/change-password"
    | "/settings/quoting/flat-rates/$packageId"
    | "/settings/quoting/playbooks/create"
    | "/settings/quoting/task-groups/import"
    | "/settings/workspace/approval-flows/create"
    | "/settings/workspace/departments/create"
    | "/settings/workspace/facilities/create"
    | "/settings/workspace/members/create"
    | "/settings/workspace/notification-rules/create"
    | "/settings/workspace/roles/create"
    | "/settings/workspace/teams/create"
    | "/settings/workspace/tool-categories/create"
    | "/settings/system/tenants/$tenantId/approval-policies"
    | "/settings/system/tenants/$tenantId/integrations"
    | "/settings/system/tenants/$tenantId/notification-rules"
    | "/settings/system/tenants/$tenantId/users"
    | "/templates/quotes/$packageId/overview/archive"
    | "/tools/$toolId/calibrations/$calibrationId/complete"
    | "/tools/$toolId/loans/$loanId/receive"
    | "/work-orders/$workOrderId/phases/$phaseId/delete"
    | "/work-orders/$workOrderId/phases/$phaseId/rename"
    | "/work-orders/$workOrderId/tasks/$taskId/delete"
    | "/planning/$planId/steps/$stepId"
    | "/quotes/$quoteId/tasks/$taskId"
    | "/quoting/emails/$emailId"
    | "/quoting/quotes/builder/$quoteId"
    | "/settings/account/notifications"
    | "/settings/account/profile"
    | "/settings/account/signing-pin"
    | "/settings/quoting/flat-rates"
    | "/settings/quoting/playbooks"
    | "/settings/quoting/rate-cards"
    | "/settings/quoting/status"
    | "/settings/quoting/task-groups"
    | "/settings/quoting/tax-rates"
    | "/settings/workspace/approval-flows"
    | "/settings/workspace/general"
    | "/settings/workspace/notification-rules"
    | "/settings/workspace/templates"
    | "/settings/system/tenants/$tenantId"
    | "/templates/quotes/$packageId/overview"
    | "/aircraft/$aircraftId/part-instances/$partInstanceId/readings/new"
    | "/customer/$customerId/contacts/$contactId/delete"
    | "/planning/$planId/steps/$stepId/tasks/$taskIndex"
    | "/quoting/quotes/builder/$quoteId/task/$taskId"
    | "/settings/integrations/erp/api-key/set"
    | "/settings/integrations/erp/relay/set"
    | "/settings/quoting/playbooks/$playbookId/activity"
    | "/settings/quoting/playbooks/$playbookId/configuration"
    | "/settings/quoting/rate-cards/$rateCardId/archive"
    | "/settings/quoting/task-groups/$groupId/archive"
    | "/settings/quoting/tax-rates/$taxRateId/archive"
    | "/settings/workspace/approval-flows/$policyId/delete"
    | "/settings/workspace/approval-flows/duplicate/$policyId"
    | "/settings/workspace/notification-rules/$ruleId/delete"
    | "/settings/workspace/notification-rules/duplicate/$ruleId"
    | "/settings/workspace/roles/duplicate/$roleId"
    | "/settings/workspace/templates/$kind/revert"
    | "/settings/system/tenants/$tenantId/settings/reindex"
    | "/templates/quotes/$packageId/tasks/create"
    | "/customer/$customerId/contacts/$contactId"
    | "/settings/quoting/playbooks/$playbookId"
    | "/settings/quoting/rate-cards/$rateCardId"
    | "/settings/quoting/tax-rates/$taxRateId"
    | "/settings/workspace/approval-flows/$policyId"
    | "/settings/workspace/notification-rules/$ruleId"
    | "/settings/workspace/templates/$kind"
    | "/settings/system/tenants/$tenantId/settings"
    | "/aircraft/$aircraftId/part-instances/$partInstanceId/readings/$readingId/delete"
    | "/quotes/$quoteId/tasks/$taskId/steps/$stepId/remove"
    | "/settings/integrations/erp/api-key/revoke"
    | "/settings/integrations/erp/relay/remove"
    | "/settings/workspace/departments/$departmentId/delete"
    | "/settings/workspace/facilities/$facilityId/delete"
    | "/settings/workspace/members/$userId/change-password"
    | "/settings/workspace/members/$userId/delete"
    | "/settings/workspace/members/$userId/resend-login-email"
    | "/settings/workspace/roles/$roleId/delete"
    | "/settings/workspace/roles/$roleId/reset"
    | "/settings/workspace/teams/$teamId/delete"
    | "/settings/workspace/tool-categories/$categoryId/delete"
    | "/templates/quotes/$packageId/tasks/$taskId/archive"
    | "/work-orders/$workOrderId/tasks/$taskId/steps/$stepId/delete"
    | "/work-orders/$workOrderId/tasks/$taskId/time-entries/$timeEntryId/delete"
    | "/settings/quoting/playbooks/$playbookId/rules"
    | "/settings/workspace/departments/$departmentId"
    | "/settings/workspace/facilities/$facilityId"
    | "/settings/workspace/members/$userId"
    | "/settings/workspace/roles/$roleId"
    | "/settings/workspace/teams/$teamId"
    | "/settings/workspace/tool-categories/$categoryId"
    | "/templates/quotes/$packageId/tasks/$taskId"
    | "/settings/quoting/playbooks/$playbookId/rules/$lineageId/delete"
    | "/settings/workspace/departments/$departmentId/positions/$positionId/remove"
    | "/settings/workspace/facilities/$facilityId/locations/$locationId/delete"
    | "/settings/workspace/facilities/$facilityId/positions/$positionId/remove"
    | "/settings/workspace/teams/$teamId/positions/$positionId/remove"
  id:
    | "__root__"
    | "/_layout"
    | "/change-password"
    | "/login"
    | "/recover-password"
    | "/reset-password"
    | "/_layout/agent"
    | "/_layout/aircraft"
    | "/_layout/airworthiness-directives"
    | "/_layout/approved-vendors"
    | "/_layout/customer"
    | "/_layout/documents"
    | "/_layout/forecasts"
    | "/_layout/inventory"
    | "/_layout/maintenance-programmes"
    | "/_layout/planning"
    | "/_layout/quotes"
    | "/_layout/settings"
    | "/_layout/tech-logs"
    | "/_layout/templates"
    | "/_layout/tie-in"
    | "/_layout/timesheet"
    | "/_layout/tools"
    | "/review/$token"
    | "/_layout/"
    | "/_layout/aircraft_/$aircraftId"
    | "/_layout/customer_/$customerId"
    | "/_layout/documents/_list"
    | "/_layout/inventory/$partId"
    | "/_layout/inventory_/purchase-orders"
    | "/_layout/maintenance-programmes_/$programmeId"
    | "/_layout/planning_/$planId"
    | "/_layout/quotes_/$quoteId"
    | "/_layout/quoting_/emails"
    | "/_layout/quoting_/squawks"
    | "/_layout/settings/_panel"
    | "/_layout/templates/quotes"
    | "/_layout/templates/tasks"
    | "/_layout/tools/$toolId"
    | "/_layout/work-orders/$workOrderId"
    | "/_layout/work-orders/_list"
    | "/_layout/agent/$id"
    | "/_layout/agent/chats"
    | "/_layout/aircraft_/new"
    | "/_layout/airworthiness-directives/upload"
    | "/_layout/airworthiness-directives_/$documentId"
    | "/_layout/approved-vendors_/$vendorId"
    | "/_layout/approved-vendors_/new"
    | "/_layout/customer_/new"
    | "/_layout/documents/$documentId"
    | "/_layout/forecasts/new"
    | "/_layout/forecasts_/$forecastId"
    | "/_layout/forecasts_/preview"
    | "/_layout/inventory/new"
    | "/_layout/maintenance-programmes/new"
    | "/_layout/quotes/create"
    | "/_layout/quotes/from-file"
    | "/_layout/settings/company"
    | "/_layout/settings/system"
    | "/_layout/settings/user"
    | "/_layout/tech-logs/$pageId"
    | "/_layout/tech-logs/new"
    | "/_layout/timesheet/log"
    | "/_layout/tools/new"
    | "/_layout/work-task/$id"
    | "/review/$token/sign"
    | "/_layout/agent/"
    | "/_layout/aircraft/"
    | "/_layout/airworthiness-directives/"
    | "/_layout/approved-vendors/"
    | "/_layout/customer/"
    | "/_layout/forecasts/"
    | "/_layout/inventory/"
    | "/_layout/maintenance-programmes/"
    | "/_layout/manpower/"
    | "/_layout/planning/"
    | "/_layout/quotes/"
    | "/_layout/quoting/"
    | "/_layout/settings/"
    | "/_layout/tech-logs/"
    | "/_layout/templates/"
    | "/_layout/timesheet/"
    | "/_layout/tools/"
    | "/review/$token/"
    | "/_layout/customer_/$customerId/contacts"
    | "/_layout/documents/_list/upload"
    | "/_layout/quoting_/emails/_list"
    | "/_layout/templates/quotes_/$packageId"
    | "/_layout/templates/tasks/$taskId"
    | "/_layout/agent/delete/$id"
    | "/_layout/aircraft_/$aircraftId_/edit"
    | "/_layout/airworthiness-directives/delete/$documentId"
    | "/_layout/approved-vendors/delete/$vendorId"
    | "/_layout/approved-vendors/delete/bulk"
    | "/_layout/assessments/ad/$reportId"
    | "/_layout/assessments/sb/$reportId"
    | "/_layout/customer/delete/$customerId"
    | "/_layout/customer_/$customerId/aircraft"
    | "/_layout/customer_/$customerId/delete"
    | "/_layout/customer_/$customerId/wo-history"
    | "/_layout/forecasts/delete/$forecastId"
    | "/_layout/inventory/$partId/archive"
    | "/_layout/inventory/delete/$partId"
    | "/_layout/inventory/delete/bulk"
    | "/_layout/inventory_/purchase-orders/$purchaseOrderId"
    | "/_layout/inventory_/purchase-orders/new"
    | "/_layout/maintenance-programmes/delete/$programmeId"
    | "/_layout/planning/new/forecast"
    | "/_layout/planning/new/quote"
    | "/_layout/quotes/delete/$quoteId"
    | "/_layout/quotes_/$quoteId/corridor"
    | "/_layout/quotes_/$quoteId/send"
    | "/_layout/quotes_/$quoteId/sent"
    | "/_layout/quoting/canned/$packageId"
    | "/_layout/quoting_/quotes/$quoteId"
    | "/_layout/quoting_/squawks/$squawkId"
    | "/_layout/tech-logs/delete/$pageId"
    | "/_layout/templates/quotes/delete"
    | "/_layout/templates/tasks/create"
    | "/_layout/templates/tasks/delete"
    | "/_layout/timesheet/delete/$timeEntryId"
    | "/_layout/tools/$toolId/issue"
    | "/_layout/tools/$toolId/label"
    | "/_layout/tools/$toolId/retire"
    | "/_layout/work-orders/$workOrderId/cancel"
    | "/_layout/work-orders/$workOrderId/close"
    | "/_layout/aircraft_/$aircraftId/"
    | "/_layout/customer_/$customerId/"
    | "/_layout/documents/_list/"
    | "/_layout/inventory/$partId/"
    | "/_layout/inventory_/purchase-orders/"
    | "/_layout/maintenance-programmes_/$programmeId/"
    | "/_layout/planning_/$planId/"
    | "/_layout/quotes_/$quoteId/"
    | "/_layout/quoting/canned/"
    | "/_layout/quoting_/quotes/"
    | "/_layout/quoting_/squawks/"
    | "/_layout/templates/quotes/"
    | "/_layout/templates/tasks/"
    | "/_layout/tools/$toolId/"
    | "/_layout/work-orders/$workOrderId/"
    | "/_layout/work-orders/_list/"
    | "/_layout/customer_/$customerId/contacts/_list"
    | "/_layout/quotes_/$quoteId/tasks/$taskId"
    | "/_layout/quoting_/emails/_list/$emailId"
    | "/_layout/settings/_panel/account/profile"
    | "/_layout/settings/_panel/integrations/erp"
    | "/_layout/settings/_panel/quoting/playbooks"
    | "/_layout/settings/_panel/quoting/rate-cards"
    | "/_layout/settings/_panel/quoting/status"
    | "/_layout/settings/_panel/quoting/task-groups"
    | "/_layout/settings/_panel/quoting/tax-rates"
    | "/_layout/settings/_panel/workspace/approval-flows"
    | "/_layout/settings/_panel/workspace/departments"
    | "/_layout/settings/_panel/workspace/facilities"
    | "/_layout/settings/_panel/workspace/members"
    | "/_layout/settings/_panel/workspace/notification-rules"
    | "/_layout/settings/_panel/workspace/roles"
    | "/_layout/settings/_panel/workspace/teams"
    | "/_layout/settings/_panel/workspace/templates"
    | "/_layout/settings/_panel/workspace/tool-categories"
    | "/_layout/settings/system_/tenants/$tenantId"
    | "/_layout/templates/quotes_/$packageId/_list"
    | "/_layout/templates/quotes_/$packageId/overview"
    | "/_layout/agent/chats/delete/$id"
    | "/_layout/aircraft_/$aircraftId/fitted-components/new"
    | "/_layout/aircraft_/$aircraftId/mod-status/new"
    | "/_layout/aircraft_/$aircraftId/readings/new"
    | "/_layout/aircraft_/$aircraftId/tech-log/$pageId"
    | "/_layout/aircraft_/$aircraftId/tech-log/new"
    | "/_layout/customer_/$customerId/contacts/create"
    | "/_layout/documents/_list/delete/$documentId"
    | "/_layout/documents/_list/delete/bulk"
    | "/_layout/documents/_list/make-private/$documentId"
    | "/_layout/documents/_list/share/$documentId"
    | "/_layout/documents/_list/share/bulk"
    | "/_layout/maintenance-programmes_/$programmeId/aircraft/enrol"
    | "/_layout/maintenance-programmes_/$programmeId/phases/$phaseId"
    | "/_layout/maintenance-programmes_/$programmeId/phases/new"
    | "/_layout/maintenance-programmes_/$programmeId/revisions/new"
    | "/_layout/maintenance-programmes_/$programmeId/tasks/$taskId"
    | "/_layout/maintenance-programmes_/$programmeId/tasks/new"
    | "/_layout/quotes_/$quoteId/phases/new"
    | "/_layout/quotes_/$quoteId/tasks/from-template"
    | "/_layout/quoting_/squawks/delete/$squawkId"
    | "/_layout/quoting_/squawks/edit/$squawkId"
    | "/_layout/settings/_panel/integrations/crm"
    | "/_layout/settings/_panel/quoting/customer-approval"
    | "/_layout/settings/_panel/quoting/general"
    | "/_layout/settings/_panel/work-orders/general"
    | "/_layout/templates/tasks/$taskId/archive"
    | "/_layout/tools/$toolId/calibrations/record"
    | "/_layout/tools/$toolId/calibrations/send"
    | "/_layout/trace/sandbox/$conversationSessionId/$"
    | "/_layout/work-orders/$workOrderId/phases/new"
    | "/_layout/work-orders/$workOrderId/squawks/$squawkId"
    | "/_layout/work-orders/$workOrderId/tasks/$taskId"
    | "/_layout/work-orders/$workOrderId/tasks/delete"
    | "/_layout/work-orders/$workOrderId/tasks/new"
    | "/_layout/work-orders/_list/delete/$workOrderId"
    | "/_layout/quoting_/emails/_list/"
    | "/_layout/settings/system_/audit-log/"
    | "/_layout/templates/tasks/$taskId/"
    | "/_layout/customer_/$customerId/contacts/_list/$contactId"
    | "/_layout/settings/_panel/integrations/erp/_list"
    | "/_layout/settings/_panel/quoting/playbooks/$playbookId"
    | "/_layout/settings/_panel/quoting/rate-cards/$rateCardId"
    | "/_layout/settings/_panel/quoting/tax-rates/$taxRateId"
    | "/_layout/settings/_panel/workspace/approval-flows/$policyId"
    | "/_layout/settings/_panel/workspace/departments/_list"
    | "/_layout/settings/_panel/workspace/facilities/_list"
    | "/_layout/settings/_panel/workspace/members/_list"
    | "/_layout/settings/_panel/workspace/notification-rules/$ruleId"
    | "/_layout/settings/_panel/workspace/roles/_list"
    | "/_layout/settings/_panel/workspace/teams/_list"
    | "/_layout/settings/_panel/workspace/templates/$kind"
    | "/_layout/settings/_panel/workspace/tool-categories/_list"
    | "/_layout/settings/system_/tenants/$tenantId/settings"
    | "/_layout/aircraft_/$aircraftId/fitted-components/remove/$componentId"
    | "/_layout/aircraft_/$aircraftId/tech-log/void/$pageId"
    | "/_layout/inventory/$partId/prices/$priceId/delete"
    | "/_layout/maintenance-programmes_/$programmeId/aircraft/remove/$enrolmentId"
    | "/_layout/maintenance-programmes_/$programmeId/phases/remove/$phaseId"
    | "/_layout/maintenance-programmes_/$programmeId/revisions/release/$revisionId"
    | "/_layout/maintenance-programmes_/$programmeId/tasks/remove/$taskId"
    | "/_layout/quotes_/$quoteId/phases/$phaseId/delete"
    | "/_layout/quotes_/$quoteId/phases/$phaseId/rename"
    | "/_layout/quotes_/$quoteId/tasks/$taskId/apply-template"
    | "/_layout/quoting_/emails/_list/$emailId/share"
    | "/_layout/quoting_/emails/_list/delete/$emailId"
    | "/_layout/quoting_/emails/_list/delete/bulk"
    | "/_layout/quoting_/emails/_list/share/bulk"
    | "/_layout/settings/_panel/account/profile/change-password"
    | "/_layout/settings/_panel/quoting/flat-rates/$packageId"
    | "/_layout/settings/_panel/quoting/playbooks/create"
    | "/_layout/settings/_panel/quoting/task-groups/import"
    | "/_layout/settings/_panel/workspace/approval-flows/create"
    | "/_layout/settings/_panel/workspace/departments/create"
    | "/_layout/settings/_panel/workspace/facilities/create"
    | "/_layout/settings/_panel/workspace/members/create"
    | "/_layout/settings/_panel/workspace/notification-rules/create"
    | "/_layout/settings/_panel/workspace/roles/create"
    | "/_layout/settings/_panel/workspace/teams/create"
    | "/_layout/settings/_panel/workspace/tool-categories/create"
    | "/_layout/settings/system_/tenants/$tenantId/approval-policies"
    | "/_layout/settings/system_/tenants/$tenantId/integrations"
    | "/_layout/settings/system_/tenants/$tenantId/notification-rules"
    | "/_layout/settings/system_/tenants/$tenantId/users"
    | "/_layout/templates/quotes_/$packageId/overview/archive"
    | "/_layout/tools/$toolId/calibrations/$calibrationId/complete"
    | "/_layout/tools/$toolId/loans/$loanId/receive"
    | "/_layout/work-orders/$workOrderId/phases/$phaseId/delete"
    | "/_layout/work-orders/$workOrderId/phases/$phaseId/rename"
    | "/_layout/work-orders/$workOrderId/tasks/$taskId/delete"
    | "/_layout/customer_/$customerId/contacts/_list/"
    | "/_layout/planning_/$planId/steps/$stepId/"
    | "/_layout/quotes_/$quoteId/tasks/$taskId/"
    | "/_layout/quoting_/emails/_list/$emailId/"
    | "/_layout/quoting_/quotes/builder/$quoteId/"
    | "/_layout/settings/_panel/account/notifications/"
    | "/_layout/settings/_panel/account/profile/"
    | "/_layout/settings/_panel/account/signing-pin/"
    | "/_layout/settings/_panel/quoting/flat-rates/"
    | "/_layout/settings/_panel/quoting/playbooks/"
    | "/_layout/settings/_panel/quoting/rate-cards/"
    | "/_layout/settings/_panel/quoting/status/"
    | "/_layout/settings/_panel/quoting/task-groups/"
    | "/_layout/settings/_panel/quoting/tax-rates/"
    | "/_layout/settings/_panel/workspace/approval-flows/"
    | "/_layout/settings/_panel/workspace/general/"
    | "/_layout/settings/_panel/workspace/notification-rules/"
    | "/_layout/settings/_panel/workspace/templates/"
    | "/_layout/settings/system_/tenants/$tenantId/"
    | "/_layout/templates/quotes_/$packageId/_list/"
    | "/_layout/templates/quotes_/$packageId/overview/"
    | "/_layout/settings/_panel/quoting/playbooks/$playbookId/rules"
    | "/_layout/settings/_panel/workspace/departments/_list/$departmentId"
    | "/_layout/settings/_panel/workspace/facilities/_list/$facilityId"
    | "/_layout/settings/_panel/workspace/members/_list/$userId"
    | "/_layout/settings/_panel/workspace/roles/_list/$roleId"
    | "/_layout/settings/_panel/workspace/teams/_list/$teamId"
    | "/_layout/settings/_panel/workspace/tool-categories/_list/$categoryId"
    | "/_layout/templates/quotes_/$packageId/_list/tasks/$taskId"
    | "/_layout/aircraft_/$aircraftId/part-instances/$partInstanceId/readings/new"
    | "/_layout/customer_/$customerId/contacts/_list/$contactId/delete"
    | "/_layout/planning_/$planId/steps/$stepId/tasks/$taskIndex"
    | "/_layout/quoting_/quotes/builder/$quoteId/task/$taskId"
    | "/_layout/settings/_panel/integrations/erp/api-key/set"
    | "/_layout/settings/_panel/integrations/erp/relay/set"
    | "/_layout/settings/_panel/quoting/playbooks/$playbookId/activity"
    | "/_layout/settings/_panel/quoting/playbooks/$playbookId/configuration"
    | "/_layout/settings/_panel/quoting/rate-cards/$rateCardId/archive"
    | "/_layout/settings/_panel/quoting/task-groups/$groupId/archive"
    | "/_layout/settings/_panel/quoting/tax-rates/$taxRateId/archive"
    | "/_layout/settings/_panel/workspace/approval-flows/$policyId/delete"
    | "/_layout/settings/_panel/workspace/approval-flows/duplicate/$policyId"
    | "/_layout/settings/_panel/workspace/notification-rules/$ruleId/delete"
    | "/_layout/settings/_panel/workspace/notification-rules/duplicate/$ruleId"
    | "/_layout/settings/_panel/workspace/roles/duplicate/$roleId"
    | "/_layout/settings/_panel/workspace/templates/$kind/revert"
    | "/_layout/settings/system_/tenants/$tenantId/settings/reindex"
    | "/_layout/templates/quotes_/$packageId/_list/tasks/create"
    | "/_layout/customer_/$customerId/contacts/_list/$contactId/"
    | "/_layout/settings/_panel/integrations/erp/_list/"
    | "/_layout/settings/_panel/quoting/playbooks/$playbookId/"
    | "/_layout/settings/_panel/quoting/rate-cards/$rateCardId/"
    | "/_layout/settings/_panel/quoting/tax-rates/$taxRateId/"
    | "/_layout/settings/_panel/workspace/approval-flows/$policyId/"
    | "/_layout/settings/_panel/workspace/departments/_list/"
    | "/_layout/settings/_panel/workspace/facilities/_list/"
    | "/_layout/settings/_panel/workspace/members/_list/"
    | "/_layout/settings/_panel/workspace/notification-rules/$ruleId/"
    | "/_layout/settings/_panel/workspace/roles/_list/"
    | "/_layout/settings/_panel/workspace/teams/_list/"
    | "/_layout/settings/_panel/workspace/templates/$kind/"
    | "/_layout/settings/_panel/workspace/tool-categories/_list/"
    | "/_layout/settings/system_/tenants/$tenantId/settings/"
    | "/_layout/aircraft_/$aircraftId/part-instances/$partInstanceId/readings/$readingId/delete"
    | "/_layout/quotes_/$quoteId/tasks/$taskId/steps/$stepId/remove"
    | "/_layout/settings/_panel/integrations/erp/_list/api-key/revoke"
    | "/_layout/settings/_panel/integrations/erp/_list/relay/remove"
    | "/_layout/settings/_panel/workspace/departments/_list/$departmentId/delete"
    | "/_layout/settings/_panel/workspace/facilities/_list/$facilityId/delete"
    | "/_layout/settings/_panel/workspace/members/_list/$userId/change-password"
    | "/_layout/settings/_panel/workspace/members/_list/$userId/delete"
    | "/_layout/settings/_panel/workspace/members/_list/$userId/resend-login-email"
    | "/_layout/settings/_panel/workspace/roles/_list/$roleId/delete"
    | "/_layout/settings/_panel/workspace/roles/_list/$roleId/reset"
    | "/_layout/settings/_panel/workspace/teams/_list/$teamId/delete"
    | "/_layout/settings/_panel/workspace/tool-categories/_list/$categoryId/delete"
    | "/_layout/templates/quotes_/$packageId/_list/tasks/$taskId/archive"
    | "/_layout/work-orders/$workOrderId/tasks/$taskId/steps/$stepId/delete"
    | "/_layout/work-orders/$workOrderId/tasks/$taskId/time-entries/$timeEntryId/delete"
    | "/_layout/settings/_panel/quoting/playbooks/$playbookId/rules/"
    | "/_layout/settings/_panel/workspace/departments/_list/$departmentId/"
    | "/_layout/settings/_panel/workspace/facilities/_list/$facilityId/"
    | "/_layout/settings/_panel/workspace/members/_list/$userId/"
    | "/_layout/settings/_panel/workspace/roles/_list/$roleId/"
    | "/_layout/settings/_panel/workspace/teams/_list/$teamId/"
    | "/_layout/settings/_panel/workspace/tool-categories/_list/$categoryId/"
    | "/_layout/templates/quotes_/$packageId/_list/tasks/$taskId/"
    | "/_layout/settings/_panel/quoting/playbooks/$playbookId/rules/$lineageId/delete"
    | "/_layout/settings/_panel/workspace/departments/_list/$departmentId/positions/$positionId/remove"
    | "/_layout/settings/_panel/workspace/facilities/_list/$facilityId/locations/$locationId/delete"
    | "/_layout/settings/_panel/workspace/facilities/_list/$facilityId/positions/$positionId/remove"
    | "/_layout/settings/_panel/workspace/teams/_list/$teamId/positions/$positionId/remove"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LayoutRoute: typeof LayoutRouteWithChildren
  ChangePasswordRoute: typeof ChangePasswordRoute
  LoginRoute: typeof LoginRoute
  RecoverPasswordRoute: typeof RecoverPasswordRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  ReviewTokenRouteRoute: typeof ReviewTokenRouteRouteWithChildren
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_layout": {
      id: "/_layout"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/change-password": {
      id: "/change-password"
      path: "/change-password"
      fullPath: "/change-password"
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/recover-password": {
      id: "/recover-password"
      path: "/recover-password"
      fullPath: "/recover-password"
      preLoaderRoute: typeof RecoverPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/reset-password": {
      id: "/reset-password"
      path: "/reset-password"
      fullPath: "/reset-password"
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_layout/": {
      id: "/_layout/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof LayoutIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/agent": {
      id: "/_layout/agent"
      path: "/agent"
      fullPath: "/agent"
      preLoaderRoute: typeof LayoutAgentRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/aircraft": {
      id: "/_layout/aircraft"
      path: "/aircraft"
      fullPath: "/aircraft"
      preLoaderRoute: typeof LayoutAircraftRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/airworthiness-directives": {
      id: "/_layout/airworthiness-directives"
      path: "/airworthiness-directives"
      fullPath: "/airworthiness-directives"
      preLoaderRoute: typeof LayoutAirworthinessDirectivesRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/approved-vendors": {
      id: "/_layout/approved-vendors"
      path: "/approved-vendors"
      fullPath: "/approved-vendors"
      preLoaderRoute: typeof LayoutApprovedVendorsRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/customer": {
      id: "/_layout/customer"
      path: "/customer"
      fullPath: "/customer"
      preLoaderRoute: typeof LayoutCustomerRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/documents": {
      id: "/_layout/documents"
      path: "/documents"
      fullPath: "/documents"
      preLoaderRoute: typeof LayoutDocumentsRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/forecasts": {
      id: "/_layout/forecasts"
      path: "/forecasts"
      fullPath: "/forecasts"
      preLoaderRoute: typeof LayoutForecastsRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/inventory": {
      id: "/_layout/inventory"
      path: "/inventory"
      fullPath: "/inventory"
      preLoaderRoute: typeof LayoutInventoryRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/maintenance-programmes": {
      id: "/_layout/maintenance-programmes"
      path: "/maintenance-programmes"
      fullPath: "/maintenance-programmes"
      preLoaderRoute: typeof LayoutMaintenanceProgrammesRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/planning": {
      id: "/_layout/planning"
      path: "/planning"
      fullPath: "/planning"
      preLoaderRoute: typeof LayoutPlanningRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/quotes": {
      id: "/_layout/quotes"
      path: "/quotes"
      fullPath: "/quotes"
      preLoaderRoute: typeof LayoutQuotesRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/settings": {
      id: "/_layout/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof LayoutSettingsRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/tech-logs": {
      id: "/_layout/tech-logs"
      path: "/tech-logs"
      fullPath: "/tech-logs"
      preLoaderRoute: typeof LayoutTechLogsRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/templates": {
      id: "/_layout/templates"
      path: "/templates"
      fullPath: "/templates"
      preLoaderRoute: typeof LayoutTemplatesRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/tie-in": {
      id: "/_layout/tie-in"
      path: "/tie-in"
      fullPath: "/tie-in"
      preLoaderRoute: typeof LayoutTieInRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/timesheet": {
      id: "/_layout/timesheet"
      path: "/timesheet"
      fullPath: "/timesheet"
      preLoaderRoute: typeof LayoutTimesheetRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/tools": {
      id: "/_layout/tools"
      path: "/tools"
      fullPath: "/tools"
      preLoaderRoute: typeof LayoutToolsRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/review/$token": {
      id: "/review/$token"
      path: "/review/$token"
      fullPath: "/review/$token"
      preLoaderRoute: typeof ReviewTokenRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_layout/agent/": {
      id: "/_layout/agent/"
      path: "/"
      fullPath: "/agent/"
      preLoaderRoute: typeof LayoutAgentIndexRouteImport
      parentRoute: typeof LayoutAgentRouteRoute
    }
    "/_layout/agent/$id": {
      id: "/_layout/agent/$id"
      path: "/$id"
      fullPath: "/agent/$id"
      preLoaderRoute: typeof LayoutAgentIdRouteImport
      parentRoute: typeof LayoutAgentRouteRoute
    }
    "/_layout/agent/chats": {
      id: "/_layout/agent/chats"
      path: "/chats"
      fullPath: "/agent/chats"
      preLoaderRoute: typeof LayoutAgentChatsRouteImport
      parentRoute: typeof LayoutAgentRouteRoute
    }
    "/_layout/aircraft/": {
      id: "/_layout/aircraft/"
      path: "/"
      fullPath: "/aircraft/"
      preLoaderRoute: typeof LayoutAircraftIndexRouteImport
      parentRoute: typeof LayoutAircraftRouteRoute
    }
    "/_layout/aircraft_/$aircraftId": {
      id: "/_layout/aircraft_/$aircraftId"
      path: "/aircraft/$aircraftId"
      fullPath: "/aircraft/$aircraftId"
      preLoaderRoute: typeof LayoutAircraftAircraftIdRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/aircraft_/new": {
      id: "/_layout/aircraft_/new"
      path: "/aircraft/new"
      fullPath: "/aircraft/new"
      preLoaderRoute: typeof LayoutAircraftNewRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/airworthiness-directives/": {
      id: "/_layout/airworthiness-directives/"
      path: "/"
      fullPath: "/airworthiness-directives/"
      preLoaderRoute: typeof LayoutAirworthinessDirectivesIndexRouteImport
      parentRoute: typeof LayoutAirworthinessDirectivesRouteRoute
    }
    "/_layout/airworthiness-directives/upload": {
      id: "/_layout/airworthiness-directives/upload"
      path: "/upload"
      fullPath: "/airworthiness-directives/upload"
      preLoaderRoute: typeof LayoutAirworthinessDirectivesUploadRouteImport
      parentRoute: typeof LayoutAirworthinessDirectivesRouteRoute
    }
    "/_layout/airworthiness-directives_/$documentId": {
      id: "/_layout/airworthiness-directives_/$documentId"
      path: "/airworthiness-directives/$documentId"
      fullPath: "/airworthiness-directives/$documentId"
      preLoaderRoute: typeof LayoutAirworthinessDirectivesDocumentIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/approved-vendors/": {
      id: "/_layout/approved-vendors/"
      path: "/"
      fullPath: "/approved-vendors/"
      preLoaderRoute: typeof LayoutApprovedVendorsIndexRouteImport
      parentRoute: typeof LayoutApprovedVendorsRouteRoute
    }
    "/_layout/approved-vendors_/$vendorId": {
      id: "/_layout/approved-vendors_/$vendorId"
      path: "/approved-vendors/$vendorId"
      fullPath: "/approved-vendors/$vendorId"
      preLoaderRoute: typeof LayoutApprovedVendorsVendorIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/approved-vendors_/new": {
      id: "/_layout/approved-vendors_/new"
      path: "/approved-vendors/new"
      fullPath: "/approved-vendors/new"
      preLoaderRoute: typeof LayoutApprovedVendorsNewRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/customer/": {
      id: "/_layout/customer/"
      path: "/"
      fullPath: "/customer/"
      preLoaderRoute: typeof LayoutCustomerIndexRouteImport
      parentRoute: typeof LayoutCustomerRouteRoute
    }
    "/_layout/customer_/$customerId": {
      id: "/_layout/customer_/$customerId"
      path: "/customer/$customerId"
      fullPath: "/customer/$customerId"
      preLoaderRoute: typeof LayoutCustomerCustomerIdRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/customer_/new": {
      id: "/_layout/customer_/new"
      path: "/customer/new"
      fullPath: "/customer/new"
      preLoaderRoute: typeof LayoutCustomerNewRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/documents/$documentId": {
      id: "/_layout/documents/$documentId"
      path: "/$documentId"
      fullPath: "/documents/$documentId"
      preLoaderRoute: typeof LayoutDocumentsDocumentIdRouteImport
      parentRoute: typeof LayoutDocumentsRouteRoute
    }
    "/_layout/documents/_list": {
      id: "/_layout/documents/_list"
      path: ""
      fullPath: "/documents"
      preLoaderRoute: typeof LayoutDocumentsListRouteRouteImport
      parentRoute: typeof LayoutDocumentsRouteRoute
    }
    "/_layout/forecasts/": {
      id: "/_layout/forecasts/"
      path: "/"
      fullPath: "/forecasts/"
      preLoaderRoute: typeof LayoutForecastsIndexRouteImport
      parentRoute: typeof LayoutForecastsRouteRoute
    }
    "/_layout/forecasts/new": {
      id: "/_layout/forecasts/new"
      path: "/new"
      fullPath: "/forecasts/new"
      preLoaderRoute: typeof LayoutForecastsNewRouteImport
      parentRoute: typeof LayoutForecastsRouteRoute
    }
    "/_layout/forecasts_/$forecastId": {
      id: "/_layout/forecasts_/$forecastId"
      path: "/forecasts/$forecastId"
      fullPath: "/forecasts/$forecastId"
      preLoaderRoute: typeof LayoutForecastsForecastIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/forecasts_/preview": {
      id: "/_layout/forecasts_/preview"
      path: "/forecasts/preview"
      fullPath: "/forecasts/preview"
      preLoaderRoute: typeof LayoutForecastsPreviewRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/inventory/": {
      id: "/_layout/inventory/"
      path: "/"
      fullPath: "/inventory/"
      preLoaderRoute: typeof LayoutInventoryIndexRouteImport
      parentRoute: typeof LayoutInventoryRouteRoute
    }
    "/_layout/inventory/$partId": {
      id: "/_layout/inventory/$partId"
      path: "/$partId"
      fullPath: "/inventory/$partId"
      preLoaderRoute: typeof LayoutInventoryPartIdRouteRouteImport
      parentRoute: typeof LayoutInventoryRouteRoute
    }
    "/_layout/inventory/new": {
      id: "/_layout/inventory/new"
      path: "/new"
      fullPath: "/inventory/new"
      preLoaderRoute: typeof LayoutInventoryNewRouteImport
      parentRoute: typeof LayoutInventoryRouteRoute
    }
    "/_layout/inventory_/purchase-orders": {
      id: "/_layout/inventory_/purchase-orders"
      path: "/inventory/purchase-orders"
      fullPath: "/inventory/purchase-orders"
      preLoaderRoute: typeof LayoutInventoryPurchaseOrdersRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/maintenance-programmes/": {
      id: "/_layout/maintenance-programmes/"
      path: "/"
      fullPath: "/maintenance-programmes/"
      preLoaderRoute: typeof LayoutMaintenanceProgrammesIndexRouteImport
      parentRoute: typeof LayoutMaintenanceProgrammesRouteRoute
    }
    "/_layout/maintenance-programmes/new": {
      id: "/_layout/maintenance-programmes/new"
      path: "/new"
      fullPath: "/maintenance-programmes/new"
      preLoaderRoute: typeof LayoutMaintenanceProgrammesNewRouteImport
      parentRoute: typeof LayoutMaintenanceProgrammesRouteRoute
    }
    "/_layout/maintenance-programmes_/$programmeId": {
      id: "/_layout/maintenance-programmes_/$programmeId"
      path: "/maintenance-programmes/$programmeId"
      fullPath: "/maintenance-programmes/$programmeId"
      preLoaderRoute: typeof LayoutMaintenanceProgrammesProgrammeIdRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/manpower/": {
      id: "/_layout/manpower/"
      path: "/manpower"
      fullPath: "/manpower/"
      preLoaderRoute: typeof LayoutManpowerIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/planning/": {
      id: "/_layout/planning/"
      path: "/"
      fullPath: "/planning/"
      preLoaderRoute: typeof LayoutPlanningIndexRouteImport
      parentRoute: typeof LayoutPlanningRouteRoute
    }
    "/_layout/planning_/$planId": {
      id: "/_layout/planning_/$planId"
      path: "/planning/$planId"
      fullPath: "/planning/$planId"
      preLoaderRoute: typeof LayoutPlanningPlanIdRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/quotes/": {
      id: "/_layout/quotes/"
      path: "/"
      fullPath: "/quotes/"
      preLoaderRoute: typeof LayoutQuotesIndexRouteImport
      parentRoute: typeof LayoutQuotesRouteRoute
    }
    "/_layout/quotes/create": {
      id: "/_layout/quotes/create"
      path: "/create"
      fullPath: "/quotes/create"
      preLoaderRoute: typeof LayoutQuotesCreateRouteImport
      parentRoute: typeof LayoutQuotesRouteRoute
    }
    "/_layout/quotes/from-file": {
      id: "/_layout/quotes/from-file"
      path: "/from-file"
      fullPath: "/quotes/from-file"
      preLoaderRoute: typeof LayoutQuotesFromFileRouteImport
      parentRoute: typeof LayoutQuotesRouteRoute
    }
    "/_layout/quotes_/$quoteId": {
      id: "/_layout/quotes_/$quoteId"
      path: "/quotes/$quoteId"
      fullPath: "/quotes/$quoteId"
      preLoaderRoute: typeof LayoutQuotesQuoteIdRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/quoting/": {
      id: "/_layout/quoting/"
      path: "/quoting"
      fullPath: "/quoting/"
      preLoaderRoute: typeof LayoutQuotingIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/quoting_/emails": {
      id: "/_layout/quoting_/emails"
      path: "/quoting/emails"
      fullPath: "/quoting/emails"
      preLoaderRoute: typeof LayoutQuotingEmailsRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/quoting_/squawks": {
      id: "/_layout/quoting_/squawks"
      path: "/quoting/squawks"
      fullPath: "/quoting/squawks"
      preLoaderRoute: typeof LayoutQuotingSquawksRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/settings/": {
      id: "/_layout/settings/"
      path: "/"
      fullPath: "/settings/"
      preLoaderRoute: typeof LayoutSettingsIndexRouteImport
      parentRoute: typeof LayoutSettingsRouteRoute
    }
    "/_layout/settings/_panel": {
      id: "/_layout/settings/_panel"
      path: ""
      fullPath: "/settings"
      preLoaderRoute: typeof LayoutSettingsPanelRouteRouteImport
      parentRoute: typeof LayoutSettingsRouteRoute
    }
    "/_layout/settings/company": {
      id: "/_layout/settings/company"
      path: "/company"
      fullPath: "/settings/company"
      preLoaderRoute: typeof LayoutSettingsCompanyRouteImport
      parentRoute: typeof LayoutSettingsRouteRoute
    }
    "/_layout/settings/system": {
      id: "/_layout/settings/system"
      path: "/system"
      fullPath: "/settings/system"
      preLoaderRoute: typeof LayoutSettingsSystemRouteImport
      parentRoute: typeof LayoutSettingsRouteRoute
    }
    "/_layout/settings/user": {
      id: "/_layout/settings/user"
      path: "/user"
      fullPath: "/settings/user"
      preLoaderRoute: typeof LayoutSettingsUserRouteImport
      parentRoute: typeof LayoutSettingsRouteRoute
    }
    "/_layout/tech-logs/": {
      id: "/_layout/tech-logs/"
      path: "/"
      fullPath: "/tech-logs/"
      preLoaderRoute: typeof LayoutTechLogsIndexRouteImport
      parentRoute: typeof LayoutTechLogsRouteRoute
    }
    "/_layout/tech-logs/$pageId": {
      id: "/_layout/tech-logs/$pageId"
      path: "/$pageId"
      fullPath: "/tech-logs/$pageId"
      preLoaderRoute: typeof LayoutTechLogsPageIdRouteImport
      parentRoute: typeof LayoutTechLogsRouteRoute
    }
    "/_layout/tech-logs/new": {
      id: "/_layout/tech-logs/new"
      path: "/new"
      fullPath: "/tech-logs/new"
      preLoaderRoute: typeof LayoutTechLogsNewRouteImport
      parentRoute: typeof LayoutTechLogsRouteRoute
    }
    "/_layout/templates/": {
      id: "/_layout/templates/"
      path: "/"
      fullPath: "/templates/"
      preLoaderRoute: typeof LayoutTemplatesIndexRouteImport
      parentRoute: typeof LayoutTemplatesRouteRoute
    }
    "/_layout/templates/quotes": {
      id: "/_layout/templates/quotes"
      path: "/quotes"
      fullPath: "/templates/quotes"
      preLoaderRoute: typeof LayoutTemplatesQuotesRouteRouteImport
      parentRoute: typeof LayoutTemplatesRouteRoute
    }
    "/_layout/templates/tasks": {
      id: "/_layout/templates/tasks"
      path: "/tasks"
      fullPath: "/templates/tasks"
      preLoaderRoute: typeof LayoutTemplatesTasksRouteRouteImport
      parentRoute: typeof LayoutTemplatesRouteRoute
    }
    "/_layout/timesheet/": {
      id: "/_layout/timesheet/"
      path: "/"
      fullPath: "/timesheet/"
      preLoaderRoute: typeof LayoutTimesheetIndexRouteImport
      parentRoute: typeof LayoutTimesheetRouteRoute
    }
    "/_layout/timesheet/log": {
      id: "/_layout/timesheet/log"
      path: "/log"
      fullPath: "/timesheet/log"
      preLoaderRoute: typeof LayoutTimesheetLogRouteImport
      parentRoute: typeof LayoutTimesheetRouteRoute
    }
    "/_layout/tools/": {
      id: "/_layout/tools/"
      path: "/"
      fullPath: "/tools/"
      preLoaderRoute: typeof LayoutToolsIndexRouteImport
      parentRoute: typeof LayoutToolsRouteRoute
    }
    "/_layout/tools/$toolId": {
      id: "/_layout/tools/$toolId"
      path: "/$toolId"
      fullPath: "/tools/$toolId"
      preLoaderRoute: typeof LayoutToolsToolIdRouteRouteImport
      parentRoute: typeof LayoutToolsRouteRoute
    }
    "/_layout/tools/new": {
      id: "/_layout/tools/new"
      path: "/new"
      fullPath: "/tools/new"
      preLoaderRoute: typeof LayoutToolsNewRouteImport
      parentRoute: typeof LayoutToolsRouteRoute
    }
    "/_layout/work-orders/$workOrderId": {
      id: "/_layout/work-orders/$workOrderId"
      path: "/work-orders/$workOrderId"
      fullPath: "/work-orders/$workOrderId"
      preLoaderRoute: typeof LayoutWorkOrdersWorkOrderIdRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/work-orders/_list": {
      id: "/_layout/work-orders/_list"
      path: "/work-orders"
      fullPath: "/work-orders"
      preLoaderRoute: typeof LayoutWorkOrdersListRouteRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/work-task/$id": {
      id: "/_layout/work-task/$id"
      path: "/work-task/$id"
      fullPath: "/work-task/$id"
      preLoaderRoute: typeof LayoutWorkTaskIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/review/$token/": {
      id: "/review/$token/"
      path: "/"
      fullPath: "/review/$token/"
      preLoaderRoute: typeof ReviewTokenIndexRouteImport
      parentRoute: typeof ReviewTokenRouteRoute
    }
    "/review/$token/sign": {
      id: "/review/$token/sign"
      path: "/sign"
      fullPath: "/review/$token/sign"
      preLoaderRoute: typeof ReviewTokenSignRouteImport
      parentRoute: typeof ReviewTokenRouteRoute
    }
    "/_layout/agent/delete/$id": {
      id: "/_layout/agent/delete/$id"
      path: "/delete/$id"
      fullPath: "/agent/delete/$id"
      preLoaderRoute: typeof LayoutAgentDeleteIdRouteImport
      parentRoute: typeof LayoutAgentRouteRoute
    }
    "/_layout/aircraft_/$aircraftId/": {
      id: "/_layout/aircraft_/$aircraftId/"
      path: "/"
      fullPath: "/aircraft/$aircraftId/"
      preLoaderRoute: typeof LayoutAircraftAircraftIdIndexRouteImport
      parentRoute: typeof LayoutAircraftAircraftIdRouteRoute
    }
    "/_layout/aircraft_/$aircraftId_/edit": {
      id: "/_layout/aircraft_/$aircraftId_/edit"
      path: "/aircraft/$aircraftId/edit"
      fullPath: "/aircraft/$aircraftId/edit"
      preLoaderRoute: typeof LayoutAircraftAircraftIdEditRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/airworthiness-directives/delete/$documentId": {
      id: "/_layout/airworthiness-directives/delete/$documentId"
      path: "/delete/$documentId"
      fullPath: "/airworthiness-directives/delete/$documentId"
      preLoaderRoute: typeof LayoutAirworthinessDirectivesDeleteDocumentIdRouteImport
      parentRoute: typeof LayoutAirworthinessDirectivesRouteRoute
    }
    "/_layout/approved-vendors/delete/$vendorId": {
      id: "/_layout/approved-vendors/delete/$vendorId"
      path: "/delete/$vendorId"
      fullPath: "/approved-vendors/delete/$vendorId"
      preLoaderRoute: typeof LayoutApprovedVendorsDeleteVendorIdRouteImport
      parentRoute: typeof LayoutApprovedVendorsRouteRoute
    }
    "/_layout/approved-vendors/delete/bulk": {
      id: "/_layout/approved-vendors/delete/bulk"
      path: "/delete/bulk"
      fullPath: "/approved-vendors/delete/bulk"
      preLoaderRoute: typeof LayoutApprovedVendorsDeleteBulkRouteImport
      parentRoute: typeof LayoutApprovedVendorsRouteRoute
    }
    "/_layout/assessments/ad/$reportId": {
      id: "/_layout/assessments/ad/$reportId"
      path: "/assessments/ad/$reportId"
      fullPath: "/assessments/ad/$reportId"
      preLoaderRoute: typeof LayoutAssessmentsAdReportIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/assessments/sb/$reportId": {
      id: "/_layout/assessments/sb/$reportId"
      path: "/assessments/sb/$reportId"
      fullPath: "/assessments/sb/$reportId"
      preLoaderRoute: typeof LayoutAssessmentsSbReportIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/customer/delete/$customerId": {
      id: "/_layout/customer/delete/$customerId"
      path: "/delete/$customerId"
      fullPath: "/customer/delete/$customerId"
      preLoaderRoute: typeof LayoutCustomerDeleteCustomerIdRouteImport
      parentRoute: typeof LayoutCustomerRouteRoute
    }
    "/_layout/customer_/$customerId/": {
      id: "/_layout/customer_/$customerId/"
      path: "/"
      fullPath: "/customer/$customerId/"
      preLoaderRoute: typeof LayoutCustomerCustomerIdIndexRouteImport
      parentRoute: typeof LayoutCustomerCustomerIdRouteRoute
    }
    "/_layout/customer_/$customerId/aircraft": {
      id: "/_layout/customer_/$customerId/aircraft"
      path: "/aircraft"
      fullPath: "/customer/$customerId/aircraft"
      preLoaderRoute: typeof LayoutCustomerCustomerIdAircraftRouteImport
      parentRoute: typeof LayoutCustomerCustomerIdRouteRoute
    }
    "/_layout/customer_/$customerId/contacts": {
      id: "/_layout/customer_/$customerId/contacts"
      path: "/contacts"
      fullPath: "/customer/$customerId/contacts"
      preLoaderRoute: typeof LayoutCustomerCustomerIdContactsRouteRouteImport
      parentRoute: typeof LayoutCustomerCustomerIdRouteRoute
    }
    "/_layout/customer_/$customerId/delete": {
      id: "/_layout/customer_/$customerId/delete"
      path: "/delete"
      fullPath: "/customer/$customerId/delete"
      preLoaderRoute: typeof LayoutCustomerCustomerIdDeleteRouteImport
      parentRoute: typeof LayoutCustomerCustomerIdRouteRoute
    }
    "/_layout/customer_/$customerId/wo-history": {
      id: "/_layout/customer_/$customerId/wo-history"
      path: "/wo-history"
      fullPath: "/customer/$customerId/wo-history"
      preLoaderRoute: typeof LayoutCustomerCustomerIdWoHistoryRouteImport
      parentRoute: typeof LayoutCustomerCustomerIdRouteRoute
    }
    "/_layout/documents/_list/": {
      id: "/_layout/documents/_list/"
      path: "/"
      fullPath: "/documents/"
      preLoaderRoute: typeof LayoutDocumentsListIndexRouteImport
      parentRoute: typeof LayoutDocumentsListRouteRoute
    }
    "/_layout/documents/_list/upload": {
      id: "/_layout/documents/_list/upload"
      path: "/upload"
      fullPath: "/documents/upload"
      preLoaderRoute: typeof LayoutDocumentsListUploadRouteRouteImport
      parentRoute: typeof LayoutDocumentsListRouteRoute
    }
    "/_layout/forecasts/delete/$forecastId": {
      id: "/_layout/forecasts/delete/$forecastId"
      path: "/delete/$forecastId"
      fullPath: "/forecasts/delete/$forecastId"
      preLoaderRoute: typeof LayoutForecastsDeleteForecastIdRouteImport
      parentRoute: typeof LayoutForecastsRouteRoute
    }
    "/_layout/inventory/$partId/": {
      id: "/_layout/inventory/$partId/"
      path: "/"
      fullPath: "/inventory/$partId/"
      preLoaderRoute: typeof LayoutInventoryPartIdIndexRouteImport
      parentRoute: typeof LayoutInventoryPartIdRouteRoute
    }
    "/_layout/inventory/$partId/archive": {
      id: "/_layout/inventory/$partId/archive"
      path: "/archive"
      fullPath: "/inventory/$partId/archive"
      preLoaderRoute: typeof LayoutInventoryPartIdArchiveRouteImport
      parentRoute: typeof LayoutInventoryPartIdRouteRoute
    }
    "/_layout/inventory/delete/$partId": {
      id: "/_layout/inventory/delete/$partId"
      path: "/delete/$partId"
      fullPath: "/inventory/delete/$partId"
      preLoaderRoute: typeof LayoutInventoryDeletePartIdRouteImport
      parentRoute: typeof LayoutInventoryRouteRoute
    }
    "/_layout/inventory/delete/bulk": {
      id: "/_layout/inventory/delete/bulk"
      path: "/delete/bulk"
      fullPath: "/inventory/delete/bulk"
      preLoaderRoute: typeof LayoutInventoryDeleteBulkRouteImport
      parentRoute: typeof LayoutInventoryRouteRoute
    }
    "/_layout/inventory_/purchase-orders/": {
      id: "/_layout/inventory_/purchase-orders/"
      path: "/"
      fullPath: "/inventory/purchase-orders/"
      preLoaderRoute: typeof LayoutInventoryPurchaseOrdersIndexRouteImport
      parentRoute: typeof LayoutInventoryPurchaseOrdersRouteRoute
    }
    "/_layout/inventory_/purchase-orders/$purchaseOrderId": {
      id: "/_layout/inventory_/purchase-orders/$purchaseOrderId"
      path: "/$purchaseOrderId"
      fullPath: "/inventory/purchase-orders/$purchaseOrderId"
      preLoaderRoute: typeof LayoutInventoryPurchaseOrdersPurchaseOrderIdRouteImport
      parentRoute: typeof LayoutInventoryPurchaseOrdersRouteRoute
    }
    "/_layout/inventory_/purchase-orders/new": {
      id: "/_layout/inventory_/purchase-orders/new"
      path: "/new"
      fullPath: "/inventory/purchase-orders/new"
      preLoaderRoute: typeof LayoutInventoryPurchaseOrdersNewRouteImport
      parentRoute: typeof LayoutInventoryPurchaseOrdersRouteRoute
    }
    "/_layout/maintenance-programmes/delete/$programmeId": {
      id: "/_layout/maintenance-programmes/delete/$programmeId"
      path: "/delete/$programmeId"
      fullPath: "/maintenance-programmes/delete/$programmeId"
      preLoaderRoute: typeof LayoutMaintenanceProgrammesDeleteProgrammeIdRouteImport
      parentRoute: typeof LayoutMaintenanceProgrammesRouteRoute
    }
    "/_layout/maintenance-programmes_/$programmeId/": {
      id: "/_layout/maintenance-programmes_/$programmeId/"
      path: "/"
      fullPath: "/maintenance-programmes/$programmeId/"
      preLoaderRoute: typeof LayoutMaintenanceProgrammesProgrammeIdIndexRouteImport
      parentRoute: typeof LayoutMaintenanceProgrammesProgrammeIdRouteRoute
    }
    "/_layout/planning/new/forecast": {
      id: "/_layout/planning/new/forecast"
      path: "/new/forecast"
      fullPath: "/planning/new/forecast"
      preLoaderRoute: typeof LayoutPlanningNewForecastRouteImport
      parentRoute: typeof LayoutPlanningRouteRoute
    }
    "/_layout/planning/new/quote": {
      id: "/_layout/planning/new/quote"
      path: "/new/quote"
      fullPath: "/planning/new/quote"
      preLoaderRoute: typeof LayoutPlanningNewQuoteRouteImport
      parentRoute: typeof LayoutPlanningRouteRoute
    }
    "/_layout/planning_/$planId/": {
      id: "/_layout/planning_/$planId/"
      path: "/"
      fullPath: "/planning/$planId/"
      preLoaderRoute: typeof LayoutPlanningPlanIdIndexRouteImport
      parentRoute: typeof LayoutPlanningPlanIdRouteRoute
    }
    "/_layout/quotes/delete/$quoteId": {
      id: "/_layout/quotes/delete/$quoteId"
      path: "/delete/$quoteId"
      fullPath: "/quotes/delete/$quoteId"
      preLoaderRoute: typeof LayoutQuotesDeleteQuoteIdRouteImport
      parentRoute: typeof LayoutQuotesRouteRoute
    }
    "/_layout/quotes_/$quoteId/": {
      id: "/_layout/quotes_/$quoteId/"
      path: "/"
      fullPath: "/quotes/$quoteId/"
      preLoaderRoute: typeof LayoutQuotesQuoteIdIndexRouteImport
      parentRoute: typeof LayoutQuotesQuoteIdRouteRoute
    }
    "/_layout/quotes_/$quoteId/corridor": {
      id: "/_layout/quotes_/$quoteId/corridor"
      path: "/corridor"
      fullPath: "/quotes/$quoteId/corridor"
      preLoaderRoute: typeof LayoutQuotesQuoteIdCorridorRouteImport
      parentRoute: typeof LayoutQuotesQuoteIdRouteRoute
    }
    "/_layout/quotes_/$quoteId/send": {
      id: "/_layout/quotes_/$quoteId/send"
      path: "/send"
      fullPath: "/quotes/$quoteId/send"
      preLoaderRoute: typeof LayoutQuotesQuoteIdSendRouteImport
      parentRoute: typeof LayoutQuotesQuoteIdRouteRoute
    }
    "/_layout/quotes_/$quoteId/sent": {
      id: "/_layout/quotes_/$quoteId/sent"
      path: "/sent"
      fullPath: "/quotes/$quoteId/sent"
      preLoaderRoute: typeof LayoutQuotesQuoteIdSentRouteImport
      parentRoute: typeof LayoutQuotesQuoteIdRouteRoute
    }
    "/_layout/quoting/canned/": {
      id: "/_layout/quoting/canned/"
      path: "/quoting/canned"
      fullPath: "/quoting/canned/"
      preLoaderRoute: typeof LayoutQuotingCannedIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/quoting/canned/$packageId": {
      id: "/_layout/quoting/canned/$packageId"
      path: "/quoting/canned/$packageId"
      fullPath: "/quoting/canned/$packageId"
      preLoaderRoute: typeof LayoutQuotingCannedPackageIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/quoting_/emails/_list": {
      id: "/_layout/quoting_/emails/_list"
      path: ""
      fullPath: "/quoting/emails"
      preLoaderRoute: typeof LayoutQuotingEmailsListRouteRouteImport
      parentRoute: typeof LayoutQuotingEmailsRouteRoute
    }
    "/_layout/quoting_/quotes/": {
      id: "/_layout/quoting_/quotes/"
      path: "/quoting/quotes"
      fullPath: "/quoting/quotes/"
      preLoaderRoute: typeof LayoutQuotingQuotesIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/quoting_/quotes/$quoteId": {
      id: "/_layout/quoting_/quotes/$quoteId"
      path: "/quoting/quotes/$quoteId"
      fullPath: "/quoting/quotes/$quoteId"
      preLoaderRoute: typeof LayoutQuotingQuotesQuoteIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/quoting_/squawks/": {
      id: "/_layout/quoting_/squawks/"
      path: "/"
      fullPath: "/quoting/squawks/"
      preLoaderRoute: typeof LayoutQuotingSquawksIndexRouteImport
      parentRoute: typeof LayoutQuotingSquawksRouteRoute
    }
    "/_layout/quoting_/squawks/$squawkId": {
      id: "/_layout/quoting_/squawks/$squawkId"
      path: "/$squawkId"
      fullPath: "/quoting/squawks/$squawkId"
      preLoaderRoute: typeof LayoutQuotingSquawksSquawkIdRouteImport
      parentRoute: typeof LayoutQuotingSquawksRouteRoute
    }
    "/_layout/tech-logs/delete/$pageId": {
      id: "/_layout/tech-logs/delete/$pageId"
      path: "/delete/$pageId"
      fullPath: "/tech-logs/delete/$pageId"
      preLoaderRoute: typeof LayoutTechLogsDeletePageIdRouteImport
      parentRoute: typeof LayoutTechLogsRouteRoute
    }
    "/_layout/templates/quotes/": {
      id: "/_layout/templates/quotes/"
      path: "/"
      fullPath: "/templates/quotes/"
      preLoaderRoute: typeof LayoutTemplatesQuotesIndexRouteImport
      parentRoute: typeof LayoutTemplatesQuotesRouteRoute
    }
    "/_layout/templates/quotes/delete": {
      id: "/_layout/templates/quotes/delete"
      path: "/delete"
      fullPath: "/templates/quotes/delete"
      preLoaderRoute: typeof LayoutTemplatesQuotesDeleteRouteImport
      parentRoute: typeof LayoutTemplatesQuotesRouteRoute
    }
    "/_layout/templates/quotes_/$packageId": {
      id: "/_layout/templates/quotes_/$packageId"
      path: "/quotes/$packageId"
      fullPath: "/templates/quotes/$packageId"
      preLoaderRoute: typeof LayoutTemplatesQuotesPackageIdRouteRouteImport
      parentRoute: typeof LayoutTemplatesRouteRoute
    }
    "/_layout/templates/tasks/": {
      id: "/_layout/templates/tasks/"
      path: "/"
      fullPath: "/templates/tasks/"
      preLoaderRoute: typeof LayoutTemplatesTasksIndexRouteImport
      parentRoute: typeof LayoutTemplatesTasksRouteRoute
    }
    "/_layout/templates/tasks/$taskId": {
      id: "/_layout/templates/tasks/$taskId"
      path: "/$taskId"
      fullPath: "/templates/tasks/$taskId"
      preLoaderRoute: typeof LayoutTemplatesTasksTaskIdRouteRouteImport
      parentRoute: typeof LayoutTemplatesTasksRouteRoute
    }
    "/_layout/templates/tasks/create": {
      id: "/_layout/templates/tasks/create"
      path: "/create"
      fullPath: "/templates/tasks/create"
      preLoaderRoute: typeof LayoutTemplatesTasksCreateRouteImport
      parentRoute: typeof LayoutTemplatesTasksRouteRoute
    }
    "/_layout/templates/tasks/delete": {
      id: "/_layout/templates/tasks/delete"
      path: "/delete"
      fullPath: "/templates/tasks/delete"
      preLoaderRoute: typeof LayoutTemplatesTasksDeleteRouteImport
      parentRoute: typeof LayoutTemplatesTasksRouteRoute
    }
    "/_layout/timesheet/delete/$timeEntryId": {
      id: "/_layout/timesheet/delete/$timeEntryId"
      path: "/delete/$timeEntryId"
      fullPath: "/timesheet/delete/$timeEntryId"
      preLoaderRoute: typeof LayoutTimesheetDeleteTimeEntryIdRouteImport
      parentRoute: typeof LayoutTimesheetRouteRoute
    }
    "/_layout/tools/$toolId/": {
      id: "/_layout/tools/$toolId/"
      path: "/"
      fullPath: "/tools/$toolId/"
      preLoaderRoute: typeof LayoutToolsToolIdIndexRouteImport
      parentRoute: typeof LayoutToolsToolIdRouteRoute
    }
    "/_layout/tools/$toolId/issue": {
      id: "/_layout/tools/$toolId/issue"
      path: "/issue"
      fullPath: "/tools/$toolId/issue"
      preLoaderRoute: typeof LayoutToolsToolIdIssueRouteImport
      parentRoute: typeof LayoutToolsToolIdRouteRoute
    }
    "/_layout/tools/$toolId/label": {
      id: "/_layout/tools/$toolId/label"
      path: "/label"
      fullPath: "/tools/$toolId/label"
      preLoaderRoute: typeof LayoutToolsToolIdLabelRouteImport
      parentRoute: typeof LayoutToolsToolIdRouteRoute
    }
    "/_layout/tools/$toolId/retire": {
      id: "/_layout/tools/$toolId/retire"
      path: "/retire"
      fullPath: "/tools/$toolId/retire"
      preLoaderRoute: typeof LayoutToolsToolIdRetireRouteImport
      parentRoute: typeof LayoutToolsToolIdRouteRoute
    }
    "/_layout/work-orders/$workOrderId/": {
      id: "/_layout/work-orders/$workOrderId/"
      path: "/"
      fullPath: "/work-orders/$workOrderId/"
      preLoaderRoute: typeof LayoutWorkOrdersWorkOrderIdIndexRouteImport
      parentRoute: typeof LayoutWorkOrdersWorkOrderIdRouteRoute
    }
    "/_layout/work-orders/$workOrderId/cancel": {
      id: "/_layout/work-orders/$workOrderId/cancel"
      path: "/cancel"
      fullPath: "/work-orders/$workOrderId/cancel"
      preLoaderRoute: typeof LayoutWorkOrdersWorkOrderIdCancelRouteImport
      parentRoute: typeof LayoutWorkOrdersWorkOrderIdRouteRoute
    }
    "/_layout/work-orders/$workOrderId/close": {
      id: "/_layout/work-orders/$workOrderId/close"
      path: "/close"
      fullPath: "/work-orders/$workOrderId/close"
      preLoaderRoute: typeof LayoutWorkOrdersWorkOrderIdCloseRouteImport
      parentRoute: typeof LayoutWorkOrdersWorkOrderIdRouteRoute
    }
    "/_layout/work-orders/_list/": {
      id: "/_layout/work-orders/_list/"
      path: "/"
      fullPath: "/work-orders/"
      preLoaderRoute: typeof LayoutWorkOrdersListIndexRouteImport
      parentRoute: typeof LayoutWorkOrdersListRouteRoute
    }
    "/_layout/agent/chats/delete/$id": {
      id: "/_layout/agent/chats/delete/$id"
      path: "/delete/$id"
      fullPath: "/agent/chats/delete/$id"
      preLoaderRoute: typeof LayoutAgentChatsDeleteIdRouteImport
      parentRoute: typeof LayoutAgentChatsRoute
    }
    "/_layout/aircraft_/$aircraftId/fitted-components/new": {
      id: "/_layout/aircraft_/$aircraftId/fitted-components/new"
      path: "/fitted-components/new"
      fullPath: "/aircraft/$aircraftId/fitted-components/new"
      preLoaderRoute: typeof LayoutAircraftAircraftIdFittedComponentsNewRouteImport
      parentRoute: typeof LayoutAircraftAircraftIdRouteRoute
    }
    "/_layout/aircraft_/$aircraftId/mod-status/new": {
      id: "/_layout/aircraft_/$aircraftId/mod-status/new"
      path: "/mod-status/new"
      fullPath: "/aircraft/$aircraftId/mod-status/new"
      preLoaderRoute: typeof LayoutAircraftAircraftIdModStatusNewRouteImport
      parentRoute: typeof LayoutAircraftAircraftIdRouteRoute
    }
    "/_layout/aircraft_/$aircraftId/readings/new": {
      id: "/_layout/aircraft_/$aircraftId/readings/new"
      path: "/readings/new"
      fullPath: "/aircraft/$aircraftId/readings/new"
      preLoaderRoute: typeof LayoutAircraftAircraftIdReadingsNewRouteImport
      parentRoute: typeof LayoutAircraftAircraftIdRouteRoute
    }
    "/_layout/aircraft_/$aircraftId/tech-log/$pageId": {
      id: "/_layout/aircraft_/$aircraftId/tech-log/$pageId"
      path: "/tech-log/$pageId"
      fullPath: "/aircraft/$aircraftId/tech-log/$pageId"
      preLoaderRoute: typeof LayoutAircraftAircraftIdTechLogPageIdRouteImport
      parentRoute: typeof LayoutAircraftAircraftIdRouteRoute
    }
    "/_layout/aircraft_/$aircraftId/tech-log/new": {
      id: "/_layout/aircraft_/$aircraftId/tech-log/new"
      path: "/tech-log/new"
      fullPath: "/aircraft/$aircraftId/tech-log/new"
      preLoaderRoute: typeof LayoutAircraftAircraftIdTechLogNewRouteImport
      parentRoute: typeof LayoutAircraftAircraftIdRouteRoute
    }
    "/_layout/customer_/$customerId/contacts/_list": {
      id: "/_layout/customer_/$customerId/contacts/_list"
      path: ""
      fullPath: "/customer/$customerId/contacts"
      preLoaderRoute: typeof LayoutCustomerCustomerIdContactsListRouteRouteImport
      parentRoute: typeof LayoutCustomerCustomerIdContactsRouteRoute
    }
    "/_layout/customer_/$customerId/contacts/create": {
      id: "/_layout/customer_/$customerId/contacts/create"
      path: "/create"
      fullPath: "/customer/$customerId/contacts/create"
      preLoaderRoute: typeof LayoutCustomerCustomerIdContactsCreateRouteImport
      parentRoute: typeof LayoutCustomerCustomerIdContactsRouteRoute
    }
    "/_layout/documents/_list/delete/$documentId": {
      id: "/_layout/documents/_list/delete/$documentId"
      path: "/delete/$documentId"
      fullPath: "/documents/delete/$documentId"
      preLoaderRoute: typeof LayoutDocumentsListDeleteDocumentIdRouteImport
      parentRoute: typeof LayoutDocumentsListRouteRoute
    }
    "/_layout/documents/_list/delete/bulk": {
      id: "/_layout/documents/_list/delete/bulk"
      path: "/delete/bulk"
      fullPath: "/documents/delete/bulk"
      preLoaderRoute: typeof LayoutDocumentsListDeleteBulkRouteImport
      parentRoute: typeof LayoutDocumentsListRouteRoute
    }
    "/_layout/documents/_list/make-private/$documentId": {
      id: "/_layout/documents/_list/make-private/$documentId"
      path: "/make-private/$documentId"
      fullPath: "/documents/make-private/$documentId"
      preLoaderRoute: typeof LayoutDocumentsListMakePrivateDocumentIdRouteImport
      parentRoute: typeof LayoutDocumentsListRouteRoute
    }
    "/_layout/documents/_list/share/$documentId": {
      id: "/_layout/documents/_list/share/$documentId"
      path: "/share/$documentId"
      fullPath: "/documents/share/$documentId"
      preLoaderRoute: typeof LayoutDocumentsListShareDocumentIdRouteImport
      parentRoute: typeof LayoutDocumentsListRouteRoute
    }
    "/_layout/documents/_list/share/bulk": {
      id: "/_layout/documents/_list/share/bulk"
      path: "/share/bulk"
      fullPath: "/documents/share/bulk"
      preLoaderRoute: typeof LayoutDocumentsListShareBulkRouteImport
      parentRoute: typeof LayoutDocumentsListRouteRoute
    }
    "/_layout/maintenance-programmes_/$programmeId/aircraft/enrol": {
      id: "/_layout/maintenance-programmes_/$programmeId/aircraft/enrol"
      path: "/aircraft/enrol"
      fullPath: "/maintenance-programmes/$programmeId/aircraft/enrol"
      preLoaderRoute: typeof LayoutMaintenanceProgrammesProgrammeIdAircraftEnrolRouteImport
      parentRoute: typeof LayoutMaintenanceProgrammesProgrammeIdRouteRoute
    }
    "/_layout/maintenance-programmes_/$programmeId/phases/$phaseId": {
      id: "/_layout/maintenance-programmes_/$programmeId/phases/$phaseId"
      path: "/phases/$phaseId"
      fullPath: "/maintenance-programmes/$programmeId/phases/$phaseId"
      preLoaderRoute: typeof LayoutMaintenanceProgrammesProgrammeIdPhasesPhaseIdRouteImport
      parentRoute: typeof LayoutMaintenanceProgrammesProgrammeIdRouteRoute
    }
    "/_layout/maintenance-programmes_/$programmeId/phases/new": {
      id: "/_layout/maintenance-programmes_/$programmeId/phases/new"
      path: "/phases/new"
      fullPath: "/maintenance-programmes/$programmeId/phases/new"
      preLoaderRoute: typeof LayoutMaintenanceProgrammesProgrammeIdPhasesNewRouteImport
      parentRoute: typeof LayoutMaintenanceProgrammesProgrammeIdRouteRoute
    }
    "/_layout/maintenance-programmes_/$programmeId/revisions/new": {
      id: "/_layout/maintenance-programmes_/$programmeId/revisions/new"
      path: "/revisions/new"
      fullPath: "/maintenance-programmes/$programmeId/revisions/new"
      preLoaderRoute: typeof LayoutMaintenanceProgrammesProgrammeIdRevisionsNewRouteImport
      parentRoute: typeof LayoutMaintenanceProgrammesProgrammeIdRouteRoute
    }
    "/_layout/maintenance-programmes_/$programmeId/tasks/$taskId": {
      id: "/_layout/maintenance-programmes_/$programmeId/tasks/$taskId"
      path: "/tasks/$taskId"
      fullPath: "/maintenance-programmes/$programmeId/tasks/$taskId"
      preLoaderRoute: typeof LayoutMaintenanceProgrammesProgrammeIdTasksTaskIdRouteImport
      parentRoute: typeof LayoutMaintenanceProgrammesProgrammeIdRouteRoute
    }
    "/_layout/maintenance-programmes_/$programmeId/tasks/new": {
      id: "/_layout/maintenance-programmes_/$programmeId/tasks/new"
      path: "/tasks/new"
      fullPath: "/maintenance-programmes/$programmeId/tasks/new"
      preLoaderRoute: typeof LayoutMaintenanceProgrammesProgrammeIdTasksNewRouteImport
      parentRoute: typeof LayoutMaintenanceProgrammesProgrammeIdRouteRoute
    }
    "/_layout/quotes_/$quoteId/phases/new": {
      id: "/_layout/quotes_/$quoteId/phases/new"
      path: "/phases/new"
      fullPath: "/quotes/$quoteId/phases/new"
      preLoaderRoute: typeof LayoutQuotesQuoteIdPhasesNewRouteImport
      parentRoute: typeof LayoutQuotesQuoteIdRouteRoute
    }
    "/_layout/quotes_/$quoteId/tasks/$taskId": {
      id: "/_layout/quotes_/$quoteId/tasks/$taskId"
      path: "/tasks/$taskId"
      fullPath: "/quotes/$quoteId/tasks/$taskId"
      preLoaderRoute: typeof LayoutQuotesQuoteIdTasksTaskIdRouteRouteImport
      parentRoute: typeof LayoutQuotesQuoteIdRouteRoute
    }
    "/_layout/quotes_/$quoteId/tasks/from-template": {
      id: "/_layout/quotes_/$quoteId/tasks/from-template"
      path: "/tasks/from-template"
      fullPath: "/quotes/$quoteId/tasks/from-template"
      preLoaderRoute: typeof LayoutQuotesQuoteIdTasksFromTemplateRouteImport
      parentRoute: typeof LayoutQuotesQuoteIdRouteRoute
    }
    "/_layout/quoting_/emails/_list/": {
      id: "/_layout/quoting_/emails/_list/"
      path: "/"
      fullPath: "/quoting/emails/"
      preLoaderRoute: typeof LayoutQuotingEmailsListIndexRouteImport
      parentRoute: typeof LayoutQuotingEmailsListRouteRoute
    }
    "/_layout/quoting_/emails/_list/$emailId": {
      id: "/_layout/quoting_/emails/_list/$emailId"
      path: "/$emailId"
      fullPath: "/quoting/emails/$emailId"
      preLoaderRoute: typeof LayoutQuotingEmailsListEmailIdRouteRouteImport
      parentRoute: typeof LayoutQuotingEmailsListRouteRoute
    }
    "/_layout/quoting_/squawks/delete/$squawkId": {
      id: "/_layout/quoting_/squawks/delete/$squawkId"
      path: "/delete/$squawkId"
      fullPath: "/quoting/squawks/delete/$squawkId"
      preLoaderRoute: typeof LayoutQuotingSquawksDeleteSquawkIdRouteImport
      parentRoute: typeof LayoutQuotingSquawksRouteRoute
    }
    "/_layout/quoting_/squawks/edit/$squawkId": {
      id: "/_layout/quoting_/squawks/edit/$squawkId"
      path: "/edit/$squawkId"
      fullPath: "/quoting/squawks/edit/$squawkId"
      preLoaderRoute: typeof LayoutQuotingSquawksEditSquawkIdRouteImport
      parentRoute: typeof LayoutQuotingSquawksRouteRoute
    }
    "/_layout/settings/_panel/account/profile": {
      id: "/_layout/settings/_panel/account/profile"
      path: "/account/profile"
      fullPath: "/settings/account/profile"
      preLoaderRoute: typeof LayoutSettingsPanelAccountProfileRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelRouteRoute
    }
    "/_layout/settings/_panel/integrations/crm": {
      id: "/_layout/settings/_panel/integrations/crm"
      path: "/integrations/crm"
      fullPath: "/settings/integrations/crm"
      preLoaderRoute: typeof LayoutSettingsPanelIntegrationsCrmRouteImport
      parentRoute: typeof LayoutSettingsPanelRouteRoute
    }
    "/_layout/settings/_panel/integrations/erp": {
      id: "/_layout/settings/_panel/integrations/erp"
      path: "/integrations/erp"
      fullPath: "/settings/integrations/erp"
      preLoaderRoute: typeof LayoutSettingsPanelIntegrationsErpRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelRouteRoute
    }
    "/_layout/settings/_panel/quoting/customer-approval": {
      id: "/_layout/settings/_panel/quoting/customer-approval"
      path: "/quoting/customer-approval"
      fullPath: "/settings/quoting/customer-approval"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingCustomerApprovalRouteImport
      parentRoute: typeof LayoutSettingsPanelRouteRoute
    }
    "/_layout/settings/_panel/quoting/general": {
      id: "/_layout/settings/_panel/quoting/general"
      path: "/quoting/general"
      fullPath: "/settings/quoting/general"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingGeneralRouteImport
      parentRoute: typeof LayoutSettingsPanelRouteRoute
    }
    "/_layout/settings/_panel/quoting/playbooks": {
      id: "/_layout/settings/_panel/quoting/playbooks"
      path: "/quoting/playbooks"
      fullPath: "/settings/quoting/playbooks"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingPlaybooksRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelRouteRoute
    }
    "/_layout/settings/_panel/quoting/rate-cards": {
      id: "/_layout/settings/_panel/quoting/rate-cards"
      path: "/quoting/rate-cards"
      fullPath: "/settings/quoting/rate-cards"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingRateCardsRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelRouteRoute
    }
    "/_layout/settings/_panel/quoting/status": {
      id: "/_layout/settings/_panel/quoting/status"
      path: "/quoting/status"
      fullPath: "/settings/quoting/status"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingStatusRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelRouteRoute
    }
    "/_layout/settings/_panel/quoting/task-groups": {
      id: "/_layout/settings/_panel/quoting/task-groups"
      path: "/quoting/task-groups"
      fullPath: "/settings/quoting/task-groups"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingTaskGroupsRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelRouteRoute
    }
    "/_layout/settings/_panel/quoting/tax-rates": {
      id: "/_layout/settings/_panel/quoting/tax-rates"
      path: "/quoting/tax-rates"
      fullPath: "/settings/quoting/tax-rates"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingTaxRatesRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelRouteRoute
    }
    "/_layout/settings/_panel/work-orders/general": {
      id: "/_layout/settings/_panel/work-orders/general"
      path: "/work-orders/general"
      fullPath: "/settings/work-orders/general"
      preLoaderRoute: typeof LayoutSettingsPanelWorkOrdersGeneralRouteImport
      parentRoute: typeof LayoutSettingsPanelRouteRoute
    }
    "/_layout/settings/_panel/workspace/approval-flows": {
      id: "/_layout/settings/_panel/workspace/approval-flows"
      path: "/workspace/approval-flows"
      fullPath: "/settings/workspace/approval-flows"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceApprovalFlowsRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelRouteRoute
    }
    "/_layout/settings/_panel/workspace/departments": {
      id: "/_layout/settings/_panel/workspace/departments"
      path: "/workspace/departments"
      fullPath: "/settings/workspace/departments"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceDepartmentsRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelRouteRoute
    }
    "/_layout/settings/_panel/workspace/facilities": {
      id: "/_layout/settings/_panel/workspace/facilities"
      path: "/workspace/facilities"
      fullPath: "/settings/workspace/facilities"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelRouteRoute
    }
    "/_layout/settings/_panel/workspace/members": {
      id: "/_layout/settings/_panel/workspace/members"
      path: "/workspace/members"
      fullPath: "/settings/workspace/members"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceMembersRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelRouteRoute
    }
    "/_layout/settings/_panel/workspace/notification-rules": {
      id: "/_layout/settings/_panel/workspace/notification-rules"
      path: "/workspace/notification-rules"
      fullPath: "/settings/workspace/notification-rules"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceNotificationRulesRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelRouteRoute
    }
    "/_layout/settings/_panel/workspace/roles": {
      id: "/_layout/settings/_panel/workspace/roles"
      path: "/workspace/roles"
      fullPath: "/settings/workspace/roles"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceRolesRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelRouteRoute
    }
    "/_layout/settings/_panel/workspace/teams": {
      id: "/_layout/settings/_panel/workspace/teams"
      path: "/workspace/teams"
      fullPath: "/settings/workspace/teams"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceTeamsRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelRouteRoute
    }
    "/_layout/settings/_panel/workspace/templates": {
      id: "/_layout/settings/_panel/workspace/templates"
      path: "/workspace/templates"
      fullPath: "/settings/workspace/templates"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceTemplatesRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelRouteRoute
    }
    "/_layout/settings/_panel/workspace/tool-categories": {
      id: "/_layout/settings/_panel/workspace/tool-categories"
      path: "/workspace/tool-categories"
      fullPath: "/settings/workspace/tool-categories"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceToolCategoriesRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelRouteRoute
    }
    "/_layout/settings/system_/audit-log/": {
      id: "/_layout/settings/system_/audit-log/"
      path: "/system/audit-log"
      fullPath: "/settings/system/audit-log/"
      preLoaderRoute: typeof LayoutSettingsSystemAuditLogIndexRouteImport
      parentRoute: typeof LayoutSettingsRouteRoute
    }
    "/_layout/settings/system_/tenants/$tenantId": {
      id: "/_layout/settings/system_/tenants/$tenantId"
      path: "/system/tenants/$tenantId"
      fullPath: "/settings/system/tenants/$tenantId"
      preLoaderRoute: typeof LayoutSettingsSystemTenantsTenantIdRouteRouteImport
      parentRoute: typeof LayoutSettingsRouteRoute
    }
    "/_layout/templates/quotes_/$packageId/_list": {
      id: "/_layout/templates/quotes_/$packageId/_list"
      path: ""
      fullPath: "/templates/quotes/$packageId"
      preLoaderRoute: typeof LayoutTemplatesQuotesPackageIdListRouteRouteImport
      parentRoute: typeof LayoutTemplatesQuotesPackageIdRouteRoute
    }
    "/_layout/templates/quotes_/$packageId/overview": {
      id: "/_layout/templates/quotes_/$packageId/overview"
      path: "/overview"
      fullPath: "/templates/quotes/$packageId/overview"
      preLoaderRoute: typeof LayoutTemplatesQuotesPackageIdOverviewRouteRouteImport
      parentRoute: typeof LayoutTemplatesQuotesPackageIdRouteRoute
    }
    "/_layout/templates/tasks/$taskId/": {
      id: "/_layout/templates/tasks/$taskId/"
      path: "/"
      fullPath: "/templates/tasks/$taskId/"
      preLoaderRoute: typeof LayoutTemplatesTasksTaskIdIndexRouteImport
      parentRoute: typeof LayoutTemplatesTasksTaskIdRouteRoute
    }
    "/_layout/templates/tasks/$taskId/archive": {
      id: "/_layout/templates/tasks/$taskId/archive"
      path: "/archive"
      fullPath: "/templates/tasks/$taskId/archive"
      preLoaderRoute: typeof LayoutTemplatesTasksTaskIdArchiveRouteImport
      parentRoute: typeof LayoutTemplatesTasksTaskIdRouteRoute
    }
    "/_layout/tools/$toolId/calibrations/record": {
      id: "/_layout/tools/$toolId/calibrations/record"
      path: "/calibrations/record"
      fullPath: "/tools/$toolId/calibrations/record"
      preLoaderRoute: typeof LayoutToolsToolIdCalibrationsRecordRouteImport
      parentRoute: typeof LayoutToolsToolIdRouteRoute
    }
    "/_layout/tools/$toolId/calibrations/send": {
      id: "/_layout/tools/$toolId/calibrations/send"
      path: "/calibrations/send"
      fullPath: "/tools/$toolId/calibrations/send"
      preLoaderRoute: typeof LayoutToolsToolIdCalibrationsSendRouteImport
      parentRoute: typeof LayoutToolsToolIdRouteRoute
    }
    "/_layout/trace/sandbox/$conversationSessionId/$": {
      id: "/_layout/trace/sandbox/$conversationSessionId/$"
      path: "/trace/sandbox/$conversationSessionId/$"
      fullPath: "/trace/sandbox/$conversationSessionId/$"
      preLoaderRoute: typeof LayoutTraceSandboxConversationSessionIdSplatRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/work-orders/$workOrderId/phases/new": {
      id: "/_layout/work-orders/$workOrderId/phases/new"
      path: "/phases/new"
      fullPath: "/work-orders/$workOrderId/phases/new"
      preLoaderRoute: typeof LayoutWorkOrdersWorkOrderIdPhasesNewRouteImport
      parentRoute: typeof LayoutWorkOrdersWorkOrderIdRouteRoute
    }
    "/_layout/work-orders/$workOrderId/squawks/$squawkId": {
      id: "/_layout/work-orders/$workOrderId/squawks/$squawkId"
      path: "/squawks/$squawkId"
      fullPath: "/work-orders/$workOrderId/squawks/$squawkId"
      preLoaderRoute: typeof LayoutWorkOrdersWorkOrderIdSquawksSquawkIdRouteImport
      parentRoute: typeof LayoutWorkOrdersWorkOrderIdRouteRoute
    }
    "/_layout/work-orders/$workOrderId/tasks/$taskId": {
      id: "/_layout/work-orders/$workOrderId/tasks/$taskId"
      path: "/tasks/$taskId"
      fullPath: "/work-orders/$workOrderId/tasks/$taskId"
      preLoaderRoute: typeof LayoutWorkOrdersWorkOrderIdTasksTaskIdRouteImport
      parentRoute: typeof LayoutWorkOrdersWorkOrderIdRouteRoute
    }
    "/_layout/work-orders/$workOrderId/tasks/delete": {
      id: "/_layout/work-orders/$workOrderId/tasks/delete"
      path: "/tasks/delete"
      fullPath: "/work-orders/$workOrderId/tasks/delete"
      preLoaderRoute: typeof LayoutWorkOrdersWorkOrderIdTasksDeleteRouteImport
      parentRoute: typeof LayoutWorkOrdersWorkOrderIdRouteRoute
    }
    "/_layout/work-orders/$workOrderId/tasks/new": {
      id: "/_layout/work-orders/$workOrderId/tasks/new"
      path: "/tasks/new"
      fullPath: "/work-orders/$workOrderId/tasks/new"
      preLoaderRoute: typeof LayoutWorkOrdersWorkOrderIdTasksNewRouteImport
      parentRoute: typeof LayoutWorkOrdersWorkOrderIdRouteRoute
    }
    "/_layout/work-orders/_list/delete/$workOrderId": {
      id: "/_layout/work-orders/_list/delete/$workOrderId"
      path: "/delete/$workOrderId"
      fullPath: "/work-orders/delete/$workOrderId"
      preLoaderRoute: typeof LayoutWorkOrdersListDeleteWorkOrderIdRouteImport
      parentRoute: typeof LayoutWorkOrdersListRouteRoute
    }
    "/_layout/aircraft_/$aircraftId/fitted-components/remove/$componentId": {
      id: "/_layout/aircraft_/$aircraftId/fitted-components/remove/$componentId"
      path: "/fitted-components/remove/$componentId"
      fullPath: "/aircraft/$aircraftId/fitted-components/remove/$componentId"
      preLoaderRoute: typeof LayoutAircraftAircraftIdFittedComponentsRemoveComponentIdRouteImport
      parentRoute: typeof LayoutAircraftAircraftIdRouteRoute
    }
    "/_layout/aircraft_/$aircraftId/tech-log/void/$pageId": {
      id: "/_layout/aircraft_/$aircraftId/tech-log/void/$pageId"
      path: "/tech-log/void/$pageId"
      fullPath: "/aircraft/$aircraftId/tech-log/void/$pageId"
      preLoaderRoute: typeof LayoutAircraftAircraftIdTechLogVoidPageIdRouteImport
      parentRoute: typeof LayoutAircraftAircraftIdRouteRoute
    }
    "/_layout/customer_/$customerId/contacts/_list/": {
      id: "/_layout/customer_/$customerId/contacts/_list/"
      path: "/"
      fullPath: "/customer/$customerId/contacts/"
      preLoaderRoute: typeof LayoutCustomerCustomerIdContactsListIndexRouteImport
      parentRoute: typeof LayoutCustomerCustomerIdContactsListRouteRoute
    }
    "/_layout/customer_/$customerId/contacts/_list/$contactId": {
      id: "/_layout/customer_/$customerId/contacts/_list/$contactId"
      path: "/$contactId"
      fullPath: "/customer/$customerId/contacts/$contactId"
      preLoaderRoute: typeof LayoutCustomerCustomerIdContactsListContactIdRouteRouteImport
      parentRoute: typeof LayoutCustomerCustomerIdContactsListRouteRoute
    }
    "/_layout/inventory/$partId/prices/$priceId/delete": {
      id: "/_layout/inventory/$partId/prices/$priceId/delete"
      path: "/prices/$priceId/delete"
      fullPath: "/inventory/$partId/prices/$priceId/delete"
      preLoaderRoute: typeof LayoutInventoryPartIdPricesPriceIdDeleteRouteImport
      parentRoute: typeof LayoutInventoryPartIdRouteRoute
    }
    "/_layout/maintenance-programmes_/$programmeId/aircraft/remove/$enrolmentId": {
      id: "/_layout/maintenance-programmes_/$programmeId/aircraft/remove/$enrolmentId"
      path: "/aircraft/remove/$enrolmentId"
      fullPath: "/maintenance-programmes/$programmeId/aircraft/remove/$enrolmentId"
      preLoaderRoute: typeof LayoutMaintenanceProgrammesProgrammeIdAircraftRemoveEnrolmentIdRouteImport
      parentRoute: typeof LayoutMaintenanceProgrammesProgrammeIdRouteRoute
    }
    "/_layout/maintenance-programmes_/$programmeId/phases/remove/$phaseId": {
      id: "/_layout/maintenance-programmes_/$programmeId/phases/remove/$phaseId"
      path: "/phases/remove/$phaseId"
      fullPath: "/maintenance-programmes/$programmeId/phases/remove/$phaseId"
      preLoaderRoute: typeof LayoutMaintenanceProgrammesProgrammeIdPhasesRemovePhaseIdRouteImport
      parentRoute: typeof LayoutMaintenanceProgrammesProgrammeIdRouteRoute
    }
    "/_layout/maintenance-programmes_/$programmeId/revisions/release/$revisionId": {
      id: "/_layout/maintenance-programmes_/$programmeId/revisions/release/$revisionId"
      path: "/revisions/release/$revisionId"
      fullPath: "/maintenance-programmes/$programmeId/revisions/release/$revisionId"
      preLoaderRoute: typeof LayoutMaintenanceProgrammesProgrammeIdRevisionsReleaseRevisionIdRouteImport
      parentRoute: typeof LayoutMaintenanceProgrammesProgrammeIdRouteRoute
    }
    "/_layout/maintenance-programmes_/$programmeId/tasks/remove/$taskId": {
      id: "/_layout/maintenance-programmes_/$programmeId/tasks/remove/$taskId"
      path: "/tasks/remove/$taskId"
      fullPath: "/maintenance-programmes/$programmeId/tasks/remove/$taskId"
      preLoaderRoute: typeof LayoutMaintenanceProgrammesProgrammeIdTasksRemoveTaskIdRouteImport
      parentRoute: typeof LayoutMaintenanceProgrammesProgrammeIdRouteRoute
    }
    "/_layout/planning_/$planId/steps/$stepId/": {
      id: "/_layout/planning_/$planId/steps/$stepId/"
      path: "/steps/$stepId"
      fullPath: "/planning/$planId/steps/$stepId/"
      preLoaderRoute: typeof LayoutPlanningPlanIdStepsStepIdIndexRouteImport
      parentRoute: typeof LayoutPlanningPlanIdRouteRoute
    }
    "/_layout/quotes_/$quoteId/phases/$phaseId/delete": {
      id: "/_layout/quotes_/$quoteId/phases/$phaseId/delete"
      path: "/phases/$phaseId/delete"
      fullPath: "/quotes/$quoteId/phases/$phaseId/delete"
      preLoaderRoute: typeof LayoutQuotesQuoteIdPhasesPhaseIdDeleteRouteImport
      parentRoute: typeof LayoutQuotesQuoteIdRouteRoute
    }
    "/_layout/quotes_/$quoteId/phases/$phaseId/rename": {
      id: "/_layout/quotes_/$quoteId/phases/$phaseId/rename"
      path: "/phases/$phaseId/rename"
      fullPath: "/quotes/$quoteId/phases/$phaseId/rename"
      preLoaderRoute: typeof LayoutQuotesQuoteIdPhasesPhaseIdRenameRouteImport
      parentRoute: typeof LayoutQuotesQuoteIdRouteRoute
    }
    "/_layout/quotes_/$quoteId/tasks/$taskId/": {
      id: "/_layout/quotes_/$quoteId/tasks/$taskId/"
      path: "/"
      fullPath: "/quotes/$quoteId/tasks/$taskId/"
      preLoaderRoute: typeof LayoutQuotesQuoteIdTasksTaskIdIndexRouteImport
      parentRoute: typeof LayoutQuotesQuoteIdTasksTaskIdRouteRoute
    }
    "/_layout/quotes_/$quoteId/tasks/$taskId/apply-template": {
      id: "/_layout/quotes_/$quoteId/tasks/$taskId/apply-template"
      path: "/apply-template"
      fullPath: "/quotes/$quoteId/tasks/$taskId/apply-template"
      preLoaderRoute: typeof LayoutQuotesQuoteIdTasksTaskIdApplyTemplateRouteImport
      parentRoute: typeof LayoutQuotesQuoteIdTasksTaskIdRouteRoute
    }
    "/_layout/quoting_/emails/_list/$emailId/": {
      id: "/_layout/quoting_/emails/_list/$emailId/"
      path: "/"
      fullPath: "/quoting/emails/$emailId/"
      preLoaderRoute: typeof LayoutQuotingEmailsListEmailIdIndexRouteImport
      parentRoute: typeof LayoutQuotingEmailsListEmailIdRouteRoute
    }
    "/_layout/quoting_/emails/_list/$emailId/share": {
      id: "/_layout/quoting_/emails/_list/$emailId/share"
      path: "/share"
      fullPath: "/quoting/emails/$emailId/share"
      preLoaderRoute: typeof LayoutQuotingEmailsListEmailIdShareRouteImport
      parentRoute: typeof LayoutQuotingEmailsListEmailIdRouteRoute
    }
    "/_layout/quoting_/emails/_list/delete/$emailId": {
      id: "/_layout/quoting_/emails/_list/delete/$emailId"
      path: "/delete/$emailId"
      fullPath: "/quoting/emails/delete/$emailId"
      preLoaderRoute: typeof LayoutQuotingEmailsListDeleteEmailIdRouteImport
      parentRoute: typeof LayoutQuotingEmailsListRouteRoute
    }
    "/_layout/quoting_/emails/_list/delete/bulk": {
      id: "/_layout/quoting_/emails/_list/delete/bulk"
      path: "/delete/bulk"
      fullPath: "/quoting/emails/delete/bulk"
      preLoaderRoute: typeof LayoutQuotingEmailsListDeleteBulkRouteImport
      parentRoute: typeof LayoutQuotingEmailsListRouteRoute
    }
    "/_layout/quoting_/emails/_list/share/bulk": {
      id: "/_layout/quoting_/emails/_list/share/bulk"
      path: "/share/bulk"
      fullPath: "/quoting/emails/share/bulk"
      preLoaderRoute: typeof LayoutQuotingEmailsListShareBulkRouteImport
      parentRoute: typeof LayoutQuotingEmailsListRouteRoute
    }
    "/_layout/quoting_/quotes/builder/$quoteId/": {
      id: "/_layout/quoting_/quotes/builder/$quoteId/"
      path: "/quoting/quotes/builder/$quoteId"
      fullPath: "/quoting/quotes/builder/$quoteId/"
      preLoaderRoute: typeof LayoutQuotingQuotesBuilderQuoteIdIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/settings/_panel/account/notifications/": {
      id: "/_layout/settings/_panel/account/notifications/"
      path: "/account/notifications"
      fullPath: "/settings/account/notifications/"
      preLoaderRoute: typeof LayoutSettingsPanelAccountNotificationsIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelRouteRoute
    }
    "/_layout/settings/_panel/account/profile/": {
      id: "/_layout/settings/_panel/account/profile/"
      path: "/"
      fullPath: "/settings/account/profile/"
      preLoaderRoute: typeof LayoutSettingsPanelAccountProfileIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelAccountProfileRouteRoute
    }
    "/_layout/settings/_panel/account/profile/change-password": {
      id: "/_layout/settings/_panel/account/profile/change-password"
      path: "/change-password"
      fullPath: "/settings/account/profile/change-password"
      preLoaderRoute: typeof LayoutSettingsPanelAccountProfileChangePasswordRouteImport
      parentRoute: typeof LayoutSettingsPanelAccountProfileRouteRoute
    }
    "/_layout/settings/_panel/account/signing-pin/": {
      id: "/_layout/settings/_panel/account/signing-pin/"
      path: "/account/signing-pin"
      fullPath: "/settings/account/signing-pin/"
      preLoaderRoute: typeof LayoutSettingsPanelAccountSigningPinIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelRouteRoute
    }
    "/_layout/settings/_panel/integrations/erp/_list": {
      id: "/_layout/settings/_panel/integrations/erp/_list"
      path: ""
      fullPath: "/settings/integrations/erp"
      preLoaderRoute: typeof LayoutSettingsPanelIntegrationsErpListRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelIntegrationsErpRouteRoute
    }
    "/_layout/settings/_panel/quoting/flat-rates/": {
      id: "/_layout/settings/_panel/quoting/flat-rates/"
      path: "/quoting/flat-rates"
      fullPath: "/settings/quoting/flat-rates/"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingFlatRatesIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelRouteRoute
    }
    "/_layout/settings/_panel/quoting/flat-rates/$packageId": {
      id: "/_layout/settings/_panel/quoting/flat-rates/$packageId"
      path: "/quoting/flat-rates/$packageId"
      fullPath: "/settings/quoting/flat-rates/$packageId"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingFlatRatesPackageIdRouteImport
      parentRoute: typeof LayoutSettingsPanelRouteRoute
    }
    "/_layout/settings/_panel/quoting/playbooks/": {
      id: "/_layout/settings/_panel/quoting/playbooks/"
      path: "/"
      fullPath: "/settings/quoting/playbooks/"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingPlaybooksIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelQuotingPlaybooksRouteRoute
    }
    "/_layout/settings/_panel/quoting/playbooks/$playbookId": {
      id: "/_layout/settings/_panel/quoting/playbooks/$playbookId"
      path: "/$playbookId"
      fullPath: "/settings/quoting/playbooks/$playbookId"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelQuotingPlaybooksRouteRoute
    }
    "/_layout/settings/_panel/quoting/playbooks/create": {
      id: "/_layout/settings/_panel/quoting/playbooks/create"
      path: "/create"
      fullPath: "/settings/quoting/playbooks/create"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingPlaybooksCreateRouteImport
      parentRoute: typeof LayoutSettingsPanelQuotingPlaybooksRouteRoute
    }
    "/_layout/settings/_panel/quoting/rate-cards/": {
      id: "/_layout/settings/_panel/quoting/rate-cards/"
      path: "/"
      fullPath: "/settings/quoting/rate-cards/"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingRateCardsIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelQuotingRateCardsRouteRoute
    }
    "/_layout/settings/_panel/quoting/rate-cards/$rateCardId": {
      id: "/_layout/settings/_panel/quoting/rate-cards/$rateCardId"
      path: "/$rateCardId"
      fullPath: "/settings/quoting/rate-cards/$rateCardId"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingRateCardsRateCardIdRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelQuotingRateCardsRouteRoute
    }
    "/_layout/settings/_panel/quoting/status/": {
      id: "/_layout/settings/_panel/quoting/status/"
      path: "/"
      fullPath: "/settings/quoting/status/"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingStatusIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelQuotingStatusRouteRoute
    }
    "/_layout/settings/_panel/quoting/task-groups/": {
      id: "/_layout/settings/_panel/quoting/task-groups/"
      path: "/"
      fullPath: "/settings/quoting/task-groups/"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingTaskGroupsIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelQuotingTaskGroupsRouteRoute
    }
    "/_layout/settings/_panel/quoting/task-groups/import": {
      id: "/_layout/settings/_panel/quoting/task-groups/import"
      path: "/import"
      fullPath: "/settings/quoting/task-groups/import"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingTaskGroupsImportRouteImport
      parentRoute: typeof LayoutSettingsPanelQuotingTaskGroupsRouteRoute
    }
    "/_layout/settings/_panel/quoting/tax-rates/": {
      id: "/_layout/settings/_panel/quoting/tax-rates/"
      path: "/"
      fullPath: "/settings/quoting/tax-rates/"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingTaxRatesIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelQuotingTaxRatesRouteRoute
    }
    "/_layout/settings/_panel/quoting/tax-rates/$taxRateId": {
      id: "/_layout/settings/_panel/quoting/tax-rates/$taxRateId"
      path: "/$taxRateId"
      fullPath: "/settings/quoting/tax-rates/$taxRateId"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingTaxRatesTaxRateIdRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelQuotingTaxRatesRouteRoute
    }
    "/_layout/settings/_panel/workspace/approval-flows/": {
      id: "/_layout/settings/_panel/workspace/approval-flows/"
      path: "/"
      fullPath: "/settings/workspace/approval-flows/"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceApprovalFlowsIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceApprovalFlowsRouteRoute
    }
    "/_layout/settings/_panel/workspace/approval-flows/$policyId": {
      id: "/_layout/settings/_panel/workspace/approval-flows/$policyId"
      path: "/$policyId"
      fullPath: "/settings/workspace/approval-flows/$policyId"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceApprovalFlowsRouteRoute
    }
    "/_layout/settings/_panel/workspace/approval-flows/create": {
      id: "/_layout/settings/_panel/workspace/approval-flows/create"
      path: "/create"
      fullPath: "/settings/workspace/approval-flows/create"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceApprovalFlowsCreateRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceApprovalFlowsRouteRoute
    }
    "/_layout/settings/_panel/workspace/departments/_list": {
      id: "/_layout/settings/_panel/workspace/departments/_list"
      path: ""
      fullPath: "/settings/workspace/departments"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceDepartmentsListRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceDepartmentsRouteRoute
    }
    "/_layout/settings/_panel/workspace/departments/create": {
      id: "/_layout/settings/_panel/workspace/departments/create"
      path: "/create"
      fullPath: "/settings/workspace/departments/create"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceDepartmentsCreateRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceDepartmentsRouteRoute
    }
    "/_layout/settings/_panel/workspace/facilities/_list": {
      id: "/_layout/settings/_panel/workspace/facilities/_list"
      path: ""
      fullPath: "/settings/workspace/facilities"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesListRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesRouteRoute
    }
    "/_layout/settings/_panel/workspace/facilities/create": {
      id: "/_layout/settings/_panel/workspace/facilities/create"
      path: "/create"
      fullPath: "/settings/workspace/facilities/create"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesCreateRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesRouteRoute
    }
    "/_layout/settings/_panel/workspace/general/": {
      id: "/_layout/settings/_panel/workspace/general/"
      path: "/workspace/general"
      fullPath: "/settings/workspace/general/"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceGeneralIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelRouteRoute
    }
    "/_layout/settings/_panel/workspace/members/_list": {
      id: "/_layout/settings/_panel/workspace/members/_list"
      path: ""
      fullPath: "/settings/workspace/members"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceMembersListRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceMembersRouteRoute
    }
    "/_layout/settings/_panel/workspace/members/create": {
      id: "/_layout/settings/_panel/workspace/members/create"
      path: "/create"
      fullPath: "/settings/workspace/members/create"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceMembersCreateRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceMembersRouteRoute
    }
    "/_layout/settings/_panel/workspace/notification-rules/": {
      id: "/_layout/settings/_panel/workspace/notification-rules/"
      path: "/"
      fullPath: "/settings/workspace/notification-rules/"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceNotificationRulesIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceNotificationRulesRouteRoute
    }
    "/_layout/settings/_panel/workspace/notification-rules/$ruleId": {
      id: "/_layout/settings/_panel/workspace/notification-rules/$ruleId"
      path: "/$ruleId"
      fullPath: "/settings/workspace/notification-rules/$ruleId"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceNotificationRulesRuleIdRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceNotificationRulesRouteRoute
    }
    "/_layout/settings/_panel/workspace/notification-rules/create": {
      id: "/_layout/settings/_panel/workspace/notification-rules/create"
      path: "/create"
      fullPath: "/settings/workspace/notification-rules/create"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceNotificationRulesCreateRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceNotificationRulesRouteRoute
    }
    "/_layout/settings/_panel/workspace/roles/_list": {
      id: "/_layout/settings/_panel/workspace/roles/_list"
      path: ""
      fullPath: "/settings/workspace/roles"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceRolesListRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceRolesRouteRoute
    }
    "/_layout/settings/_panel/workspace/roles/create": {
      id: "/_layout/settings/_panel/workspace/roles/create"
      path: "/create"
      fullPath: "/settings/workspace/roles/create"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceRolesCreateRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceRolesRouteRoute
    }
    "/_layout/settings/_panel/workspace/teams/_list": {
      id: "/_layout/settings/_panel/workspace/teams/_list"
      path: ""
      fullPath: "/settings/workspace/teams"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceTeamsListRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceTeamsRouteRoute
    }
    "/_layout/settings/_panel/workspace/teams/create": {
      id: "/_layout/settings/_panel/workspace/teams/create"
      path: "/create"
      fullPath: "/settings/workspace/teams/create"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceTeamsCreateRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceTeamsRouteRoute
    }
    "/_layout/settings/_panel/workspace/templates/": {
      id: "/_layout/settings/_panel/workspace/templates/"
      path: "/"
      fullPath: "/settings/workspace/templates/"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceTemplatesIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceTemplatesRouteRoute
    }
    "/_layout/settings/_panel/workspace/templates/$kind": {
      id: "/_layout/settings/_panel/workspace/templates/$kind"
      path: "/$kind"
      fullPath: "/settings/workspace/templates/$kind"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceTemplatesKindRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceTemplatesRouteRoute
    }
    "/_layout/settings/_panel/workspace/tool-categories/_list": {
      id: "/_layout/settings/_panel/workspace/tool-categories/_list"
      path: ""
      fullPath: "/settings/workspace/tool-categories"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceToolCategoriesListRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceToolCategoriesRouteRoute
    }
    "/_layout/settings/_panel/workspace/tool-categories/create": {
      id: "/_layout/settings/_panel/workspace/tool-categories/create"
      path: "/create"
      fullPath: "/settings/workspace/tool-categories/create"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceToolCategoriesCreateRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceToolCategoriesRouteRoute
    }
    "/_layout/settings/system_/tenants/$tenantId/": {
      id: "/_layout/settings/system_/tenants/$tenantId/"
      path: "/"
      fullPath: "/settings/system/tenants/$tenantId/"
      preLoaderRoute: typeof LayoutSettingsSystemTenantsTenantIdIndexRouteImport
      parentRoute: typeof LayoutSettingsSystemTenantsTenantIdRouteRoute
    }
    "/_layout/settings/system_/tenants/$tenantId/approval-policies": {
      id: "/_layout/settings/system_/tenants/$tenantId/approval-policies"
      path: "/approval-policies"
      fullPath: "/settings/system/tenants/$tenantId/approval-policies"
      preLoaderRoute: typeof LayoutSettingsSystemTenantsTenantIdApprovalPoliciesRouteImport
      parentRoute: typeof LayoutSettingsSystemTenantsTenantIdRouteRoute
    }
    "/_layout/settings/system_/tenants/$tenantId/integrations": {
      id: "/_layout/settings/system_/tenants/$tenantId/integrations"
      path: "/integrations"
      fullPath: "/settings/system/tenants/$tenantId/integrations"
      preLoaderRoute: typeof LayoutSettingsSystemTenantsTenantIdIntegrationsRouteImport
      parentRoute: typeof LayoutSettingsSystemTenantsTenantIdRouteRoute
    }
    "/_layout/settings/system_/tenants/$tenantId/notification-rules": {
      id: "/_layout/settings/system_/tenants/$tenantId/notification-rules"
      path: "/notification-rules"
      fullPath: "/settings/system/tenants/$tenantId/notification-rules"
      preLoaderRoute: typeof LayoutSettingsSystemTenantsTenantIdNotificationRulesRouteImport
      parentRoute: typeof LayoutSettingsSystemTenantsTenantIdRouteRoute
    }
    "/_layout/settings/system_/tenants/$tenantId/settings": {
      id: "/_layout/settings/system_/tenants/$tenantId/settings"
      path: "/settings"
      fullPath: "/settings/system/tenants/$tenantId/settings"
      preLoaderRoute: typeof LayoutSettingsSystemTenantsTenantIdSettingsRouteRouteImport
      parentRoute: typeof LayoutSettingsSystemTenantsTenantIdRouteRoute
    }
    "/_layout/settings/system_/tenants/$tenantId/users": {
      id: "/_layout/settings/system_/tenants/$tenantId/users"
      path: "/users"
      fullPath: "/settings/system/tenants/$tenantId/users"
      preLoaderRoute: typeof LayoutSettingsSystemTenantsTenantIdUsersRouteImport
      parentRoute: typeof LayoutSettingsSystemTenantsTenantIdRouteRoute
    }
    "/_layout/templates/quotes_/$packageId/_list/": {
      id: "/_layout/templates/quotes_/$packageId/_list/"
      path: "/"
      fullPath: "/templates/quotes/$packageId/"
      preLoaderRoute: typeof LayoutTemplatesQuotesPackageIdListIndexRouteImport
      parentRoute: typeof LayoutTemplatesQuotesPackageIdListRouteRoute
    }
    "/_layout/templates/quotes_/$packageId/overview/": {
      id: "/_layout/templates/quotes_/$packageId/overview/"
      path: "/"
      fullPath: "/templates/quotes/$packageId/overview/"
      preLoaderRoute: typeof LayoutTemplatesQuotesPackageIdOverviewIndexRouteImport
      parentRoute: typeof LayoutTemplatesQuotesPackageIdOverviewRouteRoute
    }
    "/_layout/templates/quotes_/$packageId/overview/archive": {
      id: "/_layout/templates/quotes_/$packageId/overview/archive"
      path: "/archive"
      fullPath: "/templates/quotes/$packageId/overview/archive"
      preLoaderRoute: typeof LayoutTemplatesQuotesPackageIdOverviewArchiveRouteImport
      parentRoute: typeof LayoutTemplatesQuotesPackageIdOverviewRouteRoute
    }
    "/_layout/tools/$toolId/calibrations/$calibrationId/complete": {
      id: "/_layout/tools/$toolId/calibrations/$calibrationId/complete"
      path: "/calibrations/$calibrationId/complete"
      fullPath: "/tools/$toolId/calibrations/$calibrationId/complete"
      preLoaderRoute: typeof LayoutToolsToolIdCalibrationsCalibrationIdCompleteRouteImport
      parentRoute: typeof LayoutToolsToolIdRouteRoute
    }
    "/_layout/tools/$toolId/loans/$loanId/receive": {
      id: "/_layout/tools/$toolId/loans/$loanId/receive"
      path: "/loans/$loanId/receive"
      fullPath: "/tools/$toolId/loans/$loanId/receive"
      preLoaderRoute: typeof LayoutToolsToolIdLoansLoanIdReceiveRouteImport
      parentRoute: typeof LayoutToolsToolIdRouteRoute
    }
    "/_layout/work-orders/$workOrderId/phases/$phaseId/delete": {
      id: "/_layout/work-orders/$workOrderId/phases/$phaseId/delete"
      path: "/phases/$phaseId/delete"
      fullPath: "/work-orders/$workOrderId/phases/$phaseId/delete"
      preLoaderRoute: typeof LayoutWorkOrdersWorkOrderIdPhasesPhaseIdDeleteRouteImport
      parentRoute: typeof LayoutWorkOrdersWorkOrderIdRouteRoute
    }
    "/_layout/work-orders/$workOrderId/phases/$phaseId/rename": {
      id: "/_layout/work-orders/$workOrderId/phases/$phaseId/rename"
      path: "/phases/$phaseId/rename"
      fullPath: "/work-orders/$workOrderId/phases/$phaseId/rename"
      preLoaderRoute: typeof LayoutWorkOrdersWorkOrderIdPhasesPhaseIdRenameRouteImport
      parentRoute: typeof LayoutWorkOrdersWorkOrderIdRouteRoute
    }
    "/_layout/work-orders/$workOrderId/tasks/$taskId/delete": {
      id: "/_layout/work-orders/$workOrderId/tasks/$taskId/delete"
      path: "/delete"
      fullPath: "/work-orders/$workOrderId/tasks/$taskId/delete"
      preLoaderRoute: typeof LayoutWorkOrdersWorkOrderIdTasksTaskIdDeleteRouteImport
      parentRoute: typeof LayoutWorkOrdersWorkOrderIdTasksTaskIdRoute
    }
    "/_layout/aircraft_/$aircraftId/part-instances/$partInstanceId/readings/new": {
      id: "/_layout/aircraft_/$aircraftId/part-instances/$partInstanceId/readings/new"
      path: "/part-instances/$partInstanceId/readings/new"
      fullPath: "/aircraft/$aircraftId/part-instances/$partInstanceId/readings/new"
      preLoaderRoute: typeof LayoutAircraftAircraftIdPartInstancesPartInstanceIdReadingsNewRouteImport
      parentRoute: typeof LayoutAircraftAircraftIdRouteRoute
    }
    "/_layout/customer_/$customerId/contacts/_list/$contactId/": {
      id: "/_layout/customer_/$customerId/contacts/_list/$contactId/"
      path: "/"
      fullPath: "/customer/$customerId/contacts/$contactId/"
      preLoaderRoute: typeof LayoutCustomerCustomerIdContactsListContactIdIndexRouteImport
      parentRoute: typeof LayoutCustomerCustomerIdContactsListContactIdRouteRoute
    }
    "/_layout/customer_/$customerId/contacts/_list/$contactId/delete": {
      id: "/_layout/customer_/$customerId/contacts/_list/$contactId/delete"
      path: "/delete"
      fullPath: "/customer/$customerId/contacts/$contactId/delete"
      preLoaderRoute: typeof LayoutCustomerCustomerIdContactsListContactIdDeleteRouteImport
      parentRoute: typeof LayoutCustomerCustomerIdContactsListContactIdRouteRoute
    }
    "/_layout/planning_/$planId/steps/$stepId/tasks/$taskIndex": {
      id: "/_layout/planning_/$planId/steps/$stepId/tasks/$taskIndex"
      path: "/steps/$stepId/tasks/$taskIndex"
      fullPath: "/planning/$planId/steps/$stepId/tasks/$taskIndex"
      preLoaderRoute: typeof LayoutPlanningPlanIdStepsStepIdTasksTaskIndexRouteImport
      parentRoute: typeof LayoutPlanningPlanIdRouteRoute
    }
    "/_layout/quoting_/quotes/builder/$quoteId/task/$taskId": {
      id: "/_layout/quoting_/quotes/builder/$quoteId/task/$taskId"
      path: "/quoting/quotes/builder/$quoteId/task/$taskId"
      fullPath: "/quoting/quotes/builder/$quoteId/task/$taskId"
      preLoaderRoute: typeof LayoutQuotingQuotesBuilderQuoteIdTaskTaskIdRouteImport
      parentRoute: typeof LayoutRoute
    }
    "/_layout/settings/_panel/integrations/erp/_list/": {
      id: "/_layout/settings/_panel/integrations/erp/_list/"
      path: "/"
      fullPath: "/settings/integrations/erp/"
      preLoaderRoute: typeof LayoutSettingsPanelIntegrationsErpListIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelIntegrationsErpListRouteRoute
    }
    "/_layout/settings/_panel/integrations/erp/api-key/set": {
      id: "/_layout/settings/_panel/integrations/erp/api-key/set"
      path: "/api-key/set"
      fullPath: "/settings/integrations/erp/api-key/set"
      preLoaderRoute: typeof LayoutSettingsPanelIntegrationsErpApiKeySetRouteImport
      parentRoute: typeof LayoutSettingsPanelIntegrationsErpRouteRoute
    }
    "/_layout/settings/_panel/integrations/erp/relay/set": {
      id: "/_layout/settings/_panel/integrations/erp/relay/set"
      path: "/relay/set"
      fullPath: "/settings/integrations/erp/relay/set"
      preLoaderRoute: typeof LayoutSettingsPanelIntegrationsErpRelaySetRouteImport
      parentRoute: typeof LayoutSettingsPanelIntegrationsErpRouteRoute
    }
    "/_layout/settings/_panel/quoting/playbooks/$playbookId/": {
      id: "/_layout/settings/_panel/quoting/playbooks/$playbookId/"
      path: "/"
      fullPath: "/settings/quoting/playbooks/$playbookId/"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdRouteRoute
    }
    "/_layout/settings/_panel/quoting/playbooks/$playbookId/activity": {
      id: "/_layout/settings/_panel/quoting/playbooks/$playbookId/activity"
      path: "/activity"
      fullPath: "/settings/quoting/playbooks/$playbookId/activity"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdActivityRouteImport
      parentRoute: typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdRouteRoute
    }
    "/_layout/settings/_panel/quoting/playbooks/$playbookId/configuration": {
      id: "/_layout/settings/_panel/quoting/playbooks/$playbookId/configuration"
      path: "/configuration"
      fullPath: "/settings/quoting/playbooks/$playbookId/configuration"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdConfigurationRouteImport
      parentRoute: typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdRouteRoute
    }
    "/_layout/settings/_panel/quoting/playbooks/$playbookId/rules": {
      id: "/_layout/settings/_panel/quoting/playbooks/$playbookId/rules"
      path: "/rules"
      fullPath: "/settings/quoting/playbooks/$playbookId/rules"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdRouteRoute
    }
    "/_layout/settings/_panel/quoting/rate-cards/$rateCardId/": {
      id: "/_layout/settings/_panel/quoting/rate-cards/$rateCardId/"
      path: "/"
      fullPath: "/settings/quoting/rate-cards/$rateCardId/"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingRateCardsRateCardIdIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelQuotingRateCardsRateCardIdRouteRoute
    }
    "/_layout/settings/_panel/quoting/rate-cards/$rateCardId/archive": {
      id: "/_layout/settings/_panel/quoting/rate-cards/$rateCardId/archive"
      path: "/archive"
      fullPath: "/settings/quoting/rate-cards/$rateCardId/archive"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingRateCardsRateCardIdArchiveRouteImport
      parentRoute: typeof LayoutSettingsPanelQuotingRateCardsRateCardIdRouteRoute
    }
    "/_layout/settings/_panel/quoting/task-groups/$groupId/archive": {
      id: "/_layout/settings/_panel/quoting/task-groups/$groupId/archive"
      path: "/$groupId/archive"
      fullPath: "/settings/quoting/task-groups/$groupId/archive"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingTaskGroupsGroupIdArchiveRouteImport
      parentRoute: typeof LayoutSettingsPanelQuotingTaskGroupsRouteRoute
    }
    "/_layout/settings/_panel/quoting/tax-rates/$taxRateId/": {
      id: "/_layout/settings/_panel/quoting/tax-rates/$taxRateId/"
      path: "/"
      fullPath: "/settings/quoting/tax-rates/$taxRateId/"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingTaxRatesTaxRateIdIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelQuotingTaxRatesTaxRateIdRouteRoute
    }
    "/_layout/settings/_panel/quoting/tax-rates/$taxRateId/archive": {
      id: "/_layout/settings/_panel/quoting/tax-rates/$taxRateId/archive"
      path: "/archive"
      fullPath: "/settings/quoting/tax-rates/$taxRateId/archive"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingTaxRatesTaxRateIdArchiveRouteImport
      parentRoute: typeof LayoutSettingsPanelQuotingTaxRatesTaxRateIdRouteRoute
    }
    "/_layout/settings/_panel/workspace/approval-flows/$policyId/": {
      id: "/_layout/settings/_panel/workspace/approval-flows/$policyId/"
      path: "/"
      fullPath: "/settings/workspace/approval-flows/$policyId/"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdRouteRoute
    }
    "/_layout/settings/_panel/workspace/approval-flows/$policyId/delete": {
      id: "/_layout/settings/_panel/workspace/approval-flows/$policyId/delete"
      path: "/delete"
      fullPath: "/settings/workspace/approval-flows/$policyId/delete"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdDeleteRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdRouteRoute
    }
    "/_layout/settings/_panel/workspace/approval-flows/duplicate/$policyId": {
      id: "/_layout/settings/_panel/workspace/approval-flows/duplicate/$policyId"
      path: "/duplicate/$policyId"
      fullPath: "/settings/workspace/approval-flows/duplicate/$policyId"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceApprovalFlowsDuplicatePolicyIdRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceApprovalFlowsRouteRoute
    }
    "/_layout/settings/_panel/workspace/departments/_list/": {
      id: "/_layout/settings/_panel/workspace/departments/_list/"
      path: "/"
      fullPath: "/settings/workspace/departments/"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceDepartmentsListIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceDepartmentsListRouteRoute
    }
    "/_layout/settings/_panel/workspace/departments/_list/$departmentId": {
      id: "/_layout/settings/_panel/workspace/departments/_list/$departmentId"
      path: "/$departmentId"
      fullPath: "/settings/workspace/departments/$departmentId"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceDepartmentsListRouteRoute
    }
    "/_layout/settings/_panel/workspace/facilities/_list/": {
      id: "/_layout/settings/_panel/workspace/facilities/_list/"
      path: "/"
      fullPath: "/settings/workspace/facilities/"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesListIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesListRouteRoute
    }
    "/_layout/settings/_panel/workspace/facilities/_list/$facilityId": {
      id: "/_layout/settings/_panel/workspace/facilities/_list/$facilityId"
      path: "/$facilityId"
      fullPath: "/settings/workspace/facilities/$facilityId"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesListRouteRoute
    }
    "/_layout/settings/_panel/workspace/members/_list/": {
      id: "/_layout/settings/_panel/workspace/members/_list/"
      path: "/"
      fullPath: "/settings/workspace/members/"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceMembersListIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceMembersListRouteRoute
    }
    "/_layout/settings/_panel/workspace/members/_list/$userId": {
      id: "/_layout/settings/_panel/workspace/members/_list/$userId"
      path: "/$userId"
      fullPath: "/settings/workspace/members/$userId"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceMembersListUserIdRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceMembersListRouteRoute
    }
    "/_layout/settings/_panel/workspace/notification-rules/$ruleId/": {
      id: "/_layout/settings/_panel/workspace/notification-rules/$ruleId/"
      path: "/"
      fullPath: "/settings/workspace/notification-rules/$ruleId/"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceNotificationRulesRuleIdIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceNotificationRulesRuleIdRouteRoute
    }
    "/_layout/settings/_panel/workspace/notification-rules/$ruleId/delete": {
      id: "/_layout/settings/_panel/workspace/notification-rules/$ruleId/delete"
      path: "/delete"
      fullPath: "/settings/workspace/notification-rules/$ruleId/delete"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceNotificationRulesRuleIdDeleteRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceNotificationRulesRuleIdRouteRoute
    }
    "/_layout/settings/_panel/workspace/notification-rules/duplicate/$ruleId": {
      id: "/_layout/settings/_panel/workspace/notification-rules/duplicate/$ruleId"
      path: "/duplicate/$ruleId"
      fullPath: "/settings/workspace/notification-rules/duplicate/$ruleId"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceNotificationRulesDuplicateRuleIdRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceNotificationRulesRouteRoute
    }
    "/_layout/settings/_panel/workspace/roles/_list/": {
      id: "/_layout/settings/_panel/workspace/roles/_list/"
      path: "/"
      fullPath: "/settings/workspace/roles/"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceRolesListIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceRolesListRouteRoute
    }
    "/_layout/settings/_panel/workspace/roles/_list/$roleId": {
      id: "/_layout/settings/_panel/workspace/roles/_list/$roleId"
      path: "/$roleId"
      fullPath: "/settings/workspace/roles/$roleId"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceRolesListRoleIdRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceRolesListRouteRoute
    }
    "/_layout/settings/_panel/workspace/roles/duplicate/$roleId": {
      id: "/_layout/settings/_panel/workspace/roles/duplicate/$roleId"
      path: "/duplicate/$roleId"
      fullPath: "/settings/workspace/roles/duplicate/$roleId"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceRolesDuplicateRoleIdRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceRolesRouteRoute
    }
    "/_layout/settings/_panel/workspace/teams/_list/": {
      id: "/_layout/settings/_panel/workspace/teams/_list/"
      path: "/"
      fullPath: "/settings/workspace/teams/"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceTeamsListIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceTeamsListRouteRoute
    }
    "/_layout/settings/_panel/workspace/teams/_list/$teamId": {
      id: "/_layout/settings/_panel/workspace/teams/_list/$teamId"
      path: "/$teamId"
      fullPath: "/settings/workspace/teams/$teamId"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceTeamsListTeamIdRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceTeamsListRouteRoute
    }
    "/_layout/settings/_panel/workspace/templates/$kind/": {
      id: "/_layout/settings/_panel/workspace/templates/$kind/"
      path: "/"
      fullPath: "/settings/workspace/templates/$kind/"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceTemplatesKindIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceTemplatesKindRouteRoute
    }
    "/_layout/settings/_panel/workspace/templates/$kind/revert": {
      id: "/_layout/settings/_panel/workspace/templates/$kind/revert"
      path: "/revert"
      fullPath: "/settings/workspace/templates/$kind/revert"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceTemplatesKindRevertRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceTemplatesKindRouteRoute
    }
    "/_layout/settings/_panel/workspace/tool-categories/_list/": {
      id: "/_layout/settings/_panel/workspace/tool-categories/_list/"
      path: "/"
      fullPath: "/settings/workspace/tool-categories/"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceToolCategoriesListIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceToolCategoriesListRouteRoute
    }
    "/_layout/settings/_panel/workspace/tool-categories/_list/$categoryId": {
      id: "/_layout/settings/_panel/workspace/tool-categories/_list/$categoryId"
      path: "/$categoryId"
      fullPath: "/settings/workspace/tool-categories/$categoryId"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdRouteRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceToolCategoriesListRouteRoute
    }
    "/_layout/settings/system_/tenants/$tenantId/settings/": {
      id: "/_layout/settings/system_/tenants/$tenantId/settings/"
      path: "/"
      fullPath: "/settings/system/tenants/$tenantId/settings/"
      preLoaderRoute: typeof LayoutSettingsSystemTenantsTenantIdSettingsIndexRouteImport
      parentRoute: typeof LayoutSettingsSystemTenantsTenantIdSettingsRouteRoute
    }
    "/_layout/settings/system_/tenants/$tenantId/settings/reindex": {
      id: "/_layout/settings/system_/tenants/$tenantId/settings/reindex"
      path: "/reindex"
      fullPath: "/settings/system/tenants/$tenantId/settings/reindex"
      preLoaderRoute: typeof LayoutSettingsSystemTenantsTenantIdSettingsReindexRouteImport
      parentRoute: typeof LayoutSettingsSystemTenantsTenantIdSettingsRouteRoute
    }
    "/_layout/templates/quotes_/$packageId/_list/tasks/$taskId": {
      id: "/_layout/templates/quotes_/$packageId/_list/tasks/$taskId"
      path: "/tasks/$taskId"
      fullPath: "/templates/quotes/$packageId/tasks/$taskId"
      preLoaderRoute: typeof LayoutTemplatesQuotesPackageIdListTasksTaskIdRouteRouteImport
      parentRoute: typeof LayoutTemplatesQuotesPackageIdListRouteRoute
    }
    "/_layout/templates/quotes_/$packageId/_list/tasks/create": {
      id: "/_layout/templates/quotes_/$packageId/_list/tasks/create"
      path: "/tasks/create"
      fullPath: "/templates/quotes/$packageId/tasks/create"
      preLoaderRoute: typeof LayoutTemplatesQuotesPackageIdListTasksCreateRouteImport
      parentRoute: typeof LayoutTemplatesQuotesPackageIdListRouteRoute
    }
    "/_layout/aircraft_/$aircraftId/part-instances/$partInstanceId/readings/$readingId/delete": {
      id: "/_layout/aircraft_/$aircraftId/part-instances/$partInstanceId/readings/$readingId/delete"
      path: "/part-instances/$partInstanceId/readings/$readingId/delete"
      fullPath: "/aircraft/$aircraftId/part-instances/$partInstanceId/readings/$readingId/delete"
      preLoaderRoute: typeof LayoutAircraftAircraftIdPartInstancesPartInstanceIdReadingsReadingIdDeleteRouteImport
      parentRoute: typeof LayoutAircraftAircraftIdRouteRoute
    }
    "/_layout/quotes_/$quoteId/tasks/$taskId/steps/$stepId/remove": {
      id: "/_layout/quotes_/$quoteId/tasks/$taskId/steps/$stepId/remove"
      path: "/steps/$stepId/remove"
      fullPath: "/quotes/$quoteId/tasks/$taskId/steps/$stepId/remove"
      preLoaderRoute: typeof LayoutQuotesQuoteIdTasksTaskIdStepsStepIdRemoveRouteImport
      parentRoute: typeof LayoutQuotesQuoteIdTasksTaskIdRouteRoute
    }
    "/_layout/settings/_panel/integrations/erp/_list/api-key/revoke": {
      id: "/_layout/settings/_panel/integrations/erp/_list/api-key/revoke"
      path: "/api-key/revoke"
      fullPath: "/settings/integrations/erp/api-key/revoke"
      preLoaderRoute: typeof LayoutSettingsPanelIntegrationsErpListApiKeyRevokeRouteImport
      parentRoute: typeof LayoutSettingsPanelIntegrationsErpListRouteRoute
    }
    "/_layout/settings/_panel/integrations/erp/_list/relay/remove": {
      id: "/_layout/settings/_panel/integrations/erp/_list/relay/remove"
      path: "/relay/remove"
      fullPath: "/settings/integrations/erp/relay/remove"
      preLoaderRoute: typeof LayoutSettingsPanelIntegrationsErpListRelayRemoveRouteImport
      parentRoute: typeof LayoutSettingsPanelIntegrationsErpListRouteRoute
    }
    "/_layout/settings/_panel/quoting/playbooks/$playbookId/rules/": {
      id: "/_layout/settings/_panel/quoting/playbooks/$playbookId/rules/"
      path: "/"
      fullPath: "/settings/quoting/playbooks/$playbookId/rules/"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesRouteRoute
    }
    "/_layout/settings/_panel/workspace/departments/_list/$departmentId/": {
      id: "/_layout/settings/_panel/workspace/departments/_list/$departmentId/"
      path: "/"
      fullPath: "/settings/workspace/departments/$departmentId/"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdRouteRoute
    }
    "/_layout/settings/_panel/workspace/departments/_list/$departmentId/delete": {
      id: "/_layout/settings/_panel/workspace/departments/_list/$departmentId/delete"
      path: "/delete"
      fullPath: "/settings/workspace/departments/$departmentId/delete"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdDeleteRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdRouteRoute
    }
    "/_layout/settings/_panel/workspace/facilities/_list/$facilityId/": {
      id: "/_layout/settings/_panel/workspace/facilities/_list/$facilityId/"
      path: "/"
      fullPath: "/settings/workspace/facilities/$facilityId/"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdRouteRoute
    }
    "/_layout/settings/_panel/workspace/facilities/_list/$facilityId/delete": {
      id: "/_layout/settings/_panel/workspace/facilities/_list/$facilityId/delete"
      path: "/delete"
      fullPath: "/settings/workspace/facilities/$facilityId/delete"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdDeleteRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdRouteRoute
    }
    "/_layout/settings/_panel/workspace/members/_list/$userId/": {
      id: "/_layout/settings/_panel/workspace/members/_list/$userId/"
      path: "/"
      fullPath: "/settings/workspace/members/$userId/"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceMembersListUserIdIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceMembersListUserIdRouteRoute
    }
    "/_layout/settings/_panel/workspace/members/_list/$userId/change-password": {
      id: "/_layout/settings/_panel/workspace/members/_list/$userId/change-password"
      path: "/change-password"
      fullPath: "/settings/workspace/members/$userId/change-password"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceMembersListUserIdChangePasswordRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceMembersListUserIdRouteRoute
    }
    "/_layout/settings/_panel/workspace/members/_list/$userId/delete": {
      id: "/_layout/settings/_panel/workspace/members/_list/$userId/delete"
      path: "/delete"
      fullPath: "/settings/workspace/members/$userId/delete"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceMembersListUserIdDeleteRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceMembersListUserIdRouteRoute
    }
    "/_layout/settings/_panel/workspace/members/_list/$userId/resend-login-email": {
      id: "/_layout/settings/_panel/workspace/members/_list/$userId/resend-login-email"
      path: "/resend-login-email"
      fullPath: "/settings/workspace/members/$userId/resend-login-email"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceMembersListUserIdResendLoginEmailRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceMembersListUserIdRouteRoute
    }
    "/_layout/settings/_panel/workspace/roles/_list/$roleId/": {
      id: "/_layout/settings/_panel/workspace/roles/_list/$roleId/"
      path: "/"
      fullPath: "/settings/workspace/roles/$roleId/"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceRolesListRoleIdIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceRolesListRoleIdRouteRoute
    }
    "/_layout/settings/_panel/workspace/roles/_list/$roleId/delete": {
      id: "/_layout/settings/_panel/workspace/roles/_list/$roleId/delete"
      path: "/delete"
      fullPath: "/settings/workspace/roles/$roleId/delete"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceRolesListRoleIdDeleteRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceRolesListRoleIdRouteRoute
    }
    "/_layout/settings/_panel/workspace/roles/_list/$roleId/reset": {
      id: "/_layout/settings/_panel/workspace/roles/_list/$roleId/reset"
      path: "/reset"
      fullPath: "/settings/workspace/roles/$roleId/reset"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceRolesListRoleIdResetRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceRolesListRoleIdRouteRoute
    }
    "/_layout/settings/_panel/workspace/teams/_list/$teamId/": {
      id: "/_layout/settings/_panel/workspace/teams/_list/$teamId/"
      path: "/"
      fullPath: "/settings/workspace/teams/$teamId/"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceTeamsListTeamIdIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceTeamsListTeamIdRouteRoute
    }
    "/_layout/settings/_panel/workspace/teams/_list/$teamId/delete": {
      id: "/_layout/settings/_panel/workspace/teams/_list/$teamId/delete"
      path: "/delete"
      fullPath: "/settings/workspace/teams/$teamId/delete"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceTeamsListTeamIdDeleteRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceTeamsListTeamIdRouteRoute
    }
    "/_layout/settings/_panel/workspace/tool-categories/_list/$categoryId/": {
      id: "/_layout/settings/_panel/workspace/tool-categories/_list/$categoryId/"
      path: "/"
      fullPath: "/settings/workspace/tool-categories/$categoryId/"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdIndexRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdRouteRoute
    }
    "/_layout/settings/_panel/workspace/tool-categories/_list/$categoryId/delete": {
      id: "/_layout/settings/_panel/workspace/tool-categories/_list/$categoryId/delete"
      path: "/delete"
      fullPath: "/settings/workspace/tool-categories/$categoryId/delete"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdDeleteRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdRouteRoute
    }
    "/_layout/templates/quotes_/$packageId/_list/tasks/$taskId/": {
      id: "/_layout/templates/quotes_/$packageId/_list/tasks/$taskId/"
      path: "/"
      fullPath: "/templates/quotes/$packageId/tasks/$taskId/"
      preLoaderRoute: typeof LayoutTemplatesQuotesPackageIdListTasksTaskIdIndexRouteImport
      parentRoute: typeof LayoutTemplatesQuotesPackageIdListTasksTaskIdRouteRoute
    }
    "/_layout/templates/quotes_/$packageId/_list/tasks/$taskId/archive": {
      id: "/_layout/templates/quotes_/$packageId/_list/tasks/$taskId/archive"
      path: "/archive"
      fullPath: "/templates/quotes/$packageId/tasks/$taskId/archive"
      preLoaderRoute: typeof LayoutTemplatesQuotesPackageIdListTasksTaskIdArchiveRouteImport
      parentRoute: typeof LayoutTemplatesQuotesPackageIdListTasksTaskIdRouteRoute
    }
    "/_layout/work-orders/$workOrderId/tasks/$taskId/steps/$stepId/delete": {
      id: "/_layout/work-orders/$workOrderId/tasks/$taskId/steps/$stepId/delete"
      path: "/steps/$stepId/delete"
      fullPath: "/work-orders/$workOrderId/tasks/$taskId/steps/$stepId/delete"
      preLoaderRoute: typeof LayoutWorkOrdersWorkOrderIdTasksTaskIdStepsStepIdDeleteRouteImport
      parentRoute: typeof LayoutWorkOrdersWorkOrderIdTasksTaskIdRoute
    }
    "/_layout/work-orders/$workOrderId/tasks/$taskId/time-entries/$timeEntryId/delete": {
      id: "/_layout/work-orders/$workOrderId/tasks/$taskId/time-entries/$timeEntryId/delete"
      path: "/time-entries/$timeEntryId/delete"
      fullPath: "/work-orders/$workOrderId/tasks/$taskId/time-entries/$timeEntryId/delete"
      preLoaderRoute: typeof LayoutWorkOrdersWorkOrderIdTasksTaskIdTimeEntriesTimeEntryIdDeleteRouteImport
      parentRoute: typeof LayoutWorkOrdersWorkOrderIdTasksTaskIdRoute
    }
    "/_layout/settings/_panel/quoting/playbooks/$playbookId/rules/$lineageId/delete": {
      id: "/_layout/settings/_panel/quoting/playbooks/$playbookId/rules/$lineageId/delete"
      path: "/$lineageId/delete"
      fullPath: "/settings/quoting/playbooks/$playbookId/rules/$lineageId/delete"
      preLoaderRoute: typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesLineageIdDeleteRouteImport
      parentRoute: typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesRouteRoute
    }
    "/_layout/settings/_panel/workspace/departments/_list/$departmentId/positions/$positionId/remove": {
      id: "/_layout/settings/_panel/workspace/departments/_list/$departmentId/positions/$positionId/remove"
      path: "/positions/$positionId/remove"
      fullPath: "/settings/workspace/departments/$departmentId/positions/$positionId/remove"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdPositionsPositionIdRemoveRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdRouteRoute
    }
    "/_layout/settings/_panel/workspace/facilities/_list/$facilityId/locations/$locationId/delete": {
      id: "/_layout/settings/_panel/workspace/facilities/_list/$facilityId/locations/$locationId/delete"
      path: "/locations/$locationId/delete"
      fullPath: "/settings/workspace/facilities/$facilityId/locations/$locationId/delete"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdLocationsLocationIdDeleteRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdRouteRoute
    }
    "/_layout/settings/_panel/workspace/facilities/_list/$facilityId/positions/$positionId/remove": {
      id: "/_layout/settings/_panel/workspace/facilities/_list/$facilityId/positions/$positionId/remove"
      path: "/positions/$positionId/remove"
      fullPath: "/settings/workspace/facilities/$facilityId/positions/$positionId/remove"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdPositionsPositionIdRemoveRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdRouteRoute
    }
    "/_layout/settings/_panel/workspace/teams/_list/$teamId/positions/$positionId/remove": {
      id: "/_layout/settings/_panel/workspace/teams/_list/$teamId/positions/$positionId/remove"
      path: "/positions/$positionId/remove"
      fullPath: "/settings/workspace/teams/$teamId/positions/$positionId/remove"
      preLoaderRoute: typeof LayoutSettingsPanelWorkspaceTeamsListTeamIdPositionsPositionIdRemoveRouteImport
      parentRoute: typeof LayoutSettingsPanelWorkspaceTeamsListTeamIdRouteRoute
    }
  }
}

interface LayoutAgentChatsRouteChildren {
  LayoutAgentChatsDeleteIdRoute: typeof LayoutAgentChatsDeleteIdRoute
}

const LayoutAgentChatsRouteChildren: LayoutAgentChatsRouteChildren = {
  LayoutAgentChatsDeleteIdRoute: LayoutAgentChatsDeleteIdRoute,
}

const LayoutAgentChatsRouteWithChildren =
  LayoutAgentChatsRoute._addFileChildren(LayoutAgentChatsRouteChildren)

interface LayoutAgentRouteRouteChildren {
  LayoutAgentIdRoute: typeof LayoutAgentIdRoute
  LayoutAgentChatsRoute: typeof LayoutAgentChatsRouteWithChildren
  LayoutAgentIndexRoute: typeof LayoutAgentIndexRoute
  LayoutAgentDeleteIdRoute: typeof LayoutAgentDeleteIdRoute
}

const LayoutAgentRouteRouteChildren: LayoutAgentRouteRouteChildren = {
  LayoutAgentIdRoute: LayoutAgentIdRoute,
  LayoutAgentChatsRoute: LayoutAgentChatsRouteWithChildren,
  LayoutAgentIndexRoute: LayoutAgentIndexRoute,
  LayoutAgentDeleteIdRoute: LayoutAgentDeleteIdRoute,
}

const LayoutAgentRouteRouteWithChildren =
  LayoutAgentRouteRoute._addFileChildren(LayoutAgentRouteRouteChildren)

interface LayoutAircraftRouteRouteChildren {
  LayoutAircraftIndexRoute: typeof LayoutAircraftIndexRoute
}

const LayoutAircraftRouteRouteChildren: LayoutAircraftRouteRouteChildren = {
  LayoutAircraftIndexRoute: LayoutAircraftIndexRoute,
}

const LayoutAircraftRouteRouteWithChildren =
  LayoutAircraftRouteRoute._addFileChildren(LayoutAircraftRouteRouteChildren)

interface LayoutAirworthinessDirectivesRouteRouteChildren {
  LayoutAirworthinessDirectivesUploadRoute: typeof LayoutAirworthinessDirectivesUploadRoute
  LayoutAirworthinessDirectivesIndexRoute: typeof LayoutAirworthinessDirectivesIndexRoute
  LayoutAirworthinessDirectivesDeleteDocumentIdRoute: typeof LayoutAirworthinessDirectivesDeleteDocumentIdRoute
}

const LayoutAirworthinessDirectivesRouteRouteChildren: LayoutAirworthinessDirectivesRouteRouteChildren =
  {
    LayoutAirworthinessDirectivesUploadRoute:
      LayoutAirworthinessDirectivesUploadRoute,
    LayoutAirworthinessDirectivesIndexRoute:
      LayoutAirworthinessDirectivesIndexRoute,
    LayoutAirworthinessDirectivesDeleteDocumentIdRoute:
      LayoutAirworthinessDirectivesDeleteDocumentIdRoute,
  }

const LayoutAirworthinessDirectivesRouteRouteWithChildren =
  LayoutAirworthinessDirectivesRouteRoute._addFileChildren(
    LayoutAirworthinessDirectivesRouteRouteChildren,
  )

interface LayoutApprovedVendorsRouteRouteChildren {
  LayoutApprovedVendorsIndexRoute: typeof LayoutApprovedVendorsIndexRoute
  LayoutApprovedVendorsDeleteVendorIdRoute: typeof LayoutApprovedVendorsDeleteVendorIdRoute
  LayoutApprovedVendorsDeleteBulkRoute: typeof LayoutApprovedVendorsDeleteBulkRoute
}

const LayoutApprovedVendorsRouteRouteChildren: LayoutApprovedVendorsRouteRouteChildren =
  {
    LayoutApprovedVendorsIndexRoute: LayoutApprovedVendorsIndexRoute,
    LayoutApprovedVendorsDeleteVendorIdRoute:
      LayoutApprovedVendorsDeleteVendorIdRoute,
    LayoutApprovedVendorsDeleteBulkRoute: LayoutApprovedVendorsDeleteBulkRoute,
  }

const LayoutApprovedVendorsRouteRouteWithChildren =
  LayoutApprovedVendorsRouteRoute._addFileChildren(
    LayoutApprovedVendorsRouteRouteChildren,
  )

interface LayoutCustomerRouteRouteChildren {
  LayoutCustomerIndexRoute: typeof LayoutCustomerIndexRoute
  LayoutCustomerDeleteCustomerIdRoute: typeof LayoutCustomerDeleteCustomerIdRoute
}

const LayoutCustomerRouteRouteChildren: LayoutCustomerRouteRouteChildren = {
  LayoutCustomerIndexRoute: LayoutCustomerIndexRoute,
  LayoutCustomerDeleteCustomerIdRoute: LayoutCustomerDeleteCustomerIdRoute,
}

const LayoutCustomerRouteRouteWithChildren =
  LayoutCustomerRouteRoute._addFileChildren(LayoutCustomerRouteRouteChildren)

interface LayoutDocumentsListRouteRouteChildren {
  LayoutDocumentsListUploadRouteRoute: typeof LayoutDocumentsListUploadRouteRoute
  LayoutDocumentsListIndexRoute: typeof LayoutDocumentsListIndexRoute
  LayoutDocumentsListDeleteDocumentIdRoute: typeof LayoutDocumentsListDeleteDocumentIdRoute
  LayoutDocumentsListDeleteBulkRoute: typeof LayoutDocumentsListDeleteBulkRoute
  LayoutDocumentsListMakePrivateDocumentIdRoute: typeof LayoutDocumentsListMakePrivateDocumentIdRoute
  LayoutDocumentsListShareDocumentIdRoute: typeof LayoutDocumentsListShareDocumentIdRoute
  LayoutDocumentsListShareBulkRoute: typeof LayoutDocumentsListShareBulkRoute
}

const LayoutDocumentsListRouteRouteChildren: LayoutDocumentsListRouteRouteChildren =
  {
    LayoutDocumentsListUploadRouteRoute: LayoutDocumentsListUploadRouteRoute,
    LayoutDocumentsListIndexRoute: LayoutDocumentsListIndexRoute,
    LayoutDocumentsListDeleteDocumentIdRoute:
      LayoutDocumentsListDeleteDocumentIdRoute,
    LayoutDocumentsListDeleteBulkRoute: LayoutDocumentsListDeleteBulkRoute,
    LayoutDocumentsListMakePrivateDocumentIdRoute:
      LayoutDocumentsListMakePrivateDocumentIdRoute,
    LayoutDocumentsListShareDocumentIdRoute:
      LayoutDocumentsListShareDocumentIdRoute,
    LayoutDocumentsListShareBulkRoute: LayoutDocumentsListShareBulkRoute,
  }

const LayoutDocumentsListRouteRouteWithChildren =
  LayoutDocumentsListRouteRoute._addFileChildren(
    LayoutDocumentsListRouteRouteChildren,
  )

interface LayoutDocumentsRouteRouteChildren {
  LayoutDocumentsListRouteRoute: typeof LayoutDocumentsListRouteRouteWithChildren
  LayoutDocumentsDocumentIdRoute: typeof LayoutDocumentsDocumentIdRoute
}

const LayoutDocumentsRouteRouteChildren: LayoutDocumentsRouteRouteChildren = {
  LayoutDocumentsListRouteRoute: LayoutDocumentsListRouteRouteWithChildren,
  LayoutDocumentsDocumentIdRoute: LayoutDocumentsDocumentIdRoute,
}

const LayoutDocumentsRouteRouteWithChildren =
  LayoutDocumentsRouteRoute._addFileChildren(LayoutDocumentsRouteRouteChildren)

interface LayoutForecastsRouteRouteChildren {
  LayoutForecastsNewRoute: typeof LayoutForecastsNewRoute
  LayoutForecastsIndexRoute: typeof LayoutForecastsIndexRoute
  LayoutForecastsDeleteForecastIdRoute: typeof LayoutForecastsDeleteForecastIdRoute
}

const LayoutForecastsRouteRouteChildren: LayoutForecastsRouteRouteChildren = {
  LayoutForecastsNewRoute: LayoutForecastsNewRoute,
  LayoutForecastsIndexRoute: LayoutForecastsIndexRoute,
  LayoutForecastsDeleteForecastIdRoute: LayoutForecastsDeleteForecastIdRoute,
}

const LayoutForecastsRouteRouteWithChildren =
  LayoutForecastsRouteRoute._addFileChildren(LayoutForecastsRouteRouteChildren)

interface LayoutInventoryPartIdRouteRouteChildren {
  LayoutInventoryPartIdArchiveRoute: typeof LayoutInventoryPartIdArchiveRoute
  LayoutInventoryPartIdIndexRoute: typeof LayoutInventoryPartIdIndexRoute
  LayoutInventoryPartIdPricesPriceIdDeleteRoute: typeof LayoutInventoryPartIdPricesPriceIdDeleteRoute
}

const LayoutInventoryPartIdRouteRouteChildren: LayoutInventoryPartIdRouteRouteChildren =
  {
    LayoutInventoryPartIdArchiveRoute: LayoutInventoryPartIdArchiveRoute,
    LayoutInventoryPartIdIndexRoute: LayoutInventoryPartIdIndexRoute,
    LayoutInventoryPartIdPricesPriceIdDeleteRoute:
      LayoutInventoryPartIdPricesPriceIdDeleteRoute,
  }

const LayoutInventoryPartIdRouteRouteWithChildren =
  LayoutInventoryPartIdRouteRoute._addFileChildren(
    LayoutInventoryPartIdRouteRouteChildren,
  )

interface LayoutInventoryRouteRouteChildren {
  LayoutInventoryPartIdRouteRoute: typeof LayoutInventoryPartIdRouteRouteWithChildren
  LayoutInventoryNewRoute: typeof LayoutInventoryNewRoute
  LayoutInventoryIndexRoute: typeof LayoutInventoryIndexRoute
  LayoutInventoryDeletePartIdRoute: typeof LayoutInventoryDeletePartIdRoute
  LayoutInventoryDeleteBulkRoute: typeof LayoutInventoryDeleteBulkRoute
}

const LayoutInventoryRouteRouteChildren: LayoutInventoryRouteRouteChildren = {
  LayoutInventoryPartIdRouteRoute: LayoutInventoryPartIdRouteRouteWithChildren,
  LayoutInventoryNewRoute: LayoutInventoryNewRoute,
  LayoutInventoryIndexRoute: LayoutInventoryIndexRoute,
  LayoutInventoryDeletePartIdRoute: LayoutInventoryDeletePartIdRoute,
  LayoutInventoryDeleteBulkRoute: LayoutInventoryDeleteBulkRoute,
}

const LayoutInventoryRouteRouteWithChildren =
  LayoutInventoryRouteRoute._addFileChildren(LayoutInventoryRouteRouteChildren)

interface LayoutMaintenanceProgrammesRouteRouteChildren {
  LayoutMaintenanceProgrammesNewRoute: typeof LayoutMaintenanceProgrammesNewRoute
  LayoutMaintenanceProgrammesIndexRoute: typeof LayoutMaintenanceProgrammesIndexRoute
  LayoutMaintenanceProgrammesDeleteProgrammeIdRoute: typeof LayoutMaintenanceProgrammesDeleteProgrammeIdRoute
}

const LayoutMaintenanceProgrammesRouteRouteChildren: LayoutMaintenanceProgrammesRouteRouteChildren =
  {
    LayoutMaintenanceProgrammesNewRoute: LayoutMaintenanceProgrammesNewRoute,
    LayoutMaintenanceProgrammesIndexRoute:
      LayoutMaintenanceProgrammesIndexRoute,
    LayoutMaintenanceProgrammesDeleteProgrammeIdRoute:
      LayoutMaintenanceProgrammesDeleteProgrammeIdRoute,
  }

const LayoutMaintenanceProgrammesRouteRouteWithChildren =
  LayoutMaintenanceProgrammesRouteRoute._addFileChildren(
    LayoutMaintenanceProgrammesRouteRouteChildren,
  )

interface LayoutPlanningRouteRouteChildren {
  LayoutPlanningIndexRoute: typeof LayoutPlanningIndexRoute
  LayoutPlanningNewForecastRoute: typeof LayoutPlanningNewForecastRoute
  LayoutPlanningNewQuoteRoute: typeof LayoutPlanningNewQuoteRoute
}

const LayoutPlanningRouteRouteChildren: LayoutPlanningRouteRouteChildren = {
  LayoutPlanningIndexRoute: LayoutPlanningIndexRoute,
  LayoutPlanningNewForecastRoute: LayoutPlanningNewForecastRoute,
  LayoutPlanningNewQuoteRoute: LayoutPlanningNewQuoteRoute,
}

const LayoutPlanningRouteRouteWithChildren =
  LayoutPlanningRouteRoute._addFileChildren(LayoutPlanningRouteRouteChildren)

interface LayoutQuotesRouteRouteChildren {
  LayoutQuotesCreateRoute: typeof LayoutQuotesCreateRoute
  LayoutQuotesFromFileRoute: typeof LayoutQuotesFromFileRoute
  LayoutQuotesIndexRoute: typeof LayoutQuotesIndexRoute
  LayoutQuotesDeleteQuoteIdRoute: typeof LayoutQuotesDeleteQuoteIdRoute
}

const LayoutQuotesRouteRouteChildren: LayoutQuotesRouteRouteChildren = {
  LayoutQuotesCreateRoute: LayoutQuotesCreateRoute,
  LayoutQuotesFromFileRoute: LayoutQuotesFromFileRoute,
  LayoutQuotesIndexRoute: LayoutQuotesIndexRoute,
  LayoutQuotesDeleteQuoteIdRoute: LayoutQuotesDeleteQuoteIdRoute,
}

const LayoutQuotesRouteRouteWithChildren =
  LayoutQuotesRouteRoute._addFileChildren(LayoutQuotesRouteRouteChildren)

interface LayoutSettingsPanelAccountProfileRouteRouteChildren {
  LayoutSettingsPanelAccountProfileChangePasswordRoute: typeof LayoutSettingsPanelAccountProfileChangePasswordRoute
  LayoutSettingsPanelAccountProfileIndexRoute: typeof LayoutSettingsPanelAccountProfileIndexRoute
}

const LayoutSettingsPanelAccountProfileRouteRouteChildren: LayoutSettingsPanelAccountProfileRouteRouteChildren =
  {
    LayoutSettingsPanelAccountProfileChangePasswordRoute:
      LayoutSettingsPanelAccountProfileChangePasswordRoute,
    LayoutSettingsPanelAccountProfileIndexRoute:
      LayoutSettingsPanelAccountProfileIndexRoute,
  }

const LayoutSettingsPanelAccountProfileRouteRouteWithChildren =
  LayoutSettingsPanelAccountProfileRouteRoute._addFileChildren(
    LayoutSettingsPanelAccountProfileRouteRouteChildren,
  )

interface LayoutSettingsPanelIntegrationsErpListRouteRouteChildren {
  LayoutSettingsPanelIntegrationsErpListIndexRoute: typeof LayoutSettingsPanelIntegrationsErpListIndexRoute
  LayoutSettingsPanelIntegrationsErpListApiKeyRevokeRoute: typeof LayoutSettingsPanelIntegrationsErpListApiKeyRevokeRoute
  LayoutSettingsPanelIntegrationsErpListRelayRemoveRoute: typeof LayoutSettingsPanelIntegrationsErpListRelayRemoveRoute
}

const LayoutSettingsPanelIntegrationsErpListRouteRouteChildren: LayoutSettingsPanelIntegrationsErpListRouteRouteChildren =
  {
    LayoutSettingsPanelIntegrationsErpListIndexRoute:
      LayoutSettingsPanelIntegrationsErpListIndexRoute,
    LayoutSettingsPanelIntegrationsErpListApiKeyRevokeRoute:
      LayoutSettingsPanelIntegrationsErpListApiKeyRevokeRoute,
    LayoutSettingsPanelIntegrationsErpListRelayRemoveRoute:
      LayoutSettingsPanelIntegrationsErpListRelayRemoveRoute,
  }

const LayoutSettingsPanelIntegrationsErpListRouteRouteWithChildren =
  LayoutSettingsPanelIntegrationsErpListRouteRoute._addFileChildren(
    LayoutSettingsPanelIntegrationsErpListRouteRouteChildren,
  )

interface LayoutSettingsPanelIntegrationsErpRouteRouteChildren {
  LayoutSettingsPanelIntegrationsErpListRouteRoute: typeof LayoutSettingsPanelIntegrationsErpListRouteRouteWithChildren
  LayoutSettingsPanelIntegrationsErpApiKeySetRoute: typeof LayoutSettingsPanelIntegrationsErpApiKeySetRoute
  LayoutSettingsPanelIntegrationsErpRelaySetRoute: typeof LayoutSettingsPanelIntegrationsErpRelaySetRoute
}

const LayoutSettingsPanelIntegrationsErpRouteRouteChildren: LayoutSettingsPanelIntegrationsErpRouteRouteChildren =
  {
    LayoutSettingsPanelIntegrationsErpListRouteRoute:
      LayoutSettingsPanelIntegrationsErpListRouteRouteWithChildren,
    LayoutSettingsPanelIntegrationsErpApiKeySetRoute:
      LayoutSettingsPanelIntegrationsErpApiKeySetRoute,
    LayoutSettingsPanelIntegrationsErpRelaySetRoute:
      LayoutSettingsPanelIntegrationsErpRelaySetRoute,
  }

const LayoutSettingsPanelIntegrationsErpRouteRouteWithChildren =
  LayoutSettingsPanelIntegrationsErpRouteRoute._addFileChildren(
    LayoutSettingsPanelIntegrationsErpRouteRouteChildren,
  )

interface LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesRouteRouteChildren {
  LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesIndexRoute: typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesIndexRoute
  LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesLineageIdDeleteRoute: typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesLineageIdDeleteRoute
}

const LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesRouteRouteChildren: LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesRouteRouteChildren =
  {
    LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesIndexRoute:
      LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesIndexRoute,
    LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesLineageIdDeleteRoute:
      LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesLineageIdDeleteRoute,
  }

const LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesRouteRouteWithChildren =
  LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesRouteRoute._addFileChildren(
    LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesRouteRouteChildren,
  )

interface LayoutSettingsPanelQuotingPlaybooksPlaybookIdRouteRouteChildren {
  LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesRouteRoute: typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesRouteRouteWithChildren
  LayoutSettingsPanelQuotingPlaybooksPlaybookIdActivityRoute: typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdActivityRoute
  LayoutSettingsPanelQuotingPlaybooksPlaybookIdConfigurationRoute: typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdConfigurationRoute
  LayoutSettingsPanelQuotingPlaybooksPlaybookIdIndexRoute: typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdIndexRoute
}

const LayoutSettingsPanelQuotingPlaybooksPlaybookIdRouteRouteChildren: LayoutSettingsPanelQuotingPlaybooksPlaybookIdRouteRouteChildren =
  {
    LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesRouteRoute:
      LayoutSettingsPanelQuotingPlaybooksPlaybookIdRulesRouteRouteWithChildren,
    LayoutSettingsPanelQuotingPlaybooksPlaybookIdActivityRoute:
      LayoutSettingsPanelQuotingPlaybooksPlaybookIdActivityRoute,
    LayoutSettingsPanelQuotingPlaybooksPlaybookIdConfigurationRoute:
      LayoutSettingsPanelQuotingPlaybooksPlaybookIdConfigurationRoute,
    LayoutSettingsPanelQuotingPlaybooksPlaybookIdIndexRoute:
      LayoutSettingsPanelQuotingPlaybooksPlaybookIdIndexRoute,
  }

const LayoutSettingsPanelQuotingPlaybooksPlaybookIdRouteRouteWithChildren =
  LayoutSettingsPanelQuotingPlaybooksPlaybookIdRouteRoute._addFileChildren(
    LayoutSettingsPanelQuotingPlaybooksPlaybookIdRouteRouteChildren,
  )

interface LayoutSettingsPanelQuotingPlaybooksRouteRouteChildren {
  LayoutSettingsPanelQuotingPlaybooksPlaybookIdRouteRoute: typeof LayoutSettingsPanelQuotingPlaybooksPlaybookIdRouteRouteWithChildren
  LayoutSettingsPanelQuotingPlaybooksCreateRoute: typeof LayoutSettingsPanelQuotingPlaybooksCreateRoute
  LayoutSettingsPanelQuotingPlaybooksIndexRoute: typeof LayoutSettingsPanelQuotingPlaybooksIndexRoute
}

const LayoutSettingsPanelQuotingPlaybooksRouteRouteChildren: LayoutSettingsPanelQuotingPlaybooksRouteRouteChildren =
  {
    LayoutSettingsPanelQuotingPlaybooksPlaybookIdRouteRoute:
      LayoutSettingsPanelQuotingPlaybooksPlaybookIdRouteRouteWithChildren,
    LayoutSettingsPanelQuotingPlaybooksCreateRoute:
      LayoutSettingsPanelQuotingPlaybooksCreateRoute,
    LayoutSettingsPanelQuotingPlaybooksIndexRoute:
      LayoutSettingsPanelQuotingPlaybooksIndexRoute,
  }

const LayoutSettingsPanelQuotingPlaybooksRouteRouteWithChildren =
  LayoutSettingsPanelQuotingPlaybooksRouteRoute._addFileChildren(
    LayoutSettingsPanelQuotingPlaybooksRouteRouteChildren,
  )

interface LayoutSettingsPanelQuotingRateCardsRateCardIdRouteRouteChildren {
  LayoutSettingsPanelQuotingRateCardsRateCardIdArchiveRoute: typeof LayoutSettingsPanelQuotingRateCardsRateCardIdArchiveRoute
  LayoutSettingsPanelQuotingRateCardsRateCardIdIndexRoute: typeof LayoutSettingsPanelQuotingRateCardsRateCardIdIndexRoute
}

const LayoutSettingsPanelQuotingRateCardsRateCardIdRouteRouteChildren: LayoutSettingsPanelQuotingRateCardsRateCardIdRouteRouteChildren =
  {
    LayoutSettingsPanelQuotingRateCardsRateCardIdArchiveRoute:
      LayoutSettingsPanelQuotingRateCardsRateCardIdArchiveRoute,
    LayoutSettingsPanelQuotingRateCardsRateCardIdIndexRoute:
      LayoutSettingsPanelQuotingRateCardsRateCardIdIndexRoute,
  }

const LayoutSettingsPanelQuotingRateCardsRateCardIdRouteRouteWithChildren =
  LayoutSettingsPanelQuotingRateCardsRateCardIdRouteRoute._addFileChildren(
    LayoutSettingsPanelQuotingRateCardsRateCardIdRouteRouteChildren,
  )

interface LayoutSettingsPanelQuotingRateCardsRouteRouteChildren {
  LayoutSettingsPanelQuotingRateCardsRateCardIdRouteRoute: typeof LayoutSettingsPanelQuotingRateCardsRateCardIdRouteRouteWithChildren
  LayoutSettingsPanelQuotingRateCardsIndexRoute: typeof LayoutSettingsPanelQuotingRateCardsIndexRoute
}

const LayoutSettingsPanelQuotingRateCardsRouteRouteChildren: LayoutSettingsPanelQuotingRateCardsRouteRouteChildren =
  {
    LayoutSettingsPanelQuotingRateCardsRateCardIdRouteRoute:
      LayoutSettingsPanelQuotingRateCardsRateCardIdRouteRouteWithChildren,
    LayoutSettingsPanelQuotingRateCardsIndexRoute:
      LayoutSettingsPanelQuotingRateCardsIndexRoute,
  }

const LayoutSettingsPanelQuotingRateCardsRouteRouteWithChildren =
  LayoutSettingsPanelQuotingRateCardsRouteRoute._addFileChildren(
    LayoutSettingsPanelQuotingRateCardsRouteRouteChildren,
  )

interface LayoutSettingsPanelQuotingStatusRouteRouteChildren {
  LayoutSettingsPanelQuotingStatusIndexRoute: typeof LayoutSettingsPanelQuotingStatusIndexRoute
}

const LayoutSettingsPanelQuotingStatusRouteRouteChildren: LayoutSettingsPanelQuotingStatusRouteRouteChildren =
  {
    LayoutSettingsPanelQuotingStatusIndexRoute:
      LayoutSettingsPanelQuotingStatusIndexRoute,
  }

const LayoutSettingsPanelQuotingStatusRouteRouteWithChildren =
  LayoutSettingsPanelQuotingStatusRouteRoute._addFileChildren(
    LayoutSettingsPanelQuotingStatusRouteRouteChildren,
  )

interface LayoutSettingsPanelQuotingTaskGroupsRouteRouteChildren {
  LayoutSettingsPanelQuotingTaskGroupsImportRoute: typeof LayoutSettingsPanelQuotingTaskGroupsImportRoute
  LayoutSettingsPanelQuotingTaskGroupsIndexRoute: typeof LayoutSettingsPanelQuotingTaskGroupsIndexRoute
  LayoutSettingsPanelQuotingTaskGroupsGroupIdArchiveRoute: typeof LayoutSettingsPanelQuotingTaskGroupsGroupIdArchiveRoute
}

const LayoutSettingsPanelQuotingTaskGroupsRouteRouteChildren: LayoutSettingsPanelQuotingTaskGroupsRouteRouteChildren =
  {
    LayoutSettingsPanelQuotingTaskGroupsImportRoute:
      LayoutSettingsPanelQuotingTaskGroupsImportRoute,
    LayoutSettingsPanelQuotingTaskGroupsIndexRoute:
      LayoutSettingsPanelQuotingTaskGroupsIndexRoute,
    LayoutSettingsPanelQuotingTaskGroupsGroupIdArchiveRoute:
      LayoutSettingsPanelQuotingTaskGroupsGroupIdArchiveRoute,
  }

const LayoutSettingsPanelQuotingTaskGroupsRouteRouteWithChildren =
  LayoutSettingsPanelQuotingTaskGroupsRouteRoute._addFileChildren(
    LayoutSettingsPanelQuotingTaskGroupsRouteRouteChildren,
  )

interface LayoutSettingsPanelQuotingTaxRatesTaxRateIdRouteRouteChildren {
  LayoutSettingsPanelQuotingTaxRatesTaxRateIdArchiveRoute: typeof LayoutSettingsPanelQuotingTaxRatesTaxRateIdArchiveRoute
  LayoutSettingsPanelQuotingTaxRatesTaxRateIdIndexRoute: typeof LayoutSettingsPanelQuotingTaxRatesTaxRateIdIndexRoute
}

const LayoutSettingsPanelQuotingTaxRatesTaxRateIdRouteRouteChildren: LayoutSettingsPanelQuotingTaxRatesTaxRateIdRouteRouteChildren =
  {
    LayoutSettingsPanelQuotingTaxRatesTaxRateIdArchiveRoute:
      LayoutSettingsPanelQuotingTaxRatesTaxRateIdArchiveRoute,
    LayoutSettingsPanelQuotingTaxRatesTaxRateIdIndexRoute:
      LayoutSettingsPanelQuotingTaxRatesTaxRateIdIndexRoute,
  }

const LayoutSettingsPanelQuotingTaxRatesTaxRateIdRouteRouteWithChildren =
  LayoutSettingsPanelQuotingTaxRatesTaxRateIdRouteRoute._addFileChildren(
    LayoutSettingsPanelQuotingTaxRatesTaxRateIdRouteRouteChildren,
  )

interface LayoutSettingsPanelQuotingTaxRatesRouteRouteChildren {
  LayoutSettingsPanelQuotingTaxRatesTaxRateIdRouteRoute: typeof LayoutSettingsPanelQuotingTaxRatesTaxRateIdRouteRouteWithChildren
  LayoutSettingsPanelQuotingTaxRatesIndexRoute: typeof LayoutSettingsPanelQuotingTaxRatesIndexRoute
}

const LayoutSettingsPanelQuotingTaxRatesRouteRouteChildren: LayoutSettingsPanelQuotingTaxRatesRouteRouteChildren =
  {
    LayoutSettingsPanelQuotingTaxRatesTaxRateIdRouteRoute:
      LayoutSettingsPanelQuotingTaxRatesTaxRateIdRouteRouteWithChildren,
    LayoutSettingsPanelQuotingTaxRatesIndexRoute:
      LayoutSettingsPanelQuotingTaxRatesIndexRoute,
  }

const LayoutSettingsPanelQuotingTaxRatesRouteRouteWithChildren =
  LayoutSettingsPanelQuotingTaxRatesRouteRoute._addFileChildren(
    LayoutSettingsPanelQuotingTaxRatesRouteRouteChildren,
  )

interface LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdRouteRouteChildren {
  LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdDeleteRoute: typeof LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdDeleteRoute
  LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdIndexRoute: typeof LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdIndexRoute
}

const LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdRouteRouteChildren: LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdRouteRouteChildren =
  {
    LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdDeleteRoute:
      LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdDeleteRoute,
    LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdIndexRoute:
      LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdIndexRoute,
  }

const LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdRouteRouteWithChildren =
  LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdRouteRoute._addFileChildren(
    LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdRouteRouteChildren,
  )

interface LayoutSettingsPanelWorkspaceApprovalFlowsRouteRouteChildren {
  LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdRouteRoute: typeof LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdRouteRouteWithChildren
  LayoutSettingsPanelWorkspaceApprovalFlowsCreateRoute: typeof LayoutSettingsPanelWorkspaceApprovalFlowsCreateRoute
  LayoutSettingsPanelWorkspaceApprovalFlowsIndexRoute: typeof LayoutSettingsPanelWorkspaceApprovalFlowsIndexRoute
  LayoutSettingsPanelWorkspaceApprovalFlowsDuplicatePolicyIdRoute: typeof LayoutSettingsPanelWorkspaceApprovalFlowsDuplicatePolicyIdRoute
}

const LayoutSettingsPanelWorkspaceApprovalFlowsRouteRouteChildren: LayoutSettingsPanelWorkspaceApprovalFlowsRouteRouteChildren =
  {
    LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdRouteRoute:
      LayoutSettingsPanelWorkspaceApprovalFlowsPolicyIdRouteRouteWithChildren,
    LayoutSettingsPanelWorkspaceApprovalFlowsCreateRoute:
      LayoutSettingsPanelWorkspaceApprovalFlowsCreateRoute,
    LayoutSettingsPanelWorkspaceApprovalFlowsIndexRoute:
      LayoutSettingsPanelWorkspaceApprovalFlowsIndexRoute,
    LayoutSettingsPanelWorkspaceApprovalFlowsDuplicatePolicyIdRoute:
      LayoutSettingsPanelWorkspaceApprovalFlowsDuplicatePolicyIdRoute,
  }

const LayoutSettingsPanelWorkspaceApprovalFlowsRouteRouteWithChildren =
  LayoutSettingsPanelWorkspaceApprovalFlowsRouteRoute._addFileChildren(
    LayoutSettingsPanelWorkspaceApprovalFlowsRouteRouteChildren,
  )

interface LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdRouteRouteChildren {
  LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdDeleteRoute: typeof LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdDeleteRoute
  LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdIndexRoute: typeof LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdIndexRoute
  LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdPositionsPositionIdRemoveRoute: typeof LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdPositionsPositionIdRemoveRoute
}

const LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdRouteRouteChildren: LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdRouteRouteChildren =
  {
    LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdDeleteRoute:
      LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdDeleteRoute,
    LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdIndexRoute:
      LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdIndexRoute,
    LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdPositionsPositionIdRemoveRoute:
      LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdPositionsPositionIdRemoveRoute,
  }

const LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdRouteRouteWithChildren =
  LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdRouteRoute._addFileChildren(
    LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdRouteRouteChildren,
  )

interface LayoutSettingsPanelWorkspaceDepartmentsListRouteRouteChildren {
  LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdRouteRoute: typeof LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdRouteRouteWithChildren
  LayoutSettingsPanelWorkspaceDepartmentsListIndexRoute: typeof LayoutSettingsPanelWorkspaceDepartmentsListIndexRoute
}

const LayoutSettingsPanelWorkspaceDepartmentsListRouteRouteChildren: LayoutSettingsPanelWorkspaceDepartmentsListRouteRouteChildren =
  {
    LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdRouteRoute:
      LayoutSettingsPanelWorkspaceDepartmentsListDepartmentIdRouteRouteWithChildren,
    LayoutSettingsPanelWorkspaceDepartmentsListIndexRoute:
      LayoutSettingsPanelWorkspaceDepartmentsListIndexRoute,
  }

const LayoutSettingsPanelWorkspaceDepartmentsListRouteRouteWithChildren =
  LayoutSettingsPanelWorkspaceDepartmentsListRouteRoute._addFileChildren(
    LayoutSettingsPanelWorkspaceDepartmentsListRouteRouteChildren,
  )

interface LayoutSettingsPanelWorkspaceDepartmentsRouteRouteChildren {
  LayoutSettingsPanelWorkspaceDepartmentsListRouteRoute: typeof LayoutSettingsPanelWorkspaceDepartmentsListRouteRouteWithChildren
  LayoutSettingsPanelWorkspaceDepartmentsCreateRoute: typeof LayoutSettingsPanelWorkspaceDepartmentsCreateRoute
}

const LayoutSettingsPanelWorkspaceDepartmentsRouteRouteChildren: LayoutSettingsPanelWorkspaceDepartmentsRouteRouteChildren =
  {
    LayoutSettingsPanelWorkspaceDepartmentsListRouteRoute:
      LayoutSettingsPanelWorkspaceDepartmentsListRouteRouteWithChildren,
    LayoutSettingsPanelWorkspaceDepartmentsCreateRoute:
      LayoutSettingsPanelWorkspaceDepartmentsCreateRoute,
  }

const LayoutSettingsPanelWorkspaceDepartmentsRouteRouteWithChildren =
  LayoutSettingsPanelWorkspaceDepartmentsRouteRoute._addFileChildren(
    LayoutSettingsPanelWorkspaceDepartmentsRouteRouteChildren,
  )

interface LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdRouteRouteChildren {
  LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdDeleteRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdDeleteRoute
  LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdIndexRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdIndexRoute
  LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdLocationsLocationIdDeleteRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdLocationsLocationIdDeleteRoute
  LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdPositionsPositionIdRemoveRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdPositionsPositionIdRemoveRoute
}

const LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdRouteRouteChildren: LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdRouteRouteChildren =
  {
    LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdDeleteRoute:
      LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdDeleteRoute,
    LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdIndexRoute:
      LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdIndexRoute,
    LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdLocationsLocationIdDeleteRoute:
      LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdLocationsLocationIdDeleteRoute,
    LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdPositionsPositionIdRemoveRoute:
      LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdPositionsPositionIdRemoveRoute,
  }

const LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdRouteRouteWithChildren =
  LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdRouteRoute._addFileChildren(
    LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdRouteRouteChildren,
  )

interface LayoutSettingsPanelWorkspaceFacilitiesListRouteRouteChildren {
  LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdRouteRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdRouteRouteWithChildren
  LayoutSettingsPanelWorkspaceFacilitiesListIndexRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesListIndexRoute
}

const LayoutSettingsPanelWorkspaceFacilitiesListRouteRouteChildren: LayoutSettingsPanelWorkspaceFacilitiesListRouteRouteChildren =
  {
    LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdRouteRoute:
      LayoutSettingsPanelWorkspaceFacilitiesListFacilityIdRouteRouteWithChildren,
    LayoutSettingsPanelWorkspaceFacilitiesListIndexRoute:
      LayoutSettingsPanelWorkspaceFacilitiesListIndexRoute,
  }

const LayoutSettingsPanelWorkspaceFacilitiesListRouteRouteWithChildren =
  LayoutSettingsPanelWorkspaceFacilitiesListRouteRoute._addFileChildren(
    LayoutSettingsPanelWorkspaceFacilitiesListRouteRouteChildren,
  )

interface LayoutSettingsPanelWorkspaceFacilitiesRouteRouteChildren {
  LayoutSettingsPanelWorkspaceFacilitiesListRouteRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesListRouteRouteWithChildren
  LayoutSettingsPanelWorkspaceFacilitiesCreateRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesCreateRoute
}

const LayoutSettingsPanelWorkspaceFacilitiesRouteRouteChildren: LayoutSettingsPanelWorkspaceFacilitiesRouteRouteChildren =
  {
    LayoutSettingsPanelWorkspaceFacilitiesListRouteRoute:
      LayoutSettingsPanelWorkspaceFacilitiesListRouteRouteWithChildren,
    LayoutSettingsPanelWorkspaceFacilitiesCreateRoute:
      LayoutSettingsPanelWorkspaceFacilitiesCreateRoute,
  }

const LayoutSettingsPanelWorkspaceFacilitiesRouteRouteWithChildren =
  LayoutSettingsPanelWorkspaceFacilitiesRouteRoute._addFileChildren(
    LayoutSettingsPanelWorkspaceFacilitiesRouteRouteChildren,
  )

interface LayoutSettingsPanelWorkspaceMembersListUserIdRouteRouteChildren {
  LayoutSettingsPanelWorkspaceMembersListUserIdChangePasswordRoute: typeof LayoutSettingsPanelWorkspaceMembersListUserIdChangePasswordRoute
  LayoutSettingsPanelWorkspaceMembersListUserIdDeleteRoute: typeof LayoutSettingsPanelWorkspaceMembersListUserIdDeleteRoute
  LayoutSettingsPanelWorkspaceMembersListUserIdResendLoginEmailRoute: typeof LayoutSettingsPanelWorkspaceMembersListUserIdResendLoginEmailRoute
  LayoutSettingsPanelWorkspaceMembersListUserIdIndexRoute: typeof LayoutSettingsPanelWorkspaceMembersListUserIdIndexRoute
}

const LayoutSettingsPanelWorkspaceMembersListUserIdRouteRouteChildren: LayoutSettingsPanelWorkspaceMembersListUserIdRouteRouteChildren =
  {
    LayoutSettingsPanelWorkspaceMembersListUserIdChangePasswordRoute:
      LayoutSettingsPanelWorkspaceMembersListUserIdChangePasswordRoute,
    LayoutSettingsPanelWorkspaceMembersListUserIdDeleteRoute:
      LayoutSettingsPanelWorkspaceMembersListUserIdDeleteRoute,
    LayoutSettingsPanelWorkspaceMembersListUserIdResendLoginEmailRoute:
      LayoutSettingsPanelWorkspaceMembersListUserIdResendLoginEmailRoute,
    LayoutSettingsPanelWorkspaceMembersListUserIdIndexRoute:
      LayoutSettingsPanelWorkspaceMembersListUserIdIndexRoute,
  }

const LayoutSettingsPanelWorkspaceMembersListUserIdRouteRouteWithChildren =
  LayoutSettingsPanelWorkspaceMembersListUserIdRouteRoute._addFileChildren(
    LayoutSettingsPanelWorkspaceMembersListUserIdRouteRouteChildren,
  )

interface LayoutSettingsPanelWorkspaceMembersListRouteRouteChildren {
  LayoutSettingsPanelWorkspaceMembersListUserIdRouteRoute: typeof LayoutSettingsPanelWorkspaceMembersListUserIdRouteRouteWithChildren
  LayoutSettingsPanelWorkspaceMembersListIndexRoute: typeof LayoutSettingsPanelWorkspaceMembersListIndexRoute
}

const LayoutSettingsPanelWorkspaceMembersListRouteRouteChildren: LayoutSettingsPanelWorkspaceMembersListRouteRouteChildren =
  {
    LayoutSettingsPanelWorkspaceMembersListUserIdRouteRoute:
      LayoutSettingsPanelWorkspaceMembersListUserIdRouteRouteWithChildren,
    LayoutSettingsPanelWorkspaceMembersListIndexRoute:
      LayoutSettingsPanelWorkspaceMembersListIndexRoute,
  }

const LayoutSettingsPanelWorkspaceMembersListRouteRouteWithChildren =
  LayoutSettingsPanelWorkspaceMembersListRouteRoute._addFileChildren(
    LayoutSettingsPanelWorkspaceMembersListRouteRouteChildren,
  )

interface LayoutSettingsPanelWorkspaceMembersRouteRouteChildren {
  LayoutSettingsPanelWorkspaceMembersListRouteRoute: typeof LayoutSettingsPanelWorkspaceMembersListRouteRouteWithChildren
  LayoutSettingsPanelWorkspaceMembersCreateRoute: typeof LayoutSettingsPanelWorkspaceMembersCreateRoute
}

const LayoutSettingsPanelWorkspaceMembersRouteRouteChildren: LayoutSettingsPanelWorkspaceMembersRouteRouteChildren =
  {
    LayoutSettingsPanelWorkspaceMembersListRouteRoute:
      LayoutSettingsPanelWorkspaceMembersListRouteRouteWithChildren,
    LayoutSettingsPanelWorkspaceMembersCreateRoute:
      LayoutSettingsPanelWorkspaceMembersCreateRoute,
  }

const LayoutSettingsPanelWorkspaceMembersRouteRouteWithChildren =
  LayoutSettingsPanelWorkspaceMembersRouteRoute._addFileChildren(
    LayoutSettingsPanelWorkspaceMembersRouteRouteChildren,
  )

interface LayoutSettingsPanelWorkspaceNotificationRulesRuleIdRouteRouteChildren {
  LayoutSettingsPanelWorkspaceNotificationRulesRuleIdDeleteRoute: typeof LayoutSettingsPanelWorkspaceNotificationRulesRuleIdDeleteRoute
  LayoutSettingsPanelWorkspaceNotificationRulesRuleIdIndexRoute: typeof LayoutSettingsPanelWorkspaceNotificationRulesRuleIdIndexRoute
}

const LayoutSettingsPanelWorkspaceNotificationRulesRuleIdRouteRouteChildren: LayoutSettingsPanelWorkspaceNotificationRulesRuleIdRouteRouteChildren =
  {
    LayoutSettingsPanelWorkspaceNotificationRulesRuleIdDeleteRoute:
      LayoutSettingsPanelWorkspaceNotificationRulesRuleIdDeleteRoute,
    LayoutSettingsPanelWorkspaceNotificationRulesRuleIdIndexRoute:
      LayoutSettingsPanelWorkspaceNotificationRulesRuleIdIndexRoute,
  }

const LayoutSettingsPanelWorkspaceNotificationRulesRuleIdRouteRouteWithChildren =
  LayoutSettingsPanelWorkspaceNotificationRulesRuleIdRouteRoute._addFileChildren(
    LayoutSettingsPanelWorkspaceNotificationRulesRuleIdRouteRouteChildren,
  )

interface LayoutSettingsPanelWorkspaceNotificationRulesRouteRouteChildren {
  LayoutSettingsPanelWorkspaceNotificationRulesRuleIdRouteRoute: typeof LayoutSettingsPanelWorkspaceNotificationRulesRuleIdRouteRouteWithChildren
  LayoutSettingsPanelWorkspaceNotificationRulesCreateRoute: typeof LayoutSettingsPanelWorkspaceNotificationRulesCreateRoute
  LayoutSettingsPanelWorkspaceNotificationRulesIndexRoute: typeof LayoutSettingsPanelWorkspaceNotificationRulesIndexRoute
  LayoutSettingsPanelWorkspaceNotificationRulesDuplicateRuleIdRoute: typeof LayoutSettingsPanelWorkspaceNotificationRulesDuplicateRuleIdRoute
}

const LayoutSettingsPanelWorkspaceNotificationRulesRouteRouteChildren: LayoutSettingsPanelWorkspaceNotificationRulesRouteRouteChildren =
  {
    LayoutSettingsPanelWorkspaceNotificationRulesRuleIdRouteRoute:
      LayoutSettingsPanelWorkspaceNotificationRulesRuleIdRouteRouteWithChildren,
    LayoutSettingsPanelWorkspaceNotificationRulesCreateRoute:
      LayoutSettingsPanelWorkspaceNotificationRulesCreateRoute,
    LayoutSettingsPanelWorkspaceNotificationRulesIndexRoute:
      LayoutSettingsPanelWorkspaceNotificationRulesIndexRoute,
    LayoutSettingsPanelWorkspaceNotificationRulesDuplicateRuleIdRoute:
      LayoutSettingsPanelWorkspaceNotificationRulesDuplicateRuleIdRoute,
  }

const LayoutSettingsPanelWorkspaceNotificationRulesRouteRouteWithChildren =
  LayoutSettingsPanelWorkspaceNotificationRulesRouteRoute._addFileChildren(
    LayoutSettingsPanelWorkspaceNotificationRulesRouteRouteChildren,
  )

interface LayoutSettingsPanelWorkspaceRolesListRoleIdRouteRouteChildren {
  LayoutSettingsPanelWorkspaceRolesListRoleIdDeleteRoute: typeof LayoutSettingsPanelWorkspaceRolesListRoleIdDeleteRoute
  LayoutSettingsPanelWorkspaceRolesListRoleIdResetRoute: typeof LayoutSettingsPanelWorkspaceRolesListRoleIdResetRoute
  LayoutSettingsPanelWorkspaceRolesListRoleIdIndexRoute: typeof LayoutSettingsPanelWorkspaceRolesListRoleIdIndexRoute
}

const LayoutSettingsPanelWorkspaceRolesListRoleIdRouteRouteChildren: LayoutSettingsPanelWorkspaceRolesListRoleIdRouteRouteChildren =
  {
    LayoutSettingsPanelWorkspaceRolesListRoleIdDeleteRoute:
      LayoutSettingsPanelWorkspaceRolesListRoleIdDeleteRoute,
    LayoutSettingsPanelWorkspaceRolesListRoleIdResetRoute:
      LayoutSettingsPanelWorkspaceRolesListRoleIdResetRoute,
    LayoutSettingsPanelWorkspaceRolesListRoleIdIndexRoute:
      LayoutSettingsPanelWorkspaceRolesListRoleIdIndexRoute,
  }

const LayoutSettingsPanelWorkspaceRolesListRoleIdRouteRouteWithChildren =
  LayoutSettingsPanelWorkspaceRolesListRoleIdRouteRoute._addFileChildren(
    LayoutSettingsPanelWorkspaceRolesListRoleIdRouteRouteChildren,
  )

interface LayoutSettingsPanelWorkspaceRolesListRouteRouteChildren {
  LayoutSettingsPanelWorkspaceRolesListRoleIdRouteRoute: typeof LayoutSettingsPanelWorkspaceRolesListRoleIdRouteRouteWithChildren
  LayoutSettingsPanelWorkspaceRolesListIndexRoute: typeof LayoutSettingsPanelWorkspaceRolesListIndexRoute
}

const LayoutSettingsPanelWorkspaceRolesListRouteRouteChildren: LayoutSettingsPanelWorkspaceRolesListRouteRouteChildren =
  {
    LayoutSettingsPanelWorkspaceRolesListRoleIdRouteRoute:
      LayoutSettingsPanelWorkspaceRolesListRoleIdRouteRouteWithChildren,
    LayoutSettingsPanelWorkspaceRolesListIndexRoute:
      LayoutSettingsPanelWorkspaceRolesListIndexRoute,
  }

const LayoutSettingsPanelWorkspaceRolesListRouteRouteWithChildren =
  LayoutSettingsPanelWorkspaceRolesListRouteRoute._addFileChildren(
    LayoutSettingsPanelWorkspaceRolesListRouteRouteChildren,
  )

interface LayoutSettingsPanelWorkspaceRolesRouteRouteChildren {
  LayoutSettingsPanelWorkspaceRolesListRouteRoute: typeof LayoutSettingsPanelWorkspaceRolesListRouteRouteWithChildren
  LayoutSettingsPanelWorkspaceRolesCreateRoute: typeof LayoutSettingsPanelWorkspaceRolesCreateRoute
  LayoutSettingsPanelWorkspaceRolesDuplicateRoleIdRoute: typeof LayoutSettingsPanelWorkspaceRolesDuplicateRoleIdRoute
}

const LayoutSettingsPanelWorkspaceRolesRouteRouteChildren: LayoutSettingsPanelWorkspaceRolesRouteRouteChildren =
  {
    LayoutSettingsPanelWorkspaceRolesListRouteRoute:
      LayoutSettingsPanelWorkspaceRolesListRouteRouteWithChildren,
    LayoutSettingsPanelWorkspaceRolesCreateRoute:
      LayoutSettingsPanelWorkspaceRolesCreateRoute,
    LayoutSettingsPanelWorkspaceRolesDuplicateRoleIdRoute:
      LayoutSettingsPanelWorkspaceRolesDuplicateRoleIdRoute,
  }

const LayoutSettingsPanelWorkspaceRolesRouteRouteWithChildren =
  LayoutSettingsPanelWorkspaceRolesRouteRoute._addFileChildren(
    LayoutSettingsPanelWorkspaceRolesRouteRouteChildren,
  )

interface LayoutSettingsPanelWorkspaceTeamsListTeamIdRouteRouteChildren {
  LayoutSettingsPanelWorkspaceTeamsListTeamIdDeleteRoute: typeof LayoutSettingsPanelWorkspaceTeamsListTeamIdDeleteRoute
  LayoutSettingsPanelWorkspaceTeamsListTeamIdIndexRoute: typeof LayoutSettingsPanelWorkspaceTeamsListTeamIdIndexRoute
  LayoutSettingsPanelWorkspaceTeamsListTeamIdPositionsPositionIdRemoveRoute: typeof LayoutSettingsPanelWorkspaceTeamsListTeamIdPositionsPositionIdRemoveRoute
}

const LayoutSettingsPanelWorkspaceTeamsListTeamIdRouteRouteChildren: LayoutSettingsPanelWorkspaceTeamsListTeamIdRouteRouteChildren =
  {
    LayoutSettingsPanelWorkspaceTeamsListTeamIdDeleteRoute:
      LayoutSettingsPanelWorkspaceTeamsListTeamIdDeleteRoute,
    LayoutSettingsPanelWorkspaceTeamsListTeamIdIndexRoute:
      LayoutSettingsPanelWorkspaceTeamsListTeamIdIndexRoute,
    LayoutSettingsPanelWorkspaceTeamsListTeamIdPositionsPositionIdRemoveRoute:
      LayoutSettingsPanelWorkspaceTeamsListTeamIdPositionsPositionIdRemoveRoute,
  }

const LayoutSettingsPanelWorkspaceTeamsListTeamIdRouteRouteWithChildren =
  LayoutSettingsPanelWorkspaceTeamsListTeamIdRouteRoute._addFileChildren(
    LayoutSettingsPanelWorkspaceTeamsListTeamIdRouteRouteChildren,
  )

interface LayoutSettingsPanelWorkspaceTeamsListRouteRouteChildren {
  LayoutSettingsPanelWorkspaceTeamsListTeamIdRouteRoute: typeof LayoutSettingsPanelWorkspaceTeamsListTeamIdRouteRouteWithChildren
  LayoutSettingsPanelWorkspaceTeamsListIndexRoute: typeof LayoutSettingsPanelWorkspaceTeamsListIndexRoute
}

const LayoutSettingsPanelWorkspaceTeamsListRouteRouteChildren: LayoutSettingsPanelWorkspaceTeamsListRouteRouteChildren =
  {
    LayoutSettingsPanelWorkspaceTeamsListTeamIdRouteRoute:
      LayoutSettingsPanelWorkspaceTeamsListTeamIdRouteRouteWithChildren,
    LayoutSettingsPanelWorkspaceTeamsListIndexRoute:
      LayoutSettingsPanelWorkspaceTeamsListIndexRoute,
  }

const LayoutSettingsPanelWorkspaceTeamsListRouteRouteWithChildren =
  LayoutSettingsPanelWorkspaceTeamsListRouteRoute._addFileChildren(
    LayoutSettingsPanelWorkspaceTeamsListRouteRouteChildren,
  )

interface LayoutSettingsPanelWorkspaceTeamsRouteRouteChildren {
  LayoutSettingsPanelWorkspaceTeamsListRouteRoute: typeof LayoutSettingsPanelWorkspaceTeamsListRouteRouteWithChildren
  LayoutSettingsPanelWorkspaceTeamsCreateRoute: typeof LayoutSettingsPanelWorkspaceTeamsCreateRoute
}

const LayoutSettingsPanelWorkspaceTeamsRouteRouteChildren: LayoutSettingsPanelWorkspaceTeamsRouteRouteChildren =
  {
    LayoutSettingsPanelWorkspaceTeamsListRouteRoute:
      LayoutSettingsPanelWorkspaceTeamsListRouteRouteWithChildren,
    LayoutSettingsPanelWorkspaceTeamsCreateRoute:
      LayoutSettingsPanelWorkspaceTeamsCreateRoute,
  }

const LayoutSettingsPanelWorkspaceTeamsRouteRouteWithChildren =
  LayoutSettingsPanelWorkspaceTeamsRouteRoute._addFileChildren(
    LayoutSettingsPanelWorkspaceTeamsRouteRouteChildren,
  )

interface LayoutSettingsPanelWorkspaceTemplatesKindRouteRouteChildren {
  LayoutSettingsPanelWorkspaceTemplatesKindRevertRoute: typeof LayoutSettingsPanelWorkspaceTemplatesKindRevertRoute
  LayoutSettingsPanelWorkspaceTemplatesKindIndexRoute: typeof LayoutSettingsPanelWorkspaceTemplatesKindIndexRoute
}

const LayoutSettingsPanelWorkspaceTemplatesKindRouteRouteChildren: LayoutSettingsPanelWorkspaceTemplatesKindRouteRouteChildren =
  {
    LayoutSettingsPanelWorkspaceTemplatesKindRevertRoute:
      LayoutSettingsPanelWorkspaceTemplatesKindRevertRoute,
    LayoutSettingsPanelWorkspaceTemplatesKindIndexRoute:
      LayoutSettingsPanelWorkspaceTemplatesKindIndexRoute,
  }

const LayoutSettingsPanelWorkspaceTemplatesKindRouteRouteWithChildren =
  LayoutSettingsPanelWorkspaceTemplatesKindRouteRoute._addFileChildren(
    LayoutSettingsPanelWorkspaceTemplatesKindRouteRouteChildren,
  )

interface LayoutSettingsPanelWorkspaceTemplatesRouteRouteChildren {
  LayoutSettingsPanelWorkspaceTemplatesKindRouteRoute: typeof LayoutSettingsPanelWorkspaceTemplatesKindRouteRouteWithChildren
  LayoutSettingsPanelWorkspaceTemplatesIndexRoute: typeof LayoutSettingsPanelWorkspaceTemplatesIndexRoute
}

const LayoutSettingsPanelWorkspaceTemplatesRouteRouteChildren: LayoutSettingsPanelWorkspaceTemplatesRouteRouteChildren =
  {
    LayoutSettingsPanelWorkspaceTemplatesKindRouteRoute:
      LayoutSettingsPanelWorkspaceTemplatesKindRouteRouteWithChildren,
    LayoutSettingsPanelWorkspaceTemplatesIndexRoute:
      LayoutSettingsPanelWorkspaceTemplatesIndexRoute,
  }

const LayoutSettingsPanelWorkspaceTemplatesRouteRouteWithChildren =
  LayoutSettingsPanelWorkspaceTemplatesRouteRoute._addFileChildren(
    LayoutSettingsPanelWorkspaceTemplatesRouteRouteChildren,
  )

interface LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdRouteRouteChildren {
  LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdDeleteRoute: typeof LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdDeleteRoute
  LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdIndexRoute: typeof LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdIndexRoute
}

const LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdRouteRouteChildren: LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdRouteRouteChildren =
  {
    LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdDeleteRoute:
      LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdDeleteRoute,
    LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdIndexRoute:
      LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdIndexRoute,
  }

const LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdRouteRouteWithChildren =
  LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdRouteRoute._addFileChildren(
    LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdRouteRouteChildren,
  )

interface LayoutSettingsPanelWorkspaceToolCategoriesListRouteRouteChildren {
  LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdRouteRoute: typeof LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdRouteRouteWithChildren
  LayoutSettingsPanelWorkspaceToolCategoriesListIndexRoute: typeof LayoutSettingsPanelWorkspaceToolCategoriesListIndexRoute
}

const LayoutSettingsPanelWorkspaceToolCategoriesListRouteRouteChildren: LayoutSettingsPanelWorkspaceToolCategoriesListRouteRouteChildren =
  {
    LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdRouteRoute:
      LayoutSettingsPanelWorkspaceToolCategoriesListCategoryIdRouteRouteWithChildren,
    LayoutSettingsPanelWorkspaceToolCategoriesListIndexRoute:
      LayoutSettingsPanelWorkspaceToolCategoriesListIndexRoute,
  }

const LayoutSettingsPanelWorkspaceToolCategoriesListRouteRouteWithChildren =
  LayoutSettingsPanelWorkspaceToolCategoriesListRouteRoute._addFileChildren(
    LayoutSettingsPanelWorkspaceToolCategoriesListRouteRouteChildren,
  )

interface LayoutSettingsPanelWorkspaceToolCategoriesRouteRouteChildren {
  LayoutSettingsPanelWorkspaceToolCategoriesListRouteRoute: typeof LayoutSettingsPanelWorkspaceToolCategoriesListRouteRouteWithChildren
  LayoutSettingsPanelWorkspaceToolCategoriesCreateRoute: typeof LayoutSettingsPanelWorkspaceToolCategoriesCreateRoute
}

const LayoutSettingsPanelWorkspaceToolCategoriesRouteRouteChildren: LayoutSettingsPanelWorkspaceToolCategoriesRouteRouteChildren =
  {
    LayoutSettingsPanelWorkspaceToolCategoriesListRouteRoute:
      LayoutSettingsPanelWorkspaceToolCategoriesListRouteRouteWithChildren,
    LayoutSettingsPanelWorkspaceToolCategoriesCreateRoute:
      LayoutSettingsPanelWorkspaceToolCategoriesCreateRoute,
  }

const LayoutSettingsPanelWorkspaceToolCategoriesRouteRouteWithChildren =
  LayoutSettingsPanelWorkspaceToolCategoriesRouteRoute._addFileChildren(
    LayoutSettingsPanelWorkspaceToolCategoriesRouteRouteChildren,
  )

interface LayoutSettingsPanelRouteRouteChildren {
  LayoutSettingsPanelAccountProfileRouteRoute: typeof LayoutSettingsPanelAccountProfileRouteRouteWithChildren
  LayoutSettingsPanelIntegrationsErpRouteRoute: typeof LayoutSettingsPanelIntegrationsErpRouteRouteWithChildren
  LayoutSettingsPanelQuotingPlaybooksRouteRoute: typeof LayoutSettingsPanelQuotingPlaybooksRouteRouteWithChildren
  LayoutSettingsPanelQuotingRateCardsRouteRoute: typeof LayoutSettingsPanelQuotingRateCardsRouteRouteWithChildren
  LayoutSettingsPanelQuotingStatusRouteRoute: typeof LayoutSettingsPanelQuotingStatusRouteRouteWithChildren
  LayoutSettingsPanelQuotingTaskGroupsRouteRoute: typeof LayoutSettingsPanelQuotingTaskGroupsRouteRouteWithChildren
  LayoutSettingsPanelQuotingTaxRatesRouteRoute: typeof LayoutSettingsPanelQuotingTaxRatesRouteRouteWithChildren
  LayoutSettingsPanelWorkspaceApprovalFlowsRouteRoute: typeof LayoutSettingsPanelWorkspaceApprovalFlowsRouteRouteWithChildren
  LayoutSettingsPanelWorkspaceDepartmentsRouteRoute: typeof LayoutSettingsPanelWorkspaceDepartmentsRouteRouteWithChildren
  LayoutSettingsPanelWorkspaceFacilitiesRouteRoute: typeof LayoutSettingsPanelWorkspaceFacilitiesRouteRouteWithChildren
  LayoutSettingsPanelWorkspaceMembersRouteRoute: typeof LayoutSettingsPanelWorkspaceMembersRouteRouteWithChildren
  LayoutSettingsPanelWorkspaceNotificationRulesRouteRoute: typeof LayoutSettingsPanelWorkspaceNotificationRulesRouteRouteWithChildren
  LayoutSettingsPanelWorkspaceRolesRouteRoute: typeof LayoutSettingsPanelWorkspaceRolesRouteRouteWithChildren
  LayoutSettingsPanelWorkspaceTeamsRouteRoute: typeof LayoutSettingsPanelWorkspaceTeamsRouteRouteWithChildren
  LayoutSettingsPanelWorkspaceTemplatesRouteRoute: typeof LayoutSettingsPanelWorkspaceTemplatesRouteRouteWithChildren
  LayoutSettingsPanelWorkspaceToolCategoriesRouteRoute: typeof LayoutSettingsPanelWorkspaceToolCategoriesRouteRouteWithChildren
  LayoutSettingsPanelIntegrationsCrmRoute: typeof LayoutSettingsPanelIntegrationsCrmRoute
  LayoutSettingsPanelQuotingCustomerApprovalRoute: typeof LayoutSettingsPanelQuotingCustomerApprovalRoute
  LayoutSettingsPanelQuotingGeneralRoute: typeof LayoutSettingsPanelQuotingGeneralRoute
  LayoutSettingsPanelWorkOrdersGeneralRoute: typeof LayoutSettingsPanelWorkOrdersGeneralRoute
  LayoutSettingsPanelQuotingFlatRatesPackageIdRoute: typeof LayoutSettingsPanelQuotingFlatRatesPackageIdRoute
  LayoutSettingsPanelAccountNotificationsIndexRoute: typeof LayoutSettingsPanelAccountNotificationsIndexRoute
  LayoutSettingsPanelAccountSigningPinIndexRoute: typeof LayoutSettingsPanelAccountSigningPinIndexRoute
  LayoutSettingsPanelQuotingFlatRatesIndexRoute: typeof LayoutSettingsPanelQuotingFlatRatesIndexRoute
  LayoutSettingsPanelWorkspaceGeneralIndexRoute: typeof LayoutSettingsPanelWorkspaceGeneralIndexRoute
}

const LayoutSettingsPanelRouteRouteChildren: LayoutSettingsPanelRouteRouteChildren =
  {
    LayoutSettingsPanelAccountProfileRouteRoute:
      LayoutSettingsPanelAccountProfileRouteRouteWithChildren,
    LayoutSettingsPanelIntegrationsErpRouteRoute:
      LayoutSettingsPanelIntegrationsErpRouteRouteWithChildren,
    LayoutSettingsPanelQuotingPlaybooksRouteRoute:
      LayoutSettingsPanelQuotingPlaybooksRouteRouteWithChildren,
    LayoutSettingsPanelQuotingRateCardsRouteRoute:
      LayoutSettingsPanelQuotingRateCardsRouteRouteWithChildren,
    LayoutSettingsPanelQuotingStatusRouteRoute:
      LayoutSettingsPanelQuotingStatusRouteRouteWithChildren,
    LayoutSettingsPanelQuotingTaskGroupsRouteRoute:
      LayoutSettingsPanelQuotingTaskGroupsRouteRouteWithChildren,
    LayoutSettingsPanelQuotingTaxRatesRouteRoute:
      LayoutSettingsPanelQuotingTaxRatesRouteRouteWithChildren,
    LayoutSettingsPanelWorkspaceApprovalFlowsRouteRoute:
      LayoutSettingsPanelWorkspaceApprovalFlowsRouteRouteWithChildren,
    LayoutSettingsPanelWorkspaceDepartmentsRouteRoute:
      LayoutSettingsPanelWorkspaceDepartmentsRouteRouteWithChildren,
    LayoutSettingsPanelWorkspaceFacilitiesRouteRoute:
      LayoutSettingsPanelWorkspaceFacilitiesRouteRouteWithChildren,
    LayoutSettingsPanelWorkspaceMembersRouteRoute:
      LayoutSettingsPanelWorkspaceMembersRouteRouteWithChildren,
    LayoutSettingsPanelWorkspaceNotificationRulesRouteRoute:
      LayoutSettingsPanelWorkspaceNotificationRulesRouteRouteWithChildren,
    LayoutSettingsPanelWorkspaceRolesRouteRoute:
      LayoutSettingsPanelWorkspaceRolesRouteRouteWithChildren,
    LayoutSettingsPanelWorkspaceTeamsRouteRoute:
      LayoutSettingsPanelWorkspaceTeamsRouteRouteWithChildren,
    LayoutSettingsPanelWorkspaceTemplatesRouteRoute:
      LayoutSettingsPanelWorkspaceTemplatesRouteRouteWithChildren,
    LayoutSettingsPanelWorkspaceToolCategoriesRouteRoute:
      LayoutSettingsPanelWorkspaceToolCategoriesRouteRouteWithChildren,
    LayoutSettingsPanelIntegrationsCrmRoute:
      LayoutSettingsPanelIntegrationsCrmRoute,
    LayoutSettingsPanelQuotingCustomerApprovalRoute:
      LayoutSettingsPanelQuotingCustomerApprovalRoute,
    LayoutSettingsPanelQuotingGeneralRoute:
      LayoutSettingsPanelQuotingGeneralRoute,
    LayoutSettingsPanelWorkOrdersGeneralRoute:
      LayoutSettingsPanelWorkOrdersGeneralRoute,
    LayoutSettingsPanelQuotingFlatRatesPackageIdRoute:
      LayoutSettingsPanelQuotingFlatRatesPackageIdRoute,
    LayoutSettingsPanelAccountNotificationsIndexRoute:
      LayoutSettingsPanelAccountNotificationsIndexRoute,
    LayoutSettingsPanelAccountSigningPinIndexRoute:
      LayoutSettingsPanelAccountSigningPinIndexRoute,
    LayoutSettingsPanelQuotingFlatRatesIndexRoute:
      LayoutSettingsPanelQuotingFlatRatesIndexRoute,
    LayoutSettingsPanelWorkspaceGeneralIndexRoute:
      LayoutSettingsPanelWorkspaceGeneralIndexRoute,
  }

const LayoutSettingsPanelRouteRouteWithChildren =
  LayoutSettingsPanelRouteRoute._addFileChildren(
    LayoutSettingsPanelRouteRouteChildren,
  )

interface LayoutSettingsSystemTenantsTenantIdSettingsRouteRouteChildren {
  LayoutSettingsSystemTenantsTenantIdSettingsReindexRoute: typeof LayoutSettingsSystemTenantsTenantIdSettingsReindexRoute
  LayoutSettingsSystemTenantsTenantIdSettingsIndexRoute: typeof LayoutSettingsSystemTenantsTenantIdSettingsIndexRoute
}

const LayoutSettingsSystemTenantsTenantIdSettingsRouteRouteChildren: LayoutSettingsSystemTenantsTenantIdSettingsRouteRouteChildren =
  {
    LayoutSettingsSystemTenantsTenantIdSettingsReindexRoute:
      LayoutSettingsSystemTenantsTenantIdSettingsReindexRoute,
    LayoutSettingsSystemTenantsTenantIdSettingsIndexRoute:
      LayoutSettingsSystemTenantsTenantIdSettingsIndexRoute,
  }

const LayoutSettingsSystemTenantsTenantIdSettingsRouteRouteWithChildren =
  LayoutSettingsSystemTenantsTenantIdSettingsRouteRoute._addFileChildren(
    LayoutSettingsSystemTenantsTenantIdSettingsRouteRouteChildren,
  )

interface LayoutSettingsSystemTenantsTenantIdRouteRouteChildren {
  LayoutSettingsSystemTenantsTenantIdSettingsRouteRoute: typeof LayoutSettingsSystemTenantsTenantIdSettingsRouteRouteWithChildren
  LayoutSettingsSystemTenantsTenantIdApprovalPoliciesRoute: typeof LayoutSettingsSystemTenantsTenantIdApprovalPoliciesRoute
  LayoutSettingsSystemTenantsTenantIdIntegrationsRoute: typeof LayoutSettingsSystemTenantsTenantIdIntegrationsRoute
  LayoutSettingsSystemTenantsTenantIdNotificationRulesRoute: typeof LayoutSettingsSystemTenantsTenantIdNotificationRulesRoute
  LayoutSettingsSystemTenantsTenantIdUsersRoute: typeof LayoutSettingsSystemTenantsTenantIdUsersRoute
  LayoutSettingsSystemTenantsTenantIdIndexRoute: typeof LayoutSettingsSystemTenantsTenantIdIndexRoute
}

const LayoutSettingsSystemTenantsTenantIdRouteRouteChildren: LayoutSettingsSystemTenantsTenantIdRouteRouteChildren =
  {
    LayoutSettingsSystemTenantsTenantIdSettingsRouteRoute:
      LayoutSettingsSystemTenantsTenantIdSettingsRouteRouteWithChildren,
    LayoutSettingsSystemTenantsTenantIdApprovalPoliciesRoute:
      LayoutSettingsSystemTenantsTenantIdApprovalPoliciesRoute,
    LayoutSettingsSystemTenantsTenantIdIntegrationsRoute:
      LayoutSettingsSystemTenantsTenantIdIntegrationsRoute,
    LayoutSettingsSystemTenantsTenantIdNotificationRulesRoute:
      LayoutSettingsSystemTenantsTenantIdNotificationRulesRoute,
    LayoutSettingsSystemTenantsTenantIdUsersRoute:
      LayoutSettingsSystemTenantsTenantIdUsersRoute,
    LayoutSettingsSystemTenantsTenantIdIndexRoute:
      LayoutSettingsSystemTenantsTenantIdIndexRoute,
  }

const LayoutSettingsSystemTenantsTenantIdRouteRouteWithChildren =
  LayoutSettingsSystemTenantsTenantIdRouteRoute._addFileChildren(
    LayoutSettingsSystemTenantsTenantIdRouteRouteChildren,
  )

interface LayoutSettingsRouteRouteChildren {
  LayoutSettingsPanelRouteRoute: typeof LayoutSettingsPanelRouteRouteWithChildren
  LayoutSettingsCompanyRoute: typeof LayoutSettingsCompanyRoute
  LayoutSettingsSystemRoute: typeof LayoutSettingsSystemRoute
  LayoutSettingsUserRoute: typeof LayoutSettingsUserRoute
  LayoutSettingsIndexRoute: typeof LayoutSettingsIndexRoute
  LayoutSettingsSystemTenantsTenantIdRouteRoute: typeof LayoutSettingsSystemTenantsTenantIdRouteRouteWithChildren
  LayoutSettingsSystemAuditLogIndexRoute: typeof LayoutSettingsSystemAuditLogIndexRoute
}

const LayoutSettingsRouteRouteChildren: LayoutSettingsRouteRouteChildren = {
  LayoutSettingsPanelRouteRoute: LayoutSettingsPanelRouteRouteWithChildren,
  LayoutSettingsCompanyRoute: LayoutSettingsCompanyRoute,
  LayoutSettingsSystemRoute: LayoutSettingsSystemRoute,
  LayoutSettingsUserRoute: LayoutSettingsUserRoute,
  LayoutSettingsIndexRoute: LayoutSettingsIndexRoute,
  LayoutSettingsSystemTenantsTenantIdRouteRoute:
    LayoutSettingsSystemTenantsTenantIdRouteRouteWithChildren,
  LayoutSettingsSystemAuditLogIndexRoute:
    LayoutSettingsSystemAuditLogIndexRoute,
}

const LayoutSettingsRouteRouteWithChildren =
  LayoutSettingsRouteRoute._addFileChildren(LayoutSettingsRouteRouteChildren)

interface LayoutTechLogsRouteRouteChildren {
  LayoutTechLogsPageIdRoute: typeof LayoutTechLogsPageIdRoute
  LayoutTechLogsNewRoute: typeof LayoutTechLogsNewRoute
  LayoutTechLogsIndexRoute: typeof LayoutTechLogsIndexRoute
  LayoutTechLogsDeletePageIdRoute: typeof LayoutTechLogsDeletePageIdRoute
}

const LayoutTechLogsRouteRouteChildren: LayoutTechLogsRouteRouteChildren = {
  LayoutTechLogsPageIdRoute: LayoutTechLogsPageIdRoute,
  LayoutTechLogsNewRoute: LayoutTechLogsNewRoute,
  LayoutTechLogsIndexRoute: LayoutTechLogsIndexRoute,
  LayoutTechLogsDeletePageIdRoute: LayoutTechLogsDeletePageIdRoute,
}

const LayoutTechLogsRouteRouteWithChildren =
  LayoutTechLogsRouteRoute._addFileChildren(LayoutTechLogsRouteRouteChildren)

interface LayoutTemplatesQuotesRouteRouteChildren {
  LayoutTemplatesQuotesDeleteRoute: typeof LayoutTemplatesQuotesDeleteRoute
  LayoutTemplatesQuotesIndexRoute: typeof LayoutTemplatesQuotesIndexRoute
}

const LayoutTemplatesQuotesRouteRouteChildren: LayoutTemplatesQuotesRouteRouteChildren =
  {
    LayoutTemplatesQuotesDeleteRoute: LayoutTemplatesQuotesDeleteRoute,
    LayoutTemplatesQuotesIndexRoute: LayoutTemplatesQuotesIndexRoute,
  }

const LayoutTemplatesQuotesRouteRouteWithChildren =
  LayoutTemplatesQuotesRouteRoute._addFileChildren(
    LayoutTemplatesQuotesRouteRouteChildren,
  )

interface LayoutTemplatesTasksTaskIdRouteRouteChildren {
  LayoutTemplatesTasksTaskIdArchiveRoute: typeof LayoutTemplatesTasksTaskIdArchiveRoute
  LayoutTemplatesTasksTaskIdIndexRoute: typeof LayoutTemplatesTasksTaskIdIndexRoute
}

const LayoutTemplatesTasksTaskIdRouteRouteChildren: LayoutTemplatesTasksTaskIdRouteRouteChildren =
  {
    LayoutTemplatesTasksTaskIdArchiveRoute:
      LayoutTemplatesTasksTaskIdArchiveRoute,
    LayoutTemplatesTasksTaskIdIndexRoute: LayoutTemplatesTasksTaskIdIndexRoute,
  }

const LayoutTemplatesTasksTaskIdRouteRouteWithChildren =
  LayoutTemplatesTasksTaskIdRouteRoute._addFileChildren(
    LayoutTemplatesTasksTaskIdRouteRouteChildren,
  )

interface LayoutTemplatesTasksRouteRouteChildren {
  LayoutTemplatesTasksTaskIdRouteRoute: typeof LayoutTemplatesTasksTaskIdRouteRouteWithChildren
  LayoutTemplatesTasksCreateRoute: typeof LayoutTemplatesTasksCreateRoute
  LayoutTemplatesTasksDeleteRoute: typeof LayoutTemplatesTasksDeleteRoute
  LayoutTemplatesTasksIndexRoute: typeof LayoutTemplatesTasksIndexRoute
}

const LayoutTemplatesTasksRouteRouteChildren: LayoutTemplatesTasksRouteRouteChildren =
  {
    LayoutTemplatesTasksTaskIdRouteRoute:
      LayoutTemplatesTasksTaskIdRouteRouteWithChildren,
    LayoutTemplatesTasksCreateRoute: LayoutTemplatesTasksCreateRoute,
    LayoutTemplatesTasksDeleteRoute: LayoutTemplatesTasksDeleteRoute,
    LayoutTemplatesTasksIndexRoute: LayoutTemplatesTasksIndexRoute,
  }

const LayoutTemplatesTasksRouteRouteWithChildren =
  LayoutTemplatesTasksRouteRoute._addFileChildren(
    LayoutTemplatesTasksRouteRouteChildren,
  )

interface LayoutTemplatesQuotesPackageIdListTasksTaskIdRouteRouteChildren {
  LayoutTemplatesQuotesPackageIdListTasksTaskIdArchiveRoute: typeof LayoutTemplatesQuotesPackageIdListTasksTaskIdArchiveRoute
  LayoutTemplatesQuotesPackageIdListTasksTaskIdIndexRoute: typeof LayoutTemplatesQuotesPackageIdListTasksTaskIdIndexRoute
}

const LayoutTemplatesQuotesPackageIdListTasksTaskIdRouteRouteChildren: LayoutTemplatesQuotesPackageIdListTasksTaskIdRouteRouteChildren =
  {
    LayoutTemplatesQuotesPackageIdListTasksTaskIdArchiveRoute:
      LayoutTemplatesQuotesPackageIdListTasksTaskIdArchiveRoute,
    LayoutTemplatesQuotesPackageIdListTasksTaskIdIndexRoute:
      LayoutTemplatesQuotesPackageIdListTasksTaskIdIndexRoute,
  }

const LayoutTemplatesQuotesPackageIdListTasksTaskIdRouteRouteWithChildren =
  LayoutTemplatesQuotesPackageIdListTasksTaskIdRouteRoute._addFileChildren(
    LayoutTemplatesQuotesPackageIdListTasksTaskIdRouteRouteChildren,
  )

interface LayoutTemplatesQuotesPackageIdListRouteRouteChildren {
  LayoutTemplatesQuotesPackageIdListIndexRoute: typeof LayoutTemplatesQuotesPackageIdListIndexRoute
  LayoutTemplatesQuotesPackageIdListTasksTaskIdRouteRoute: typeof LayoutTemplatesQuotesPackageIdListTasksTaskIdRouteRouteWithChildren
  LayoutTemplatesQuotesPackageIdListTasksCreateRoute: typeof LayoutTemplatesQuotesPackageIdListTasksCreateRoute
}

const LayoutTemplatesQuotesPackageIdListRouteRouteChildren: LayoutTemplatesQuotesPackageIdListRouteRouteChildren =
  {
    LayoutTemplatesQuotesPackageIdListIndexRoute:
      LayoutTemplatesQuotesPackageIdListIndexRoute,
    LayoutTemplatesQuotesPackageIdListTasksTaskIdRouteRoute:
      LayoutTemplatesQuotesPackageIdListTasksTaskIdRouteRouteWithChildren,
    LayoutTemplatesQuotesPackageIdListTasksCreateRoute:
      LayoutTemplatesQuotesPackageIdListTasksCreateRoute,
  }

const LayoutTemplatesQuotesPackageIdListRouteRouteWithChildren =
  LayoutTemplatesQuotesPackageIdListRouteRoute._addFileChildren(
    LayoutTemplatesQuotesPackageIdListRouteRouteChildren,
  )

interface LayoutTemplatesQuotesPackageIdOverviewRouteRouteChildren {
  LayoutTemplatesQuotesPackageIdOverviewArchiveRoute: typeof LayoutTemplatesQuotesPackageIdOverviewArchiveRoute
  LayoutTemplatesQuotesPackageIdOverviewIndexRoute: typeof LayoutTemplatesQuotesPackageIdOverviewIndexRoute
}

const LayoutTemplatesQuotesPackageIdOverviewRouteRouteChildren: LayoutTemplatesQuotesPackageIdOverviewRouteRouteChildren =
  {
    LayoutTemplatesQuotesPackageIdOverviewArchiveRoute:
      LayoutTemplatesQuotesPackageIdOverviewArchiveRoute,
    LayoutTemplatesQuotesPackageIdOverviewIndexRoute:
      LayoutTemplatesQuotesPackageIdOverviewIndexRoute,
  }

const LayoutTemplatesQuotesPackageIdOverviewRouteRouteWithChildren =
  LayoutTemplatesQuotesPackageIdOverviewRouteRoute._addFileChildren(
    LayoutTemplatesQuotesPackageIdOverviewRouteRouteChildren,
  )

interface LayoutTemplatesQuotesPackageIdRouteRouteChildren {
  LayoutTemplatesQuotesPackageIdListRouteRoute: typeof LayoutTemplatesQuotesPackageIdListRouteRouteWithChildren
  LayoutTemplatesQuotesPackageIdOverviewRouteRoute: typeof LayoutTemplatesQuotesPackageIdOverviewRouteRouteWithChildren
}

const LayoutTemplatesQuotesPackageIdRouteRouteChildren: LayoutTemplatesQuotesPackageIdRouteRouteChildren =
  {
    LayoutTemplatesQuotesPackageIdListRouteRoute:
      LayoutTemplatesQuotesPackageIdListRouteRouteWithChildren,
    LayoutTemplatesQuotesPackageIdOverviewRouteRoute:
      LayoutTemplatesQuotesPackageIdOverviewRouteRouteWithChildren,
  }

const LayoutTemplatesQuotesPackageIdRouteRouteWithChildren =
  LayoutTemplatesQuotesPackageIdRouteRoute._addFileChildren(
    LayoutTemplatesQuotesPackageIdRouteRouteChildren,
  )

interface LayoutTemplatesRouteRouteChildren {
  LayoutTemplatesQuotesRouteRoute: typeof LayoutTemplatesQuotesRouteRouteWithChildren
  LayoutTemplatesTasksRouteRoute: typeof LayoutTemplatesTasksRouteRouteWithChildren
  LayoutTemplatesIndexRoute: typeof LayoutTemplatesIndexRoute
  LayoutTemplatesQuotesPackageIdRouteRoute: typeof LayoutTemplatesQuotesPackageIdRouteRouteWithChildren
}

const LayoutTemplatesRouteRouteChildren: LayoutTemplatesRouteRouteChildren = {
  LayoutTemplatesQuotesRouteRoute: LayoutTemplatesQuotesRouteRouteWithChildren,
  LayoutTemplatesTasksRouteRoute: LayoutTemplatesTasksRouteRouteWithChildren,
  LayoutTemplatesIndexRoute: LayoutTemplatesIndexRoute,
  LayoutTemplatesQuotesPackageIdRouteRoute:
    LayoutTemplatesQuotesPackageIdRouteRouteWithChildren,
}

const LayoutTemplatesRouteRouteWithChildren =
  LayoutTemplatesRouteRoute._addFileChildren(LayoutTemplatesRouteRouteChildren)

interface LayoutTimesheetRouteRouteChildren {
  LayoutTimesheetLogRoute: typeof LayoutTimesheetLogRoute
  LayoutTimesheetIndexRoute: typeof LayoutTimesheetIndexRoute
  LayoutTimesheetDeleteTimeEntryIdRoute: typeof LayoutTimesheetDeleteTimeEntryIdRoute
}

const LayoutTimesheetRouteRouteChildren: LayoutTimesheetRouteRouteChildren = {
  LayoutTimesheetLogRoute: LayoutTimesheetLogRoute,
  LayoutTimesheetIndexRoute: LayoutTimesheetIndexRoute,
  LayoutTimesheetDeleteTimeEntryIdRoute: LayoutTimesheetDeleteTimeEntryIdRoute,
}

const LayoutTimesheetRouteRouteWithChildren =
  LayoutTimesheetRouteRoute._addFileChildren(LayoutTimesheetRouteRouteChildren)

interface LayoutToolsToolIdRouteRouteChildren {
  LayoutToolsToolIdIssueRoute: typeof LayoutToolsToolIdIssueRoute
  LayoutToolsToolIdLabelRoute: typeof LayoutToolsToolIdLabelRoute
  LayoutToolsToolIdRetireRoute: typeof LayoutToolsToolIdRetireRoute
  LayoutToolsToolIdIndexRoute: typeof LayoutToolsToolIdIndexRoute
  LayoutToolsToolIdCalibrationsRecordRoute: typeof LayoutToolsToolIdCalibrationsRecordRoute
  LayoutToolsToolIdCalibrationsSendRoute: typeof LayoutToolsToolIdCalibrationsSendRoute
  LayoutToolsToolIdCalibrationsCalibrationIdCompleteRoute: typeof LayoutToolsToolIdCalibrationsCalibrationIdCompleteRoute
  LayoutToolsToolIdLoansLoanIdReceiveRoute: typeof LayoutToolsToolIdLoansLoanIdReceiveRoute
}

const LayoutToolsToolIdRouteRouteChildren: LayoutToolsToolIdRouteRouteChildren =
  {
    LayoutToolsToolIdIssueRoute: LayoutToolsToolIdIssueRoute,
    LayoutToolsToolIdLabelRoute: LayoutToolsToolIdLabelRoute,
    LayoutToolsToolIdRetireRoute: LayoutToolsToolIdRetireRoute,
    LayoutToolsToolIdIndexRoute: LayoutToolsToolIdIndexRoute,
    LayoutToolsToolIdCalibrationsRecordRoute:
      LayoutToolsToolIdCalibrationsRecordRoute,
    LayoutToolsToolIdCalibrationsSendRoute:
      LayoutToolsToolIdCalibrationsSendRoute,
    LayoutToolsToolIdCalibrationsCalibrationIdCompleteRoute:
      LayoutToolsToolIdCalibrationsCalibrationIdCompleteRoute,
    LayoutToolsToolIdLoansLoanIdReceiveRoute:
      LayoutToolsToolIdLoansLoanIdReceiveRoute,
  }

const LayoutToolsToolIdRouteRouteWithChildren =
  LayoutToolsToolIdRouteRoute._addFileChildren(
    LayoutToolsToolIdRouteRouteChildren,
  )

interface LayoutToolsRouteRouteChildren {
  LayoutToolsToolIdRouteRoute: typeof LayoutToolsToolIdRouteRouteWithChildren
  LayoutToolsNewRoute: typeof LayoutToolsNewRoute
  LayoutToolsIndexRoute: typeof LayoutToolsIndexRoute
}

const LayoutToolsRouteRouteChildren: LayoutToolsRouteRouteChildren = {
  LayoutToolsToolIdRouteRoute: LayoutToolsToolIdRouteRouteWithChildren,
  LayoutToolsNewRoute: LayoutToolsNewRoute,
  LayoutToolsIndexRoute: LayoutToolsIndexRoute,
}

const LayoutToolsRouteRouteWithChildren =
  LayoutToolsRouteRoute._addFileChildren(LayoutToolsRouteRouteChildren)

interface LayoutAircraftAircraftIdRouteRouteChildren {
  LayoutAircraftAircraftIdIndexRoute: typeof LayoutAircraftAircraftIdIndexRoute
  LayoutAircraftAircraftIdFittedComponentsNewRoute: typeof LayoutAircraftAircraftIdFittedComponentsNewRoute
  LayoutAircraftAircraftIdModStatusNewRoute: typeof LayoutAircraftAircraftIdModStatusNewRoute
  LayoutAircraftAircraftIdReadingsNewRoute: typeof LayoutAircraftAircraftIdReadingsNewRoute
  LayoutAircraftAircraftIdTechLogPageIdRoute: typeof LayoutAircraftAircraftIdTechLogPageIdRoute
  LayoutAircraftAircraftIdTechLogNewRoute: typeof LayoutAircraftAircraftIdTechLogNewRoute
  LayoutAircraftAircraftIdFittedComponentsRemoveComponentIdRoute: typeof LayoutAircraftAircraftIdFittedComponentsRemoveComponentIdRoute
  LayoutAircraftAircraftIdTechLogVoidPageIdRoute: typeof LayoutAircraftAircraftIdTechLogVoidPageIdRoute
  LayoutAircraftAircraftIdPartInstancesPartInstanceIdReadingsNewRoute: typeof LayoutAircraftAircraftIdPartInstancesPartInstanceIdReadingsNewRoute
  LayoutAircraftAircraftIdPartInstancesPartInstanceIdReadingsReadingIdDeleteRoute: typeof LayoutAircraftAircraftIdPartInstancesPartInstanceIdReadingsReadingIdDeleteRoute
}

const LayoutAircraftAircraftIdRouteRouteChildren: LayoutAircraftAircraftIdRouteRouteChildren =
  {
    LayoutAircraftAircraftIdIndexRoute: LayoutAircraftAircraftIdIndexRoute,
    LayoutAircraftAircraftIdFittedComponentsNewRoute:
      LayoutAircraftAircraftIdFittedComponentsNewRoute,
    LayoutAircraftAircraftIdModStatusNewRoute:
      LayoutAircraftAircraftIdModStatusNewRoute,
    LayoutAircraftAircraftIdReadingsNewRoute:
      LayoutAircraftAircraftIdReadingsNewRoute,
    LayoutAircraftAircraftIdTechLogPageIdRoute:
      LayoutAircraftAircraftIdTechLogPageIdRoute,
    LayoutAircraftAircraftIdTechLogNewRoute:
      LayoutAircraftAircraftIdTechLogNewRoute,
    LayoutAircraftAircraftIdFittedComponentsRemoveComponentIdRoute:
      LayoutAircraftAircraftIdFittedComponentsRemoveComponentIdRoute,
    LayoutAircraftAircraftIdTechLogVoidPageIdRoute:
      LayoutAircraftAircraftIdTechLogVoidPageIdRoute,
    LayoutAircraftAircraftIdPartInstancesPartInstanceIdReadingsNewRoute:
      LayoutAircraftAircraftIdPartInstancesPartInstanceIdReadingsNewRoute,
    LayoutAircraftAircraftIdPartInstancesPartInstanceIdReadingsReadingIdDeleteRoute:
      LayoutAircraftAircraftIdPartInstancesPartInstanceIdReadingsReadingIdDeleteRoute,
  }

const LayoutAircraftAircraftIdRouteRouteWithChildren =
  LayoutAircraftAircraftIdRouteRoute._addFileChildren(
    LayoutAircraftAircraftIdRouteRouteChildren,
  )

interface LayoutCustomerCustomerIdContactsListContactIdRouteRouteChildren {
  LayoutCustomerCustomerIdContactsListContactIdDeleteRoute: typeof LayoutCustomerCustomerIdContactsListContactIdDeleteRoute
  LayoutCustomerCustomerIdContactsListContactIdIndexRoute: typeof LayoutCustomerCustomerIdContactsListContactIdIndexRoute
}

const LayoutCustomerCustomerIdContactsListContactIdRouteRouteChildren: LayoutCustomerCustomerIdContactsListContactIdRouteRouteChildren =
  {
    LayoutCustomerCustomerIdContactsListContactIdDeleteRoute:
      LayoutCustomerCustomerIdContactsListContactIdDeleteRoute,
    LayoutCustomerCustomerIdContactsListContactIdIndexRoute:
      LayoutCustomerCustomerIdContactsListContactIdIndexRoute,
  }

const LayoutCustomerCustomerIdContactsListContactIdRouteRouteWithChildren =
  LayoutCustomerCustomerIdContactsListContactIdRouteRoute._addFileChildren(
    LayoutCustomerCustomerIdContactsListContactIdRouteRouteChildren,
  )

interface LayoutCustomerCustomerIdContactsListRouteRouteChildren {
  LayoutCustomerCustomerIdContactsListContactIdRouteRoute: typeof LayoutCustomerCustomerIdContactsListContactIdRouteRouteWithChildren
  LayoutCustomerCustomerIdContactsListIndexRoute: typeof LayoutCustomerCustomerIdContactsListIndexRoute
}

const LayoutCustomerCustomerIdContactsListRouteRouteChildren: LayoutCustomerCustomerIdContactsListRouteRouteChildren =
  {
    LayoutCustomerCustomerIdContactsListContactIdRouteRoute:
      LayoutCustomerCustomerIdContactsListContactIdRouteRouteWithChildren,
    LayoutCustomerCustomerIdContactsListIndexRoute:
      LayoutCustomerCustomerIdContactsListIndexRoute,
  }

const LayoutCustomerCustomerIdContactsListRouteRouteWithChildren =
  LayoutCustomerCustomerIdContactsListRouteRoute._addFileChildren(
    LayoutCustomerCustomerIdContactsListRouteRouteChildren,
  )

interface LayoutCustomerCustomerIdContactsRouteRouteChildren {
  LayoutCustomerCustomerIdContactsListRouteRoute: typeof LayoutCustomerCustomerIdContactsListRouteRouteWithChildren
  LayoutCustomerCustomerIdContactsCreateRoute: typeof LayoutCustomerCustomerIdContactsCreateRoute
}

const LayoutCustomerCustomerIdContactsRouteRouteChildren: LayoutCustomerCustomerIdContactsRouteRouteChildren =
  {
    LayoutCustomerCustomerIdContactsListRouteRoute:
      LayoutCustomerCustomerIdContactsListRouteRouteWithChildren,
    LayoutCustomerCustomerIdContactsCreateRoute:
      LayoutCustomerCustomerIdContactsCreateRoute,
  }

const LayoutCustomerCustomerIdContactsRouteRouteWithChildren =
  LayoutCustomerCustomerIdContactsRouteRoute._addFileChildren(
    LayoutCustomerCustomerIdContactsRouteRouteChildren,
  )

interface LayoutCustomerCustomerIdRouteRouteChildren {
  LayoutCustomerCustomerIdContactsRouteRoute: typeof LayoutCustomerCustomerIdContactsRouteRouteWithChildren
  LayoutCustomerCustomerIdAircraftRoute: typeof LayoutCustomerCustomerIdAircraftRoute
  LayoutCustomerCustomerIdDeleteRoute: typeof LayoutCustomerCustomerIdDeleteRoute
  LayoutCustomerCustomerIdWoHistoryRoute: typeof LayoutCustomerCustomerIdWoHistoryRoute
  LayoutCustomerCustomerIdIndexRoute: typeof LayoutCustomerCustomerIdIndexRoute
}

const LayoutCustomerCustomerIdRouteRouteChildren: LayoutCustomerCustomerIdRouteRouteChildren =
  {
    LayoutCustomerCustomerIdContactsRouteRoute:
      LayoutCustomerCustomerIdContactsRouteRouteWithChildren,
    LayoutCustomerCustomerIdAircraftRoute:
      LayoutCustomerCustomerIdAircraftRoute,
    LayoutCustomerCustomerIdDeleteRoute: LayoutCustomerCustomerIdDeleteRoute,
    LayoutCustomerCustomerIdWoHistoryRoute:
      LayoutCustomerCustomerIdWoHistoryRoute,
    LayoutCustomerCustomerIdIndexRoute: LayoutCustomerCustomerIdIndexRoute,
  }

const LayoutCustomerCustomerIdRouteRouteWithChildren =
  LayoutCustomerCustomerIdRouteRoute._addFileChildren(
    LayoutCustomerCustomerIdRouteRouteChildren,
  )

interface LayoutInventoryPurchaseOrdersRouteRouteChildren {
  LayoutInventoryPurchaseOrdersPurchaseOrderIdRoute: typeof LayoutInventoryPurchaseOrdersPurchaseOrderIdRoute
  LayoutInventoryPurchaseOrdersNewRoute: typeof LayoutInventoryPurchaseOrdersNewRoute
  LayoutInventoryPurchaseOrdersIndexRoute: typeof LayoutInventoryPurchaseOrdersIndexRoute
}

const LayoutInventoryPurchaseOrdersRouteRouteChildren: LayoutInventoryPurchaseOrdersRouteRouteChildren =
  {
    LayoutInventoryPurchaseOrdersPurchaseOrderIdRoute:
      LayoutInventoryPurchaseOrdersPurchaseOrderIdRoute,
    LayoutInventoryPurchaseOrdersNewRoute:
      LayoutInventoryPurchaseOrdersNewRoute,
    LayoutInventoryPurchaseOrdersIndexRoute:
      LayoutInventoryPurchaseOrdersIndexRoute,
  }

const LayoutInventoryPurchaseOrdersRouteRouteWithChildren =
  LayoutInventoryPurchaseOrdersRouteRoute._addFileChildren(
    LayoutInventoryPurchaseOrdersRouteRouteChildren,
  )

interface LayoutMaintenanceProgrammesProgrammeIdRouteRouteChildren {
  LayoutMaintenanceProgrammesProgrammeIdIndexRoute: typeof LayoutMaintenanceProgrammesProgrammeIdIndexRoute
  LayoutMaintenanceProgrammesProgrammeIdAircraftEnrolRoute: typeof LayoutMaintenanceProgrammesProgrammeIdAircraftEnrolRoute
  LayoutMaintenanceProgrammesProgrammeIdPhasesPhaseIdRoute: typeof LayoutMaintenanceProgrammesProgrammeIdPhasesPhaseIdRoute
  LayoutMaintenanceProgrammesProgrammeIdPhasesNewRoute: typeof LayoutMaintenanceProgrammesProgrammeIdPhasesNewRoute
  LayoutMaintenanceProgrammesProgrammeIdRevisionsNewRoute: typeof LayoutMaintenanceProgrammesProgrammeIdRevisionsNewRoute
  LayoutMaintenanceProgrammesProgrammeIdTasksTaskIdRoute: typeof LayoutMaintenanceProgrammesProgrammeIdTasksTaskIdRoute
  LayoutMaintenanceProgrammesProgrammeIdTasksNewRoute: typeof LayoutMaintenanceProgrammesProgrammeIdTasksNewRoute
  LayoutMaintenanceProgrammesProgrammeIdAircraftRemoveEnrolmentIdRoute: typeof LayoutMaintenanceProgrammesProgrammeIdAircraftRemoveEnrolmentIdRoute
  LayoutMaintenanceProgrammesProgrammeIdPhasesRemovePhaseIdRoute: typeof LayoutMaintenanceProgrammesProgrammeIdPhasesRemovePhaseIdRoute
  LayoutMaintenanceProgrammesProgrammeIdRevisionsReleaseRevisionIdRoute: typeof LayoutMaintenanceProgrammesProgrammeIdRevisionsReleaseRevisionIdRoute
  LayoutMaintenanceProgrammesProgrammeIdTasksRemoveTaskIdRoute: typeof LayoutMaintenanceProgrammesProgrammeIdTasksRemoveTaskIdRoute
}

const LayoutMaintenanceProgrammesProgrammeIdRouteRouteChildren: LayoutMaintenanceProgrammesProgrammeIdRouteRouteChildren =
  {
    LayoutMaintenanceProgrammesProgrammeIdIndexRoute:
      LayoutMaintenanceProgrammesProgrammeIdIndexRoute,
    LayoutMaintenanceProgrammesProgrammeIdAircraftEnrolRoute:
      LayoutMaintenanceProgrammesProgrammeIdAircraftEnrolRoute,
    LayoutMaintenanceProgrammesProgrammeIdPhasesPhaseIdRoute:
      LayoutMaintenanceProgrammesProgrammeIdPhasesPhaseIdRoute,
    LayoutMaintenanceProgrammesProgrammeIdPhasesNewRoute:
      LayoutMaintenanceProgrammesProgrammeIdPhasesNewRoute,
    LayoutMaintenanceProgrammesProgrammeIdRevisionsNewRoute:
      LayoutMaintenanceProgrammesProgrammeIdRevisionsNewRoute,
    LayoutMaintenanceProgrammesProgrammeIdTasksTaskIdRoute:
      LayoutMaintenanceProgrammesProgrammeIdTasksTaskIdRoute,
    LayoutMaintenanceProgrammesProgrammeIdTasksNewRoute:
      LayoutMaintenanceProgrammesProgrammeIdTasksNewRoute,
    LayoutMaintenanceProgrammesProgrammeIdAircraftRemoveEnrolmentIdRoute:
      LayoutMaintenanceProgrammesProgrammeIdAircraftRemoveEnrolmentIdRoute,
    LayoutMaintenanceProgrammesProgrammeIdPhasesRemovePhaseIdRoute:
      LayoutMaintenanceProgrammesProgrammeIdPhasesRemovePhaseIdRoute,
    LayoutMaintenanceProgrammesProgrammeIdRevisionsReleaseRevisionIdRoute:
      LayoutMaintenanceProgrammesProgrammeIdRevisionsReleaseRevisionIdRoute,
    LayoutMaintenanceProgrammesProgrammeIdTasksRemoveTaskIdRoute:
      LayoutMaintenanceProgrammesProgrammeIdTasksRemoveTaskIdRoute,
  }

const LayoutMaintenanceProgrammesProgrammeIdRouteRouteWithChildren =
  LayoutMaintenanceProgrammesProgrammeIdRouteRoute._addFileChildren(
    LayoutMaintenanceProgrammesProgrammeIdRouteRouteChildren,
  )

interface LayoutPlanningPlanIdRouteRouteChildren {
  LayoutPlanningPlanIdIndexRoute: typeof LayoutPlanningPlanIdIndexRoute
  LayoutPlanningPlanIdStepsStepIdIndexRoute: typeof LayoutPlanningPlanIdStepsStepIdIndexRoute
  LayoutPlanningPlanIdStepsStepIdTasksTaskIndexRoute: typeof LayoutPlanningPlanIdStepsStepIdTasksTaskIndexRoute
}

const LayoutPlanningPlanIdRouteRouteChildren: LayoutPlanningPlanIdRouteRouteChildren =
  {
    LayoutPlanningPlanIdIndexRoute: LayoutPlanningPlanIdIndexRoute,
    LayoutPlanningPlanIdStepsStepIdIndexRoute:
      LayoutPlanningPlanIdStepsStepIdIndexRoute,
    LayoutPlanningPlanIdStepsStepIdTasksTaskIndexRoute:
      LayoutPlanningPlanIdStepsStepIdTasksTaskIndexRoute,
  }

const LayoutPlanningPlanIdRouteRouteWithChildren =
  LayoutPlanningPlanIdRouteRoute._addFileChildren(
    LayoutPlanningPlanIdRouteRouteChildren,
  )

interface LayoutQuotesQuoteIdTasksTaskIdRouteRouteChildren {
  LayoutQuotesQuoteIdTasksTaskIdApplyTemplateRoute: typeof LayoutQuotesQuoteIdTasksTaskIdApplyTemplateRoute
  LayoutQuotesQuoteIdTasksTaskIdIndexRoute: typeof LayoutQuotesQuoteIdTasksTaskIdIndexRoute
  LayoutQuotesQuoteIdTasksTaskIdStepsStepIdRemoveRoute: typeof LayoutQuotesQuoteIdTasksTaskIdStepsStepIdRemoveRoute
}

const LayoutQuotesQuoteIdTasksTaskIdRouteRouteChildren: LayoutQuotesQuoteIdTasksTaskIdRouteRouteChildren =
  {
    LayoutQuotesQuoteIdTasksTaskIdApplyTemplateRoute:
      LayoutQuotesQuoteIdTasksTaskIdApplyTemplateRoute,
    LayoutQuotesQuoteIdTasksTaskIdIndexRoute:
      LayoutQuotesQuoteIdTasksTaskIdIndexRoute,
    LayoutQuotesQuoteIdTasksTaskIdStepsStepIdRemoveRoute:
      LayoutQuotesQuoteIdTasksTaskIdStepsStepIdRemoveRoute,
  }

const LayoutQuotesQuoteIdTasksTaskIdRouteRouteWithChildren =
  LayoutQuotesQuoteIdTasksTaskIdRouteRoute._addFileChildren(
    LayoutQuotesQuoteIdTasksTaskIdRouteRouteChildren,
  )

interface LayoutQuotesQuoteIdRouteRouteChildren {
  LayoutQuotesQuoteIdCorridorRoute: typeof LayoutQuotesQuoteIdCorridorRoute
  LayoutQuotesQuoteIdSendRoute: typeof LayoutQuotesQuoteIdSendRoute
  LayoutQuotesQuoteIdSentRoute: typeof LayoutQuotesQuoteIdSentRoute
  LayoutQuotesQuoteIdIndexRoute: typeof LayoutQuotesQuoteIdIndexRoute
  LayoutQuotesQuoteIdTasksTaskIdRouteRoute: typeof LayoutQuotesQuoteIdTasksTaskIdRouteRouteWithChildren
  LayoutQuotesQuoteIdPhasesNewRoute: typeof LayoutQuotesQuoteIdPhasesNewRoute
  LayoutQuotesQuoteIdTasksFromTemplateRoute: typeof LayoutQuotesQuoteIdTasksFromTemplateRoute
  LayoutQuotesQuoteIdPhasesPhaseIdDeleteRoute: typeof LayoutQuotesQuoteIdPhasesPhaseIdDeleteRoute
  LayoutQuotesQuoteIdPhasesPhaseIdRenameRoute: typeof LayoutQuotesQuoteIdPhasesPhaseIdRenameRoute
}

const LayoutQuotesQuoteIdRouteRouteChildren: LayoutQuotesQuoteIdRouteRouteChildren =
  {
    LayoutQuotesQuoteIdCorridorRoute: LayoutQuotesQuoteIdCorridorRoute,
    LayoutQuotesQuoteIdSendRoute: LayoutQuotesQuoteIdSendRoute,
    LayoutQuotesQuoteIdSentRoute: LayoutQuotesQuoteIdSentRoute,
    LayoutQuotesQuoteIdIndexRoute: LayoutQuotesQuoteIdIndexRoute,
    LayoutQuotesQuoteIdTasksTaskIdRouteRoute:
      LayoutQuotesQuoteIdTasksTaskIdRouteRouteWithChildren,
    LayoutQuotesQuoteIdPhasesNewRoute: LayoutQuotesQuoteIdPhasesNewRoute,
    LayoutQuotesQuoteIdTasksFromTemplateRoute:
      LayoutQuotesQuoteIdTasksFromTemplateRoute,
    LayoutQuotesQuoteIdPhasesPhaseIdDeleteRoute:
      LayoutQuotesQuoteIdPhasesPhaseIdDeleteRoute,
    LayoutQuotesQuoteIdPhasesPhaseIdRenameRoute:
      LayoutQuotesQuoteIdPhasesPhaseIdRenameRoute,
  }

const LayoutQuotesQuoteIdRouteRouteWithChildren =
  LayoutQuotesQuoteIdRouteRoute._addFileChildren(
    LayoutQuotesQuoteIdRouteRouteChildren,
  )

interface LayoutQuotingEmailsListEmailIdRouteRouteChildren {
  LayoutQuotingEmailsListEmailIdShareRoute: typeof LayoutQuotingEmailsListEmailIdShareRoute
  LayoutQuotingEmailsListEmailIdIndexRoute: typeof LayoutQuotingEmailsListEmailIdIndexRoute
}

const LayoutQuotingEmailsListEmailIdRouteRouteChildren: LayoutQuotingEmailsListEmailIdRouteRouteChildren =
  {
    LayoutQuotingEmailsListEmailIdShareRoute:
      LayoutQuotingEmailsListEmailIdShareRoute,
    LayoutQuotingEmailsListEmailIdIndexRoute:
      LayoutQuotingEmailsListEmailIdIndexRoute,
  }

const LayoutQuotingEmailsListEmailIdRouteRouteWithChildren =
  LayoutQuotingEmailsListEmailIdRouteRoute._addFileChildren(
    LayoutQuotingEmailsListEmailIdRouteRouteChildren,
  )

interface LayoutQuotingEmailsListRouteRouteChildren {
  LayoutQuotingEmailsListEmailIdRouteRoute: typeof LayoutQuotingEmailsListEmailIdRouteRouteWithChildren
  LayoutQuotingEmailsListIndexRoute: typeof LayoutQuotingEmailsListIndexRoute
  LayoutQuotingEmailsListDeleteEmailIdRoute: typeof LayoutQuotingEmailsListDeleteEmailIdRoute
  LayoutQuotingEmailsListDeleteBulkRoute: typeof LayoutQuotingEmailsListDeleteBulkRoute
  LayoutQuotingEmailsListShareBulkRoute: typeof LayoutQuotingEmailsListShareBulkRoute
}

const LayoutQuotingEmailsListRouteRouteChildren: LayoutQuotingEmailsListRouteRouteChildren =
  {
    LayoutQuotingEmailsListEmailIdRouteRoute:
      LayoutQuotingEmailsListEmailIdRouteRouteWithChildren,
    LayoutQuotingEmailsListIndexRoute: LayoutQuotingEmailsListIndexRoute,
    LayoutQuotingEmailsListDeleteEmailIdRoute:
      LayoutQuotingEmailsListDeleteEmailIdRoute,
    LayoutQuotingEmailsListDeleteBulkRoute:
      LayoutQuotingEmailsListDeleteBulkRoute,
    LayoutQuotingEmailsListShareBulkRoute:
      LayoutQuotingEmailsListShareBulkRoute,
  }

const LayoutQuotingEmailsListRouteRouteWithChildren =
  LayoutQuotingEmailsListRouteRoute._addFileChildren(
    LayoutQuotingEmailsListRouteRouteChildren,
  )

interface LayoutQuotingEmailsRouteRouteChildren {
  LayoutQuotingEmailsListRouteRoute: typeof LayoutQuotingEmailsListRouteRouteWithChildren
}

const LayoutQuotingEmailsRouteRouteChildren: LayoutQuotingEmailsRouteRouteChildren =
  {
    LayoutQuotingEmailsListRouteRoute:
      LayoutQuotingEmailsListRouteRouteWithChildren,
  }

const LayoutQuotingEmailsRouteRouteWithChildren =
  LayoutQuotingEmailsRouteRoute._addFileChildren(
    LayoutQuotingEmailsRouteRouteChildren,
  )

interface LayoutQuotingSquawksRouteRouteChildren {
  LayoutQuotingSquawksSquawkIdRoute: typeof LayoutQuotingSquawksSquawkIdRoute
  LayoutQuotingSquawksIndexRoute: typeof LayoutQuotingSquawksIndexRoute
  LayoutQuotingSquawksDeleteSquawkIdRoute: typeof LayoutQuotingSquawksDeleteSquawkIdRoute
  LayoutQuotingSquawksEditSquawkIdRoute: typeof LayoutQuotingSquawksEditSquawkIdRoute
}

const LayoutQuotingSquawksRouteRouteChildren: LayoutQuotingSquawksRouteRouteChildren =
  {
    LayoutQuotingSquawksSquawkIdRoute: LayoutQuotingSquawksSquawkIdRoute,
    LayoutQuotingSquawksIndexRoute: LayoutQuotingSquawksIndexRoute,
    LayoutQuotingSquawksDeleteSquawkIdRoute:
      LayoutQuotingSquawksDeleteSquawkIdRoute,
    LayoutQuotingSquawksEditSquawkIdRoute:
      LayoutQuotingSquawksEditSquawkIdRoute,
  }

const LayoutQuotingSquawksRouteRouteWithChildren =
  LayoutQuotingSquawksRouteRoute._addFileChildren(
    LayoutQuotingSquawksRouteRouteChildren,
  )

interface LayoutWorkOrdersWorkOrderIdTasksTaskIdRouteChildren {
  LayoutWorkOrdersWorkOrderIdTasksTaskIdDeleteRoute: typeof LayoutWorkOrdersWorkOrderIdTasksTaskIdDeleteRoute
  LayoutWorkOrdersWorkOrderIdTasksTaskIdStepsStepIdDeleteRoute: typeof LayoutWorkOrdersWorkOrderIdTasksTaskIdStepsStepIdDeleteRoute
  LayoutWorkOrdersWorkOrderIdTasksTaskIdTimeEntriesTimeEntryIdDeleteRoute: typeof LayoutWorkOrdersWorkOrderIdTasksTaskIdTimeEntriesTimeEntryIdDeleteRoute
}

const LayoutWorkOrdersWorkOrderIdTasksTaskIdRouteChildren: LayoutWorkOrdersWorkOrderIdTasksTaskIdRouteChildren =
  {
    LayoutWorkOrdersWorkOrderIdTasksTaskIdDeleteRoute:
      LayoutWorkOrdersWorkOrderIdTasksTaskIdDeleteRoute,
    LayoutWorkOrdersWorkOrderIdTasksTaskIdStepsStepIdDeleteRoute:
      LayoutWorkOrdersWorkOrderIdTasksTaskIdStepsStepIdDeleteRoute,
    LayoutWorkOrdersWorkOrderIdTasksTaskIdTimeEntriesTimeEntryIdDeleteRoute:
      LayoutWorkOrdersWorkOrderIdTasksTaskIdTimeEntriesTimeEntryIdDeleteRoute,
  }

const LayoutWorkOrdersWorkOrderIdTasksTaskIdRouteWithChildren =
  LayoutWorkOrdersWorkOrderIdTasksTaskIdRoute._addFileChildren(
    LayoutWorkOrdersWorkOrderIdTasksTaskIdRouteChildren,
  )

interface LayoutWorkOrdersWorkOrderIdRouteRouteChildren {
  LayoutWorkOrdersWorkOrderIdCancelRoute: typeof LayoutWorkOrdersWorkOrderIdCancelRoute
  LayoutWorkOrdersWorkOrderIdCloseRoute: typeof LayoutWorkOrdersWorkOrderIdCloseRoute
  LayoutWorkOrdersWorkOrderIdIndexRoute: typeof LayoutWorkOrdersWorkOrderIdIndexRoute
  LayoutWorkOrdersWorkOrderIdPhasesNewRoute: typeof LayoutWorkOrdersWorkOrderIdPhasesNewRoute
  LayoutWorkOrdersWorkOrderIdSquawksSquawkIdRoute: typeof LayoutWorkOrdersWorkOrderIdSquawksSquawkIdRoute
  LayoutWorkOrdersWorkOrderIdTasksTaskIdRoute: typeof LayoutWorkOrdersWorkOrderIdTasksTaskIdRouteWithChildren
  LayoutWorkOrdersWorkOrderIdTasksDeleteRoute: typeof LayoutWorkOrdersWorkOrderIdTasksDeleteRoute
  LayoutWorkOrdersWorkOrderIdTasksNewRoute: typeof LayoutWorkOrdersWorkOrderIdTasksNewRoute
  LayoutWorkOrdersWorkOrderIdPhasesPhaseIdDeleteRoute: typeof LayoutWorkOrdersWorkOrderIdPhasesPhaseIdDeleteRoute
  LayoutWorkOrdersWorkOrderIdPhasesPhaseIdRenameRoute: typeof LayoutWorkOrdersWorkOrderIdPhasesPhaseIdRenameRoute
}

const LayoutWorkOrdersWorkOrderIdRouteRouteChildren: LayoutWorkOrdersWorkOrderIdRouteRouteChildren =
  {
    LayoutWorkOrdersWorkOrderIdCancelRoute:
      LayoutWorkOrdersWorkOrderIdCancelRoute,
    LayoutWorkOrdersWorkOrderIdCloseRoute:
      LayoutWorkOrdersWorkOrderIdCloseRoute,
    LayoutWorkOrdersWorkOrderIdIndexRoute:
      LayoutWorkOrdersWorkOrderIdIndexRoute,
    LayoutWorkOrdersWorkOrderIdPhasesNewRoute:
      LayoutWorkOrdersWorkOrderIdPhasesNewRoute,
    LayoutWorkOrdersWorkOrderIdSquawksSquawkIdRoute:
      LayoutWorkOrdersWorkOrderIdSquawksSquawkIdRoute,
    LayoutWorkOrdersWorkOrderIdTasksTaskIdRoute:
      LayoutWorkOrdersWorkOrderIdTasksTaskIdRouteWithChildren,
    LayoutWorkOrdersWorkOrderIdTasksDeleteRoute:
      LayoutWorkOrdersWorkOrderIdTasksDeleteRoute,
    LayoutWorkOrdersWorkOrderIdTasksNewRoute:
      LayoutWorkOrdersWorkOrderIdTasksNewRoute,
    LayoutWorkOrdersWorkOrderIdPhasesPhaseIdDeleteRoute:
      LayoutWorkOrdersWorkOrderIdPhasesPhaseIdDeleteRoute,
    LayoutWorkOrdersWorkOrderIdPhasesPhaseIdRenameRoute:
      LayoutWorkOrdersWorkOrderIdPhasesPhaseIdRenameRoute,
  }

const LayoutWorkOrdersWorkOrderIdRouteRouteWithChildren =
  LayoutWorkOrdersWorkOrderIdRouteRoute._addFileChildren(
    LayoutWorkOrdersWorkOrderIdRouteRouteChildren,
  )

interface LayoutWorkOrdersListRouteRouteChildren {
  LayoutWorkOrdersListIndexRoute: typeof LayoutWorkOrdersListIndexRoute
  LayoutWorkOrdersListDeleteWorkOrderIdRoute: typeof LayoutWorkOrdersListDeleteWorkOrderIdRoute
}

const LayoutWorkOrdersListRouteRouteChildren: LayoutWorkOrdersListRouteRouteChildren =
  {
    LayoutWorkOrdersListIndexRoute: LayoutWorkOrdersListIndexRoute,
    LayoutWorkOrdersListDeleteWorkOrderIdRoute:
      LayoutWorkOrdersListDeleteWorkOrderIdRoute,
  }

const LayoutWorkOrdersListRouteRouteWithChildren =
  LayoutWorkOrdersListRouteRoute._addFileChildren(
    LayoutWorkOrdersListRouteRouteChildren,
  )

interface LayoutRouteChildren {
  LayoutAgentRouteRoute: typeof LayoutAgentRouteRouteWithChildren
  LayoutAircraftRouteRoute: typeof LayoutAircraftRouteRouteWithChildren
  LayoutAirworthinessDirectivesRouteRoute: typeof LayoutAirworthinessDirectivesRouteRouteWithChildren
  LayoutApprovedVendorsRouteRoute: typeof LayoutApprovedVendorsRouteRouteWithChildren
  LayoutCustomerRouteRoute: typeof LayoutCustomerRouteRouteWithChildren
  LayoutDocumentsRouteRoute: typeof LayoutDocumentsRouteRouteWithChildren
  LayoutForecastsRouteRoute: typeof LayoutForecastsRouteRouteWithChildren
  LayoutInventoryRouteRoute: typeof LayoutInventoryRouteRouteWithChildren
  LayoutMaintenanceProgrammesRouteRoute: typeof LayoutMaintenanceProgrammesRouteRouteWithChildren
  LayoutPlanningRouteRoute: typeof LayoutPlanningRouteRouteWithChildren
  LayoutQuotesRouteRoute: typeof LayoutQuotesRouteRouteWithChildren
  LayoutSettingsRouteRoute: typeof LayoutSettingsRouteRouteWithChildren
  LayoutTechLogsRouteRoute: typeof LayoutTechLogsRouteRouteWithChildren
  LayoutTemplatesRouteRoute: typeof LayoutTemplatesRouteRouteWithChildren
  LayoutTieInRouteRoute: typeof LayoutTieInRouteRoute
  LayoutTimesheetRouteRoute: typeof LayoutTimesheetRouteRouteWithChildren
  LayoutToolsRouteRoute: typeof LayoutToolsRouteRouteWithChildren
  LayoutIndexRoute: typeof LayoutIndexRoute
  LayoutAircraftAircraftIdRouteRoute: typeof LayoutAircraftAircraftIdRouteRouteWithChildren
  LayoutCustomerCustomerIdRouteRoute: typeof LayoutCustomerCustomerIdRouteRouteWithChildren
  LayoutInventoryPurchaseOrdersRouteRoute: typeof LayoutInventoryPurchaseOrdersRouteRouteWithChildren
  LayoutMaintenanceProgrammesProgrammeIdRouteRoute: typeof LayoutMaintenanceProgrammesProgrammeIdRouteRouteWithChildren
  LayoutPlanningPlanIdRouteRoute: typeof LayoutPlanningPlanIdRouteRouteWithChildren
  LayoutQuotesQuoteIdRouteRoute: typeof LayoutQuotesQuoteIdRouteRouteWithChildren
  LayoutQuotingEmailsRouteRoute: typeof LayoutQuotingEmailsRouteRouteWithChildren
  LayoutQuotingSquawksRouteRoute: typeof LayoutQuotingSquawksRouteRouteWithChildren
  LayoutWorkOrdersWorkOrderIdRouteRoute: typeof LayoutWorkOrdersWorkOrderIdRouteRouteWithChildren
  LayoutWorkOrdersListRouteRoute: typeof LayoutWorkOrdersListRouteRouteWithChildren
  LayoutAircraftNewRoute: typeof LayoutAircraftNewRoute
  LayoutAirworthinessDirectivesDocumentIdRoute: typeof LayoutAirworthinessDirectivesDocumentIdRoute
  LayoutApprovedVendorsVendorIdRoute: typeof LayoutApprovedVendorsVendorIdRoute
  LayoutApprovedVendorsNewRoute: typeof LayoutApprovedVendorsNewRoute
  LayoutCustomerNewRoute: typeof LayoutCustomerNewRoute
  LayoutForecastsForecastIdRoute: typeof LayoutForecastsForecastIdRoute
  LayoutForecastsPreviewRoute: typeof LayoutForecastsPreviewRoute
  LayoutWorkTaskIdRoute: typeof LayoutWorkTaskIdRoute
  LayoutManpowerIndexRoute: typeof LayoutManpowerIndexRoute
  LayoutQuotingIndexRoute: typeof LayoutQuotingIndexRoute
  LayoutAircraftAircraftIdEditRoute: typeof LayoutAircraftAircraftIdEditRoute
  LayoutAssessmentsAdReportIdRoute: typeof LayoutAssessmentsAdReportIdRoute
  LayoutAssessmentsSbReportIdRoute: typeof LayoutAssessmentsSbReportIdRoute
  LayoutQuotingCannedPackageIdRoute: typeof LayoutQuotingCannedPackageIdRoute
  LayoutQuotingQuotesQuoteIdRoute: typeof LayoutQuotingQuotesQuoteIdRoute
  LayoutQuotingCannedIndexRoute: typeof LayoutQuotingCannedIndexRoute
  LayoutQuotingQuotesIndexRoute: typeof LayoutQuotingQuotesIndexRoute
  LayoutTraceSandboxConversationSessionIdSplatRoute: typeof LayoutTraceSandboxConversationSessionIdSplatRoute
  LayoutQuotingQuotesBuilderQuoteIdIndexRoute: typeof LayoutQuotingQuotesBuilderQuoteIdIndexRoute
  LayoutQuotingQuotesBuilderQuoteIdTaskTaskIdRoute: typeof LayoutQuotingQuotesBuilderQuoteIdTaskTaskIdRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutAgentRouteRoute: LayoutAgentRouteRouteWithChildren,
  LayoutAircraftRouteRoute: LayoutAircraftRouteRouteWithChildren,
  LayoutAirworthinessDirectivesRouteRoute:
    LayoutAirworthinessDirectivesRouteRouteWithChildren,
  LayoutApprovedVendorsRouteRoute: LayoutApprovedVendorsRouteRouteWithChildren,
  LayoutCustomerRouteRoute: LayoutCustomerRouteRouteWithChildren,
  LayoutDocumentsRouteRoute: LayoutDocumentsRouteRouteWithChildren,
  LayoutForecastsRouteRoute: LayoutForecastsRouteRouteWithChildren,
  LayoutInventoryRouteRoute: LayoutInventoryRouteRouteWithChildren,
  LayoutMaintenanceProgrammesRouteRoute:
    LayoutMaintenanceProgrammesRouteRouteWithChildren,
  LayoutPlanningRouteRoute: LayoutPlanningRouteRouteWithChildren,
  LayoutQuotesRouteRoute: LayoutQuotesRouteRouteWithChildren,
  LayoutSettingsRouteRoute: LayoutSettingsRouteRouteWithChildren,
  LayoutTechLogsRouteRoute: LayoutTechLogsRouteRouteWithChildren,
  LayoutTemplatesRouteRoute: LayoutTemplatesRouteRouteWithChildren,
  LayoutTieInRouteRoute: LayoutTieInRouteRoute,
  LayoutTimesheetRouteRoute: LayoutTimesheetRouteRouteWithChildren,
  LayoutToolsRouteRoute: LayoutToolsRouteRouteWithChildren,
  LayoutIndexRoute: LayoutIndexRoute,
  LayoutAircraftAircraftIdRouteRoute:
    LayoutAircraftAircraftIdRouteRouteWithChildren,
  LayoutCustomerCustomerIdRouteRoute:
    LayoutCustomerCustomerIdRouteRouteWithChildren,
  LayoutInventoryPurchaseOrdersRouteRoute:
    LayoutInventoryPurchaseOrdersRouteRouteWithChildren,
  LayoutMaintenanceProgrammesProgrammeIdRouteRoute:
    LayoutMaintenanceProgrammesProgrammeIdRouteRouteWithChildren,
  LayoutPlanningPlanIdRouteRoute: LayoutPlanningPlanIdRouteRouteWithChildren,
  LayoutQuotesQuoteIdRouteRoute: LayoutQuotesQuoteIdRouteRouteWithChildren,
  LayoutQuotingEmailsRouteRoute: LayoutQuotingEmailsRouteRouteWithChildren,
  LayoutQuotingSquawksRouteRoute: LayoutQuotingSquawksRouteRouteWithChildren,
  LayoutWorkOrdersWorkOrderIdRouteRoute:
    LayoutWorkOrdersWorkOrderIdRouteRouteWithChildren,
  LayoutWorkOrdersListRouteRoute: LayoutWorkOrdersListRouteRouteWithChildren,
  LayoutAircraftNewRoute: LayoutAircraftNewRoute,
  LayoutAirworthinessDirectivesDocumentIdRoute:
    LayoutAirworthinessDirectivesDocumentIdRoute,
  LayoutApprovedVendorsVendorIdRoute: LayoutApprovedVendorsVendorIdRoute,
  LayoutApprovedVendorsNewRoute: LayoutApprovedVendorsNewRoute,
  LayoutCustomerNewRoute: LayoutCustomerNewRoute,
  LayoutForecastsForecastIdRoute: LayoutForecastsForecastIdRoute,
  LayoutForecastsPreviewRoute: LayoutForecastsPreviewRoute,
  LayoutWorkTaskIdRoute: LayoutWorkTaskIdRoute,
  LayoutManpowerIndexRoute: LayoutManpowerIndexRoute,
  LayoutQuotingIndexRoute: LayoutQuotingIndexRoute,
  LayoutAircraftAircraftIdEditRoute: LayoutAircraftAircraftIdEditRoute,
  LayoutAssessmentsAdReportIdRoute: LayoutAssessmentsAdReportIdRoute,
  LayoutAssessmentsSbReportIdRoute: LayoutAssessmentsSbReportIdRoute,
  LayoutQuotingCannedPackageIdRoute: LayoutQuotingCannedPackageIdRoute,
  LayoutQuotingQuotesQuoteIdRoute: LayoutQuotingQuotesQuoteIdRoute,
  LayoutQuotingCannedIndexRoute: LayoutQuotingCannedIndexRoute,
  LayoutQuotingQuotesIndexRoute: LayoutQuotingQuotesIndexRoute,
  LayoutTraceSandboxConversationSessionIdSplatRoute:
    LayoutTraceSandboxConversationSessionIdSplatRoute,
  LayoutQuotingQuotesBuilderQuoteIdIndexRoute:
    LayoutQuotingQuotesBuilderQuoteIdIndexRoute,
  LayoutQuotingQuotesBuilderQuoteIdTaskTaskIdRoute:
    LayoutQuotingQuotesBuilderQuoteIdTaskTaskIdRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

interface ReviewTokenRouteRouteChildren {
  ReviewTokenSignRoute: typeof ReviewTokenSignRoute
  ReviewTokenIndexRoute: typeof ReviewTokenIndexRoute
}

const ReviewTokenRouteRouteChildren: ReviewTokenRouteRouteChildren = {
  ReviewTokenSignRoute: ReviewTokenSignRoute,
  ReviewTokenIndexRoute: ReviewTokenIndexRoute,
}

const ReviewTokenRouteRouteWithChildren =
  ReviewTokenRouteRoute._addFileChildren(ReviewTokenRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,
  ChangePasswordRoute: ChangePasswordRoute,
  LoginRoute: LoginRoute,
  RecoverPasswordRoute: RecoverPasswordRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  ReviewTokenRouteRoute: ReviewTokenRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
